import { sectionType } from '@/views/website/products/components/description/common/types';
import { replaceImageUrl, isYoutubeUrl, escapeHtml } from '../utils';
import { updateContainerFuild } from './snippets-el/container-fuild';
import { updateButtonBasic } from '../../ui-modules/button-primary/extract-update.js';
import { updateDividerPrimary } from '../../ui-modules/divider-primary/extract-update.js';
import { updateAccordionPrimary } from '../../ui-modules/accordion-primary/extract-update.js';
import buttonPrimaryHtml from '../../ui-modules/button-primary/raw-html.js';
import {
  renderBandOptions,
  renderCupOptions,
  renderSizeOptions,
} from '@/section-templates/hurrybox/html-snippets/size-calculator.js';

export const updateHtmlFromData = {
  sectionCustomizeCard(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector(`[data-attribute="card-item-content"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector(`[data-attribute="card-item-image"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector(`[data-attribute="card-btn-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-btn', updatedData[key]);
          }
          break;
        }
        case 'card-rated-row': {
          const el = container.querySelector(`[data-attribute="card-rated-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector(`[data-attribute="card-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key].text || '');
            el.setAttribute('href', updatedData[key].url);
            if (updatedData[key].background) {
              el.style.backgroundColor = updatedData[key].background;
              el.setAttribute('data-background', updatedData[key].background);
            }
            if (updatedData[key].color) {
              el.style.color = updatedData[key].color;
              el.setAttribute('data-color', updatedData[key].color);
            }
          }
          break;
        }
        // case 'card-content': {
        //   const el = container.querySelector(`[data-attribute="card-content"]`)
        //   if (el) {
        //     el.innerHTML = updatedData[key]
        //   }
        //   break
        // }
        case 'card-image': {
          const el = container.querySelector(`[data-attribute="card-image"]`);
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector(`[data-attribute="sub-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key] || '');
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector(`[data-attribute="rating-stars"]`);
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector(`[data-attribute="rating-text"]`);
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          // const showSurvay = container.getAttribute('data-show-survay')
          if (el) {
            el.setAttribute('data-show-survay', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          if (wrapSurvay) {
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item" style="color: #d1d5db;">
                        <svg class="size-full" viewBox="0 0 100 100">
                            <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50" cy="50" r="40"></circle>
                            <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}" />
                        </svg>
                        <div class="wrap-percent"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                        ${item.description}
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'style-center-y': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');

          if (elCardContent) {
            elCardContent.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const cardDescription = container.querySelector('[data-attribute="card-description"]');
          const ratingText = container.querySelectorAll('[data-attribute="rating-text"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');

          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardTitle) {
            cardTitle.style.color = updatedData[key];
            cardTitle.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardDescription) {
            cardDescription.style.color = updatedData[key];
            cardDescription.setAttribute('data-text-color', updatedData[key]);
          }
          if (ratingText) {
            ratingText.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        case 'accrodion': {
          const accordionEl = container.querySelector('[data-attribute="card-accordion"]');
          if (accordionEl) {
            accordionEl.setAttribute('data-show-accordion', updatedData[key]?.show);
            accordionEl.style.display = updatedData[key]?.show ? 'block' : 'none';
          }
          const accordionTitleEl = container.querySelector('[data-attribute="accordion-title-text"]');
          if (accordionTitleEl) {
            accordionTitleEl.textContent = updatedData[key]?.title;
          }
          const accordionDescriptionEl = container.querySelector('[data-attribute="accordion-text"]');
          if (accordionDescriptionEl) {
            accordionDescriptionEl.textContent = updatedData[key]?.description;
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardWithSurvey(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector(`[data-attribute="card-item-content"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector(`[data-attribute="card-item-image"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector(`[data-attribute="card-btn-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-btn', updatedData[key]);
          }
          break;
        }
        case 'card-rated-row': {
          const el = container.querySelector(`[data-attribute="card-rated-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector(`[data-attribute="card-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key].text || '');
            el.setAttribute('href', updatedData[key].url);
            if (updatedData[key].background) {
              el.style.backgroundColor = updatedData[key].background;
              el.setAttribute('data-background', updatedData[key].background);
            }
            if (updatedData[key].color) {
              el.style.color = updatedData[key].color;
              el.setAttribute('data-color', updatedData[key].color);
            }
          }
          break;
        }
        // case 'card-content': {
        //   const el = container.querySelector(`[data-attribute="card-content"]`)
        //   if (el) {
        //     el.innerHTML = updatedData[key]
        //   }
        //   break
        // }
        case 'card-image': {
          const el = container.querySelector(`[data-attribute="card-image"]`);
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector(`[data-attribute="sub-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key] || '');
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector(`[data-attribute="rating-stars"]`);
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector(`[data-attribute="rating-text"]`);
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          // const showSurvay = container.getAttribute('data-show-survay')
          if (el) {
            el.setAttribute('data-show-survay', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          const showSurvay = updatedData['card-survay'];
          if (!showSurvay) {
            wrapSurvay.innerHTML = ``;
            break;
          }
          if (wrapSurvay) {
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item" style="color: #d1d5db;">
                        <svg class="size-full" viewBox="0 0 100 100">
                            <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50" cy="50" r="40"></circle>
                            <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}" />
                        </svg>
                        <div class="wrap-percent"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                        ${item.description}
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'style-center-y': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');

          if (elCardContent) {
            elCardContent.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const cardDescription = container.querySelector('[data-attribute="card-description"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');
          const percentSurvay = container.querySelectorAll('.wrap-percent');
          const percentCircleSurvay = container.querySelectorAll('[data-attribute="percent-circle-survay"]');
          const wrapSurvayItem = container.querySelectorAll('.wrap-survay-item');

          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardTitle) {
            cardTitle.style.color = updatedData[key];
            cardTitle.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardDescription) {
            cardDescription.style.color = updatedData[key];
            cardDescription.setAttribute('data-text-color', updatedData[key]);
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (percentSurvay) {
            percentSurvay.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (percentCircleSurvay) {
            percentCircleSurvay.forEach(item => {
              item.style.stroke = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (wrapSurvayItem) {
            wrapSurvayItem.forEach(item => {
              item.style.borderColor = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionFreestyle(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'content': {
          const el = container.querySelector('[data-attribute="content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="content"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="wrap-content"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'layoutFullWidth': {
          const el = container.querySelector('[data-attribute="wrap-content"]');
          if (el) {
            el.setAttribute('data-layout-full-width', updatedData[key]);
          }
          break;
        }
        case 'spacingHorizontal': {
          const el = container.querySelector('[data-attribute="wrap-content"]');
          if (el) {
            el.setAttribute('data-spacing-horizontal', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="wrap-content"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="wrap-content"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionProductGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-grid': {
          const el = container.querySelector('[data-attribute="title-grid"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'data-show-rating': {
          const el = container.querySelector('[data-attribute="rating-stars"]');
          const elRatingText = container.querySelector('[data-attribute="rating-text"]');
          if (el) {
            el.setAttribute('data-show-rating', updatedData[key]);
            if (updatedData[key]) {
              el.style.display = 'flex';
            } else {
              el.style.display = 'none';
            }
          }
          if (elRatingText) {
            elRatingText.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector('[data-attribute="rating-stars"]');
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector('[data-attribute="rating-text"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'body-grid': {
          const el = container.querySelector('[data-attribute="body-grid"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                return `<a data-attribute="item-product" href="${item.url}" class="item-product">
                    <div class="wrap-img">
                        <img loading="lazy" data-attribute="product-image" class="product-image" src="${item.image}" alt="">
                    </div>
                    <div data-attribute="product-content" class="wrap-content">
                        ${item.content}
                    </div>
                </a>`;
              })
              .join('');
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          const elItems = container.querySelectorAll('[data-attribute="item-product"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          if (elItems) {
            elItems.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionSatelliteGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'satellite-grid-container': {
          const el = container.querySelector('[data-attribute="satellite-grid-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'main-title-satellite': {
          const el = container.querySelector('[data-attribute="main-title-satellite"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          const elItemsCenter = container.querySelector('[data-attribute="items-center"]');
          if (elItemsCenter) {
            const elTitle = elItemsCenter.querySelector('[data-attribute="title-satellite"]');
            if (elTitle) {
              elTitle.innerHTML = updatedData[key];
            }
          }
          break;
        }
        case 'main-description-satellite': {
          const el = container.querySelector('[data-attribute="main-description-satellite"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          const elItemsCenter = container.querySelector('[data-attribute="items-center"]');
          if (elItemsCenter) {
            const elDescription = elItemsCenter.querySelector('[data-attribute="description-satellite"]');
            if (elDescription) {
              elDescription.textContent = updatedData[key];
            }
          }

          break;
        }
        case 'main-image-satellite': {
          const elItemsCenter = container.querySelector('[data-attribute="items-center"]');
          if (elItemsCenter) {
            const el = elItemsCenter.querySelector('[data-attribute="satellite-image"]');
            if (el) {
              el.setAttribute('src', updatedData[key]);
            }
          }
          break;
        }
        case 'items-satellite': {
          const items = updatedData[key];
          const length = items.length;
          const itemsLeft = items.slice(0, length / 2);
          const itemsRight = items.slice(length / 2);
          const itemsLeftHtml = itemsLeft.map(item => {
            const displayImage = item.image ? '' : 'display: none !important;';
            return `<div data-attribute="item-satellite" class="item-satellite">
                <div class="wrap-img" style="${displayImage}">
                    <img loading="lazy" data-attribute="satellite-image" class="satellite-image" src="${item.image}" alt="">
                </div>
                <h2 data-attribute="title-satellite" class="title-satellite">${item.title}</h2>
                <p data-attribute="description-satellite" class="description-satellite">${item.description}</p>
            </div>`;
          });
          const itemsRightHtml = itemsRight.map(item => {
            const displayImage = item.image ? '' : 'display: none !important;';
            return `<div data-attribute="item-satellite" class="item-satellite">
                <div class="wrap-img" style="${displayImage}">
                    <img loading="lazy" data-attribute="satellite-image" class="satellite-image" src="${item.image}" alt="">
                </div>
                <h2 data-attribute="title-satellite" class="title-satellite">${item.title}</h2>
                <p data-attribute="description-satellite" class="description-satellite">${item.description}</p>
              </div>`;
          });
          const elItemsLeft = container.querySelector('[data-attribute="items-left"]');
          const elItemsRight = container.querySelector('[data-attribute="items-right"]');
          if (elItemsLeft) {
            elItemsLeft.innerHTML = itemsLeftHtml.join('');
          }
          if (elItemsRight) {
            elItemsRight.innerHTML = itemsRightHtml.join('');
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="satellite-grid-container"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="satellite-grid-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="satellite-grid-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="satellite-grid-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        case 'dividerPrimary': {
          const el = container.querySelector('[data-attribute="divider-primary"]');
          if (el) {
            updateDividerPrimary(el, updatedData[key]);
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionQuestionFaq(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-question-faq': {
          const el = container.querySelector('[data-attribute="title-question-faq"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'items-question-faq': {
          const items = updatedData[key];
          const wrapItemQuestionFaq = container.querySelector('[data-attribute="wrap-item-question-faq"]');
          if (wrapItemQuestionFaq) {
            const uniqueId = Math.random()
              .toString(36)
              .slice(2, 8);
            wrapItemQuestionFaq.innerHTML = items
              .map((item, index) => {
                return ` <div data-attribute="item-question-faq" class="item-question-faq accordion-item">
                        <input data-attribute="accordion-input" type="radio" name="accordion" id="accordion-${uniqueId}-${index}" class="accordion-input">
                        <label data-attribute="accordion-header" for="accordion-${uniqueId}-${index}" class="accordion-header">
                            <p data-attribute="accordion-title" class="accordion-title">${item.question}</p>
                            <span class="accordion-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                    class="lucide-icon lucide lucide-chevron-down text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200"><!---->
                                    <path d="m6 9 6 6 6-6"></path><!----><!----><!---->
                                </svg>
                            </span>
                            <label for="close-all" class="close-btn"></label>
                        </label>
                        <div class="accordion-content">
                            <div data-attribute="accordion-content" class="accordion-text">
                               ${item.answer}
                            </div>
                        </div>
                    </div>`;
              })
              .join('');
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="question-faq-container"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="question-faq-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'border-color': {
          const els = container.querySelectorAll('.accordion-item');
          if (els) {
            els.forEach(item => {
              item.style.borderColor = updatedData[key];
              item.setAttribute('data-border-color', updatedData[key]);
            });
          }
          break;
        }
        case 'hover-background-color': {
          const el = container.querySelector('[data-attribute="question-faq-container"]');
          if (el) {
            el.setAttribute('data-hover-background', updatedData[key]);
            el.style.setProperty('--faq-accordion-hover-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="question-faq-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="question-faq-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionIconWithText(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'icon-with-text-container': {
          const el = container.querySelector('[data-attribute="icon-with-text-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'items-icon-with-text': {
          const items = updatedData[key];
          const listIconWithText = container.querySelector('[data-attribute="list-icon-with-text"]');
          if (listIconWithText) {
            listIconWithText.innerHTML = items
              .map(item => {
                return `<div data-attribute="item-icon-with-text" class="item-icon-with-text">
                    <div class="wrap-img">
                        <img loading="lazy" data-attribute="icon-item" class="icon-item" src="${item.img}" alt="">
                    </div>
                    <h2 data-attribute="title-item" class="title-item">${item.title}</h2>
                </div>`;
              })
              .join('');
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="icon-with-text-container"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="icon-with-text-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardDualImg(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector('[data-attribute="card-btn-row"]');
          if (el) {
            el.setAttribute('data-show-btn', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector('[data-attribute="card-btn"]');
          if (el) {
            el.setAttribute('href', updatedData[key].url);
            el.textContent = updatedData[key].text;
            el.style.backgroundColor = updatedData[key].background;
            el.style.color = updatedData[key].color;
            el.setAttribute('data-background', updatedData[key].background);
            el.setAttribute('data-color', updatedData[key].color);
          }
          break;
        }
        case 'list-image': {
          const el = container.querySelector('[data-attribute="list-image"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                return `<div class="image-item">
                  <img loading="lazy" data-attribute="card-image" class="card-image" src="${item.image}" alt="">
                </div>`;
              })
              .join('');
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector('[data-attribute="card-item-image"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionFindAnswer(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector('[data-attribute="card-btn-row"]');
          if (el) {
            el.setAttribute('data-show-btn', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector('[data-attribute="card-btn"]');
          if (el) {
            el.setAttribute('href', updatedData[key].url);
            el.textContent = updatedData[key].text;
            el.style.backgroundColor = updatedData[key].background;
            el.style.color = updatedData[key].color;
            el.style.borderColor = updatedData[key].border;
            el.setAttribute('data-background', updatedData[key].background);
            el.setAttribute('data-color', updatedData[key].color);
            el.setAttribute('data-border', updatedData[key].border);
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionTextCarousel(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-item-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background-item-color', updatedData[key]);
            el.style.setProperty('--background-item-color', updatedData[key]);
          }
          break;
        }
        case 'text-item-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-text-item-color', updatedData[key]);
            el.style.setProperty('--text-item-color', updatedData[key]);
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'pagination-active-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-pagination-active-color', updatedData[key]);
            el.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-pagination-inactive-color', updatedData[key]);
            el.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'list-item': {
          const items = updatedData[key];
          const listItem = container.querySelector('[data-attribute="list-item"]');
          if (listItem) {
            listItem.innerHTML = items
              .map(item => {
                return `<div data-attribute="item" class="swiper-slide">
                <div class="wrap-ct">
                  <div class="decor-item">
                    <svg aria-hidden="true" focusable="false" role="presentation"
                      class="icon icon-quote" viewBox="0 0 41 35">
                      <path
                        d="M10.208 17.711h6.124v16.332H0V21.684C0 8.184 5.444.956 16.332 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Zm24.498 0h6.124v16.332H24.498V21.684C24.498 8.184 29.942.956 40.83 0v6.125c-4.083 1.14-6.124 4.414-6.124 9.82v1.766Z"
                        fill-rule="evenodd"></path>
                    </svg>
                  </div>
                  <div data-attribute="content" class="item-text">
                    ${item.content}
                  </div>
                </div>
              </div>`;
              })
              .join('');
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionHeading(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.textContent = updatedData[key];
            el.style.color = updatedData['text-color'];
            el.setAttribute('data-text-color', updatedData['text-color']);
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.textContent = updatedData[key];
            el.style.color = updatedData['text-color'];
            el.setAttribute('data-text-color', updatedData['text-color']);
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardSmoking(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-content': {
          const el = container.querySelector('[data-attribute="card-content"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
            el.style.color = updatedData['text-color'];
            el.setAttribute('data-text-color', updatedData['text-color']);
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
            el.style.color = updatedData['text-color'];
            el.setAttribute('data-text-color', updatedData['text-color']);
          }
          break;
        }
        case 'card-image': {
          const el = container.querySelector('[data-attribute="card-image"]');
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector('[data-attribute="card-item-image"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionMarqueeBasicText(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'background': {
          const el = container.querySelector('[data-attribute="marquee-basic-text-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'color': {
          const el = container.querySelector('[data-attribute="marquee-basic-text-container"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key]);
            el.style.color = updatedData[key];
          }
          break;
        }
        case 'list-item': {
          const items = updatedData[key];
          const listItem = container.querySelector('[data-attribute="grid-group"]');
          if (listItem) {
            listItem.innerHTML = Array(30)
              .fill(
                `<div data-attribute="wrap-item" class="wrap-item">
                ${items.map(item => `<div data-attribute="item-text" class="item-text">${item.text}</div>`).join('')}
              </div>`,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionTextSurvey(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-left': {
          const el = container.querySelector('[data-attribute="card-left"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-right': {
          const el = container.querySelector('[data-attribute="card-right"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'border-color': {
          const containerEls = container.querySelectorAll('[data-attribute="item-survay"]');
          if (containerEls) {
            containerEls.forEach(item => {
              item.style.borderColor = updatedData[key];
              item.setAttribute('data-border-color', updatedData[key]);
            });
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          const colorPercent = updatedData['colorPercent'];
          if (el) {
            el.setAttribute('data-color-percent', colorPercent);
            el.innerHTML = updatedData[key]
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
              <div data-attribute="item-survay" class="wrap-survay-item">
                <div class="left-item">
                    <svg class="size-full" viewBox="0 0 100 100">
                      <circle class="text-gray-300" stroke-width="8" stroke="#ffffff" fill="transparent" cx="50" cy="50" r="40"></circle>
                      <circle data-attribute="percent-circle-survay" r="${radius}" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="${colorPercent}" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}"></circle>
                    </svg>
                    <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: ${colorPercent};"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                </div>
                <div data-attribute="description-survay" class="right-item">
                    ${item.description}
                </div>
              </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCompareTwoImg(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'title-color': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-title-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="section-title"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'card-left': {
          const el = container.querySelector('[data-attribute="card-left"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-right': {
          const el = container.querySelector('[data-attribute="card-right"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'imageBefore': {
          const elImgBefore = container.querySelector('[data-attribute="image-before"]');
          const elImgAfter = container.querySelector('[data-attribute="image-after"]');
          const elBeforeDecor = container.querySelector('[data-attribute="before"]');
          const elAfterDecor = container.querySelector('[data-attribute="after"]');

          if (elImgBefore) elImgBefore.setAttribute('src', updatedData.imageBefore.img);
          if (elImgAfter) elImgAfter.setAttribute('src', updatedData.imageAfter.img);
          if (elBeforeDecor) {
            elBeforeDecor.setAttribute('data-background', updatedData.imageBefore.bgDecor);
            elBeforeDecor.setAttribute('data-color', updatedData.imageBefore.colorDecor);
            elBeforeDecor.textContent = updatedData.imageBefore.text;
            elBeforeDecor.style.backgroundColor = updatedData.imageBefore.bgDecor;
            elBeforeDecor.style.color = updatedData.imageBefore.colorDecor;
          }
          if (elAfterDecor) {
            elAfterDecor.setAttribute('data-background', updatedData.imageAfter.bgDecor);
            elAfterDecor.setAttribute('data-color', updatedData.imageAfter.colorDecor);
            elAfterDecor.textContent = updatedData.imageAfter.text;
            elAfterDecor.style.backgroundColor = updatedData.imageAfter.bgDecor;
            elAfterDecor.style.color = updatedData.imageAfter.colorDecor;
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardCompareYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          if (sectionEl) {
            sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          if (sectionEl) {
            sectionEl.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]);
            cardContainer.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'bottomPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]);
            cardContainer.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'background': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#FFFFFF');
            cardContainer.style.backgroundColor = updatedData[key] || '#FFFFFF';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key] || '#000000');
          }
          break;
        }
        case 'enableContainerPage': {
          if (containerPage) {
            const showContainer = updatedData[key] === true;
            containerPage.setAttribute('data-enable-style', String(showContainer));
            containerPage.style.backgroundColor = showContainer
              ? containerPage.getAttribute('data-background-container') || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'backgroundContainer': {
          if (containerPage) {
            containerPage.setAttribute('data-background-container', updatedData[key] || '#FFFFFF');
            const showContainer = containerPage.getAttribute('data-enable-style') === 'true';
            containerPage.style.backgroundColor = showContainer ? updatedData[key] || '#FFFFFF' : 'transparent';
          }
          break;
        }
        case 'showTitle':
        case 'titleCard': {
          const titleEl = container.querySelector('[data-attribute="title-card"]');
          const showTitle = updatedData.showTitle !== false;
          if (titleEl) {
            titleEl.setAttribute('data-show', String(showTitle));
            if (showTitle) {
              titleEl.innerHTML = updatedData.titleCard || '';
              titleEl.style.display = '';
            } else {
              titleEl.innerHTML = '';
              titleEl.style.display = 'none';
            }
          }
          break;
        }
        case 'maxWidth':
        case 'enableBorder':
        case 'borderColor': {
          const wrapCard = container.querySelector('[data-attribute="wrap-card"]');
          if (wrapCard) {
            const maxWidth = Number(updatedData.maxWidth) > 0 ? Number(updatedData.maxWidth) : 700;
            const enableBorder = updatedData.enableBorder !== false;
            const borderColor = updatedData.borderColor || '#e5e7eb';

            wrapCard.setAttribute('data-max-width', String(maxWidth));
            wrapCard.setAttribute('data-enable-border', String(enableBorder));
            wrapCard.setAttribute('data-color-border', borderColor);

            wrapCard.style.setProperty('--max-width-wrap', `${maxWidth}px`);
            wrapCard.style.setProperty('--border-color', borderColor);
            wrapCard.style.borderWidth = enableBorder ? '' : '0';
            wrapCard.style.borderStyle = enableBorder ? '' : 'none';
          }
          break;
        }
        case 'imageBefore': {
          const beforeImg = container.querySelector('[data-attribute="image-before"]');
          const beforeDecor = container.querySelector('[data-attribute="before"]');
          if (beforeImg) {
            beforeImg.setAttribute('src', updatedData.imageBefore?.img || '');
          }
          if (beforeDecor) {
            const background = updatedData.imageBefore?.bgDecor || '#17d4f4';
            const color = updatedData.imageBefore?.colorDecor || '#ffffff';
            beforeDecor.setAttribute('data-background', background);
            beforeDecor.setAttribute('data-color', color);
            beforeDecor.textContent = updatedData.imageBefore?.text || '';
            beforeDecor.style.backgroundColor = background;
            beforeDecor.style.color = color;
          }
          break;
        }
        case 'imageAfter': {
          const afterImg = container.querySelector('[data-attribute="image-after"]');
          const afterDecor = container.querySelector('[data-attribute="after"]');
          if (afterImg) {
            afterImg.setAttribute('src', updatedData.imageAfter?.img || '');
          }
          if (afterDecor) {
            const background = updatedData.imageAfter?.bgDecor || '#17d4f4';
            const color = updatedData.imageAfter?.colorDecor || '#ffffff';
            afterDecor.setAttribute('data-background', background);
            afterDecor.setAttribute('data-color', color);
            afterDecor.textContent = updatedData.imageAfter?.text || '';
            afterDecor.style.backgroundColor = background;
            afterDecor.style.color = color;
          }
          break;
        }
        case 'explication': {
          const explication = container.querySelector('[data-attribute="explication"]');
          const showExplication = updatedData.showExplication !== false;
          if (explication) {
            explication.setAttribute('data-show', String(showExplication));
            if (showExplication) {
              explication.innerHTML = updatedData[key];
              explication.style.display = '';
            } else {
              explication.innerHTML = '';
              explication.style.display = 'none';
            }
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardTimelineYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'topPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]);
            cardContainer.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'bottomPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]);
            cardContainer.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'background': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#FFFFFF');
            cardContainer.style.backgroundColor = updatedData[key] || '#FFFFFF';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key] || '#000000');
          }
          break;
        }
        case 'enableContainerPage': {
          if (containerPage) {
            const showContainer = updatedData[key] === true;
            containerPage.setAttribute('data-enable-style', String(showContainer));
            containerPage.style.backgroundColor = showContainer
              ? containerPage.getAttribute('data-background-container') || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'backgroundContainer': {
          if (containerPage) {
            containerPage.setAttribute('data-background-container', updatedData[key] || '#FFFFFF');
            const showContainer = containerPage.getAttribute('data-enable-style') === 'true';
            containerPage.style.backgroundColor = showContainer ? updatedData[key] || '#FFFFFF' : 'transparent';
          }
          break;
        }
        case 'showTitle':
        case 'titleCard': {
          const titleCard = container.querySelector('[data-attribute="title-card"]');
          const showTitle = updatedData.showTitle !== false;
          if (titleCard) {
            titleCard.setAttribute('data-show', String(showTitle));
            if (showTitle) {
              titleCard.innerHTML = updatedData.titleCard || '';
              titleCard.style.display = '';
            } else {
              titleCard.innerHTML = '';
              titleCard.style.display = 'none';
            }
          }
          break;
        }
        case 'listShow':
        case 'highlightColor':
        case 'listItem': {
          const listWrap = container.querySelector('[data-attribute="list-item"]');
          if (!listWrap) break;

          const showList = updatedData.listShow !== false;
          const highlightColor = updatedData.highlightColor || '#e64c4c';
          const listItem = Array.isArray(updatedData.listItem) ? updatedData.listItem : [];

          listWrap.setAttribute('data-show', String(showList));
          listWrap.setAttribute('data-color-highlight', highlightColor);
          listWrap.style.setProperty('--color-highlight', highlightColor);

          if (!showList) {
            listWrap.innerHTML = '';
            listWrap.style.display = 'none';
            break;
          }

          listWrap.style.display = '';
          listWrap.innerHTML = listItem
            .map(
              item => `
                <div data-attribute="item-timeline" class="wrap-item-timeline">
                  <div class="goup-item-content">
                    <div data-attribute="timeline-node" class="timeline-node">${item.node || ''}</div>
                    <div data-attribute="timeline-content" class="timeline-content">${item.content || ''}</div>
                  </div>
                </div>
              `,
            )
            .join('');
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardSliderYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'topPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]);
            cardContainer.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'bottomPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]);
            cardContainer.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'background': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#FFFFFF');
            cardContainer.style.backgroundColor = updatedData[key] || '#FFFFFF';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key] || '#000000');
          }
          break;
        }
        case 'enableContainerPage': {
          if (containerPage) {
            const showContainer = updatedData[key] === true;
            containerPage.setAttribute('data-enable-style', String(showContainer));
            containerPage.style.backgroundColor = showContainer
              ? containerPage.getAttribute('data-background-container') || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'backgroundContainer': {
          if (containerPage) {
            containerPage.setAttribute('data-background-container', updatedData[key] || '#FFFFFF');
            const showContainer = containerPage.getAttribute('data-enable-style') === 'true';
            containerPage.style.backgroundColor = showContainer ? updatedData[key] || '#FFFFFF' : 'transparent';
          }
          break;
        }
        case 'showTitle':
        case 'titleCard': {
          const titleCard = container.querySelector('[data-attribute="title-card"]');
          const showTitle = updatedData.showTitle !== false;
          if (titleCard) {
            titleCard.setAttribute('data-show', String(showTitle));
            if (showTitle) {
              titleCard.innerHTML = updatedData.titleCard || '';
              titleCard.style.display = '';
            } else {
              titleCard.innerHTML = '';
              titleCard.style.display = 'none';
            }
          }
          break;
        }
        case 'listShow':
        case 'colPerView':
        case 'listItem': {
          const listWrap = container.querySelector('[data-attribute="list-item"]');
          if (!listWrap) break;

          const showList = updatedData.listShow !== false;
          const listItem = Array.isArray(updatedData.listItem) ? updatedData.listItem : [];
          const colPerView = Number(updatedData.colPerView);
          const normalizedColPerView = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : 3;

          listWrap.setAttribute('data-show', String(showList));
          listWrap.setAttribute('data-col-per-view', String(normalizedColPerView));

          if (!showList) {
            listWrap.innerHTML = '';
            listWrap.style.display = 'none';
            break;
          }

          listWrap.style.display = '';
          listWrap.innerHTML = listItem
            .map(
              item => `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <div class="wrap-img">
                      <img data-attribute="image-item" src="${item.image || ''}" alt="">
                    </div>
                    <div data-attribute="content-item" class="wrap-content">${item.content || ''}</div>
                  </div>
                </div>
              `,
            )
            .join('');
          break;
        }
        case 'decorBottomShow':
        case 'decorBottomColor': {
          const decorBottom = container.querySelector('[data-attribute="decor-bottom"]');
          if (decorBottom) {
            const showDecorBottom = updatedData.decorBottomShow !== false;
            const color = updatedData.decorBottomColor || '#ffffff';
            decorBottom.setAttribute('data-show', String(showDecorBottom));
            decorBottom.setAttribute('data-color', color);
            decorBottom.style.display = showDecorBottom ? 'block' : 'none';
            decorBottom.style.setProperty('--color-decor', color);
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardStatisticsYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'topPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]);
            cardContainer.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'bottomPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]);
            cardContainer.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'background': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#FFFFFF');
            cardContainer.style.backgroundColor = updatedData[key] || '#FFFFFF';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key] || '#000000');
          }
          break;
        }
        case 'enableContainerPage': {
          if (containerPage) {
            const showContainer = updatedData[key] === true;
            containerPage.setAttribute('data-enable-style', String(showContainer));
            containerPage.style.backgroundColor = showContainer
              ? containerPage.getAttribute('data-background-container') || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'backgroundContainer': {
          if (containerPage) {
            containerPage.setAttribute('data-background-container', updatedData[key] || '#FFFFFF');
            const showContainer = containerPage.getAttribute('data-enable-style') === 'true';
            containerPage.style.backgroundColor = showContainer ? updatedData[key] || '#FFFFFF' : 'transparent';
          }
          break;
        }
        case 'showTitle':
        case 'titleCard': {
          const titleCard = container.querySelector('[data-attribute="title-card"]');
          const showTitle = updatedData.showTitle !== false;
          if (titleCard) {
            titleCard.setAttribute('data-show', String(showTitle));
            if (showTitle) {
              titleCard.innerHTML = updatedData.titleCard || '';
              titleCard.style.display = '';
            } else {
              titleCard.innerHTML = '';
              titleCard.style.display = 'none';
            }
          }
          break;
        }
        case 'highlightColor': {
          const listWrap = container.querySelector('[data-attribute="list-item"]');
          if (listWrap) {
            listWrap.setAttribute('data-color-highlight', updatedData[key] || '#000000');
            listWrap.style.setProperty('--color-highlight', updatedData[key] || '#000000');
          }
          break;
        }
        case 'listShow':
        case 'listItem': {
          const listWrap = container.querySelector('[data-attribute="list-item"]');
          if (!listWrap) break;

          const showList = updatedData.listShow !== false;
          const listItem = Array.isArray(updatedData.listItem) ? updatedData.listItem : [];
          listWrap.setAttribute('data-show', String(showList));

          if (!showList) {
            listWrap.innerHTML = '';
            listWrap.style.display = 'none';
            break;
          }

          listWrap.style.display = '';
          listWrap.innerHTML = listItem
            .map(
              item => `
                <div data-attribute="item" class="wrap-item">
                  <div data-attribute="value-item" class="value-highlight">${item.value || ''}</div>
                  <div data-attribute="content-item" class="content-item">${item.content || ''}</div>
                </div>
              `,
            )
            .join('');
          break;
        }
        case 'showHint':
        case 'contentHint':
        case 'iconHint': {
          const hintBlock = container.querySelector('[data-attribute="hint-block"]');
          const hintContent = container.querySelector('[data-attribute="content-hint"]');
          const hintIcon = container.querySelector('[data-attribute="icon-item"]');
          const showHint = updatedData.showHint !== false;

          if (hintBlock) {
            hintBlock.setAttribute('data-show', String(showHint));
            hintBlock.style.display = showHint ? '' : 'none';
          }

          if (hintContent) {
            hintContent.innerHTML = showHint ? updatedData.contentHint || '' : '';
          }

          if (hintIcon) {
            hintIcon.setAttribute('src', showHint ? updatedData.iconHint || '' : '');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionReviewSliderYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    const buildStarsHtml = count => {
      const safeCount = Math.min(Math.max(parseInt(count, 10) || 5, 1), 5);
      return new Array(safeCount)
        .fill(
          `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" fill="currentColor" />
          </svg>`,
        )
        .join('');
    };

    const syncProductReviewIntoItems = () => {
      const productReview = container.querySelector('[data-attribute="product-review"]');
      if (!productReview) return;
      const productReviewHtml = productReview.innerHTML || '';
      const insertBlocks = container.querySelectorAll('[data-attribute="insert-product-reivew"]');
      insertBlocks.forEach(el => {
        const purchaseDate = (el.getAttribute('data-purchase-date') || '').trim();
        const wrapper = document.createElement('div');
        wrapper.innerHTML = productReviewHtml;
        const purchaseDateEl = wrapper.querySelector('[data-attribute="purchase-date"]');
        if (purchaseDateEl) {
          purchaseDateEl.textContent = purchaseDate;
        }
        el.innerHTML = wrapper.innerHTML;
      });
      productReview.style.display = 'none';
    };

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'topPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]);
            cardContainer.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'bottomPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]);
            cardContainer.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'background': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#FFFFFF');
            cardContainer.style.backgroundColor = updatedData[key] || '#FFFFFF';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key] || '#000000');
          }
          break;
        }
        case 'enableContainerPage': {
          if (containerPage) {
            const showContainer = updatedData[key] === true;
            containerPage.setAttribute('data-enable-style', String(showContainer));
            containerPage.style.backgroundColor = showContainer
              ? containerPage.getAttribute('data-background-container') || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'backgroundContainer': {
          if (containerPage) {
            containerPage.setAttribute('data-background-container', updatedData[key] || '#FFFFFF');
            const showContainer = containerPage.getAttribute('data-enable-style') === 'true';
            containerPage.style.backgroundColor = showContainer ? updatedData[key] || '#FFFFFF' : 'transparent';
          }
          break;
        }
        case 'highlightColor': {
          const wrapCard = container.querySelector('[data-attribute="wrap-card"]');
          if (wrapCard) {
            wrapCard.setAttribute('data-color-highlight', updatedData[key] || '#cb6387');
            wrapCard.style.setProperty('--color-highlight', updatedData[key] || '#cb6387');
          }
          break;
        }
        case 'showRatedBlock':
        case 'ratingValue': {
          const blockRated = container.querySelector('[data-attribute="block-rated"]');
          if (blockRated) {
            const showRated = updatedData.showRatedBlock !== false;
            blockRated.setAttribute('data-show', String(showRated));
            blockRated.style.display = showRated ? '' : 'none';
            const ratingValue = blockRated.querySelector('[data-attribute="rating-value"]');
            if (ratingValue) {
              ratingValue.innerHTML = showRated ? updatedData.ratingValue || '' : '';
            }
          }
          break;
        }
        case 'showTitle':
        case 'titleCard': {
          const titleCard = container.querySelector('[data-attribute="card-title"]');
          if (titleCard) {
            const showTitle = updatedData.showTitle !== false;
            titleCard.setAttribute('data-show', String(showTitle));
            titleCard.style.display = showTitle ? '' : 'none';
            titleCard.innerHTML = showTitle ? updatedData.titleCard || '' : '';
          }
          break;
        }
        case 'productReview': {
          const productReview = container.querySelector('[data-attribute="product-review"]');
          if (productReview) {
            const productData = updatedData[key] || {};
            const productImage = productReview.querySelector('[data-attribute="product-image"]');
            const productName = productReview.querySelector('[data-attribute="product-name"]');
            const currentPrice = productReview.querySelector('[data-attribute="current-price"]');
            const oldPrice = productReview.querySelector('[data-attribute="old-price"]');

            if (productImage) productImage.setAttribute('src', productData.image || '');
            if (productName) productName.textContent = productData.productName || '';
            if (currentPrice) currentPrice.textContent = productData.currentPrice || '';
            if (oldPrice) oldPrice.textContent = productData.oldPrice || '';
            productReview.style.display = 'none';
          }
          // syncProductReviewIntoItems()
          break;
        }
        case 'colPerView':
        case 'spaceBetween':
        case 'listItem': {
          const listWrap = container.querySelector('[data-attribute="list-item"]');
          if (!listWrap) break;

          const colPerView = Number(updatedData.colPerView);
          const safeColPerView = Number.isFinite(colPerView) && colPerView > 0 ? colPerView : 3;
          const spaceBetween = Number(updatedData.spaceBetween);
          const safeSpaceBetween = Number.isFinite(spaceBetween) && spaceBetween >= 0 ? spaceBetween : 16;
          const listItem = Array.isArray(updatedData.listItem) ? updatedData.listItem : [];

          listWrap.setAttribute('data-col-per-view', String(safeColPerView));
          listWrap.setAttribute('data-space-between', String(safeSpaceBetween));
          listWrap.innerHTML = listItem
            .map(item => {
              const starValue = Math.min(Math.max(parseInt(item.starValue, 10) || 5, 1), 5);
              return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <div class="wrap-review-image">
                      <img data-attribute="review-image" src="${item.reviewImage || ''}" alt="">
                    </div>
                    <div class="wrap-review-content">
                      <div class="group-stars">
                        <div data-attribute="star-item" data-value="${starValue}" class="wrap-stars">
                          ${buildStarsHtml(starValue)}
                        </div>
                        <div class="wrap-reviewer-name">
                          <span data-attribute="reviewer-name">${item.reviewerName || ''}</span>
                          <span class="icon-verified">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                              <title>check-decagram</title>
                              <path d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z" fill="currentColor" />
                            </svg>
                          </span>
                          <span>Verified Buyer</span>
                        </div>
                      </div>
                      <div data-attribute="content-review" class="content-review">${item.contentReview || ''}</div>
                      <div data-purchase-date="${item.purchaseDate ||
                        ''}" data-attribute="insert-product-reivew" class="insert-product-reivew"></div>
                    </div>
                  </div>
                </div>
              `;
            })
            .join('');

          syncProductReviewIntoItems();
          break;
        }
        default:
          break;
      }
    }

    syncProductReviewIntoItems();
    return container.innerHTML.trim();
  },
  sectionCardWithTableCompare(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-left': {
          const el = container.querySelector('[data-attribute="card-left"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-right': {
          const el = container.querySelector('[data-attribute="card-right"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'first-title': {
          const el = container.querySelector('[data-attribute="first-title"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'second-title': {
          const el = container.querySelector('[data-attribute="second-title"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'columnCount': {
          const elCardRight = container.querySelector('[data-attribute="card-right"]');
          if (elCardRight) {
            elCardRight.setAttribute('data-colum-perview', updatedData[key]);
            elCardRight.style.setProperty('--columperview', updatedData[key]);
          }
          const elTableHead = container.querySelector('.table-head');
          if (elTableHead) {
            let elThirdTitle = elTableHead.querySelector('[data-attribute="third-title"]');
            if (updatedData[key] >= 3) {
              if (!elThirdTitle) {
                elThirdTitle = doc.createElement('div');
                elThirdTitle.setAttribute('data-attribute', 'third-title');
                elTableHead.appendChild(elThirdTitle);
              }
              elThirdTitle.textContent = updatedData['third-title'] || '';
            } else if (elThirdTitle) {
              elThirdTitle.remove();
            }
          }
          break;
        }
        case 'third-title': {
          const el = container.querySelector('[data-attribute="third-title"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const elTableBody = container.querySelector('[data-attribute="table-body"]');
          const elCheck = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00c75a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-icon lucide-check"><path d="M20 6 9 17l-5-5"/></svg>`;
          const elX = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;
          const background = updatedData['table-body'].background;
          const color = updatedData['table-body'].color;
          const columnCount = updatedData.columnCount || 2;
          elTableBody.setAttribute('data-background', background);
          elTableBody.setAttribute('data-color', color);
          if (elTableBody) {
            elTableBody.innerHTML = updatedData[key]
              .map(({ comparisonContent, firstTd, secondTd, thirdTd }) => {
                return `
               <div data-attribute="table-row" class="table-row">
                    <div style="background-color: ${background}; color: ${color};" data-attribute="comparison-content" class="comparison-content">${comparisonContent}</div>
                    <div data-attribute="first-td" data-value="${firstTd}" class="first-td">
                        ${firstTd ? elCheck : elX}
                    </div>
                    <div data-attribute="second-td" data-value="${secondTd}" class="second-td">
                        ${secondTd ? elCheck : elX}
                    </div>
                    ${
                      columnCount >= 3
                        ? `<div data-attribute="third-td" data-value="${thirdTd}" class="third-td">
                        ${thirdTd ? elCheck : elX}
                    </div>`
                        : ''
                    }
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionBannerSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'container-page': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key]);
            if (updatedData[key]) {
              elContainerPage.classList.add('container');
            } else {
              elContainerPage.classList.remove('container');
            }
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-text-color', updatedData[key]);
            containerEl.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'button-text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-button-text-color', updatedData[key]);
            containerEl.style.setProperty('--button-text-color', updatedData[key]);
          }
          break;
        }
        case 'button-background-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-button-background-color', updatedData[key]);
            containerEl.style.setProperty('--button-background-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-active-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-active-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-inactive-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'list-item': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                  <div data-attribute="item" class="swiper-slide">
                        <div data-attribute="wrap-content" class="wrap-ct">
                            <div class="wrap-img">
                                <img data-attribute="image-banner" src="${item.image}" alt="">
                            </div>
                            <div class="wrap-text-btn">
                                <div data-show-text="${
                                  item.textBanner.showText
                                }" data-attribute="text-banner" class="wrap-text"
                                    style="display: ${item.textBanner.showText ? 'block' : 'none'};">
                                    ${item.textBanner.text}
                                </div>
                                <div data-show-button="${
                                  item.button.showBtn
                                }" data-attribute="button-banner" class="wrap-btn"
                                    style="display: ${item.button.showBtn ? 'block' : 'none'};">
                                    <a data-background="${item.button.background}" data-color="${
                  item.button.color
                }" style="background-color: ${item.button.background}; color: ${
                  item.button.color
                };" data-attribute="button-link" class="btn-slide" href="${item.button.link}">${item.button.text}</a>
                                </div>
                            </div>
                            <div data-show-overlay="${item.overlay.showOverlay}" data-opacity="${
                  item.overlay.opacity
                }" data-attribute="overlay-slide" class="slide-overlay"
                                style="background-color: black; opacity: ${item.overlay.opacity}; display: ${
                  item.overlay.showOverlay ? 'block' : 'none'
                };"></div>
                        </div>
                    </div>
                `;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionIconWithTextSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const containerEls = container.querySelectorAll('[data-attribute="text-icon"]');
          if (containerEls) {
            containerEls.forEach(containerEl => {
              containerEl.style.color = updatedData[key];
              containerEl.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        case 'pagination-active-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-active-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-inactive-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'list-item': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                  <div data-attribute="item" class="swiper-slide">
                    <div data-attribute="wrap-content" class="wrap-ct">
                      <div class="wrap-img">
                        <img data-attribute="image-icon" src="${item.image}" alt="">
                      </div>
                      <div class="wrap-text" data-attribute="text-icon" data-text-color="${updatedData['text-color']}" style="color: ${updatedData['text-color']}">
                        ${item.text}
                      </div>
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionSubscribeEmail(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.style.setProperty('--text-color', updatedData[key]);
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'border-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-border-color', updatedData[key]);
            containerEl.style.setProperty('--border-color', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'description-card': {
          const el = container.querySelector('[data-attribute="description-card"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardSona(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'button-text-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-button-text-color', updatedData[key]);
            containerEl.style.setProperty('--button-text-color', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector('[data-attribute="card-item-image"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'style-center-y': {
          const el = container.querySelector('[data-attribute="card-item-content"]');
          if (el) {
            el.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'card-image': {
          const el = container.querySelector('[data-attribute="card-image"]');
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'buttonCard': {
          const elRowBtn = container.querySelector('[data-attribute="card-btn-row"]');
          if (elRowBtn) {
            elRowBtn.setAttribute('data-show-btn', updatedData[key].show);
            elRowBtn.style.display = updatedData[key].show ? 'block' : 'none';
          }
          const elBtn = container.querySelector('[data-attribute="card-btn"]');
          if (elBtn) {
            elBtn.setAttribute('data-background', updatedData[key].background);
            elBtn.setAttribute('data-radius', updatedData[key].radius);
            elBtn.setAttribute('data-color', updatedData[key].color);
            elBtn.style.backgroundColor = updatedData[key].background;
            elBtn.style.color = updatedData[key].color;
            elBtn.style.borderRadius = updatedData[key].radius + 'px';
            elBtn.textContent = updatedData[key].text;
            elBtn.setAttribute('href', updatedData[key].link);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionTinoGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-section': {
          const el = container.querySelector('[data-attribute="title-section"]');
          if (!(updatedData[key] || '').trim()) {
            el.style.display = 'none';
          } else {
            el.style.display = '';
          }
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'itemBackground': {
          const elBodyGrid = container.querySelector('[data-attribute="body-grid"]');
          if (elBodyGrid) {
            elBodyGrid.setAttribute('data-item-bg', updatedData[key]);
          }
          break;
        }
        case 'itemTextColor': {
          const elBodyGrid = container.querySelector('[data-attribute="body-grid"]');
          if (elBodyGrid) {
            elBodyGrid.setAttribute('data-item-text-color', updatedData[key]);
          }
          break;
        }
        case 'textColor': {
          const elBodyGrid = container.querySelector('[data-attribute="product-grid-container"]');
          if (elBodyGrid) {
            elBodyGrid.style.color = updatedData[key];
            elBodyGrid.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const elBodyGrid = container.querySelector('[data-attribute="product-grid-container"]');
          if (elBodyGrid) {
            elBodyGrid.style.backgroundColor = updatedData[key];
            elBodyGrid.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'pagination-active-color': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          if (el) {
            el.setAttribute('data-pagination-active-color', updatedData[key]);
            el.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          if (el) {
            el.setAttribute('data-pagination-inactive-color', updatedData[key]);
            el.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            const hideTextStyle = updatedData.showText === false ? 'display: none;' : '';
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                 <div data-attribute="item-slide" class="swiper-slide">
                   <a
                      data-attribute="item-product"
                      href="${item.url}"
                      class="item-product"
                      style="background: ${updatedData.itemBackground}; color: ${updatedData.itemTextColor};"
                      >
                      <div class="wrap-img">
                         <img
                            loading="lazy"
                            data-attribute="product-image"
                            class="product-image"
                            src="${item.image}"
                            alt=""
                            />
                      </div>
                      <div data-attribute="product-content" class="wrap-content" style="${hideTextStyle}" ${
                  updatedData.showText === false ? 'data-hide-text="true"' : ''
                }>${item.content || ''}</div>
                   </a>
                </div>
                `;
              })
              .join('');
          }
          break;
        }
        case 'buttonViewAll': {
          const elRowBtn = container.querySelector('[data-attribute="row-btn"]');
          if (elRowBtn) {
            elRowBtn.setAttribute('data-show-btn', updatedData[key].show);
            elRowBtn.style.display = updatedData[key].show ? 'block' : 'none';
          }
          const elBtn = container.querySelector('[data-attribute="btn-view-all"]');
          if (elBtn) {
            elBtn.setAttribute('data-background', updatedData[key].background);
            elBtn.style.backgroundColor = updatedData[key].background;
            elBtn.setAttribute('data-color', updatedData[key].color);
            elBtn.style.color = updatedData[key].color;
            elBtn.setAttribute('data-radius', updatedData[key].radius);
            elBtn.style.borderRadius = updatedData[key].radius + 'px';
            elBtn.textContent = updatedData[key].text;
            elBtn.setAttribute('href', updatedData[key].link);
          }
          break;
        }
        case 'showText': {
          const productContentElements = container.querySelectorAll('[data-attribute="product-content"]');
          productContentElements.forEach(el => {
            if (updatedData[key] === false) {
              el.style.display = 'none';
              el.setAttribute('data-hide-text', 'true');
            } else {
              el.style.display = '';
              el.removeAttribute('data-hide-text');
            }
          });
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="product-grid-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardVideoSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'header': {
          const el = container.querySelector('[data-attribute="card-header"]');
          const show = updatedData[key].show;
          if (el) {
            el.innerHTML = updatedData[key].content;
            el.style.display = show ? 'block' : 'none';
            el.setAttribute('data-show', show);
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.setAttribute('data-auto-play-video', updatedData.autoPlayVideo ? 'true' : 'false');
            el.setAttribute('data-muted', updatedData.muted ? 'true' : 'false');
            el.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <video loop playsinline width="600" ${updatedData.muted ? 'muted' : ''}>
                      <source data-attribute="card-video"
                        src="${item.video}"
                        type="video/mp4">
                    </video>
                    <div data-attribute="playvideo" data-background="${
                      updatedData.btnPlayVideo.background
                    }" data-color="${updatedData.btnPlayVideo.color}"
                      style="background-color: ${updatedData.btnPlayVideo.background}; color: ${
                  updatedData.btnPlayVideo.color
                };" class="playvideo">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-play-icon lucide-play">
                        <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z" />
                      </svg>
                    </div>
                    <div class="volume" style="display: ${updatedData.muted ? 'none' : 'flex'};">
                      <span class="volume-icon" style="display: flex;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-volume2-icon lucide-volume-2">
                          <path
                            d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                          <path d="M16 9a5 5 0 0 1 0 6" />
                          <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                        </svg>
                      </span>
                      <span class="mute-icon" style="display: none;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-volume-off-icon lucide-volume-off">
                          <path d="M16 9a5 5 0 0 1 .95 2.293" />
                          <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                          <path d="m2 2 20 20" />
                          <path
                            d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                          <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'autoPlayVideo': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.setAttribute('data-auto-play-video', updatedData[key] ? 'true' : 'false');
          }
          break;
        }
        case 'muted': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.setAttribute('data-muted', updatedData[key] ? 'true' : 'false');
          }
          const volumeEls = container.querySelectorAll('.volume');
          volumeEls.forEach(volumeEl => {
            volumeEl.style.display = updatedData[key] ? 'none' : 'flex';
          });
          const videos = container.querySelectorAll('.wrap-item video');
          videos.forEach(video => {
            video.muted = !!updatedData[key];
            if (updatedData[key]) {
              video.setAttribute('muted', '');
            } else {
              video.removeAttribute('muted');
            }
          });
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardVideo(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector(`[data-attribute="card-item-content"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector(`[data-attribute="card-item-image"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector(`[data-attribute="card-btn-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-btn', updatedData[key]);
          }
          break;
        }
        case 'card-rated-row': {
          const el = container.querySelector(`[data-attribute="card-rated-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector(`[data-attribute="card-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key].text || '');
            el.setAttribute('href', updatedData[key].url);
            if (updatedData[key].background) {
              el.style.backgroundColor = updatedData[key].background;
              el.setAttribute('data-background', updatedData[key].background);
            }
            if (updatedData[key].color) {
              el.style.color = updatedData[key].color;
              el.setAttribute('data-color', updatedData[key].color);
            }
            if (updatedData[key].radius) {
              el.style.borderRadius = updatedData[key].radius + 'px';
              el.setAttribute('data-radius', updatedData[key].radius);
            }
          }
          break;
        }
        // case 'card-content': {
        //   const el = container.querySelector(`[data-attribute="card-content"]`)
        //   if (el) {
        //     el.innerHTML = updatedData[key]
        //   }
        //   break
        // }
        case 'wrap-img-radius': {
          const el = container.querySelector(`[data-attribute="wrap-img"]`);
          if (el) {
            el.setAttribute('data-radius', updatedData[key]);
            el.style.borderRadius = updatedData[key] + 'px';
          }
          break;
        }
        case 'card-video': {
          const el = container.querySelector(`[data-attribute="card-video"]`);
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector(`[data-attribute="sub-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key] || '');
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector(`[data-attribute="rating-stars"]`);
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector(`[data-attribute="rating-text"]`);
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          // const showSurvay = container.getAttribute('data-show-survay')
          if (el) {
            el.setAttribute('data-show-survay', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          if (wrapSurvay) {
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item" style="color: #d1d5db;">
                        <svg class="size-full" viewBox="0 0 100 100">
                            <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50" cy="50" r="40"></circle>
                            <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}" />
                        </svg>
                        <div class="wrap-percent"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                        ${item.description}
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'style-center-y': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');

          if (elCardContent) {
            elCardContent.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const cardDescription = container.querySelector('[data-attribute="card-description"]');
          const ratingText = container.querySelectorAll('[data-attribute="rating-text"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');

          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardTitle) {
            cardTitle.style.color = updatedData[key];
            cardTitle.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardDescription) {
            cardDescription.style.color = updatedData[key];
            cardDescription.setAttribute('data-text-color', updatedData[key]);
          }
          if (ratingText) {
            ratingText.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardAccordions(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-item-content': {
          const el = container.querySelector(`[data-attribute="card-item-content"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-item-image': {
          const el = container.querySelector(`[data-attribute="card-item-image"]`);
          if (el) {
            el.setAttribute('data-order', updatedData[key]);
            el.style.order = updatedData[key];
          }
          break;
        }
        case 'card-btn-row': {
          const el = container.querySelector(`[data-attribute="card-btn-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-btn', updatedData[key]);
          }
          break;
        }
        case 'card-rated-row': {
          const el = container.querySelector(`[data-attribute="card-rated-row"]`);
          if (el) {
            el.style.display = updatedData[key] ? 'block' : 'none';
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'card-btn': {
          const el = container.querySelector(`[data-attribute="card-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key].text || '');
            el.setAttribute('href', updatedData[key].url);
            if (updatedData[key].background) {
              el.style.backgroundColor = updatedData[key].background;
              el.setAttribute('data-background', updatedData[key].background);
            }
            if (updatedData[key].color) {
              el.style.color = updatedData[key].color;
              el.setAttribute('data-color', updatedData[key].color);
            }
          }
          break;
        }
        // case 'card-content': {
        //   const el = container.querySelector(`[data-attribute="card-content"]`)
        //   if (el) {
        //     el.innerHTML = updatedData[key]
        //   }
        //   break
        // }
        case 'card-image': {
          const el = container.querySelector(`[data-attribute="card-image"]`);
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'sub-btn': {
          const el = container.querySelector(`[data-attribute="sub-btn"]`);
          if (el) {
            el.textContent = String(updatedData[key] || '');
          }
          break;
        }
        case 'rating-stars': {
          const el = container.querySelector(`[data-attribute="rating-stars"]`);
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'rating-text': {
          const el = container.querySelector(`[data-attribute="rating-text"]`);
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-description': {
          const el = container.querySelector('[data-attribute="card-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-survay': {
          const el = container.querySelector('[data-attribute="card-survay"]');
          // const showSurvay = container.getAttribute('data-show-survay')
          if (el) {
            el.setAttribute('data-show-survay', updatedData[key]);
            el.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'items-survay': {
          const itemsSurvay = updatedData[key];
          const wrapSurvay = container.querySelector('[data-attribute="card-survay"]');
          if (wrapSurvay) {
            wrapSurvay.innerHTML = itemsSurvay
              .map(item => {
                const radius = 40;
                const circumference = 2 * Math.PI * radius;
                const offset = circumference * (1 - item.percent / 100);
                return `
                <div data-attribute="item-survay" class="wrap-survay-item">
                    <div class="left-item" style="color: #d1d5db;">
                        <svg class="size-full" viewBox="0 0 100 100">
                            <circle class="text-gray-300" stroke-width="8" stroke="currentColor" fill="transparent" cx="50" cy="50" r="40"></circle>
                            <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8" fill="transparent" stroke="black" stroke-linecap="butt" transform="rotate(-90 50 50)" stroke-dasharray="${circumference}" stroke-dashoffset="${offset}" />
                        </svg>
                        <div class="wrap-percent"><span data-attribute="percent-survay">${item.percent}</span>%</div>
                    </div>
                    <div data-attribute="description-survay" class="right-item">
                        ${item.description}
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'container-page': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            el.setAttribute('data-show-style', updatedData[key]['show-style']);
            el.setAttribute('data-background', updatedData[key]['background']);
            el.style.backgroundColor = updatedData[key]['show-style'] ? updatedData[key]['background'] : 'transparent';
          }
          break;
        }
        case 'style-center-y': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');

          if (elCardContent) {
            elCardContent.setAttribute('data-style-center-y', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const cardTitle = container.querySelector('[data-attribute="card-title"]');
          const cardDescription = container.querySelector('[data-attribute="card-description"]');
          const ratingText = container.querySelectorAll('[data-attribute="rating-text"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');

          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardTitle) {
            cardTitle.style.color = updatedData[key];
            cardTitle.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardDescription) {
            cardDescription.style.color = updatedData[key];
            cardDescription.setAttribute('data-text-color', updatedData[key]);
          }
          if (ratingText) {
            ratingText.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        case 'accordions': {
          const el = container.querySelector('[data-attribute="card-accordions"]');
          if (el) {
            el.setAttribute('data-show-accordion', updatedData[key]?.show);
            el.style.display = updatedData[key]?.show ? 'block' : 'none';
            el.innerHTML = updatedData[key]?.listItem
              .map(item => {
                return `
                <div data-attribute="card-accordion" class="wrap-accordion">
                  <div data-attribute="accordion-title" class="accordion-title">
                    <div data-attribute="accordion-title-text">${item.title}</div>
                    <div class="accordion-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-chevron-down-icon lucide-chevron-down">
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </div>
                  </div>
                  <div data-attribute="accordion-content" class="accordion-content">
                    <div data-attribute="accordion-text" class="accordion-text">${item.content}</div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionMarqueeTino(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'sectionBackground': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'sectionTitle': {
          const el = container.querySelector('[data-attribute="title"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'sectionDescription': {
          const el = container.querySelector('[data-attribute="description"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'lineStroke': {
          const el = container.querySelector('[data-attribute="line-stroke"]');
          if (el) {
            el.setAttribute('data-enable-line', updatedData[key]?.show);
            el.setAttribute('data-width', updatedData[key]?.width);
            el.setAttribute('data-color', updatedData[key]?.color);
            el.style.backgroundColor = updatedData[key]?.color;
            el.style.width = updatedData[key]?.width + '%';
            el.style.display = updatedData[key]?.show ? 'block' : 'none';
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              ?.map(item => {
                return `
                <div data-attribute="track" class="track">
                  <div class="wrap-item">
                    <div class="wrap-img">
                      <img loading="lazy" data-attribute="image-item"
                        src="${item.image}"
                        alt="">
                    </div>
                    <div class="group-text" data-attribute="text-item">
                      ${item.htmlText}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          const lengthItem = updatedData[key]?.length;
          const elCardContent = container.querySelector('[data-attribute="card-container"]');
          if (lengthItem && elCardContent) {
            elCardContent.style.setProperty('--marquee-duration', `${lengthItem * 12 * 1.38}s`);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionMarqueeImage(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'sectionBackground': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              ?.map(item => {
                return `
                <div data-attribute="track" class="track">
                  <div class="wrap-item">
                    <div class="wrap-img">
                      <img loading="lazy" data-attribute="image-item"
                        src="${item.image}"
                        alt="">
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          const lengthItem = updatedData[key]?.length;
          const elCardContent = container.querySelector('[data-attribute="card-container"]');
          if (lengthItem && elCardContent) {
            elCardContent.style.setProperty('--marquee-duration', `${lengthItem * 12 * 1.38}s`);
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionMarqueeYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    const marqueeIconSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>check-decagram-outline</title>
        <path
          d="M23 12L20.6 9.2L20.9 5.5L17.3 4.7L15.4 1.5L12 3L8.6 1.5L6.7 4.7L3.1 5.5L3.4 9.2L1 12L3.4 14.8L3.1 18.5L6.7 19.3L8.6 22.5L12 21L15.4 22.5L17.3 19.3L20.9 18.5L20.6 14.8L23 12M18.7 16.9L16 17.5L14.6 19.9L12 18.8L9.4 19.9L8 17.5L5.3 16.9L5.5 14.1L3.7 12L5.5 9.9L5.3 7.1L8 6.5L9.4 4.1L12 5.2L14.6 4.1L16 6.5L18.7 7.1L18.5 9.9L20.3 12L18.5 14.1L18.7 16.9M16.6 7.6L18 9L10 17L6 13L7.4 11.6L10 14.2L16.6 7.6Z"
          fill="currentColor" />
      </svg>
    `;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            el.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            el.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'background': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#FFFFFF');
            cardContainer.style.backgroundColor = updatedData[key] || '#FFFFFF';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key] || '#000000');
          }
          break;
        }
        case 'enableContainerPage': {
          if (containerPage) {
            const showContainer = updatedData[key] === true;
            containerPage.setAttribute('data-enable-style', String(showContainer));
            containerPage.style.backgroundColor = showContainer
              ? containerPage.getAttribute('data-background-container') || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'backgroundContainer': {
          if (containerPage) {
            containerPage.setAttribute('data-background-container', updatedData[key] || '#FFFFFF');
            const showContainer = containerPage.getAttribute('data-enable-style') === 'true';
            containerPage.style.backgroundColor = showContainer ? updatedData[key] || '#FFFFFF' : 'transparent';
          }
          break;
        }
        case 'highlightColor': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.setAttribute('data-highlight-color', updatedData[key] || '#cb6387');
            el.style.setProperty('--color-highlight', updatedData[key] || '#cb6387');
          }
          break;
        }
        case 'showTitle': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            el.setAttribute('data-show', updatedData[key]);
            el.style.display = updatedData[key] ? '' : 'none';
          }
          break;
        }
        case 'titleCard': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            // el.setAttribute('data-highlight-color', updatedData[key])
            // el.style.setProperty('--color-highlight', updatedData[key])
            const normalizedItems =
              Array.isArray(updatedData[key]) && updatedData[key].length
                ? updatedData[key]
                : [{ text: 'Overnight Hydration' }];
            el.innerHTML = normalizedItems
              .map(item => {
                return `
                <div data-attribute="wrap-item-marquee" class="wrap-item-marquee">
                  <div class="icon-item">
                    ${marqueeIconSvg}
                  </div>
                  <div data-attribute="content-item" class="content-item">
                    <p>${item?.text || ''}</p>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionTabs(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'containerBackground': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'listTab': {
          const elListTabHeader = container.querySelector('[data-attribute="list-tab-header"]');
          const elListTabContent = container.querySelector('[data-attribute="list-tab-content"]');
          if (elListTabHeader) {
            elListTabHeader.setAttribute('data-color', updatedData.headerColor);
            elListTabHeader.setAttribute('data-position', updatedData.headerPosition);
            elListTabHeader.style.borderColor = updatedData.headerColor;
            elListTabHeader.innerHTML = updatedData[key]
              .map((item, index) => {
                return `
                <div class="tab-header-item ${index === 0 ? 'active' : ''}" data-tab="tab-${index +
                  1}" data-attribute="tab-header-item">${item.title}</div>
              `;
              })
              .join('');
          }
          if (elListTabContent) {
            elListTabContent.innerHTML = updatedData[key]
              .map((item, index) => {
                return `
                <div class="tab-content-item ${index === 0 ? 'active' : ''}" data-tab="tab-${index +
                  1}" data-attribute="tab-content-item">
                  ${item.content}
                </div>
              `;
              })
              .join('');
            break;
          }
          break;
        }
        case 'headerColor': {
          const elContainer = container.querySelector('[data-attribute="wrapper-container"]');
          if (elContainer) {
            elContainer.style.setProperty('--header-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardFeeSizeImg(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'backgroundImage': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-enable-background-image', updatedData[key].enable);
            if (updatedData[key].enable) {
              el.setAttribute('data-background-img', updatedData[key].image);
              el.style.backgroundImage = `url(${updatedData[key].image})`;
            } else {
              el.setAttribute('data-background-img', '');
              el.style.backgroundImage = 'none';
            }
          }
          break;
        }
        case 'overlay': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-overlay-enable', updatedData[key].enable);
            if (updatedData[key].enable) {
              el.style.setProperty('--overlay-color', `rgba(0, 0, 0, ${updatedData[key].opacity})`);
            } else {
              el.style.setProperty('--overlay-color', 'transparent');
            }
          }
          break;
        }
        case 'dataImg': {
          const el = container.querySelector('[data-attribute="wrap-image"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key].order);
            el.style.order = updatedData[key].order;
            el.setAttribute('data-image-enable', updatedData[key].enable);
            el.style.display = updatedData[key].enable ? 'block' : 'none';

            // wrap-text-ct
            const elTextContent = container.querySelector('.wrap-text-ct');
            if (elTextContent) {
              if (updatedData[key].enable) {
                // elTextContent.style.width = 'calc((100% - 30px) / 2)'
              } else {
                elTextContent.style.width = '100%';
              }
            }
          }
          const elImage = container.querySelector('[data-attribute="image"]');
          if (elImage) {
            elImage.setAttribute('src', updatedData[key].image);
          }
          break;
        }
        case 'dataContent': {
          const el = container.querySelector('[data-attribute="card-content"]');
          if (el) {
            el.setAttribute('data-order', updatedData[key].order);
            el.style.order = updatedData[key].order;
            el.innerHTML = updatedData[key].content;
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionTableKubo(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'backgroundImage': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-enable-background-image', updatedData[key].enable);
            if (updatedData[key].enable) {
              el.setAttribute('data-background-img', updatedData[key].image);
              el.style.backgroundImage = `url(${updatedData[key].image})`;
            } else {
              el.setAttribute('data-background-img', '');
              el.style.backgroundImage = 'none';
            }
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'tableKubo': {
          const el = container.querySelector('[data-attribute="table-kubo"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        case 'borderSpacingVertical': {
          const el = container.querySelector('[data-attribute="table-kubo"] table');
          if (el) {
            el.setAttribute('data-border-spacing-vertical', updatedData[key]);
            const borderSpacingHorizontal = el.getAttribute('data-border-spacing-horizontal');
            el.style.borderSpacing = `${updatedData[key]}px ${borderSpacingHorizontal}px`;
          }
          break;
        }
        case 'borderSpacingHorizontal': {
          const el = container.querySelector('[data-attribute="table-kubo"] table');
          if (el) {
            el.setAttribute('data-border-spacing-horizontal', updatedData[key]);
            const borderSpacingVertical = el.getAttribute('data-border-spacing-vertical');
            el.style.borderSpacing = `${borderSpacingVertical}px ${updatedData[key]}px`;
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionItemsGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'backgroundImage': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-enable-background-image', updatedData[key].enable);
            if (updatedData[key].enable) {
              el.setAttribute('data-background-img', updatedData[key].image);
              el.style.backgroundImage = `url(${updatedData[key].image})`;
            } else {
              el.setAttribute('data-background-img', '');
              el.style.backgroundImage = 'none';
            }
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              ?.map(item => {
                return `
                <div data-attribute="item" class="item swiper-slide">
                  <div class="wrap-imge">
                    <img data-attribute="image-item" src="${item.image}" alt="">
                  </div>
                  <div data-attribute="text-item" class="wrap-text">
                  ${item.htmlText}
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'paginationActiveColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-pagination-active-color', updatedData[key]);
            el.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'paginationInactiveColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-pagination-inactive-color', updatedData[key]);
            el.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionItemsGrid02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              ?.map(item => {
                return `
                <div data-attribute="item" class="items-grid-02-item">
                  <div class="items-grid-02-item-image">
                    <img data-attribute="image-item" src="${item.image}" alt="">
                  </div>
                  <div data-attribute="text-item" class="items-grid-02-item-text">
                    ${item.htmlText}
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="wrapper-content"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
            if (updatedData[key]) {
              el.classList.remove('container');
            } else {
              el.classList.add('container');
            }
          }
          break;
        }
        case 'itemsPerRow': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            const itemCount =
              Array.isArray(updatedData.listItem) && updatedData.listItem.length > 0
                ? updatedData.listItem.length
                : el.querySelectorAll('[data-attribute="item"]').length || 1;
            const normalizedMobile = Math.max(1, Math.min(Number(updatedData[key].mobile) || 1, itemCount));
            const normalizedDesktop = Math.max(1, Math.min(Number(updatedData[key].desktop) || 1, itemCount));

            el.setAttribute('data-items-per-row-mobile', normalizedMobile);
            el.setAttribute('data-items-per-row-desktop', normalizedDesktop);
            el.style.setProperty('--items-per-row-mobile', `${normalizedMobile}`);
            el.style.setProperty('--items-per-row-desktop', `${normalizedDesktop}`);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  //hurrybox
  sectionCountdownHurryBox(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'left-in-stock-number': {
          const el = container.querySelector('[data-attribute="left-in-stock-number"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'people-are-viewing-number': {
          const el = container.querySelector('[data-attribute="people-are-viewing-number"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'last-minute-sale-end-in': {
          const el = container.querySelector('[data-attribute="last-minute-sale-end-in"]');
          if (el) {
            el.setAttribute('data-value', updatedData[key]);
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="section-countdown-hurry-box"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="section-countdown-hurry-box"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'sectionPadding': {
          const containerEl = container.querySelector('[data-attribute="section-countdown-hurry-box"]');
          const pad = updatedData[key];
          if (!containerEl || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (attrName, cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            containerEl.setAttribute(attrName, n);
            containerEl.style.setProperty(cssVar, `${n}px`);
          };

          setSide('data-top-desktop-padding', '--padding-top-desktop', pad.topDesktop);
          setSide('data-bottom-desktop-padding', '--padding-bottom-desktop', pad.bottomDesktop);
          setSide('data-top-mobile-padding', '--padding-top-mobile', pad.topMobile);
          setSide('data-bottom-mobile-padding', '--padding-bottom-mobile', pad.bottomMobile);
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionFreestyleHurryBox(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'content': {
          const el = container.querySelector('[data-attribute="content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'sectionPadding': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          const pad = updatedData[key];
          if (!containerEl || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (attrName, cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            containerEl.setAttribute(attrName, n);
            containerEl.style.setProperty(cssVar, `${n}px`);
          };

          setSide('data-top-desktop-padding', '--padding-top-desktop', pad.topDesktop);
          setSide('data-bottom-desktop-padding', '--padding-bottom-desktop', pad.bottomDesktop);
          setSide('data-top-mobile-padding', '--padding-top-mobile', pad.topMobile);
          setSide('data-bottom-mobile-padding', '--padding-bottom-mobile', pad.bottomMobile);
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionHarryboxYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const value = updatedData[key];
            if (typeof value === 'string') {
              el.innerHTML = value;
            } else if (value && typeof value === 'object') {
              // Backward compatible with old payload `{ heading, description }`.
              const heading = value.heading || '';
              const description = value.description || '';
              el.innerHTML = `
                <h2>${heading}</h2>
                <p>${description}</p>
              `;
            }
            const showTitle = updatedData['show-title'];
            if (showTitle === false) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'show-title': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            const isShow = updatedData[key] !== false;
            el.setAttribute('data-show-title', isShow ? 'true' : 'false');
            if (!isShow) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'background-icon': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.setAttribute('data-background-icon', updatedData[key]);
            el.style.setProperty('--background-icon', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'enableContainerPage': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            const enabled = updatedData[key] !== false;
            // Keep both attrs for compatibility with existing CSS/sections.
            el.setAttribute('data-enable-style', enabled ? 'true' : 'false');
          }
          break;
        }
        case 'backgroundContainer': {
          const enableContainerPage = updatedData['enableContainerPage'] !== false;
          const el = container.querySelector('[data-attribute="container-page"]');
          if (enableContainerPage && el) {
            el.setAttribute('data-background-container', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          } else {
            el.style.backgroundColor = 'transparent';
          }
          break;
        }
        case 'listItem': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            const nextItems =
              Array.isArray(updatedData[key]) && updatedData[key].length > 0
                ? updatedData[key]
                : [
                    {
                      iconItem: '',
                      textItem: '',
                    },
                  ];

            listEl.innerHTML = nextItems
              .map(
                item => `
                  <div data-attribute="item" class="wrap-item">
                    <div class="icon-left">
                      <img data-attribute="icon-item" src="${item.iconItem || ''}" alt="">
                    </div>
                    <div data-attribute="text-item" class="text-right-item">
                      ${item.textItem || ''}
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionReviewGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'show-more-text': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-show-more-text', updatedData[key]);
          }
          break;
        }
        case 'show-less-text': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-show-less-text', updatedData[key]);
          }
          break;
        }
        case 'line-clamp': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-line-clamp', updatedData[key]);
          }
          break;
        }
        case 'title-review': {
          const el = container.querySelector('[data-attribute="title-review"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'card-background-color': {
          const cardElements = container.querySelectorAll('[data-attribute="item-review"] .review-card');
          cardElements.forEach(card => {
            card.style.backgroundColor = updatedData[key];
          });
          // Set data attribute for future use
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-card-background-color', updatedData[key]);
          }
          break;
        }
        case 'card-text-color': {
          const cardElements = container.querySelectorAll('[data-attribute="item-review"] .review-card');
          cardElements.forEach(card => {
            card.style.color = updatedData[key];
          });
          // Set data attribute for future use
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-card-text-color', updatedData[key]);
          }
          break;
        }
        case 'title-color': {
          const el = container.querySelector('[data-attribute="title-review"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-title-color', updatedData[key]);
          }
          break;
        }
        case 'button-text-color': {
          const el = container.querySelector('[data-attribute="show-more-btn"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-button-text-color', updatedData[key]);
          }
          break;
        }
        case 'button-background-color': {
          const el = container.querySelector('[data-attribute="show-more-btn"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-button-background-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-active-color': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-pagination-active-color', updatedData[key]);
            el.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-pagination-inactive-color', updatedData[key]);
            el.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'body-review': {
          const bodyReview = container.querySelector('[data-attribute="body-review"]');
          const reviewSlider = bodyReview?.querySelector('.review-slider');
          if (reviewSlider && updatedData[key]) {
            const cardBackgroundColor = updatedData['card-background-color'] || '#f6f6f6';
            reviewSlider.innerHTML = updatedData[key]
              .map(review => {
                const starsSvg = Array(5)
                  .fill(
                    `
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                  </svg>`,
                  )
                  .join('');

                const cardTextColor = updatedData['card-text-color'] || '#000000';
                return `
                  <div data-attribute="item-review" class="item-review swiper-slide">
                    <div class="review-card" style="background-color: ${cardBackgroundColor}; color: ${cardTextColor};">
                      <div class="reviewer-info">
                        <div class="reviewer-avatar">
                          <img loading="lazy" data-attribute="reviewer-avatar" src="${review.avatar}" alt="${
                  review.name
                }" onerror="this.style.display='none'">
                        </div>
                        <div class="reviewer-details">
                          <h3 data-attribute="reviewer-name" class="reviewer-name">${review.name}</h3>
                          <div data-attribute="rating-stars" data-value="${review.rating}" class="wrap-stars">
                            ${starsSvg}
                          </div>
                        </div>
                      </div>
                      <div data-attribute="review-content" class="review-content">
                        ${review.content}
                      </div>
                      <button type="button" data-attribute="show-more-btn" class="show-more-btn"
                        style="background-color: ${updatedData['button-background-color'] ||
                          '#000000'}; color: ${updatedData['button-text-color'] || '#ffffff'};"
                        data-button-background-color="${updatedData['button-background-color'] || '#000000'}"
                        data-button-text-color="${updatedData['button-text-color'] || '#ffffff'}">${updatedData[
                  'show-more-text'
                ] || 'Show more'}</button>
                    </div>
                  </div>`;
              })
              .join('');
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionReviewGrid02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-review': {
          const el = container.querySelector('[data-attribute="title-review"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'card-background-color': {
          const cardElements = container.querySelectorAll('[data-attribute="item-review"] .review-card');
          cardElements.forEach(card => {
            card.style.backgroundColor = updatedData[key];
          });
          // Set data attribute for future use
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-card-background-color', updatedData[key]);
          }
          break;
        }
        case 'card-text-color': {
          const cardElements = container.querySelectorAll('[data-attribute="item-review"] .review-card');
          cardElements.forEach(card => {
            card.style.color = updatedData[key];
          });
          // Set data attribute for future use
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-card-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'body-review': {
          const bodyReview = container.querySelector('[data-attribute="body-review"]');
          const reviewSlider = bodyReview?.querySelector('.review-slider');
          if (reviewSlider && updatedData[key]) {
            const cardBackgroundColor = updatedData['card-background-color'] || '#FFFFFF';
            reviewSlider.innerHTML = updatedData[key]
              .map(review => {
                const starsSvg = Array(5)
                  .fill(
                    `
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                  </svg>`,
                  )
                  .join('');

                const cardTextColor = updatedData['card-text-color'] || '#000000';
                return `
                  <div data-attribute="item-review" class="item-review swiper-slide">
                    <div class="review-card" style="background-color: ${cardBackgroundColor}; color: ${cardTextColor};">
                      <div class="reviewer-avatar">
                        <img loading="lazy" data-attribute="reviewer-avatar" src="${review.avatar}" alt="${review.name}" onerror="this.style.display='none'">
                      </div>
                      <h3 data-attribute="reviewer-name" class="reviewer-name">${review.name}</h3>
                      <div data-attribute="review-content" class="review-content">
                        ${review.content}
                      </div>
                      <div data-attribute="rating-stars" data-value="${review.rating}" class="wrap-stars">
                        ${starsSvg}
                      </div>
                    </div>
                  </div>`;
              })
              .join('');
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionProductReviews(htmlString, updatedData, templateType) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const defaultDataByType = {
      [sectionType.sectionProductReviews]: {
        buttonLabel: 'Load more',
        limit: 5,
        loadMoreBackground: '#000000',
        loadMoreTextColor: '#ffffff',
        buttonBorderColor: '#000000',
        buttonBorderRadius: 8,
      },
      [sectionType.sectionProductReviews02]: {
        buttonLabel: 'Show more reviews',
        limit: 6,
        loadMoreBackground: '#000000',
        loadMoreTextColor: '#ffffff',
        buttonBorderColor: '#000000',
        buttonBorderRadius: 0,
      },
      [sectionType.sectionProductReviews03]: {
        buttonLabel: 'Show more reviews',
        limit: 6,
        loadMoreBackground: '#000000',
        loadMoreTextColor: '#ffffff',
        buttonBorderColor: '#000000',
        buttonBorderRadius: 8,
      },
      [sectionType.sectionProductReviews04]: {
        buttonLabel: 'Show more reviews',
        limit: 5,
        loadMoreBackground: '#ffffff',
        loadMoreTextColor: '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 0,
      },
      [sectionType.sectionProductReviews05]: {
        buttonLabel: 'Show more reviews',
        limit: 8,
        loadMoreBackground: '#ffffff',
        loadMoreTextColor: '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 0,
      },
      [sectionType.sectionProductReviews06]: {
        buttonLabel: 'Load more',
        limit: 8,
        loadMoreBackground: '#ffffff',
        loadMoreTextColor: '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
      },
      [sectionType.sectionFastvaluedealReviews]: {
        buttonLabel: 'Load more',
        limit: 10,
        loadMoreBackground: '#ffffff',
        loadMoreTextColor: '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 0,
      },
      [sectionType.sectionGatorzReviews]: {
        buttonLabel: 'Load more',
        limit: 8,
        loadMoreBackground: '#ffffff',
        loadMoreTextColor: '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
      },
      [sectionType.sectionSaintbrandReviews]: {
        buttonLabel: 'Load more',
        limit: 8,
        loadMoreBackground: '#ffffff',
        loadMoreTextColor: '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
      },
      [sectionType.sectionLosaprilyReviews]: {
        buttonLabel: 'Load more',
        limit: 10,
        loadMoreBackground: '#ffffff',
        loadMoreTextColor: '#000000',
        buttonBorderColor: '#d9d9d9',
        buttonBorderRadius: 4,
      },
    };

    // Progress bar for sectionProductReviews
    const updateProgressBar = (recommendCount, totalReviews) => {
      if (templateType !== sectionType.sectionProductReviews) return;
      const progressBarElement = container.querySelector('.progress-bar-value');
      if (progressBarElement) {
        if (totalReviews > 0) {
          let percentage = (recommendCount / totalReviews) * 100;
          if (percentage > 100) {
            percentage = 100;
          }
          progressBarElement.style.width = percentage.toFixed(2) + '%';
        } else {
          progressBarElement.style.width = '0%';
        }
      }
    };

    // Generate star SVG HTML
    const generateStarSvg = () => {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
              </svg>`;
    };

    // Overview stars for sectionProductReviews, sectionProductReviews02, sectionProductReviews05
    const updateOverviewStars = averageRating => {
      if (
        templateType !== sectionType.sectionProductReviews &&
        templateType !== sectionType.sectionProductReviews02 &&
        templateType !== sectionType.sectionProductReviews05 &&
        templateType !== sectionType.sectionFastvaluedealReviews &&
        templateType !== sectionType.sectionProductReviews06 &&
        templateType !== sectionType.sectionGatorzReviews &&
        templateType !== sectionType.sectionSaintbrandReviews &&
        templateType !== sectionType.sectionLosaprilyReviews
      )
        return;
      const overviewStarsElements = container.querySelectorAll('.wrap-stars');
      overviewStarsElements.forEach(element => {
        const rating = parseFloat(averageRating);
        const floorRating = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.1;

        element.setAttribute('data-full-stars', floorRating.toString());
        if (hasHalfStar && floorRating < 5) {
          element.setAttribute('data-half-star', (floorRating + 1).toString());
        } else {
          element.removeAttribute('data-half-star');
        }

        const starsSvg = Array(5)
          .fill(generateStarSvg())
          .join('');
        const starsHtml = `
          <svg style="width:0;height:0;position:absolute;">
            <defs>
              <linearGradient id="half-star-gradient-overview">
                <stop offset="50%" style="stop-color:var(--star-color, #f0b100);stop-opacity:1" />
                <stop offset="50%" style="stop-color:var(--star-color, #f0b100);stop-opacity:0" />
              </linearGradient>
            </defs>
          </svg>
          ${starsSvg}
        `;
        element.innerHTML = starsHtml;
      });
    };

    // Update rate distribution (only sectionProductReviews06)
    const updateRateDistribution = totalReviews => {
      const sectionTypesWithRateDistribution = [
        sectionType.sectionProductReviews06,
        sectionType.sectionGatorzReviews,
        sectionType.sectionSaintbrandReviews,
        sectionType.sectionLosaprilyReviews,
        sectionType.sectionFastvaluedealReviews,
      ];
      if (!sectionTypesWithRateDistribution.includes(templateType)) return;

      const total = parseInt(totalReviews) || 0;
      const rateItems = container.querySelectorAll('.rate-item[data-rate-value]');
      if (!rateItems || !rateItems.length) return;

      const dist = updatedData['rate-distribution'] || {};
      rateItems.forEach(item => {
        const rateValue = parseInt(item.getAttribute('data-rate-value'), 10);
        if (!rateValue || rateValue < 1 || rateValue > 5) return;

        const countKey = `rate-${rateValue}`;
        const count = parseInt(dist[countKey]) || 0;

        const countEl = item.querySelector('.rate-count');
        if (countEl) countEl.textContent = String(count);

        const fillEl = item.querySelector('.rate-bar-fill');
        if (fillEl) {
          const pct = total > 0 ? Math.min((count / total) * 100, 100) : 0;
          fillEl.style.width = pct.toFixed(2) + '%';
        }
      });
    };

    const sectionTypesWithSlides = [sectionType.sectionGatorzReviews];

    const getReviewsSlidesContainer = () => {
      if (sectionTypesWithSlides.includes(templateType)) {
        return container.querySelector('.reviews-swiper-wrapper');
      }
      return container.querySelector('.reviews-container');
    };

    const formatReviewItemHtml = (reviewHtml, shouldHide) => {
      const cardBackground = updatedData['card-background'] || '#ffffff';
      const cardTextColor = updatedData['card-text-color'] || '#000000';

      if (sectionTypesWithSlides.includes(templateType)) {
        return reviewHtml.replace(
          '<div class="review-item"',
          `<div class="review-item swiper-slide" style="background-color: ${cardBackground}; color: ${cardTextColor};"`,
        );
      }

      if (shouldHide) {
        return reviewHtml.replace(
          '<div class="review-item"',
          `<div class="review-item" style="display: none; background-color: ${cardBackground}; color: ${cardTextColor};"`,
        );
      }

      return reviewHtml;
    };

    const generateReviewItemHtml = (reviewData, index) => {
      // Temporarily hide time
      const review = {
        ...reviewData,
        date: '',
      };
      const reviewRating = parseFloat(review.star) || 5;
      const floorRating = Math.floor(reviewRating);
      const hasHalfStar = reviewRating % 1 >= 0.1;

      const fullStarsAttr = `data-full-stars="${floorRating}"`;
      const halfStarAttr = hasHalfStar && floorRating < 5 ? `data-half-star="${floorRating + 1}"` : '';

      const starsHtml = Array(5)
        .fill(generateStarSvg())
        .join('');
      const productData = updatedData.product || {};
      const productImage =
        productData.image ||
        replaceImageUrl(
          'https://cdn.skyfastimg.com/images/2026/03/13/image-69b38e94b99ca90a851b6bd6.avif?w=50&h=50&q=80',
        );
      const productTitle = productData.title || 'Reviewing';
      const productName = productData.name || 'Product Name';
      const productEnabled = productData.enabled !== false;
      const productContainerStyle = productEnabled ? '' : 'display: none;';

      // Generate review images HTML
      const reviewImagesHtml =
        review.images && review.images.length > 0
          ? `
          <div class='review-images' data-attribute="review-images">
            <div class='review-images-grid'>
              ${review.images
                .map(
                  (image, idx) => `
                <div class='review-image-item' ${index !== undefined ? `data-index="${idx}"` : ''}>
                  <img src="${image.src}" alt="${image.alt || ''}" />
                </div>
              `,
                )
                .join('')}
            </div>
          </div>
        `
          : '<div class=\'review-images\' data-attribute="review-images" style="display: none;"></div>';

      let reviewItemHtml = ``;
      switch (templateType) {
        case sectionType.sectionProductReviews:
          reviewItemHtml = `
            <div class="review-item" style="background-color: ${updatedData['card-background'] ||
              '#ffffff'}; color: ${updatedData['card-text-color'] || '#000000'};">
              <div class='review-content-container'>
                <div class='reviewer-header'>
                  <div class='reviewer-avatar'>
                    <img loading="lazy" data-attribute="product-reviewer-avatar" src="${
                      review.avatar
                    }" alt="" onerror="this.style.display='none'">
                  </div>
                  <div class='reviewer-info'>
                    <div class='reviewer-details'>
                      <h3 class='reviewer-name'>${review.fullName}</h3>
                      <div class='verified-purchase'>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#00c75a"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          >
                          <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
                          <path d="m9 12 2 2 4-4"></path>
                        </svg>
                        <p>Verified Purchase</p>
                      </div>
                    </div>
                    <p class='review-date'>${review.date}</p>
                  </div>
                </div>
                <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                  ${starsHtml}
                </div>
                <p class='review-title'>${review.title}</p>
                <div class='review-content'>${review.content}</div>
              </div>
              ${reviewImagesHtml}
            </div>
          `;
          break;
        case sectionType.sectionProductReviews02:
          reviewItemHtml = `
            <div class="review-item" style="background-color: ${updatedData['card-background'] ||
              '#ffffff'}; color: ${updatedData['card-text-color'] || '#000000'};">
              <div class='review-content-container'>
                <div class='reviewer-header'>
                  <div class='reviewer-info'>
                    <div class='reviewer-details'>
                      <h3 class='reviewer-name'>${review.fullName}</h3>
                      <div class='verified-purchase'>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#00c75a"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          >
                          <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"></path>
                          <path d="m9 12 2 2 4-4"></path>
                        </svg>
                        <p>Verified Purchase</p>
                      </div>
                    </div>
                    <p class='review-date'>${review.date}</p>
                  </div>
                </div>
                <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                  ${starsHtml}
                </div>
                <p class='review-title'>${review.title}</p>
                <div class='review-content'>${review.content}</div>
              </div>
              ${reviewImagesHtml}
            </div>
          `;
          break;
        case sectionType.sectionProductReviews03:
          reviewItemHtml = `
            <div class="review-item" style="background-color: ${updatedData['card-background'] ||
              '#ffffff'}; color: ${updatedData['card-text-color'] || '#000000'};">
              <div class='review-content-container'>
                <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                  ${starsHtml}
                </div>
                <p class='review-title'>${review.title}</p>
                <div class='review-content'>${review.content}</div>
              </div>
              ${reviewImagesHtml}
            </div>
          `;
          break;
        case sectionType.sectionProductReviews04:
          reviewItemHtml = `
            <div
              class="review-item"
              style="background-color: ${updatedData['card-background'] || '#ffffff'}; color: ${updatedData[
            'card-text-color'
          ] || '#000000'};"
            >
              <div class="review-content-container">
                <div class="review-left">
                  <h3 class="reviewer-name">${review.fullName}</h3>
                  <div class="verified-purchase">
                    <img
                      class="review-verified-purchase-image"
                      src="${replaceImageUrl(
                        'https://cdn.skyfastimg.com/images/2026/03/13/image-69b38e6f3a3c142e3462c8ab.avif?w=50&h=50&q=80',
                      )}"
                      alt="image"
                    />
                    <p class="review-verified-purchase-text">Verified Customer</p>
                  </div>
                  <div class="review-separator"></div>
                  <div
                    class="review-product-container"
                    data-attribute="review-product-container"
                    data-product-enabled="${productEnabled}"
                    style="${productContainerStyle}"
                  >
                    <img
                      class="review-product-image"
                      data-attribute="review-product-image"
                      src="${productImage}"
                      alt="product"
                    />
                    <div class="review-product-info">
                      <p class="review-product-info-title" data-attribute="review-product-info-title">${productTitle}</p>
                      <p class="review-product-info-name" data-attribute="review-product-info-name">${productName}</p>
                    </div>
                  </div>
                  <div class="review-recommend-container">
                    <img
                      class="review-recommend-image"
                      src="${replaceImageUrl(
                        'https://cdn.skyfastimg.com/images/2026/03/13/image-69b38e80d8d5f52f387f41ff.avif?w=50&h=50&q=80',
                      )}"
                      alt="image"
                    />
                    <p class="review-recommend-text">I recommend this product</p>
                  </div>
                </div>
                <div class="review-right">
                  <div class="review-rating-container">
                    <div
                      class="review-rating"
                      data-value="${review.star}"
                      ${fullStarsAttr}
                      ${halfStarAttr}
                    >
                      ${starsHtml}
                    </div>
                    <p class='review-date'>${review.date}</p>
                  </div>
                  <p class="review-title">${review.title}</p>
                  <div class="review-content">${review.content}</div>
                  ${reviewImagesHtml}
                </div>
              </div>
            </div>
          `;
          break;
        case sectionType.sectionProductReviews05:
          reviewItemHtml = `
            <div
              class="review-item"
              style="
                background-color: ${updatedData['card-background'] || '#ffffff'};
                color: ${updatedData['card-text-color'] || '#000000'};
              "
            >
              <div class='review-content-container'>
                <div class='reviewer-header'>
                  <div class='reviewer-info'>
                    <div class='reviewer-details'>
                      <h3 class='reviewer-name'>${review.fullName}</h3>
                      <div class='verified-purchase'>
                        <svg
                          width="100"
                          height="100"
                          viewBox="0 0 100 100"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M49.9999 91.6667C73.0116 91.6667 91.6666 73.0117 91.6666 50C91.6666 26.9881 73.0116 8.33334 49.9999 8.33334C26.988 8.33334 8.33325 26.9881 8.33325 50C8.33325 73.0117 26.988 91.6667 49.9999 91.6667ZM42.6774 60.0592L72.1403 30.5965L78.0328 36.489L42.6774 71.8442L24.9999 54.1667L30.8925 48.2742L42.6774 60.0592Z"
                            fill="black"
                          />
                        </svg>
                        <p>Verified</p>
                      </div>
                    </div>
                    <p class='review-date'>${review.date}</p>
                  </div>
                </div>
                <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                  ${starsHtml}
                </div>
                <p class='review-title'>${review.title}</p>
                <div class='review-content'>${review.content}</div>
              </div>
              ${reviewImagesHtml}
            </div>
          `;
          break;
        case sectionType.sectionProductReviews06:
          reviewItemHtml = `
            <div class="review-item" style="background-color: ${updatedData['card-background'] ||
              '#ffffff'}; color: ${updatedData['card-text-color'] || '#000000'};">
              <div class='review-content-container'>
                <div class='reviewer-header'>
                  <div class='reviewer-avatar'>
                    <img loading="lazy" data-attribute="product-reviewer-avatar" src="${
                      review.avatar
                    }" alt="" onerror="this.style.display='none'">
                  </div>
                  <div class='reviewer-info'>
                    <div class='reviewer-details'>
                      <h3 class='reviewer-name'>${review.fullName}</h3>
                      <div class='verified-purchase'>
                        <svg
                          width="100"
                          height="100"
                          viewBox="0 0 100 100"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M49.9999 91.6667C73.0116 91.6667 91.6666 73.0117 91.6666 50C91.6666 26.9881 73.0116 8.33334 49.9999 8.33334C26.988 8.33334 8.33325 26.9881 8.33325 50C8.33325 73.0117 26.988 91.6667 49.9999 91.6667ZM42.6774 60.0592L72.1403 30.5965L78.0328 36.489L42.6774 71.8442L24.9999 54.1667L30.8925 48.2742L42.6774 60.0592Z"
                            fill="black"
                          />
                        </svg>
                      </div>
                    </div>
                    <p class='review-date'>${review.date}</p>
                  </div>
                </div>
                <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                  ${starsHtml}
                </div>
                <p class='review-title'>${review.title}</p>
                <div class='review-content'>${review.content}</div>
              </div>
              ${reviewImagesHtml}
              <div class="review-helpful-container">
                <div class="review-helpful-title">Is this helpful?</div>
                <div class="review-helpful-items">
                  <div class="review-helpful-item" data-attribute="like-btn">
                    <span class="review-helpful-item-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-thumbs-up-icon lucide-thumbs-up">
                        <path
                          d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                        <path d="M7 10v12" />
                      </svg>
                    </span>
                    <span class="review-helpful-item-count">0</span>
                  </div>
                  <div class="review-helpful-item" data-attribute="dislike-btn">
                    <span class="review-helpful-item-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-thumbs-down-icon lucide-thumbs-down">
                        <path
                          d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                        <path d="M17 14V2" />
                      </svg>
                    </span>
                    <span class="review-helpful-item-count">0</span>
                  </div>
                </div>
              </div>
            </div>
          `;
          break;
        case sectionType.sectionFastvaluedealReviews:
          reviewItemHtml = `
              <div
                class="review-item"
                style="
                  background-color: ${updatedData['card-background'] || '#ffffff'};
                  color: ${updatedData['card-text-color'] || '#000000'};
                "
              >
                <div class='review-content-container'>
                  <div class='reviewer-header'>
                    <div class='reviewer-info'>
                      <div class='reviewer-details'>
                        <h3 class='reviewer-name'>${review.fullName}</h3>
                        <div class='verified-purchase'>
                          <svg
                            height="16"
                            viewBox="0 0 48 48"
                            width="48"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M0 0h48v48H0z" fill="none"></path>
                            <path
                              fill="green"
                              d="M24 2L6 10v12c0 11.11 7.67 21.47 18 24 10.33-2.53 18-12.89 18-24V10L24 2zm-4 32l-8-8 2.83-2.83L20 28.34l13.17-13.17L36 18 20 34z"
                            ></path>
                          </svg>
                        </div>
                      </div>
                      <p class='review-date'>${review.date}</p>
                    </div>
                  </div>
                  <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                    ${starsHtml}
                  </div>
                  <p class='review-title'>${review.title}</p>
                  <div class='review-content'>${review.content}</div>
                </div>
                ${reviewImagesHtml}
              </div>
            `;
          break;
        case sectionType.sectionGatorzReviews:
          reviewItemHtml = `
              <div class="review-item" style="background-color: ${updatedData['card-background'] ||
                '#ffffff'}; color: ${updatedData['card-text-color'] || '#000000'};">
                <div class='review-content-container'>
                  <div class="review-rating-date-container">
                    <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                      ${starsHtml}
                    </div>
                    <p class='review-date'>${review.date}</p>
                  </div>

                  <div class='reviewer-header'>
                    <div class='reviewer-info'>
                      <div class='reviewer-details'>
                        <h3 class='reviewer-name'>${review.fullName}</h3>
                        <div class='verified-purchase'>
                          Verified Buyer
                        </div>
                      </div>
                      <div class='reviewer-location'>
                        <div class='reviewer-location-flag'>
                          <img src="${replaceImageUrl('https://cdn.stamped.io/cdn/flags/us.svg')}" alt="image" />
                        </div>
                        <div class='reviewer-location-text'>United States</div>
                      </div>
                    </div>
                  </div>
                  <p class='review-title'>${review.title}</p>
                  <div class='review-content'>${review.content}</div>
                </div>
                ${reviewImagesHtml}
                <div class="review-helpful-container">
                  <div class="review-helpful-title">Was this helpful?</div>
                  <div class="review-helpful-items">
                    <div class="review-helpful-item" data-attribute="like-btn">
                      <span class="review-helpful-item-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-thumbs-up-icon lucide-thumbs-up">
                          <path
                            d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                          <path d="M7 10v12" />
                        </svg>
                      </span>
                      <span class="review-helpful-item-count">0</span>
                    </div>
                    <div class="review-helpful-item" data-attribute="dislike-btn">
                      <span class="review-helpful-item-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-thumbs-down-icon lucide-thumbs-down">
                          <path
                            d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z" />
                          <path d="M17 14V2" />
                        </svg>
                      </span>
                      <span class="review-helpful-item-count">0</span>
                    </div>
                  </div>
                </div>
              </div>
            `;
          break;
        case sectionType.sectionSaintbrandReviews:
          reviewItemHtml = `
              <div class="review-item" style="background-color: ${updatedData['card-background'] ||
                '#ffffff'}; color: ${updatedData['card-text-color'] || '#000000'};">
                <div class='review-content-container'>
                  <div class="review-rating" data-value="${review.star}" ${fullStarsAttr} ${halfStarAttr}>
                    ${starsHtml}
                  </div>
                  <div class="reviewer-name-verified-purchase-container">
                    <h3 class='reviewer-name'>${review.fullName}</h3>
                    <img
                      class="review-verified-purchase-image"
                      src="${replaceImageUrl(
                        'https://cdn.skyfastimg.com/images/2026/03/13/image-69b38e6f3a3c142e3462c8ab.avif?w=50&h=50&q=80',
                      )}"
                      alt="image"
                    />
                  </div>
                  <p class='review-title'>${review.title}</p>
                  <div class='review-content'>${review.content}</div>
                </div>
                ${reviewImagesHtml}
              </div>
            `;
          break;
        case sectionType.sectionLosaprilyReviews:
          reviewItemHtml = `
              <div class="review-item" style="background-color: ${updatedData['card-background'] ||
                '#ffffff'}; color: ${updatedData['card-text-color'] || '#000000'};">
                <div class="review-content-container">
                  <div
                    class="review-rating"
                    data-value="${review.star}"
                    ${fullStarsAttr}
                    ${halfStarAttr}
                  >
                    ${starsHtml}
                  </div>
                  <h3 class="reviewer-name">${review.fullName}</h3>
                  <div class="verified-purchase">
                    <svg
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M49.9999 91.6667C73.0116 91.6667 91.6666 73.0117 91.6666 50C91.6666 26.9881 73.0116 8.33334 49.9999 8.33334C26.988 8.33334 8.33325 26.9881 8.33325 50C8.33325 73.0117 26.988 91.6667 49.9999 91.6667ZM42.6774 60.0592L72.1403 30.5965L78.0328 36.489L42.6774 71.8442L24.9999 54.1667L30.8925 48.2742L42.6774 60.0592Z"
                        fill="black"
                      />
                    </svg>
                    <p>Verified purchase</p>
                  </div>
                  <p class="review-title">${review.title}</p>
                  <div class="review-content">${review.content}</div>
                </div>
                ${reviewImagesHtml}
              </div>
            `;
          break;
        default:
          break;
      }
      return reviewItemHtml;
    };

    const generateLoadMoreButton = limit => {
      const loadMoreLabel =
        updatedData['load-more-label'] || defaultDataByType[templateType]?.buttonLabel || 'Show more reviews';
      const loadMoreBackground =
        updatedData['load-more-background'] || defaultDataByType[templateType]?.loadMoreBackground || '#000000';
      const loadMoreTextColor =
        updatedData['load-more-text-color'] || defaultDataByType[templateType]?.loadMoreTextColor || '#ffffff';
      const buttonBorderColor =
        updatedData['buttonBorderColor'] || defaultDataByType[templateType]?.buttonBorderColor || '#000000';
      const buttonBorderRadius =
        updatedData['buttonBorderRadius'] || defaultDataByType[templateType]?.buttonBorderRadius;

      const style = `
        background-color: ${loadMoreBackground};
        color: ${loadMoreTextColor};
        ${defaultDataByType[templateType]?.style || ''};
        border: 1px solid ${buttonBorderColor};
        border-radius: ${buttonBorderRadius}px;
        `;

      return `
        <div class="load-more-container" style="text-align: center;">
          <button
            class="load-more-btn"
            type="button"
            data-attribute="load-more-btn"
            data-limit="${limit}"
            style="${style}"
          >
            ${loadMoreLabel}
          </button>
        </div>
      `;
    };

    // Update data attributes and styles
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-review': {
          const el = container.querySelector('[data-attribute="review-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
            el.setAttribute('data-title-review', updatedData[key]);
          }
          break;
        }
        case 'show-title-underline': {
          const el = container.querySelector('[data-attribute="review-title"]');
          if (el) {
            el.setAttribute('data-show-title-underline', updatedData[key]);
          }
          break;
        }
        case 'recommend-count': {
          const el = container.querySelector('.recommendation-score');
          if (el) {
            el.textContent = updatedData[key];
            el.setAttribute('data-recommend-count', updatedData[key]);

            // Recalculate progress bar after updating recommend count
            const reviewersCountElements = container.querySelectorAll('.reviewers-count');
            reviewersCountElements.forEach(element => {
              const recommendCount = parseInt(updatedData[key]) || 0;
              const totalReviews = parseInt(element.textContent) || 0;
              updateProgressBar(recommendCount, totalReviews);
            });
          }
          break;
        }
        case 'container-background': {
          const dataEl = container.querySelector('[data-attribute="product-reviews-container"]');
          if (dataEl) {
            dataEl.style.backgroundColor = updatedData[key];
            dataEl.setAttribute('data-container-background', updatedData[key]);
          }
          break;
        }
        case 'card-background': {
          const reviewItems = container.querySelectorAll('.review-item');
          reviewItems.forEach(item => {
            item.style.backgroundColor = updatedData[key];
            item.style.color = updatedData['card-text-color'];
            item.setAttribute('data-card-background', updatedData[key]);
          });
          const productReviewsWrapper = container.querySelector('.product-reviews-wrapper');
          if (productReviewsWrapper) {
            productReviewsWrapper.setAttribute('data-card-background', updatedData[key]);
          }

          const reviewOverview = container.querySelector('.review-overview');
          if (reviewOverview) {
            reviewOverview.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'card-text-color': {
          const reviewItems = container.querySelectorAll('.review-item');
          const recommendationIcon = container.querySelector('.recommendation-icon > svg');
          const progressBarValue = container.querySelector('.progress-bar-value');

          if (recommendationIcon) {
            recommendationIcon.style.stroke = updatedData[key];
          }

          if (progressBarValue) {
            progressBarValue.style.backgroundColor = updatedData[key];
          }

          reviewItems.forEach(item => {
            item.style.color = updatedData[key];
          });
          const productReviewsWrapper = container.querySelector('.product-reviews-wrapper');
          if (productReviewsWrapper) {
            productReviewsWrapper.setAttribute('data-card-text-color', updatedData[key]);
          }
          break;
        }
        case 'load-more-label': {
          const loadMoreBtn = container.querySelector('[data-attribute="load-more-btn"]');
          if (loadMoreBtn) {
            loadMoreBtn.textContent = updatedData[key];
          }
          break;
        }
        case 'load-more-background': {
          const loadMoreBtn = container.querySelector('[data-attribute="load-more-btn"]');
          if (loadMoreBtn) {
            loadMoreBtn.style.backgroundColor = updatedData[key];
            loadMoreBtn.setAttribute('data-load-more-background', updatedData[key]);
          }
          break;
        }
        case 'load-more-text-color': {
          const loadMoreBtn = container.querySelector('[data-attribute="load-more-btn"]');
          if (loadMoreBtn) {
            loadMoreBtn.style.color = updatedData[key];
            loadMoreBtn.setAttribute('data-load-more-text-color', updatedData[key]);
          }
          break;
        }
        case 'buttonBorderColor': {
          const loadMoreBtn = container.querySelector('[data-attribute="load-more-btn"]');
          if (loadMoreBtn) {
            loadMoreBtn.style.borderColor = updatedData[key];
            loadMoreBtn.setAttribute('data-button-border-color', updatedData[key]);
          }
          break;
        }
        case 'buttonBorderRadius': {
          const loadMoreBtn = container.querySelector('[data-attribute="load-more-btn"]');
          if (loadMoreBtn) {
            loadMoreBtn.style.borderRadius = updatedData[key] + 'px';
            loadMoreBtn.setAttribute('data-button-border-radius', updatedData[key]);
          }
          break;
        }
        case 'reviews-limit': {
          const loadMoreBtn = container.querySelector('[data-attribute="load-more-btn"]');
          if (loadMoreBtn) {
            loadMoreBtn.setAttribute('data-limit', updatedData[key]);
          }
          break;
        }
        case 'total-reviewers': {
          const els = container.querySelectorAll('.reviewers-count');
          els.forEach(element => {
            element.textContent = updatedData[key];
            element.setAttribute('data-total-reviewers', updatedData[key]);
          });

          const recommendationScoreElement = container.querySelector('.recommendation-score');
          if (recommendationScoreElement) {
            const recommendCount = parseInt(recommendationScoreElement.textContent) || 0;
            const totalReviews = parseInt(updatedData[key]) || 0;
            updateProgressBar(recommendCount, totalReviews);
          }
          // Update rate bar distribution when total changes (section 06)
          updateRateDistribution(updatedData[key]);
          break;
        }
        case 'rate-distribution': {
          const total =
            parseInt(updatedData['total-reviewers']) ||
            parseInt(container.querySelector('.reviewers-count')?.textContent) ||
            0;
          updateRateDistribution(total);
          break;
        }
        case 'average-rating': {
          const els = container.querySelectorAll('.rating-score');
          els.forEach(element => {
            element.textContent = updatedData[key];
            element.setAttribute('data-average-rating', updatedData[key]);
          });
          break;
        }
        case 'imported-reviews': {
          const reviewsSlidesContainer = getReviewsSlidesContainer();
          const reviewsList = container.querySelector('.reviews-list');
          const loadMoreBtn = reviewsList?.querySelector('.load-more-btn');

          if (reviewsList && reviewsSlidesContainer && updatedData[key]) {
            // if total-reviewers, average-rating enter from user, calculate average rating and total reviewers
            const totalReviewers = updatedData[key].length;

            const reviewsData = [...updatedData[key]];

            const limit = updatedData['reviews-limit'] || defaultDataByType[templateType]?.limit || 5;
            const hasMore = !sectionTypesWithSlides.includes(templateType) && reviewsData.length > limit;

            reviewsSlidesContainer.innerHTML = reviewsData
              .map((review, index) => {
                const shouldHide = !sectionTypesWithSlides.includes(templateType) && index >= limit;
                return formatReviewItemHtml(generateReviewItemHtml(review, index), shouldHide);
              })
              .join('');

            if (hasMore && !loadMoreBtn) {
              reviewsList.innerHTML += generateLoadMoreButton(limit);
            }

            const recommendationScoreElement = container.querySelector('.recommendation-score');
            if (recommendationScoreElement) {
              const recommendCount = parseInt(recommendationScoreElement.textContent) || 0;
              updateProgressBar(recommendCount, totalReviewers);
            }
          }
          break;
        }
        case 'add-more-info-when-create': {
          const addMoreInfoWhenCreate = updatedData['add-more-info-when-create'];
          const averageRating = parseFloat(addMoreInfoWhenCreate.averageRating) || 5.0;
          const totalReviews = parseInt(addMoreInfoWhenCreate.totalReviews) || 10;
          const recommendCount = parseInt(addMoreInfoWhenCreate.recommendCount) || 0;

          const ratingScoreElement = container.querySelector('.rating-score');
          const totalReviewsElement = container.querySelector('.reviewers-count');
          const recommendCountElement = container.querySelector('.recommendation-score');

          if (ratingScoreElement) {
            ratingScoreElement.textContent = averageRating;
            ratingScoreElement.setAttribute('data-average-rating', averageRating);
          }
          if (totalReviewsElement) {
            totalReviewsElement.textContent = totalReviews;
            totalReviewsElement.setAttribute('data-total-reviewers', totalReviews);
          }
          if (recommendCountElement) {
            recommendCountElement.textContent = recommendCount;
            recommendCountElement.setAttribute('data-recommend-count', recommendCount);
          }

          updateProgressBar(recommendCount, totalReviews);
          updateOverviewStars(averageRating);

          break;
        }
        case 'body-reviews': {
          const reviewsSlidesContainer = getReviewsSlidesContainer();
          const reviewsList = container.querySelector('.reviews-list');
          const loadMoreBtn = reviewsList?.querySelector('.load-more-btn');

          if (reviewsList && reviewsSlidesContainer && updatedData[key]) {
            // if total-reviewers, average-rating enter from user, calculate average rating and total reviewers
            const totalReviewers = parseInt(updatedData['total-reviewers']) || 10;
            const averageRating = parseFloat(updatedData['average-rating']) || 5.0;

            updateOverviewStars(averageRating);

            const reviewsData = [...updatedData[key]];
            const limit = updatedData['reviews-limit'] || defaultDataByType[templateType]?.limit || 5;
            const hasMore = !sectionTypesWithSlides.includes(templateType) && reviewsData.length > limit;

            reviewsSlidesContainer.innerHTML = reviewsData
              .map((review, index) => {
                const shouldHide = !sectionTypesWithSlides.includes(templateType) && index >= limit;
                return formatReviewItemHtml(generateReviewItemHtml(review, index), shouldHide);
              })
              .join('');

            if (hasMore && !loadMoreBtn) {
              reviewsList.innerHTML += generateLoadMoreButton(limit);
            }

            const recommendationScoreElement = container.querySelector('.recommendation-score');
            if (recommendationScoreElement) {
              const recommendCount = parseInt(recommendationScoreElement.textContent) || 0;
              updateProgressBar(recommendCount, totalReviewers);
            }
          }
          break;
        }
        case 'product': {
          if (templateType !== sectionType.sectionProductReviews04 || !updatedData[key]) {
            break;
          }
          const productData = updatedData[key] || {};
          const productEnabled = productData.enabled !== false;
          const productContainers = container.querySelectorAll(
            '[data-attribute="review-product-container"], .review-product-container',
          );
          const productImages = container.querySelectorAll(
            '[data-attribute="review-product-image"], .review-product-image',
          );
          const productTitles = container.querySelectorAll(
            '[data-attribute="review-product-info-title"], .review-product-info-title',
          );
          const productNames = container.querySelectorAll(
            '[data-attribute="review-product-info-name"], .review-product-info-name',
          );

          productContainers.forEach(el => {
            el.setAttribute('data-product-enabled', productEnabled);
            el.style.display = productEnabled ? '' : 'none';
          });
          productImages.forEach(el => {
            if (productData.image) {
              el.setAttribute('src', productData.image);
            }
          });
          productTitles.forEach(el => {
            el.textContent = productData.title || '';
          });
          productNames.forEach(el => {
            el.textContent = productData.name || '';
          });
          break;
        }
        case 'star-color': {
          const productReviewsWrapper = container.querySelector('[data-attribute="product-reviews-container"]');
          if (productReviewsWrapper) {
            productReviewsWrapper.setAttribute('data-star-color', updatedData[key]);
            productReviewsWrapper.style.setProperty('--star-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="product-reviews-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="product-reviews-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        case 'divider': {
          const dividerEl = container.querySelector('[data-attribute="divider-primary"]');
          if (dividerEl) updateDividerPrimary(dividerEl, updatedData[key]);
          break;
        }
        case 'accordion': {
          const wrapProductReviews = container.querySelector('.wrap-product-reviews');
          if (wrapProductReviews) updateAccordionPrimary(wrapProductReviews, updatedData[key]);
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionReviewGridKindLokal(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-review': {
          const el = container.querySelector('[data-attribute="title-review"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'title-color': {
          const el = container.querySelector('[data-attribute="title-review"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-title-color', updatedData[key]);
          }
          break;
        }
        case 'card-text-color': {
          const reviewCards = container.querySelectorAll('.review-card');
          reviewCards.forEach(card => {
            card.style.color = updatedData[key];
          });
          const containerEl = container.querySelector('[data-attribute="review-grid-kind-lokal-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-card-text-color', updatedData[key]);
          }
          break;
        }
        case 'card-background-color': {
          const reviewCards = container.querySelectorAll('.review-card');
          reviewCards.forEach(card => {
            card.style.backgroundColor = updatedData[key];
          });
          const containerEl = container.querySelector('[data-attribute="review-grid-kind-lokal-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-card-background-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="review-grid-kind-lokal-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-active-color': {
          const el = container.querySelector('[data-attribute="review-grid-kind-lokal-container"]');
          if (el) {
            el.setAttribute('data-pagination-active-color', updatedData[key]);
            el.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const el = container.querySelector('[data-attribute="review-grid-kind-lokal-container"]');
          if (el) {
            el.setAttribute('data-pagination-inactive-color', updatedData[key]);
            el.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'body-review': {
          const bodyReview = container.querySelector('[data-attribute="body-review"]');
          const reviewSlider = bodyReview?.querySelector('.review-slider');
          if (reviewSlider && updatedData[key]) {
            const cardBackgroundColor = updatedData['card-background-color'] || '#f6f6f6';
            const cardTextColor = updatedData['card-text-color'] || '#000000';

            reviewSlider.innerHTML = updatedData[key]
              .map(review => {
                return `
                  <div data-attribute="item-review" class="item-review swiper-slide">
                    <div class="review-card" style="background-color: ${cardBackgroundColor}; color: ${cardTextColor};">
                      <div class="review-image-container">
                        <img data-attribute="review-image" src="${
                          review.image
                        }" alt="review image" class="review-image" />
                        <div class="speech-bubble">
                          <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <path fill="currentColor" d="M119.472 66.59C53.489 66.59 0 120.094 0 186.1c0 65.983 53.489 119.487 119.472 119.487c0 0-0.578 44.392-36.642 108.284c-4.006 12.802 3.135 26.435 15.945 30.418c9.089 2.859 18.653 0.08 24.829-6.389c82.925-90.7 115.385-197.448 115.385-251.8C238.989 120.094 185.501 66.59 119.472 66.59z"></path>
                            <path fill="currentColor" d="M392.482 66.59c-65.983 0-119.472 53.505-119.472 119.51c0 65.983 53.489 119.487 119.472 119.487c0 0-0.578 44.392-36.642 108.284c-4.006 12.802 3.136 26.435 15.945 30.418c9.089 2.859 18.653 0.08 24.828-6.389C479.539 347.2 512 240.452 512 186.1C512 120.094 458.511 66.59 392.482 66.59z"></path>
                          </svg>
                        </div>
                      </div>
                      <div class="review-content">
                        <div data-attribute="wrap-stars" class="wrap-stars" data-value="${review.rating}">
                          ${Array(5)
                            .fill(
                              `
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                            </svg>
                          `,
                            )
                            .join('')}
                        </div>
                        <blockquote class="review-content-text" data-attribute="review-content">
                          ${review.quote}
                        </blockquote>
                        <div class="review-name" data-attribute="review-name">${review.name}</div>
                      </div>
                    </div>
                  </div>
                  `;
              })
              .join('');
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="review-grid-kind-lokal-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="review-grid-kind-lokal-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionFaqGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'backgroundContainer': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          const backgroundItems = updatedData['backgroundItems'] || '#ffffff';
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div data-attribute="item-wapper" class="item-wapper"
                style="background-color: ${backgroundItems};">
                    <div data-attribute="item-question" class="item-question">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark">
                                <circle cx="12" cy="12" r="10" />
                                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                                <path d="M12 17h.01" />
                            </svg></span>
                        <h3 data-attribute="title-item-question" data-color="#000000" class="title-item-question"
                            style="color: '#000000';">${item.question}</h3>
                        <span data-attribute="icon-minus" style="display: none;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-minus-icon lucide-minus">
                                <path d="M5 12h14" />
                            </svg>
                        </span>

                        <span data-attribute="icon-plus"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus-icon lucide-plus">
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                            </svg></span>
                    </div>
                    <div data-attribute="item-answer" class="item-answer">
                        <div data-attribute="answer-content" class="answer-content">
                            ${item.answer}
                        </div>
                    </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionFaqGrid02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const faqGridContainerEl = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (faqGridContainerEl) {
            faqGridContainerEl.setAttribute('data-background', updatedData[key].backgroundContainer);
            faqGridContainerEl.style.setProperty('--background-container', updatedData[key].backgroundContainer);
          }
          const listItemsEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemsEl) {
            listItemsEl.setAttribute('data-background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.style.setProperty('--background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.setAttribute('data-background-faq-item-content', updatedData[key].backgroundFaqItemContent);
            listItemsEl.style.setProperty('--background-faq-item-content', updatedData[key].backgroundFaqItemContent);
            listItemsEl.setAttribute('data-text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.style.setProperty('--text-faq-item-color', updatedData[key].textFaqItem);
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div
                  data-attribute="item-wapper"
                  class="item-wapper"
                >
                  <div data-attribute="item-question" class="item-question">
                    <h3
                      data-attribute="title-item-question"
                      data-color="#000000"
                      class="title-item-question"
                      style="color: '#000000'"
                    >
                      ${item.question}
                    </h3>
                    <span data-attribute="icon-minus" style="display: none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-minus-icon lucide-minus"
                      >
                        <path d="M5 12h14" />
                      </svg>
                    </span>

                    <span data-attribute="icon-plus"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-plus-icon lucide-plus"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5v14" /></svg
                    ></span>
                  </div>
                  <div data-attribute="item-answer" class="item-answer">
                    <div data-attribute="answer-content" class="answer-content">
                      ${item.answer}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionFaqGrid03(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const faqGridContainerEl = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (faqGridContainerEl) {
            faqGridContainerEl.setAttribute('data-background', updatedData[key].backgroundContainer);
            faqGridContainerEl.style.setProperty('--background-container', updatedData[key].backgroundContainer);
          }
          const listItemsEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemsEl) {
            listItemsEl.setAttribute('data-background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.style.setProperty('--background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.setAttribute('data-text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.style.setProperty('--text-faq-item-color', updatedData[key].textFaqItem);
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div
                  data-attribute="item-wapper"
                  class="item-wapper"
                >
                  <div data-attribute="item-question" class="item-question">
                    <h3
                      data-attribute="title-item-question"
                      data-color="#000000"
                      class="title-item-question"
                      style="color: '#000000'"
                    >
                      ${item.question}
                    </h3>
                    <span data-attribute="icon-minus" style="display: none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="m18 15-6-6-6 6" />
                      </svg>
                    </span>

                    <span data-attribute="icon-plus">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </span>
                  </div>
                  <div data-attribute="item-answer" class="item-answer">
                    <div data-attribute="answer-content" class="answer-content">
                      ${item.answer}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionFaqGrid04(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const faqGridContainerEl = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (faqGridContainerEl) {
            faqGridContainerEl.setAttribute('data-background', updatedData[key].backgroundContainer);
            faqGridContainerEl.style.setProperty('--background-container', updatedData[key].backgroundContainer);
          }
          const listItemsEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemsEl) {
            listItemsEl.setAttribute('data-background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.style.setProperty('--background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.setAttribute('data-text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.style.setProperty('--text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.setAttribute('data-border-faq-item', updatedData[key].borderFaqItem);
            listItemsEl.style.setProperty('--border-faq-item', updatedData[key].borderFaqItem);
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div
                  data-attribute="item-wapper"
                  class="item-wapper"
                >
                  <div data-attribute="item-question" class="item-question">
                    <h3
                      data-attribute="title-item-question"
                      data-color="#000000"
                      class="title-item-question"
                      style="color: '#000000'"
                    >
                      ${item.question}
                    </h3>
                    <span data-attribute="icon-minus" style="display: none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    </span>
                    <span data-attribute="icon-plus">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                      </svg>
                    </span>
                  </div>
                  <div data-attribute="item-answer" class="item-answer">
                    <div data-attribute="answer-content" class="answer-content">
                      ${item.answer}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionSizingChartHurryBox(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    // Helper function to normalize border weight (add 'px' if it's just a number)
    const normalizeBorderWeight = weight => {
      if (!weight) return '2px';
      const weightStr = String(weight).trim();
      // If it's just a number, add 'px'
      if (/^\d+$/.test(weightStr)) {
        return weightStr + 'px';
      }
      return weightStr;
    };

    const getBorderStyles = () => {
      const borderEnabled = updatedData['border-enabled'] !== false; // default true
      const borderColor = updatedData['border-color'] || '#000000';
      const borderWeight = normalizeBorderWeight(updatedData['border-weight'] || '2px');

      if (borderEnabled) {
        return {
          accordionBorder: `border: solid ${borderWeight} ${borderColor};`,
          contentBorderTop: `border-top: solid ${borderWeight} ${borderColor};`,
        };
      } else {
        return {
          accordionBorder: 'border: none;',
          contentBorderTop: 'border-top: none;',
        };
      }
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'border-color':
        case 'border-weight':
        case 'border-enabled': {
          const accordionItems = container.querySelectorAll('[data-attribute="card-accordion"]');
          const borderEnabled = updatedData['border-enabled'] !== false; // default true
          const borderColor = updatedData['border-color'] || '#000000';
          const borderWeight = normalizeBorderWeight(updatedData['border-weight'] || '2px');

          accordionItems.forEach((item, index) => {
            if (item) {
              if (borderEnabled) {
                item.style.border = `solid ${borderWeight} ${borderColor}`;
                item.style.borderRadius = '10px';
              } else {
                item.style.border = 'none';
                item.style.borderRadius = '0';
                if (index < accordionItems.length - 1) {
                  item.style.borderBottom = `solid ${borderWeight} ${borderColor}`;
                } else {
                  item.style.borderBottom = 'none';
                }
              }

              const wrapContent = item.querySelector('.wrap-content');
              if (wrapContent) {
                if (borderEnabled) {
                  wrapContent.style.borderTop = `solid ${borderWeight} ${borderColor}`;
                } else {
                  wrapContent.style.borderTop = 'none';
                }
              }
            }
          });

          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            if (key === 'border-color') {
              cardContainer.setAttribute('data-border-color', updatedData[key]);
            } else if (key === 'border-weight') {
              cardContainer.setAttribute('data-border-weight', borderWeight);
            } else if (key === 'border-enabled') {
              cardContainer.setAttribute('data-border-enabled', updatedData[key]);
            }
          }
          break;
        }
        case 'title-color': {
          const titleElements = container.querySelectorAll('[data-attribute="accordion-title"]');
          const titleColor = updatedData[key] || '#000000';

          titleElements.forEach(titleEl => {
            if (titleEl) {
              titleEl.style.color = titleColor;
              titleEl.setAttribute('data-title-color', titleColor);
            }
          });

          // Set data attribute for persistence
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.setAttribute('data-title-color', titleColor);
          }
          break;
        }

        case 'sectionPadding': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          const pad = updatedData[key];
          if (!containerEl || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (attrName, cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            containerEl.setAttribute(attrName, n);
            containerEl.style.setProperty(cssVar, `${n}px`);
          };

          setSide('data-top-desktop-padding', '--padding-top-desktop', pad.topDesktop);
          setSide('data-bottom-desktop-padding', '--padding-bottom-desktop', pad.bottomDesktop);
          setSide('data-top-mobile-padding', '--padding-top-mobile', pad.topMobile);
          setSide('data-bottom-mobile-padding', '--padding-bottom-mobile', pad.bottomMobile);
          break;
        }

        case 'accordions': {
          const el = container.querySelector('[data-attribute="card-accordions"]');
          if (el) {
            const borderStyles = getBorderStyles();
            const borderEnabled = updatedData['border-enabled'] !== false; // default true
            const borderColor = updatedData['border-color'] || '#000000';
            const borderWeight = normalizeBorderWeight(updatedData['border-weight'] || '2px');

            const titleColor = updatedData['title-color'] || '#000000';

            el.innerHTML = updatedData[key]?.listItem
              .map((item, index) => {
                const isLastItem = index === updatedData[key]?.listItem.length - 1;
                let itemBorderStyle = borderStyles.accordionBorder;

                if (!borderEnabled) {
                  itemBorderStyle = 'border: none; border-radius: 0;';
                  if (!isLastItem) {
                    itemBorderStyle += ` border-bottom: solid ${borderWeight} ${borderColor};`;
                  }
                } else {
                  itemBorderStyle += ' border-radius: 10px;';
                }

                return `
                <div data-attribute="card-accordion" class="wrap-accordion" style="${itemBorderStyle}">
                  <div data-attribute="accordion-title" class="accordion-title" style="color: ${titleColor};" data-title-color="${titleColor}">
                    <div data-attribute="accordion-title-text">${item.title}</div>
                    <div class="accordion-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-chevron-down-icon lucide-chevron-down">
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </div>
                  </div>
                  <div data-attribute="accordion-content" class="accordion-content">
                    <div class="wrap-content" style="${borderStyles.contentBorderTop}">
                      <div data-attribute="wrap-image" class="wrap-img" data-show-image="${
                        item.enableImage ? 'true' : 'false'
                      }" style="display: ${item.enableImage ? 'block' : 'none'};">
                        <img loading="lazy" data-attribute="image-content"
                          src="${item.imageContent}"
                          alt="">
                      </div>
                      <div data-attribute="accordion-text" class="accordion-text">${item.textContent}</div>
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        default: {
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },

  sectionBannerB1(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.setProperty('--text-color', updatedData[key]);
            el.style.color = updatedData[key];
          }
          break;
        }
        case 'contentAlign': {
          const el = container.querySelector('[data-attribute="wrap-content"]');
          if (el) {
            el.setAttribute('data-align', updatedData[key]);
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'overlay': {
          const el = container.querySelector('[data-attribute="overlay-bg"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key].color);
            el.setAttribute('data-opacity', updatedData[key].opacity);
            el.style.backgroundColor = updatedData[key].color;
            el.style.opacity = updatedData[key].opacity;
          }
          break;
        }
        case 'background': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key].color);
            el.style.backgroundColor = updatedData[key].color;
          }
          const elBackgroundSection = container.querySelector('[data-attribute="background-section"]');
          if (elBackgroundSection) {
            elBackgroundSection.setAttribute('data-background-img', updatedData[key].img);
            elBackgroundSection.setAttribute('data-opacity', updatedData[key].opacity);
            elBackgroundSection.style.opacity = updatedData[key].opacity;
            elBackgroundSection.style.backgroundImage = `url(${updatedData[key].img})`;
          }
          const elBackgroundSectionMobile = container.querySelector('[data-attribute="background-section-mobile"]');
          if (elBackgroundSectionMobile) {
            elBackgroundSectionMobile.setAttribute('data-background-img', updatedData[key].imgMobile);
            elBackgroundSectionMobile.setAttribute('data-opacity', updatedData[key].opacity);
            elBackgroundSectionMobile.style.backgroundImage = `url(${updatedData[key].imgMobile})`;
          }
          break;
        }
        case 'titleBanner': {
          const el = container.querySelector('[data-attribute="title-banner"]');
          if (el) {
            el.setAttribute('data-show-banner-title', updatedData[key].show);
            el.innerHTML = updatedData[key].text;
          }
          break;
        }
        case 'contentBanner': {
          const el = container.querySelector('[data-attribute="content-banner"]');
          if (el) {
            el.setAttribute('data-show-banner-content', updatedData[key].show);
            el.innerHTML = updatedData[key].text;
          }
          break;
        }
        case 'button': {
          const el = container.querySelector('[data-attribute="wrap-btn"]');
          if (el) {
            el.setAttribute('data-show-btn', updatedData[key].show);
          }
          const elButtonLink = container.querySelector('[data-attribute="button-link"]');
          if (elButtonLink) {
            elButtonLink.setAttribute('data-background', updatedData[key].background);
            elButtonLink.setAttribute('data-color', updatedData[key].color);
            elButtonLink.style.backgroundColor = updatedData[key].background;
            elButtonLink.style.color = updatedData[key].color;
            elButtonLink.href = updatedData[key].link;
            elButtonLink.innerHTML = updatedData[key].text;
          }
          const elSubButton = container.querySelector('[data-attribute="sub-button"]');
          if (elSubButton) {
            elSubButton.innerHTML = updatedData[key].subButton;
          }
          break;
        }
        case 'rating': {
          const el = container.querySelector('[data-attribute="rating"]');
          if (el) {
            el.setAttribute('data-show-rating', updatedData[key].show);
          }
          const elRatingStars = container.querySelector('[data-attribute="rating-stars"]');
          if (elRatingStars) {
            elRatingStars.setAttribute('data-value', updatedData[key].value);
          }
          const elRatingText = container.querySelector('[data-attribute="rating-text"]');
          if (elRatingText) {
            elRatingText.textContent = updatedData[key].text;
          }
          break;
        }
        case 'tag': {
          const el = container.querySelector('[data-attribute="tag-name"]');
          if (el) {
            el.setAttribute('data-show-tag', updatedData[key].show);
            el.setAttribute('data-background', updatedData[key].background);
            el.style.backgroundColor = updatedData[key].background;
            el.setAttribute('data-text', updatedData[key].text);
            el.style.color = updatedData[key].text;
            el.innerHTML = updatedData[key].text;
          }
          break;
        }
        case 'features': {
          const elWrapFeatures = container.querySelector('[data-attribute="wrapper-container"]');
          const el = container.querySelector('[data-attribute="features"]');
          if (el) {
            el.setAttribute('data-show-features', updatedData[key].show);
            el.setAttribute('data-col-per-view', updatedData[key].colPerView);
            elWrapFeatures?.style.setProperty('--col-per-view', updatedData[key].colPerView);
          }
          el.innerHTML = updatedData[key].items
            .map(item => {
              return `
                <div data-attribute="feature-item">
                  <img class="icon" data-attribute="icon-feature"
                    src="${item.icon}"
                    alt="">
                  <div data-attribute="text-feature" class="text-feature">${item.text}</div>
                </div>
              `;
            })
            .join('');
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionItemsSlideB1(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'header': {
          const el = container.querySelector('[data-attribute="header-section"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                return `
                  <div data-attribute="item" class="swiper-slide">
                    <div class="wrap-item">
                      <img data-attribute="image"
                        src="${item.image}"
                        alt="">
                      <div data-attribute="overlay" data-opacity="${item.overlay.opacity}" data-background-color="${item.overlay.backgroundColor}"
                        style="background-color: ${item.overlay.backgroundColor}; opacity: ${item.overlay.opacity};" class="overlay-item"></div>
                      <div data-attribute="text" class="wrap-text">
                        ${item.text}
                      </div>
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        case 'button': {
          const el = container.querySelector('[data-attribute="button-cta"]');
          if (el) {
            el.setAttribute('data-show-button', updatedData[key].show);
            el.setAttribute('data-background-color', updatedData[key].backgroundColor);
            el.setAttribute('data-color', updatedData[key].color);
            el.style.backgroundColor = updatedData[key].backgroundColor;
            el.style.color = updatedData[key].color;
            el.href = updatedData[key].link;
            el.textContent = updatedData[key].text;
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardBasicB1(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'showLeftGroup': {
          const el = container.querySelector('[data-attribute="left-group"]');
          if (el) {
            el.setAttribute('data-show-left-group', updatedData[key]);
          }
          break;
        }
        case 'showRightGroup': {
          const el = container.querySelector('[data-attribute="right-group"]');
          if (el) {
            el.setAttribute('data-show-right-group', updatedData[key]);
          }
          break;
        }
        case 'order': {
          const leftGroup = container.querySelector('[data-attribute="left-group"]');
          const rightGroup = container.querySelector('[data-attribute="right-group"]');
          if (leftGroup) {
            leftGroup.setAttribute('data-order', updatedData[key].leftGroup);
          }
          if (rightGroup) {
            rightGroup.setAttribute('data-order', updatedData[key].rightGroup);
          }
          break;
        }
        case 'textContentPrimary': {
          const el = container.querySelector('[data-attribute="text-content-primary"]');
          if (el) {
            el.setAttribute('data-show-text', updatedData[key].show);
            el.innerHTML = updatedData[key].text;
          }
          break;
        }
        case 'icon': {
          const el = container.querySelector('[data-attribute="wrap-icon-img"]');
          if (el) {
            el.setAttribute('data-show-icon', updatedData[key].show);
            const imgEl = el.querySelector('img');
            if (imgEl) {
              imgEl.setAttribute('src', updatedData[key].src);
            } else if (updatedData[key].src) {
              const img = doc.createElement('img');
              img.setAttribute('src', updatedData[key].src);
              img.setAttribute('alt', '');
              el.appendChild(img);
            }
          }
          break;
        }
        case 'textContentSecondary': {
          const el = container.querySelector('[data-attribute="text-content-secondary"]');
          if (el) {
            el.setAttribute('data-show-text', updatedData[key].show);
            el.innerHTML = updatedData[key].text;
          }
          break;
        }
        case 'button': {
          const buttonLink = container.querySelector('[data-attribute="button-link"]');
          const subBtn = container.querySelector('[data-attribute="sub-btn"]');
          if (buttonLink) {
            buttonLink.setAttribute('data-show-btn', updatedData[key].show);
            buttonLink.setAttribute('data-background-color', updatedData[key].backgroundColor);
            buttonLink.setAttribute('data-color', updatedData[key].color);
            buttonLink.style.backgroundColor = updatedData[key].backgroundColor;
            buttonLink.style.color = updatedData[key].color;
            buttonLink.href = updatedData[key].link;
            buttonLink.textContent = updatedData[key].text;
          }
          if (subBtn) {
            subBtn.textContent = updatedData[key].subBtn;
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardCompareB1(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'headerSection': {
          const el = container.querySelector('[data-attribute="header-section"]');
          if (el) {
            el.setAttribute('data-show-header', updatedData[key].show);
            el.innerHTML = updatedData[key].text;
          }
          break;
        }
        case 'before': {
          const beforeEl = container.querySelector('[data-attribute="before"]');
          if (beforeEl) {
            const imageEl = beforeEl.querySelector('[data-attribute="image-before"]');
            const textLabelEl = beforeEl.querySelector('[data-attribute="text-before"]');
            if (imageEl) {
              imageEl.setAttribute('src', updatedData[key].image);
            }
            if (textLabelEl) {
              textLabelEl.setAttribute('data-background', updatedData[key].backgroundColorLabel);
              textLabelEl.setAttribute('data-color', updatedData[key].colorLabel);
              textLabelEl.style.backgroundColor = updatedData[key].backgroundColorLabel;
              textLabelEl.style.color = updatedData[key].colorLabel;
              textLabelEl.textContent = updatedData[key].textLabel;
            }
          }
          break;
        }
        case 'after': {
          const afterEl = container.querySelector('[data-attribute="after"]');
          if (afterEl) {
            const imageEl = afterEl.querySelector('[data-attribute="image-after"]');
            const textLabelEl = afterEl.querySelector('[data-attribute="text-after"]');
            if (imageEl) {
              imageEl.setAttribute('src', updatedData[key].image);
            }
            if (textLabelEl) {
              textLabelEl.setAttribute('data-background', updatedData[key].backgroundColorLabel);
              textLabelEl.setAttribute('data-color', updatedData[key].colorLabel);
              textLabelEl.style.backgroundColor = updatedData[key].backgroundColorLabel;
              textLabelEl.style.color = updatedData[key].colorLabel;
              textLabelEl.textContent = updatedData[key].textLabel;
            }
          }
          break;
        }
        case 'summarySection': {
          const el = container.querySelector('[data-attribute="summary-section"]');
          if (el) {
            el.setAttribute('data-show-summary', updatedData[key].show);
            el.setAttribute('data-border-color', updatedData[key].borderColor);
            el.setAttribute('data-background-color', updatedData[key].backgroundColor);
            el.style.borderColor = updatedData[key].borderColor;
            el.style.borderWidth = updatedData[key].borderWidth;
            el.style.borderStyle = 'solid';
            el.style.backgroundColor = updatedData[key].backgroundColor;
            el.innerHTML = updatedData[key].text;
          }
          break;
        }
        case 'button': {
          const btnCta = container.querySelector('[data-attribute="btn-cta"]');
          const buttonLink = container.querySelector('[data-attribute="button-link"]');
          const subBtn = container.querySelector('[data-attribute="sub-btn"]');
          if (btnCta) {
            btnCta.setAttribute('data-show-btn', updatedData[key].show);
          }
          if (buttonLink) {
            buttonLink.setAttribute('data-background-color', updatedData[key].backgroundColor);
            buttonLink.setAttribute('data-color', updatedData[key].color);
            buttonLink.style.backgroundColor = updatedData[key].backgroundColor;
            buttonLink.style.color = updatedData[key].color;
            buttonLink.href = updatedData[key].link;
            buttonLink.textContent = updatedData[key].text;
          }
          if (subBtn) {
            subBtn.textContent = updatedData[key].subBtn;
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionBannerBasicB1(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'overlay': {
          const el = container.querySelector('[data-attribute="overlay-bg"]');
          if (el) {
            el.setAttribute('data-color', updatedData[key].color);
            el.setAttribute('data-opacity', updatedData[key].opacity);
            el.style.backgroundColor = updatedData[key].color;
            el.style.opacity = updatedData[key].opacity;
          }
          break;
        }
        case 'background': {
          const elBackgroundSection = container.querySelector('[data-attribute="background-section"]');
          const elBackgroundSectionMobile = container.querySelector('[data-attribute="background-section-mobile"]');
          const elWrapperContainer = container.querySelector('[data-attribute="wrapper-container"]');
          if (elBackgroundSection) {
            elBackgroundSection.setAttribute('data-background-img', updatedData[key].img);
            elBackgroundSection.setAttribute('data-opacity', updatedData[key].opacity);
            elBackgroundSection.style.opacity = updatedData[key].opacity;
            elBackgroundSection.style.backgroundImage = `url(${updatedData[key].img})`;
          }
          if (elBackgroundSectionMobile) {
            elBackgroundSectionMobile.setAttribute('data-background-img', updatedData[key].imgMobile);
            elBackgroundSectionMobile.style.backgroundImage = `url(${updatedData[key].imgMobile})`;
          }
          if (elWrapperContainer) {
            elWrapperContainer.setAttribute('data-background-color', updatedData[key].color);
            elWrapperContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'content': {
          const elWrapContent = container.querySelector('[data-attribute="wrap-content"]');
          const elContentTitle = container.querySelector('[data-attribute="content-title"]');
          const listItemEl = container.querySelector('.list-item');
          if (elWrapContent) {
            if (updatedData[key].contentAlign) {
              elWrapContent.setAttribute('data-align', updatedData[key].contentAlign);
              elWrapContent.style.textAlign = updatedData[key].contentAlign;
            }
            if (updatedData[key].backgroundColor) {
              elWrapContent.setAttribute('data-background-color', updatedData[key].backgroundColor);
              elWrapContent.style.backgroundColor = updatedData[key].backgroundColor;
            }
          }
          if (elContentTitle) {
            elContentTitle.innerHTML = updatedData[key].title;
          }
          if (listItemEl) {
            listItemEl.innerHTML = updatedData[key].listItem
              .map(item => {
                return `
                  <div data-attribute="item" class="item">
                    <div data-attribute="icon" class="icon">
                      <img src="${item.icon}" alt="">
                    </div>
                    <div data-attribute="item-text" class="item-text">${item.text}</div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionTableSmallB1(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'background': {
          const elWrapperContainer = container.querySelector('[data-attribute="wrapper-container"]');
          if (elWrapperContainer && updatedData[key].color) {
            elWrapperContainer.setAttribute('data-background-color', updatedData[key].color);
            elWrapperContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'table': {
          const elTableAdd = container.querySelector('[data-attribute="table-add"]');
          if (elTableAdd) {
            // Update table attributes
            elTableAdd.setAttribute('data-col-border', updatedData[key].colBorder);
            elTableAdd.setAttribute('data-row-border', updatedData[key].rowBorder);
            elTableAdd.setAttribute('data-border-color', updatedData[key].borderColor);
            elTableAdd.setAttribute('data-border-spacing-vertical', updatedData[key].borderSpacingVertical);
            elTableAdd.setAttribute('data-border-spacing-horizontal', updatedData[key].borderSpacingHorizontal);
            elTableAdd.setAttribute('data-border-weight', updatedData[key].borderWeight);

            // Set CSS variables
            elTableAdd.style.setProperty('--border-color', updatedData[key].borderColor);
            elTableAdd.style.setProperty('--border-spacing-vertical', `${updatedData[key].borderSpacingVertical}px`);
            elTableAdd.style.setProperty(
              '--border-spacing-horizontal',
              `${updatedData[key].borderSpacingHorizontal}px`,
            );
            elTableAdd.style.setProperty('--border-weight', updatedData[key].borderWeight);

            // Update table HTML
            if (updatedData[key].html) {
              const tableEl = elTableAdd.querySelector('table');
              if (tableEl) {
                const tempDiv = doc.createElement('div');
                tempDiv.innerHTML = updatedData[key].html;
                const newTable = tempDiv.querySelector('table');
                if (newTable) {
                  tableEl.parentNode.replaceChild(newTable, tableEl);
                }
              }
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionIconWithTextB1(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'background': {
          const elWrapperContainer = container.querySelector('[data-attribute="wrapper-container"]');
          if (elWrapperContainer && updatedData[key].color) {
            elWrapperContainer.setAttribute('data-background-color', updatedData[key].color);
            elWrapperContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'showTitleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.setAttribute('data-show-header', updatedData[key]);
            el.style.display = updatedData[key] ? '' : 'none';
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'wapperItems': {
          const elList = container.querySelector('[data-attribute="list-item"]');
          if (elList) {
            // Update attributes and CSS variables
            elList.setAttribute('data-align-items', updatedData[key].contentAlign || 'center');
            elList.setAttribute('data-col-per-view', updatedData[key].colPerView || 4);
            if (updatedData[key].withIcon !== undefined) {
              elList.setAttribute('data-with-icon', updatedData[key].withIcon || 60);
              elList.style.setProperty('--with-icon', `${updatedData[key].withIcon || 60}px`);
            }
            elList.style.setProperty('--col-per-view', updatedData[key].colPerView || 4);
            elList.style.setProperty('--align-items', updatedData[key].contentAlign || 'center');

            // Update list items
            if (updatedData[key].listItem && Array.isArray(updatedData[key].listItem)) {
              elList.innerHTML = updatedData[key].listItem
                .map(item => {
                  return `
                    <div data-attribute="item" class="item-w-t">
                      <div data-attribute="image-item" class="wrap-img">
                        <img src="${item.image || ''}" alt="">
                      </div>
                      <div data-attribute="text-item" class="wrap-text">
                        ${item.htmlText || ''}
                      </div>
                    </div>
                  `;
                })
                .join('');
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },

  sectionImageWithTextBasic(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) el.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) el.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'background': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el && updatedData[key]?.color) {
            el.setAttribute('data-background-color', updatedData[key].color);
            el.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'backgroundContent': {
          const el = container.querySelector('[data-attribute="wrapper-content"]');
          if (el && updatedData[key]?.color) {
            el.setAttribute('data-background', updatedData[key].color);
            el.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            const show = updatedData[key]?.show;
            el.setAttribute('data-show-title', show);
            el.style.display = show ? 'block' : 'none';
            if (updatedData[key]?.htmlContent !== undefined) el.innerHTML = updatedData[key].htmlContent;
          }
          break;
        }
        case 'img': {
          const elWrapImg = container.querySelector('[data-attribute="wrap-img"]');
          if (elWrapImg) {
            if (updatedData[key]?.show !== undefined) {
              elWrapImg.setAttribute('data-show-img', updatedData[key].show);
              elWrapImg.style.display = updatedData[key].show ? 'flex' : 'none';
            }
            if (updatedData[key]?.width !== undefined) {
              const widthPx = `${updatedData[key].width}px`;
              elWrapImg.setAttribute('data-width-image', widthPx);
              const elWrapper = container.querySelector('[data-attribute="wrapper-container"]');
              if (elWrapper) elWrapper.style.setProperty('--width-image', widthPx);
            }
          }

          if (updatedData[key]?.src !== undefined) {
            const elImg = container.querySelector('[data-attribute="image-item"]');
            if (elImg) elImg.setAttribute('src', updatedData[key].src);
          }
          break;
        }
        case 'descriptionContent': {
          const el = container.querySelector('[data-attribute="description-content"]');
          if (el) el.innerHTML = updatedData[key];
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },

  //order policy
  sectionGuaranteedSafeCheckout(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'content': {
          const el = container.querySelector('[data-attribute="content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'sectionPadding': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          const pad = updatedData[key];
          if (!containerEl || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (attrName, cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            containerEl.setAttribute(attrName, n);
            containerEl.style.setProperty(cssVar, `${n}px`);
          };

          setSide('data-top-desktop-padding', '--padding-top-desktop', pad.topDesktop);
          setSide('data-bottom-desktop-padding', '--padding-bottom-desktop', pad.bottomDesktop);
          setSide('data-top-mobile-padding', '--padding-top-mobile', pad.topMobile);
          setSide('data-bottom-mobile-padding', '--padding-bottom-mobile', pad.bottomMobile);
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionOrderInfo(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'timeline-enabled': {
          const timelineEl = container.querySelector('.timeline');
          if (timelineEl) {
            timelineEl.setAttribute('data-timeline-enabled', updatedData[key]);
            timelineEl.style.setProperty('--timeline-enabled', updatedData[key] ? 'grid' : 'none');
          }
          break;
        }
        case 'timeline-ordered-text': {
          const timelineSteps = container.querySelectorAll('.timeline-step');
          if (timelineSteps[0]) {
            const textEl = timelineSteps[0].querySelector('.timeline-text p:last-child');
            if (textEl) {
              textEl.textContent = updatedData[key];
            }
          }
          break;
        }
        case 'timeline-shipping-text': {
          const timelineSteps = container.querySelectorAll('.timeline-step');
          if (timelineSteps[1]) {
            const textEl = timelineSteps[1].querySelector('.timeline-text p:last-child');
            if (textEl) {
              textEl.textContent = updatedData[key];
            }
          }
          break;
        }
        case 'timeline-delivered-text': {
          const timelineSteps = container.querySelectorAll('.timeline-step');
          if (timelineSteps[2]) {
            const textEl = timelineSteps[2].querySelector('.timeline-text p:last-child');
            if (textEl) {
              textEl.textContent = updatedData[key];
            }
          }
          break;
        }
        case 'timeline-shipping-days':
        case 'timeline-delivery-days': {
          const timelineEl = container.querySelector('.timeline');
          if (timelineEl) {
            // Store the days in data attributes for persistence
            if (key === 'timeline-shipping-days') {
              timelineEl.setAttribute('data-timeline-shipping-days', updatedData[key]);
            } else if (key === 'timeline-delivery-days') {
              timelineEl.setAttribute('data-timeline-delivery-days', updatedData[key]);
            }
          }
          break;
        }
        case 'timeline-circle-bg-color':
        case 'timeline-svg-color':
        case 'timeline-line-color': {
          const timelineEl = container.querySelector('.timeline');
          if (timelineEl) {
            if (key === 'timeline-circle-bg-color') {
              timelineEl.setAttribute('data-timeline-circle-bg-color', updatedData[key]);
              timelineEl.style.setProperty('--timeline-circle-bg-color', updatedData[key]);
            } else if (key === 'timeline-svg-color') {
              timelineEl.setAttribute('data-timeline-svg-color', updatedData[key]);
              timelineEl.style.setProperty('--timeline-svg-color', updatedData[key]);
            } else if (key === 'timeline-line-color') {
              timelineEl.setAttribute('data-timeline-line-color', updatedData[key]);
              timelineEl.style.setProperty('--timeline-line-color', updatedData[key]);
            }
          }
          break;
        }
        case 'accordion-enabled': {
          const accordionEl = container.querySelector('.accordion');
          if (accordionEl) {
            accordionEl.setAttribute('data-accordion-enabled', updatedData[key]);
            accordionEl.style.setProperty('--accordion-enabled', updatedData[key] ? 'block' : 'none');
          }
          break;
        }
        case 'accordion-hover-color': {
          const accordionEl = container.querySelector('.accordion');
          if (accordionEl) {
            accordionEl.setAttribute('data-accordion-hover-color', updatedData[key]);
            accordionEl.style.setProperty('--accordion-hover-color', updatedData[key]);
          }
          break;
        }
        case 'accordion-border-color': {
          const accordionEl = container.querySelector('.accordion');
          if (accordionEl) {
            accordionEl.setAttribute('data-accordion-border-color', updatedData[key]);
            accordionEl.style.setProperty('--accordion-border-color', updatedData[key]);
          }
          break;
        }
        case 'accordion-items': {
          const accordionEl = container.querySelector('.accordion');
          if (accordionEl && Array.isArray(updatedData[key])) {
            accordionEl.innerHTML = updatedData[key]
              .map(
                (item, index) => `
              <div class="accordion-item" key="${index}">
                <div class="accordion-header" data-attribute="accordion-header">
                  <span data-attribute="accordion-title" class="accordion-title">${item.title}</span>
                  <span class="chevron" data-attribute="accordion-icon">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      class="icon icon-caret"
                      viewBox="0 0 10 6"
                      >
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
                    </svg>
                  </span>
                </div>
                <div class="accordion-content" data-attribute="accordion-content">
                  <div>${item.content}</div>
                </div>
              </div>
            `,
              )
              .join('');
          }
          break;
        }

        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="order-info"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="order-info"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-active-color': {
          const containerEl = container.querySelector('[data-attribute="order-info"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-active-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const containerEl = container.querySelector('[data-attribute="order-info"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-inactive-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'reviews-enabled': {
          const reviewWrapper = container.querySelector('.policy-review-grid-wrapper');
          if (reviewWrapper) {
            if (updatedData[key]) {
              reviewWrapper.style.display = '';
            } else {
              reviewWrapper.style.display = 'none';
            }
          }
          break;
        }

        case 'body-review': {
          const bodyReview = container.querySelector('[data-attribute="body-review"]');
          const reviewSlider = bodyReview?.querySelector('.review-slider');
          if (reviewSlider && updatedData[key]) {
            reviewSlider.innerHTML = updatedData[key]
              .map(review => {
                const starsSvg = Array(5)
                  .fill(
                    `
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                  </svg>`,
                  )
                  .join('');

                return `
                <div data-attribute="item-review" class="item-review swiper-slide">
                  <div class="reviewer-avatar">
                    <img loading="lazy" data-attribute="reviewer-avatar" src="${review.avatar}" alt="${review.name}" onerror="this.style.display='none'">
                  </div>
                  <div class="reviewer-details">
                    <div class="review-content" data-attribute="review-content">
                      ${review.content}
                    </div>
                    <div class="reviewer-info">
                      <h3 data-attribute="reviewer-name" class="reviewer-name">${review.name}</h3>
                      <div data-attribute="rating-stars" data-value="${review.rating}" class="wrap-stars">
                        ${starsSvg}
                      </div>
                    </div>
                  </div>
                </div>
                `;
              })
              .join('');
          }
          break;
        }
        case 'sectionPadding': {
          const containerEl = container.querySelector('[data-attribute="order-info"]');
          const pad = updatedData[key];
          if (!containerEl || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (attrName, cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            containerEl.setAttribute(attrName, n);
            containerEl.style.setProperty(cssVar, `${n}px`);
          };

          setSide('data-top-desktop-padding', '--padding-top-desktop', pad.topDesktop);
          setSide('data-bottom-desktop-padding', '--padding-bottom-desktop', pad.bottomDesktop);
          setSide('data-top-mobile-padding', '--padding-top-mobile', pad.topMobile);
          setSide('data-bottom-mobile-padding', '--padding-bottom-mobile', pad.bottomMobile);
          break;
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionPolicyAccordionBasic(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const chevronDownSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-chevron-down-icon lucide-chevron-down">
        <path d="m6 9 6 6 6-6" />
      </svg>
    `;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'itemAccordions': {
          const el = container.querySelector('[data-attribute="card-accordions"]');
          if (el) {
            el.setAttribute('data-show-accordion', updatedData[key]?.dataShowAccordion);
            el.style.display = updatedData[key]?.dataShowAccordion ? 'block' : 'none';
            el.innerHTML = (updatedData[key]?.listItem || [])
              .map(
                item => `
                  <div data-attribute="card-accordion" class="wrap-accordion">
                    <div data-attribute="accordion-title" class="accordion-title">
                      <div data-attribute="accordion-title-text">${item.title || ''}</div>
                      <div class="accordion-icon">${chevronDownSvg}</div>
                    </div>
                    <div data-attribute="accordion-content" class="accordion-content">
                      <div data-attribute="accordion-text" class="accordion-text">${item.answer || ''}</div>
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionPolicyYuriAccordion(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const chevronDownSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>plus</title>
          <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor" />
        </svg>
    `;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            const showStyle = updatedData[key].showStyle;
            const background = updatedData[key].background || '#ffffff';
            elContainerPage.setAttribute('data-show-style', showStyle);
            elContainerPage.setAttribute('data-enable-style', showStyle);
            elContainerPage.setAttribute('data-background', background);
            elContainerPage.setAttribute('data-background-container', background);
            elContainerPage.style.backgroundColor = showStyle ? background : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'show-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const isShow = updatedData[key] !== false;
            el.setAttribute('data-show-title', isShow ? 'true' : 'false');
            if (!isShow) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const isShowTitle = updatedData['show-title'] !== false;
            if (!isShowTitle) {
              el.innerHTML = '';
              break;
            }
            el.innerHTML = typeof updatedData[key] === 'string' ? updatedData[key] : '';
          }
          break;
        }
        case 'itemAccordions': {
          const el = container.querySelector('[data-attribute="card-accordions"]');
          if (el) {
            el.setAttribute('data-show-accordion', updatedData[key]?.dataShowAccordion);
            el.style.display = updatedData[key]?.dataShowAccordion ? 'block' : 'none';
            el.innerHTML = (updatedData[key]?.listItem || [])
              .map(
                item => `
                  <div data-attribute="card-accordion" class="wrap-accordion">
                    <div data-attribute="accordion-title" class="accordion-title">
                      <div data-attribute="accordion-title-text">${item.title || ''}</div>
                      <div class="accordion-icon">${chevronDownSvg}</div>
                    </div>
                    <div data-attribute="accordion-content" class="accordion-content">
                      <div data-attribute="accordion-text" class="accordion-text">${item.answer || ''}</div>
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionPolicyYuriList(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const value = updatedData[key];
            if (typeof value === 'string') {
              el.innerHTML = value;
            }
            if (updatedData['show-title'] === false) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'show-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const isShow = updatedData[key] !== false;
            el.setAttribute('data-show-title', isShow ? 'true' : 'false');
            if (!isShow) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'background-icon': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.setAttribute('data-background-icon', updatedData[key]);
            el.style.setProperty('--background-icon', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'enableContainerPage': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            const enabled = updatedData[key] !== false;
            el.setAttribute('data-enable-style', enabled ? 'true' : 'false');
          }
          break;
        }
        case 'backgroundContainer': {
          const enableContainerPage = updatedData['enableContainerPage'] !== false;
          const el = container.querySelector('[data-attribute="container-page"]');
          if (enableContainerPage && el) {
            el.setAttribute('data-background-container', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          } else if (el) {
            el.style.backgroundColor = 'transparent';
          }
          break;
        }
        case 'listItem': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            const nextItems =
              Array.isArray(updatedData[key]) && updatedData[key].length > 0
                ? updatedData[key]
                : [
                    {
                      iconItem: '',
                      textItem: '',
                    },
                  ];

            listEl.innerHTML = nextItems
              .map(
                item => `
                  <div data-attribute="item" class="wrap-item">
                    <div class="icon-left">
                      <img data-attribute="icon-item" src="${item.iconItem || ''}" alt="">
                    </div>
                    <div data-attribute="text-item" class="text-right-item">
                      ${item.textItem || ''}
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionPolicyYuriVideos(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const value = updatedData[key];
            if (typeof value === 'string') {
              el.innerHTML = value;
            }
            if (updatedData['show-title'] === false) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'show-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const isShow = updatedData[key] !== false;
            el.setAttribute('data-show-title', isShow ? 'true' : 'false');
            if (!isShow) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'enableContainerPage': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            const enabled = updatedData[key] !== false;
            el.setAttribute('data-enable-style', enabled ? 'true' : 'false');
          }
          break;
        }
        case 'backgroundContainer': {
          const enableContainerPage = updatedData['enableContainerPage'] !== false;
          const el = container.querySelector('[data-attribute="container-page"]');
          if (enableContainerPage && el) {
            el.setAttribute('data-background-container', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          } else if (el) {
            el.style.backgroundColor = 'transparent';
          }
          break;
        }
        case 'listItem': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            const nextItems =
              Array.isArray(updatedData[key]) && updatedData[key].length > 0
                ? updatedData[key]
                : [
                    {
                      mediaType: 'video',
                      videoItem: '',
                      imageItem: '',
                    },
                  ];

            listEl.innerHTML = nextItems
              .map(item => {
                const mediaType = item.mediaType === 'image' ? 'image' : 'video';
                const showVideo = mediaType === 'video';
                const showImage = mediaType === 'image';
                return `
                  <div data-attribute="item" class="swiper-slide">
                    <div
                      data-show-video="${showVideo ? 'true' : 'false'}"
                      data-attribute="wrap-video"
                      class="video-item"
                      style="display: ${showVideo ? 'block' : 'none'};"
                    >
                      <video
                        data-attribute="video-item"
                        loop
                        autoplay
                        playsinline
                        muted
                        src="${showVideo ? item.videoItem || '' : ''}"
                        alt=""></video>
                    </div>
                    <div
                      data-show-image="${showImage ? 'true' : 'false'}"
                      data-attribute="wrap-image"
                      class="image-item"
                      style="display: ${showImage ? 'block' : 'none'};"
                    >
                      <img src="${showImage ? item.imageItem || '' : ''}" alt="">
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionPolicyYuriReivew(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const createStarsHtml = count => {
      const safeCount = Math.min(Math.max(parseInt(count, 10) || 5, 1), 5);
      return new Array(safeCount)
        .fill(
          `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>star</title>
            <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" fill="currentColor" />
          </svg>`,
        )
        .join('');
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const value = updatedData[key];
            if (typeof value === 'string') {
              el.innerHTML = value;
            }
            if (updatedData['show-title'] === false) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'show-title': {
          const el = container.querySelector('[data-attribute="card-title"]');
          if (el) {
            const isShow = updatedData[key] !== false;
            el.setAttribute('data-show-title', isShow ? 'true' : 'false');
            if (!isShow) {
              el.innerHTML = '';
            }
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.color = updatedData[key];
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        case 'settingItem': {
          const el = container.querySelector('[data-attribute="slider"]');
          if (el) {
            el.setAttribute('data-enable-background', updatedData[key].enableBackgroundItem ? 'true' : 'false');
            el.setAttribute('data-bg-start', updatedData[key].bgStart);
            el.setAttribute('data-bg-end', updatedData[key].bgEnd);
            el.setAttribute('data-main-color-item', updatedData[key].mainColorItem);
            el.style.setProperty('--bg-start', updatedData[key].bgStart);
            el.style.setProperty('--bg-end', updatedData[key].bgEnd);
            el.style.setProperty('--main-color-item', updatedData[key].mainColorItem);
          }
          break;
        }
        case 'enableContainerPage': {
          const el = container.querySelector('[data-attribute="container-page"]');
          if (el) {
            const enabled = updatedData[key] !== false;
            el.setAttribute('data-enable-style', enabled ? 'true' : 'false');
          }
          break;
        }
        case 'backgroundContainer': {
          const enableContainerPage = updatedData['enableContainerPage'] !== false;
          const el = container.querySelector('[data-attribute="container-page"]');
          if (enableContainerPage && el) {
            el.setAttribute('data-background-container', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          } else if (el) {
            el.style.backgroundColor = 'transparent';
          }
          break;
        }
        case 'listItem': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            const nextItems =
              Array.isArray(updatedData[key]) && updatedData[key].length > 0
                ? updatedData[key]
                : [
                    {
                      avatar: '',
                      nameReviewer: '',
                      starsReview: 5,
                      contentReview: '',
                    },
                  ];

            listEl.innerHTML = nextItems
              .map(item => {
                const starsReview = Math.min(Math.max(parseInt(item.starsReview, 10) || 5, 1), 5);
                return `
                  <div data-attribute="item" class="swiper-slide">
                    <div class="wrap-item">
                      <div class="avatar">
                        <img data-attribute="avatar" src="${item.avatar || ''}" alt="">
                      </div>
                      <div class="right-item">
                        <div class="head-item">
                          <div data-attribute="name-reviewer" class="name-reviewer">${item.nameReviewer || ''}</div>
                          <div class="icon-verified">
                            <svg class="customer-review-verified" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5924 3.20027C9.34888 3.4078 9.22711 3.51158 9.09706 3.59874C8.79896 3.79854 8.46417 3.93721 8.1121 4.00672C7.95851 4.03705 7.79903 4.04977 7.48008 4.07522C6.6787 4.13918 6.278 4.17115 5.94371 4.28923C5.17051 4.56233 4.56233 5.17051 4.28923 5.94371C4.17115 6.278 4.13918 6.6787 4.07522 7.48008C4.04977 7.79903 4.03705 7.95851 4.00672 8.1121C3.93721 8.46417 3.79854 8.79896 3.59874 9.09706C3.51158 9.22711 3.40781 9.34887 3.20027 9.5924C2.67883 10.2043 2.4181 10.5102 2.26522 10.8301C1.91159 11.57 1.91159 12.43 2.26522 13.1699C2.41811 13.4898 2.67883 13.7957 3.20027 14.4076C3.40778 14.6511 3.51158 14.7729 3.59874 14.9029C3.79854 15.201 3.93721 15.5358 4.00672 15.8879C4.03705 16.0415 4.04977 16.201 4.07522 16.5199C4.13918 17.3213 4.17115 17.722 4.28923 18.0563C4.56233 18.8295 5.17051 19.4377 5.94371 19.7108C6.278 19.8288 6.6787 19.8608 7.48008 19.9248C7.79903 19.9502 7.95851 19.963 8.1121 19.9933C8.46417 20.0628 8.79896 20.2015 9.09706 20.4013C9.22711 20.4884 9.34887 20.5922 9.5924 20.7997C10.2043 21.3212 10.5102 21.5819 10.8301 21.7348C11.57 22.0884 12.43 22.0884 13.1699 21.7348C13.4898 21.5819 13.7957 21.3212 14.4076 20.7997C14.6511 20.5922 14.7729 20.4884 14.9029 20.4013C15.201 20.2015 15.5358 20.0628 15.8879 19.9933C16.0415 19.963 16.201 19.9502 16.5199 19.9248C17.3213 19.8608 17.722 19.8288 18.0563 19.7108C18.8295 19.4377 19.4377 18.8295 19.7108 18.0563C19.8288 17.722 19.8608 17.3213 19.9248 16.5199C19.9502 16.201 19.963 16.0415 19.9933 15.8879C20.0628 15.5358 20.2015 15.201 20.4013 14.9029C20.4884 14.7729 20.5922 14.6511 20.7997 14.4076C21.3212 13.7957 21.5819 13.4898 21.7348 13.1699C22.0884 12.43 22.0884 11.57 21.7348 10.8301C21.5819 10.5102 21.3212 10.2043 20.7997 9.5924C20.5922 9.34887 20.4884 9.22711 20.4013 9.09706C20.2015 8.79896 20.0628 8.46417 19.9933 8.1121C19.963 7.95851 19.9502 7.79903 19.9248 7.48008C19.8608 6.6787 19.8288 6.278 19.7108 5.94371C19.4377 5.17051 18.8295 4.56233 18.0563 4.28923C17.722 4.17115 17.3213 4.13918 16.5199 4.07522C16.201 4.04977 16.0415 4.03705 15.8879 4.00672C15.5358 3.93721 15.201 3.79854 14.9029 3.59874C14.7729 3.51158 14.6511 3.40781 14.4076 3.20027C13.7957 2.67883 13.4898 2.41811 13.1699 2.26522C12.43 1.91159 11.57 1.91159 10.8301 2.26522C10.5102 2.4181 10.2043 2.67883 9.5924 3.20027ZM16.3735 9.86314C16.6913 9.5453 16.6913 9.03 16.3735 8.71216C16.0557 8.39433 15.5403 8.39433 15.2225 8.71216L10.3723 13.5624L8.77746 11.9676C8.45963 11.6498 7.94432 11.6498 7.62649 11.9676C7.30866 12.2854 7.30866 12.8007 7.62649 13.1186L9.79678 15.2889C10.1146 15.6067 10.6299 15.6067 10.9478 15.2889L16.3735 9.86314Z" fill="currentColor"></path>
                            </svg>
                          </div>
                          <div data-attribute="stars-review" data-value="${starsReview}" class="stars-review">
                            ${createStarsHtml(starsReview)}
                          </div>
                        </div>
                        <div data-attribute="content-review" class="content-review">
                          ${item.contentReview || ''}
                        </div>
                      </div>
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionTextWithButton(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const syncCardContainerCssVars = () => {
      if (!cardContainer) return;
      const bg = updatedData['background-section']?.color;
      const text = updatedData.textColor;
      const btnBg = updatedData.btnCard?.background;
      const btnColor = updatedData.btnCard?.color;
      if (bg) cardContainer.style.setProperty('--color-background', bg);
      if (text) cardContainer.style.setProperty('--color-text', text);
      if (btnBg) cardContainer.style.setProperty('--btn-background-color', btnBg);
      if (btnColor) cardContainer.style.setProperty('--btn-text-color', btnColor);
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
            syncCardContainerCssVars();
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.setAttribute('data-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            syncCardContainerCssVars();
          }
          break;
        }
        case 'titleCard': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) {
            el.setAttribute('data-show-title', updatedData[key].show);
            el.style.display = updatedData[key].show ? '' : 'none';
            el.innerHTML = updatedData[key].content || '';
          }
          break;
        }
        case 'btnCard': {
          const el = container.querySelector('[data-attribute="btn-card"]');
          if (el) {
            el.setAttribute('data-show-btn', updatedData[key].show);
            el.style.display = updatedData[key].show ? '' : 'none';
            el.setAttribute('href', updatedData[key].url || '#');
            el.setAttribute('data-background', updatedData[key].background);
            el.setAttribute('data-color', updatedData[key].color);
            el.style.backgroundColor = updatedData[key].background;
            el.style.color = updatedData[key].color;
            el.textContent = updatedData[key].text || '';
          }
          syncCardContainerCssVars();
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionFaqVital(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const chevronDownSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-chevron-down-icon lucide-chevron-down">
        <path d="m6 9 6 6 6-6" />
      </svg>
    `;

    const syncCardContainerCssVars = () => {
      if (!cardContainer) return;
      const bg = updatedData['background-section']?.color;
      const text = updatedData.textColor;
      if (bg) cardContainer.style.setProperty('--color-background', bg);
      if (text) cardContainer.style.setProperty('--color-text', text);
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
            syncCardContainerCssVars();
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.setAttribute('data-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            syncCardContainerCssVars();
          }
          break;
        }
        case 'leftCard': {
          const el = container.querySelector('[data-attribute="card-left"]');
          if (el) {
            el.style.order = String(updatedData[key]?.order || 1);
            el.setAttribute('data-order', String(updatedData[key]?.order || 1));
          }
          break;
        }
        case 'titleCardLeft': {
          const el = container.querySelector('[data-attribute="title-card-left"]');
          if (el) {
            el.setAttribute('data-show', updatedData[key].show);
            el.style.display = updatedData[key].show ? '' : 'none';
            el.innerHTML = updatedData[key].content || '';
          }
          break;
        }
        case 'highlightGroup': {
          const el = container.querySelector('[data-attribute="hight-light-group"]');
          const leftCardEl = container.querySelector('[data-attribute="card-left"]');
          if (el) {
            el.setAttribute('data-show', updatedData[key].show);
            el.setAttribute('data-hl-background', updatedData[key].background || '#daecf0');
            el.style.display = updatedData[key].show ? '' : 'none';
            el.innerHTML = updatedData[key].content || '';
          }
          if (leftCardEl) {
            leftCardEl.style.setProperty('--hl-background', updatedData[key].background || '#daecf0');
          }
          break;
        }
        case 'btnCardLeft': {
          const el = container.querySelector('[data-attribute="btn-card-left"]');
          if (el) {
            el.setAttribute('data-show', updatedData[key].show);
            el.style.display = updatedData[key].show ? '' : 'none';
            el.setAttribute('href', updatedData[key].url || '#');
            el.setAttribute('data-color', updatedData[key].color || '#214a88');
            el.style.color = updatedData[key].color || '#214a88';
            const textEl = el.querySelector('[data-attribute="text-btn"]');
            if (textEl) {
              textEl.textContent = updatedData[key].text || '';
            } else {
              el.textContent = updatedData[key].text || '';
            }
          }
          break;
        }
        case 'rightCard': {
          const el = container.querySelector('[data-attribute="card-right"]');
          if (el) {
            el.style.order = String(updatedData[key]?.order || 2);
            el.setAttribute('data-order', String(updatedData[key]?.order || 2));
          }
          break;
        }
        case 'itemAccordions': {
          const el = container.querySelector('[data-attribute="card-accordions"]');
          if (el) {
            el.setAttribute('data-show-accordion', updatedData[key]?.dataShowAccordion);
            el.style.display = updatedData[key]?.dataShowAccordion ? 'block' : 'none';
            el.innerHTML = (updatedData[key]?.listItem || [])
              .map(
                item => `
                <div data-attribute="card-accordion" class="wrap-accordion">
                  <div data-attribute="accordion-title" class="accordion-title">
                    <div data-attribute="accordion-title-text">${item.title || ''}</div>
                    <div class="accordion-icon">${chevronDownSvg}</div>
                  </div>
                  <div data-attribute="accordion-content" class="accordion-content">
                    <div data-attribute="accordion-text" class="accordion-text">${item.answer || ''}</div>
                  </div>
                </div>
              `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardVitalSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const syncItemCssVars = () => {
      if (!cardContainer) return;
      const ib = updatedData.slider?.itemBackground;
      const idb = updatedData.slider?.itemDesBackground;
      if (ib) cardContainer.style.setProperty('--item-background', ib);
      if (idb) cardContainer.style.setProperty('--item-des-background', idb);
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
            cardContainer.style.setProperty('--color-background', updatedData[key].color);
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.setAttribute('data-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--color-text', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const titleCardEl = container.querySelector('[data-attribute="title-card"]');
          if (titleCardEl && updatedData[key]) {
            const tc = updatedData[key];
            titleCardEl.setAttribute('data-show-title', tc.showTitle !== false ? 'true' : 'false');
            if (tc.html != null) titleCardEl.innerHTML = tc.html;
          }
          break;
        }
        case 'slider': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl && updatedData[key]) {
            listEl.setAttribute('data-col-per-view', String(updatedData[key].colPerView ?? 4));
            listEl.setAttribute('data-space-between', String(updatedData[key].spaceBetween ?? 16));
            listEl.setAttribute('data-item-background', updatedData[key].itemBackground || '#ffffff');
            listEl.setAttribute('data-item-des-background', updatedData[key].itemDesBackground || '#daecf0');
          }
          syncItemCssVars();
          break;
        }
        case 'listItem': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            listEl.setAttribute('data-col-per-view', String(updatedData.slider?.colPerView ?? 4));
            listEl.setAttribute('data-space-between', String(updatedData.slider?.spaceBetween ?? 16));
            listEl.setAttribute('data-item-background', updatedData.slider?.itemBackground || '#ffffff');
            listEl.setAttribute('data-item-des-background', updatedData.slider?.itemDesBackground || '#daecf0');
            listEl.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <div class="wrap-img">
                      <img data-attribute="image-item" src="${item.image || ''}" alt="">
                    </div>
                    <div data-padding="${
                      item.descriptionPadding !== false ? 'true' : 'false'
                    }" data-attribute="description-item" class="description-item">${item.description || ''}</div>
                  </div>
                </div>
              `,
              )
              .join('');
          }
          syncItemCssVars();
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardVitalSlider02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const syncItemCssVars = () => {
      if (!cardContainer) return;

      const s = updatedData.slider || {};
      if (s.itemBackground) cardContainer.style.setProperty('--item-background', s.itemBackground);
      if (s.itemContentBackground)
        cardContainer.style.setProperty('--item-content-background', s.itemContentBackground);
      if (s.itemContentBackgroundHover)
        cardContainer.style.setProperty('--item-content-background-hover', s.itemContentBackgroundHover);
      if (s.itemContentTextColor) cardContainer.style.setProperty('--item-content-text-color', s.itemContentTextColor);
      if (s.itemContentTextColorHover)
        cardContainer.style.setProperty('--item-content-text-color-hover', s.itemContentTextColorHover);
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
            cardContainer.style.setProperty('--color-background', updatedData[key].color);
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.setAttribute('data-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--color-text', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const titleCardEl = container.querySelector('[data-attribute="title-card"]');
          if (titleCardEl && updatedData[key]) {
            const tc = updatedData[key];
            titleCardEl.setAttribute('data-show-title', tc.showTitle !== false ? 'true' : 'false');
            if (tc.html != null) titleCardEl.innerHTML = tc.html;
          }
          break;
        }
        case 'slider': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl && updatedData[key]) {
            listEl.setAttribute('data-col-per-view', String(updatedData[key].colPerView ?? 3));
            listEl.setAttribute('data-space-between', String(updatedData[key].spaceBetween ?? 16));
            listEl.setAttribute('data-item-background', updatedData[key].itemBackground || '#ffffff');
            listEl.setAttribute('data-item-content-background', updatedData[key].itemContentBackground || '#daecf0');
            listEl.setAttribute(
              'data-item-content-background-hover',
              updatedData[key].itemContentBackgroundHover || '#214a88',
            );
            listEl.setAttribute('data-item-content-text-color', updatedData[key].itemContentTextColor || '#214a88');
            listEl.setAttribute(
              'data-item-content-text-color-hover',
              updatedData[key].itemContentTextColorHover || '#ffffff',
            );
          }
          syncItemCssVars();
          break;
        }
        case 'listItem': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            listEl.setAttribute('data-col-per-view', String(updatedData.slider?.colPerView ?? 3));
            listEl.setAttribute('data-space-between', String(updatedData.slider?.spaceBetween ?? 16));
            listEl.setAttribute('data-item-background', updatedData.slider?.itemBackground || '#ffffff');
            listEl.setAttribute('data-item-content-background', updatedData.slider?.itemContentBackground || '#daecf0');
            listEl.setAttribute(
              'data-item-content-background-hover',
              updatedData.slider?.itemContentBackgroundHover || '#214a88',
            );
            listEl.setAttribute('data-item-content-text-color', updatedData.slider?.itemContentTextColor || '#214a88');
            listEl.setAttribute(
              'data-item-content-text-color-hover',
              updatedData.slider?.itemContentTextColorHover || '#ffffff',
            );

            listEl.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <div class="wrap-img-decor">
                      <img data-attribute="img-decor-item" src="${item.imageDecor || ''}" alt="">
                    </div>
                    <div data-attribute="content-item" class="content-item">
                      <div data-attribute="title-item" class="title-item">
                        ${item.titleItemHtml || ''}
                      </div>
                      <div data-attribute="description-item" class="description-item">
                        ${item.descriptionItemHtml || ''}
                      </div>
                    </div>
                  </div>
                </div>
              `,
              )
              .join('');
          }
          syncItemCssVars();
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardVitalSurround(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
            cardContainer.style.setProperty('--color-background', updatedData[key].color);
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.setAttribute('data-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--color-text', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const titleCardEl = container.querySelector('[data-attribute="title-card"]');
          if (titleCardEl && updatedData[key]) {
            const tc = updatedData[key];
            titleCardEl.setAttribute('data-show-title', tc.showTitle !== false ? 'true' : 'false');
            if (tc.html != null) titleCardEl.innerHTML = tc.html;
          }
          break;
        }
        case 'mainItemImage': {
          const imgEl = container.querySelector('[data-attribute="img-main-item"]');
          if (imgEl) imgEl.setAttribute('src', updatedData[key] || '');
          break;
        }
        case 'listItem': {
          const listEl = container.querySelector('[data-attribute="list-item"]');
          if (listEl) {
            listEl.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                <div data-attribute="item-surround" class="item-surround">
                  <div class="wrap-img-item">
                    <img data-attribute="img-item" src="${item.image || ''}" alt="">
                  </div>
                  <div data-attribute="text-item" class="text-item">${item.text || ''}</div>
                </div>
              `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardVitalTab(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const syncWrapCardImageSideAttr = () => {
      const wrap = container.querySelector('[data-attribute="wrap-card"]') || container.querySelector('.wrap-card');
      const rightCard = container.querySelector('[data-attribute="right-card"]');
      const leftCard = container.querySelector('[data-attribute="left-card"]');
      if (!wrap || !rightCard || !leftCard) return;
      const ro = parseInt(rightCard.getAttribute('data-order') || rightCard.style.order || '1', 10);
      const lo = parseInt(leftCard.getAttribute('data-order') || leftCard.style.order || '2', 10);
      const r = Number.isNaN(ro) ? 1 : ro;
      const l = Number.isNaN(lo) ? 2 : lo;
      wrap.setAttribute('data-right-card-position', r <= l ? 'left' : 'right');
    };

    const applyTabHeaderColors = data => {
      const elList = container.querySelector('[data-attribute="list-tab-header"]');
      const c1 = data.colorTabHeader || elList?.getAttribute('data-color-tab-header') || '#214a88';
      const c2 = data.colorTabHeaderHover || elList?.getAttribute('data-color-tab-header-hover') || '#ffffff';
      const c3 = data.bgTabHeaderHover || elList?.getAttribute('data-bg-tab-header-hover') || '#214a88';
      if (elList) {
        elList.setAttribute('data-color-tab-header', c1);
        elList.setAttribute('data-color-tab-header-hover', c2);
        elList.setAttribute('data-bg-tab-header-hover', c3);
      }
      if (cardContainer) {
        cardContainer.style.setProperty('--color-tab-header', c1);
        cardContainer.style.setProperty('--color-tab-header-hover', c2);
        cardContainer.style.setProperty('--bg-tab-header-hover', c3);
      }
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
            cardContainer.style.setProperty('--color-background', updatedData[key].color);
          }
          break;
        }
        case 'container-content': {
          const elPage = container.querySelector('[data-attribute="container-page"]');
          if (elPage) {
            elPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elPage.setAttribute('data-background', updatedData[key].background);
            elPage.style.backgroundColor = updatedData[key].showStyle ? updatedData[key].background : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.setAttribute('data-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--color-text', updatedData[key]);
          }
          break;
        }
        case 'title-card': {
          const pageContainer = container.querySelector('[data-attribute="container-page"] .container');
          const outerTitle = pageContainer?.querySelector(':scope > [data-attribute="title-card"]');
          if (outerTitle && updatedData[key]) {
            const tc = updatedData[key];
            outerTitle.setAttribute('data-show-title', tc.showTitle !== false ? 'true' : 'false');
            if (tc.html != null) outerTitle.innerHTML = tc.html;
          }
          break;
        }
        case 'leftHighlight': {
          const leftCard = container.querySelector('[data-attribute="left-card"]');
          if (leftCard) {
            leftCard.setAttribute('data-highlight-left-card', updatedData[key] || '');
          }
          if (cardContainer) {
            cardContainer.style.setProperty('--hl-background-left-card', updatedData[key] || '#eff6f9');
          }
          break;
        }
        case 'leftCardTitle': {
          const innerTitle = container.querySelector('[data-attribute="left-card"] > [data-attribute="title-card"]');
          if (innerTitle && updatedData[key] != null) innerTitle.innerHTML = updatedData[key];
          break;
        }
        case 'rightCardImage': {
          const imgEl = container.querySelector('[data-attribute="image-right-card"]');
          if (imgEl) imgEl.setAttribute('src', updatedData[key] || '');
          break;
        }
        case 'rightCardLayoutPosition': {
          const rightCard = container.querySelector('[data-attribute="right-card"]');
          if (rightCard) {
            const o = updatedData[key];
            rightCard.setAttribute('data-order', String(o));
            rightCard.style.order = String(o);
          }
          syncWrapCardImageSideAttr();
          break;
        }
        case 'leftCardLayoutPosition': {
          const leftCard = container.querySelector('[data-attribute="left-card"]');
          if (leftCard) {
            const o = updatedData[key];
            leftCard.setAttribute('data-order', String(o));
            leftCard.style.order = String(o);
          }
          syncWrapCardImageSideAttr();
          break;
        }
        /** legacy fields from older editor saves */
        case 'rightCardPosition': {
          const rightCard = container.querySelector('[data-attribute="right-card"]');
          const leftCard = container.querySelector('[data-attribute="left-card"]');
          const imageLeft = updatedData[key] !== 'right';
          const rightOrder = imageLeft ? 1 : 2;
          const leftOrder = imageLeft ? 2 : 1;
          if (rightCard) {
            rightCard.setAttribute('data-order', String(rightOrder));
            rightCard.style.order = String(rightOrder);
          }
          if (leftCard) {
            leftCard.setAttribute('data-order', String(leftOrder));
            leftCard.style.order = String(leftOrder);
          }
          syncWrapCardImageSideAttr();
          break;
        }
        case 'leftCardPosition': {
          const pos = updatedData[key] === 'left' ? 'right' : 'left';
          const rightCard = container.querySelector('[data-attribute="right-card"]');
          const leftCard = container.querySelector('[data-attribute="left-card"]');
          const imageLeft = pos === 'left';
          const rightOrder = imageLeft ? 1 : 2;
          const leftOrder = imageLeft ? 2 : 1;
          if (rightCard) {
            rightCard.setAttribute('data-order', String(rightOrder));
            rightCard.style.order = String(rightOrder);
          }
          if (leftCard) {
            leftCard.setAttribute('data-order', String(leftOrder));
            leftCard.style.order = String(leftOrder);
          }
          syncWrapCardImageSideAttr();
          break;
        }
        case 'colorTabHeader':
        case 'colorTabHeaderHover':
        case 'bgTabHeaderHover': {
          applyTabHeaderColors(updatedData);
          break;
        }
        case 'listTab': {
          const elListTabHeader = container.querySelector('[data-attribute="list-tab-header"]');
          const elListTabContent = container.querySelector('[data-attribute="list-tab-content"]');
          const tabs = updatedData[key] || [];
          applyTabHeaderColors(updatedData);
          if (elListTabHeader) {
            elListTabHeader.innerHTML = tabs
              .map((item, index) => {
                return `
                <div class="tab-header-item ${index === 0 ? 'active' : ''}" data-tab="tab-${index +
                  1}" data-attribute="tab-header-item">${item.title || ''}</div>
              `;
              })
              .join('');
          }
          if (elListTabContent) {
            elListTabContent.innerHTML = tabs
              .map((item, index) => {
                return `
                <div class="tab-content-item ${index === 0 ? 'active' : ''}" data-tab="tab-${index +
                  1}" data-attribute="tab-content-item">
                  <div data-attribute="title-tab-content" class="title-tab-content">${item.titleContent || ''}</div>
                  <div data-attribute="foot-tab-content" class="foot-tab-content">${item.footContent || ''}</div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionReviewInfiniteMarquee(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'review-title': {
          const el = container.querySelector('[data-attribute="review-infinite-marquee-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('.review-infinite-marquee-container-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('.review-infinite-marquee-container-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        case 'imageSize': {
          const el = container.querySelector('.review-infinite-marquee-container-wrapper');
          if (el) {
            el.setAttribute('data-image-size', updatedData[key]);
          }
          break;
        }
        case 'containerStyle': {
          const wrapperEl = container.querySelector('.review-infinite-marquee-container-wrapper');
          const containerEl = container.querySelector('.review-infinite-marquee-container');
          if (wrapperEl) {
            wrapperEl.setAttribute('data-container-style', updatedData[key]);
            if (containerEl && updatedData[key]) {
              containerEl.classList.add('container');
            } else {
              containerEl.classList.remove('container');
            }
          }
          break;
        }
        case 'enableRating': {
          const wrapperEl = container.querySelector('.review-infinite-marquee-container-wrapper');
          const ratingEl = wrapperEl.querySelector('.review-infinite-marquee-rating');
          if (wrapperEl) {
            wrapperEl.setAttribute('data-enable-rating', updatedData[key]);
            if (updatedData[key]) {
              ratingEl.style.display = 'flex';
            } else {
              ratingEl.style.display = 'none';
            }
          }
          break;
        }
        case 'rating-value': {
          const ratingValueEl = container.querySelector('[data-attribute="review-infinite-marquee-rating-value"]');
          const starsEl = container.querySelector('[data-attribute="review-infinite-marquee-rating-stars"]');

          if (ratingValueEl) {
            ratingValueEl.textContent = updatedData[key];
          }

          if (starsEl) {
            const rating = parseFloat(updatedData[key]);
            const fullStars = Math.floor(rating);
            const hasHalfStar = rating % 1 >= 0.1;

            // Set data attributes like product-reviews section
            starsEl.setAttribute('data-full-stars', fullStars);
            if (hasHalfStar) {
              starsEl.setAttribute('data-half-star', fullStars + 1);
            } else {
              starsEl.removeAttribute('data-half-star');
            }

            // Generate 5 stars like product-reviews-section.js - all with fill="currentColor"
            let starsHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" style="position: absolute;">
                <defs>
                  <linearGradient id="half-star-gradient-infinite" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="50%" style="stop-color:#f0b100;stop-opacity:1" />
                    <stop offset="50%" style="stop-color:#f0b100;stop-opacity:0" />
                  </linearGradient>
                </defs>
              </svg>
            `;
            for (let i = 0; i < 5; i++) {
              starsHTML += `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                </svg>
              `;
            }

            starsEl.innerHTML = starsHTML;
          }
          break;
        }
        case 'description': {
          const el = container.querySelector('[data-attribute="review-infinite-marquee-description"]');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('.review-infinite-marquee-container-wrapper');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('.review-infinite-marquee-container-wrapper');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'showHeader': {
          const headerEl = doc.querySelector('.review-infinite-marquee-header');
          if (headerEl) {
            headerEl.setAttribute('data-show', updatedData[key]);
          }
          break;
        }
        case 'showTag': {
          const tagEl = doc.querySelector('.review-infinite-marquee-tag');
          if (tagEl) {
            tagEl.setAttribute('data-show', updatedData[key]);
          }
          break;
        }
        case 'tagContent': {
          const tagEl = doc.querySelector('.review-infinite-marquee-tag');
          if (tagEl) {
            tagEl.textContent = updatedData[key] || '';
          }
          break;
        }
        case 'review-images': {
          const listEl = container.querySelector('[data-attribute="review-infinite-marquee-list"]');
          if (listEl) {
            if (!updatedData[key] || !Array.isArray(updatedData[key]) || updatedData[key].length === 0) {
              listEl.innerHTML = '';
              const container = listEl.closest('.review-infinite-marquee-container');
              if (container) {
                container.style.removeProperty('--marquee-duration');
                container.style.removeProperty('--marquee-content-width');
                container.style.removeProperty('--marquee-translate-distance');
                container.style.removeProperty('--marquee-original-count');
              }
              break;
            }

            const images = updatedData[key];

            let containerWidth = 1920;
            if (typeof window !== 'undefined' && window.innerWidth) {
              containerWidth = window.innerWidth;

              const marqueeContainer = listEl.closest('.review-infinite-marquee-container');
              if (marqueeContainer && marqueeContainer.offsetWidth > 0) {
                containerWidth = marqueeContainer.offsetWidth;
              }
            }

            const itemWidth = containerWidth <= 768 ? 120 : containerWidth <= 1024 ? 180 : 250;
            const gap = containerWidth <= 768 ? 12 : 16;
            const itemWithGap = itemWidth + gap;

            const minItemsNeeded = Math.ceil((containerWidth * 3) / itemWithGap);
            const minItemsForSmoothScroll = Math.max(8, minItemsNeeded);

            let itemsToRender = [];
            let needsDuplication = false;

            if (images.length < minItemsForSmoothScroll && images.length > 0) {
              needsDuplication = true;
              const duplicationFactor = Math.ceil(minItemsForSmoothScroll / images.length);

              for (let i = 0; i < duplicationFactor; i++) {
                itemsToRender.push(
                  ...images.map(image => ({
                    ...image,
                    isClone: i > 0,
                  })),
                );
              }
            } else {
              itemsToRender = images.map(image => ({ ...image, isClone: false }));
            }

            const itemsHTML = itemsToRender
              .map((image, index) => {
                const isOriginal = index < images.length;
                const cssClasses = [
                  'review-infinite-marquee-item',
                  isOriginal ? 'marquee-item-original' : 'marquee-item-clone',
                ].join(' ');

                return `
                <div data-attribute="review-infinite-marquee-item"
                     class="${cssClasses}"
                     data-original="${isOriginal}"
                     data-clone-index="${isOriginal ? '' : Math.floor(index / images.length)}">
                  <img loading="lazy" data-attribute="review-infinite-marquee-item-avatar"
                    src="${image.avatar}" alt=""
                    onerror="this.style.display='none'">
                </div>
              `;
              })
              .join('');

            listEl.innerHTML = itemsHTML;

            // Calculate animation duration based on ORIGINAL items only for consistent speed
            const originalItems = images.length;
            const baseSpeedPerOriginalItem = 3; // Base seconds per original item
            const minDuration = 8;
            const maxDuration = 100;

            const calculatedDuration = Math.max(
              minDuration,
              Math.min(maxDuration, originalItems * baseSpeedPerOriginalItem),
            );

            const marqueeContainer = listEl.closest('.review-infinite-marquee-container');
            if (marqueeContainer) {
              marqueeContainer.style.setProperty('--marquee-duration', `${calculatedDuration}s`);

              if (needsDuplication) {
                const originalContentWidth = images.length * itemWidth + (images.length - 1) * gap;
                const totalContentWidth = itemsToRender.length * itemWidth + (itemsToRender.length - 1) * gap;

                const translateDistance = originalContentWidth;

                marqueeContainer.style.setProperty('--marquee-content-width', `${totalContentWidth}px`);
                marqueeContainer.style.setProperty('--marquee-translate-distance', `-${translateDistance}px`);
                marqueeContainer.style.setProperty('--marquee-original-count', images.length);
              } else {
                // For sufficient items, use standard percentage-based translate
                marqueeContainer.style.removeProperty('--marquee-content-width');
                marqueeContainer.style.setProperty('--marquee-translate-distance', `-50%`);
                marqueeContainer.style.removeProperty('--marquee-original-count');
              }
            }
          }
          break;
        }
      }
    }

    return container.innerHTML.trim();
  },
  sectionCollapsibleProductGrid(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          const innerTitleEl = container.querySelector(
            '[data-attribute="section-container"] [data-attribute="section-title"]',
          );
          if (innerTitleEl) {
            innerTitleEl.textContent = updatedData[key];
          }
          break;
        }
        case 'section-text-color': {
          const el = container.querySelector('[data-attribute="section-container"]');
          if (el) {
            el.style.color = updatedData[key];
            el.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'section-background-color': {
          const el = container.querySelector('[data-attribute="section-container"]');
          if (el) {
            el.style.backgroundColor = updatedData[key];
            el.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'card-text-color': {
          const items = container.querySelectorAll('[data-attribute="grid-item"]');
          items.forEach(item => {
            item.style.color = updatedData[key];
            item.setAttribute('data-card-text-color', updatedData[key]);
          });
          break;
        }
        case 'card-background-color': {
          const items = container.querySelectorAll('[data-attribute="grid-item"]');
          items.forEach(item => {
            item.style.backgroundColor = updatedData[key];
            item.setAttribute('data-card-background-color', updatedData[key]);
          });
          break;
        }
        case 'section-description': {
          const el = container.querySelector('[data-attribute="section-description"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'see-more-text': {
          const elements = container.querySelectorAll('[data-attribute="see-more-text"]');
          elements.forEach(el => {
            el.textContent = updatedData[key];
          });
          const container_el = container.querySelector('[data-attribute="section-container"]');
          if (container_el) {
            container_el.setAttribute('data-see-more-text', updatedData[key]);
          }
          break;
        }
        case 'see-less-text': {
          const elements = container.querySelectorAll('[data-attribute="see-more-text"]');
          elements.forEach(el => {
            el.textContent = updatedData[key];
          });
          const container_el = container.querySelector('[data-attribute="section-container"]');
          if (container_el) {
            container_el.setAttribute('data-see-less-text', updatedData[key]);
          }
          break;
        }
        case 'grid-items': {
          const containerEl = container.querySelector('[data-attribute="grid-items-container"]');
          if (containerEl && Array.isArray(updatedData[key])) {
            const cardBg = updatedData['card-background-color'];
            const cardText = updatedData['card-text-color'];
            containerEl.innerHTML = updatedData[key]
              .map(item => {
                const styleAttr = `style="${cardBg ? `background-color: ${cardBg};` : ''} ${
                  cardText ? `color: ${cardText};` : ''
                }"`;
                const dataAttrs = `${cardBg ? `data-card-background-color="${cardBg}"` : ''} ${
                  cardText ? `data-card-text-color="${cardText}"` : ''
                }`;
                return `<div class="collapsible-product-grid-item" data-attribute="grid-item" ${dataAttrs} ${styleAttr}>
                  <div class="collapsible-product-grid-item-head">
                    <div class="collapsible-product-grid-item-meta">
                      <img class="collapsible-product-grid-item-image" loading="lazy" data-attribute="item-image"
                        src="${item.image}"
                        alt="product-image">
                      <h3 class="collapsible-product-grid-item-title" data-attribute="item-title">
                        ${item.title}
                      </h3>
                    </div>
                    <div class="collapsible-product-grid-item-button" type="button">
                      <span class="collapsible-product-grid-item-button-text" data-attribute="see-more-text">
                        ${updatedData['see-more-text']}
                      </span>
                      <span class="collapsible-product-grid-item-button-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.043" height="7.602" viewBox="0 0 10.043 7.602">
                          <path id="Union_19" data-name="Union 19"
                            d="M8.428,0a.386.386,0,0,0-.315.167L4.922,4.8,1.91.177A.381.381,0,0,0,1.589,0H.384A.379.379,0,0,0,.05.2.379.379,0,0,0,.056.586L4.285,7.422a.387.387,0,0,0,.328.18h.533a.376.376,0,0,0,.318-.17L9.979.6A.387.387,0,0,0,9.658,0Z"
                            fill="${cardText}"></path>
                        </svg>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.042" height="7.602" viewBox="0 0 10.042 7.602">
                          <path id="Union_17" data-name="Union 17"
                            d="M11.428,7.6a.382.382,0,0,1-.315-.167L7.922,2.8,4.911,7.427a.381.381,0,0,1-.322.177h-1.2a.384.384,0,0,1-.328-.586L7.285.182A.385.385,0,0,1,7.61,0h.533a.382.382,0,0,1,.322.17L12.979,7A.389.389,0,0,1,13,7.4a.384.384,0,0,1-.337.2Z"
                            transform="translate(-3 -0.002)" fill="${cardText}"></path>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div class="collapsible-product-grid-item-content" data-attribute="item-content">
                    ${item.content}
                  </div>
                </div>`;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="section-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="section-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardMediaSlider(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'card-container': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'header': {
          const el = container.querySelector('[data-attribute="card-header"]');
          const show = updatedData[key].show;
          if (el) {
            el.innerHTML = updatedData[key].content;
            el.style.display = show ? 'block' : 'none';
            el.setAttribute('data-show', show);
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                const type = item.type || (item.image ? 'image' : 'video');

                if (type === 'image' && item.image) {
                  // Render image
                  const objectFit = item.objectFit || 'cover';
                  return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <img loading="lazy" data-attribute="card-image" src="${item.image}" alt="" style="width: 100%; height: 100%; object-fit: ${objectFit}; border-radius: 16px;" />
                  </div>
                </div>
              `;
                } else {
                  // Render video (default or fallback)
                  return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <video loop playsinline muted width="600">
                      <source data-attribute="card-video"
                        src="${item.video || ''}"
                        type="video/mp4">
                    </video>
                    <div class="volume">
                      <span class="volume-icon" style="display: none;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-volume2-icon lucide-volume-2">
                          <path
                            d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                          <path d="M16 9a5 5 0 0 1 0 6" />
                          <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                        </svg>
                      </span>
                      <span class="mute-icon" style="display: flex;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-volume-off-icon lucide-volume-off">
                          <path d="M16 9a5 5 0 0 1 .95 2.293" />
                          <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                          <path d="m2 2 20 20" />
                          <path
                            d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                          <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              `;
                }
              })
              .join('');
          }
          break;
        }
        case 'pagination-active-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          const listItemEl = container.querySelector('[data-attribute="list-item"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-active-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          if (listItemEl) {
            listItemEl.setAttribute('data-pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          const listItemEl = container.querySelector('[data-attribute="list-item"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-inactive-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          if (listItemEl) {
            listItemEl.setAttribute('data-pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardMediaSlider03(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'header': {
          const el = container.querySelector('[data-attribute="card-header"]');
          const show = updatedData[key].show;
          if (el) {
            el.innerHTML = updatedData[key].content;
            el.style.display = show ? 'block' : 'none';
            el.setAttribute('data-show', show);
          }
          break;
        }
        case 'card-item-background-color': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-card-item-background-color', updatedData[key]);
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          const cardItemBackgroundColor = updatedData['card-item-background-color'];
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                const type = item.type || (item.image ? 'image' : 'video');

                if (type === 'image' && item.image) {
                  // Render image
                  return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item" style="background-color: ${cardItemBackgroundColor};">
                    <img loading="lazy" data-attribute="card-image" src="${item.image}" alt="" />
                    <div class="wrap-item-content">
                      ${item.content}
                    </div>
                  </div>
                </div>
              `;
                } else {
                  // Render video (default or fallback)
                  return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item" style="background-color: ${cardItemBackgroundColor};">
                    <div class="wrap-item-video">
                      <video loop playsinline muted width="600">
                        <source data-attribute="card-video"
                          src="${item.video || ''}"
                          type="video/mp4">
                      </video>
                      <div class="volume">
                        <span class="volume-icon" style="display: none;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-volume2-icon lucide-volume-2">
                            <path
                              d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                            <path d="M16 9a5 5 0 0 1 0 6" />
                            <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                          </svg>
                        </span>
                        <span class="mute-icon" style="display: flex;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-volume-off-icon lucide-volume-off">
                            <path d="M16 9a5 5 0 0 1 .95 2.293" />
                            <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                            <path d="m2 2 20 20" />
                            <path
                              d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                            <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div class="wrap-item-content">
                      ${item.content}
                    </div>
                  </div>
                </div>
              `;
                }
              })
              .join('');
          }
          break;
        }
        case 'pagination-active-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          const listItemEl = container.querySelector('[data-attribute="list-item"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-active-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          if (listItemEl) {
            listItemEl.setAttribute('data-pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'pagination-inactive-color': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          const listItemEl = container.querySelector('[data-attribute="list-item"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-inactive-color', updatedData[key]);
            containerEl.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          if (listItemEl) {
            listItemEl.setAttribute('data-pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardStepInstructions(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key] ? 'true' : 'false');
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'steps-title': {
          const el = container.querySelector('[data-attribute="steps-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer) {
            cardContainer.style.color = updatedData[key];
            cardContainer.setAttribute('data-text-color', updatedData[key]);

            // Update step numbers border and text color
            const stepNumbers = container.querySelectorAll('.step-number');
            stepNumbers.forEach(stepNumber => {
              stepNumber.style.borderColor = updatedData[key];
              stepNumber.style.color = updatedData[key];
            });

            // Update arrow color via CSS variable
            cardContainer.style.setProperty('--arrow-color', updatedData[key]);
          }

          // Also update steps-title color if exists
          const stepsTitleEl = container.querySelector('[data-attribute="steps-title"]');
          if (stepsTitleEl) {
            stepsTitleEl.style.color = updatedData[key];
          }
          break;
        }
        case 'background-color': {
          const cardStepInstructionsContainer = container.querySelector('.card-step-instructions');
          if (cardStepInstructionsContainer) {
            cardStepInstructionsContainer.style.backgroundColor = updatedData[key];
            cardStepInstructionsContainer.setAttribute('data-background', updatedData[key]);
          }
          break;
        }
        case 'steps-grid': {
          const cardContainer = container.querySelector('[data-attribute="card-container"]');
          if (cardContainer && Array.isArray(updatedData[key])) {
            const textColor = updatedData['text-color'] || '#000';
            const backgroundColor = updatedData['background-color'] || '';

            // Set container attributes and styles
            if (textColor) {
              cardContainer.style.color = textColor;
              cardContainer.setAttribute('data-text-color', textColor);
              cardContainer.style.setProperty('--arrow-color', textColor);

              // Also update steps-title color
              const stepsTitleEl = container.querySelector('[data-attribute="steps-title"]');
              if (stepsTitleEl) {
                stepsTitleEl.style.color = textColor;
              }
            }
            if (backgroundColor) {
              cardContainer.style.backgroundColor = backgroundColor;
              cardContainer.setAttribute('data-background', backgroundColor);
            }

            cardContainer.innerHTML = updatedData[key]
              .map((item, index) => {
                return `
                  <div class="card-item swiper-slide">
                    <div class="step-image">
                      <img
                        src="${item.image}"
                        alt="image"
                      />
                    </div>
                    <div class="step-number" style="border-color: ${textColor}; color: ${textColor};">${index + 1}</div>
                    <div class="step-content">
                      ${item.content}
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'paginationActiveColor': {
          const el = container.querySelector('.card-step-instructions');
          if (el) {
            el.setAttribute('data-pagination-active-color', updatedData[key]);
            el.style.setProperty('--pagination-active-color', updatedData[key]);
          }
          break;
        }
        case 'paginationInactiveColor': {
          const el = container.querySelector('.card-step-instructions');
          if (el) {
            el.setAttribute('data-pagination-inactive-color', updatedData[key]);
            el.style.setProperty('--pagination-inactive-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('.card-step-instructions');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('.card-step-instructions');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionPurchaseIncentive(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');

    // Update section element
    const sectionEl = doc.querySelector('.purchase-incentive-wrapper');
    const sectionContentEl = doc.querySelector('.purchase-incentive');

    if (sectionEl) {
      sectionEl.setAttribute('data-enable-anchor', updatedData['enableAnchor'] ? 'true' : 'false');
      if (updatedData['title']) {
        sectionEl.setAttribute('data-title', updatedData['title']);
      }
      if (updatedData['background-color']) {
        sectionEl.style.backgroundColor = updatedData['background-color'];
      }
      if (updatedData['text-color']) {
        sectionEl.style.color = updatedData['text-color'];
      }
      if (updatedData['section-content-position']) {
        sectionEl.style.justifyContent = updatedData['section-content-position'];
        sectionEl.setAttribute('data-content-position', updatedData['section-content-position']);
      }
    }

    if (sectionContentEl) {
      // Remove inline padding styles to let CSS handle it
      sectionContentEl.style.removeProperty('padding');

      if (sectionContentEl) {
        sectionContentEl.setAttribute('data-top-padding', updatedData.topPadding);
        if (updatedData.topPadding) {
          sectionContentEl.style.paddingTop = '';
        } else {
          sectionContentEl.style.paddingTop = '0';
        }
      }
      if (sectionContentEl) {
        sectionContentEl.setAttribute('data-bottom-padding', updatedData.bottomPadding);
        if (updatedData.bottomPadding) {
          sectionContentEl.style.paddingBottom = '';
        } else {
          sectionContentEl.style.paddingBottom = '0';
        }
      }
    }

    // Update wrap-sale-item paragraphs
    const wrapSaleEl = doc.querySelector('.wrap-sale');
    const wrapSaleItems = doc.querySelectorAll('.wrap-sale-item');
    const wrapSaleItemsContent = doc.querySelectorAll('.wrap-sale-item p');
    if (wrapSaleItemsContent[0] && updatedData['sale-text-1']) {
      wrapSaleItemsContent[0].textContent = updatedData['sale-text-1'];
      if (updatedData['sale-text-1-show']) {
        wrapSaleItems[0].style.display = 'flex';
        sectionEl.setAttribute('data-sale-text-1-show', 'true');
      } else {
        wrapSaleItems[0].style.display = 'none';
        sectionEl.setAttribute('data-sale-text-1-show', 'false');
      }
    }
    if (wrapSaleItemsContent[1] && updatedData['sale-text-2']) {
      wrapSaleItemsContent[1].textContent = updatedData['sale-text-2'];
      if (updatedData['sale-text-2-show']) {
        wrapSaleItems[1].style.display = 'flex';
        sectionEl.setAttribute('data-sale-text-2-show', 'true');
      } else {
        wrapSaleItems[1].style.display = 'none';
        sectionEl.setAttribute('data-sale-text-2-show', 'false');
      }
    }

    if (wrapSaleEl) {
      const allItemsHidden = Array.from(wrapSaleItems).every(item => item.style.display === 'none');
      if (allItemsHidden) {
        wrapSaleEl.style.display = 'none';
      } else {
        wrapSaleEl.style.display = 'flex';
      }
    }

    // Update button element
    const btnOrderNow = doc.querySelector('.btn-order-now');
    if (btnOrderNow) {
      if (updatedData['button-text']) {
        btnOrderNow.textContent = updatedData['button-text'];
      }
      if (updatedData['button-text-color']) {
        btnOrderNow.style.color = updatedData['button-text-color'];
      }
      if (updatedData['button-bg-color']) {
        btnOrderNow.style.backgroundColor = updatedData['button-bg-color'];
      }
    }

    // Update wrap-guarantee-item paragraphs
    const wrapGuaranteeEl = doc.querySelector('.wrap-guarantee');
    const wrapGuaranteeItems = doc.querySelectorAll('.wrap-guarantee-item');
    const wrapGuaranteeItemsContent = doc.querySelectorAll('.wrap-guarantee-item p');
    if (wrapGuaranteeItemsContent[0] && updatedData['guarantee-text-1']) {
      wrapGuaranteeItemsContent[0].textContent = updatedData['guarantee-text-1'];
      if (updatedData['guarantee-text-1-show']) {
        wrapGuaranteeItems[0].style.display = 'flex';
        sectionEl.setAttribute('data-guarantee-text-1-show', 'true');
      } else {
        wrapGuaranteeItems[0].style.display = 'none';
        sectionEl.setAttribute('data-guarantee-text-1-show', 'false');
      }
    }
    if (wrapGuaranteeItemsContent[1] && updatedData['guarantee-text-2']) {
      wrapGuaranteeItemsContent[1].textContent = updatedData['guarantee-text-2'];
      if (updatedData['guarantee-text-2-show']) {
        wrapGuaranteeItems[1].style.display = 'flex';
        sectionEl.setAttribute('data-guarantee-text-2-show', 'true');
      } else {
        wrapGuaranteeItems[1].style.display = 'none';
        sectionEl.setAttribute('data-guarantee-text-2-show', 'false');
      }
    }

    if (wrapGuaranteeEl) {
      const allItemsHidden = Array.from(wrapGuaranteeItems).every(item => item.style.display === 'none');
      if (allItemsHidden) {
        wrapGuaranteeEl.style.display = 'none';
      } else {
        wrapGuaranteeEl.style.display = 'flex';
      }
    }
    return doc.body.firstChild.innerHTML;
  },
  sectionSocialMedia(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'socialMediaTitle': {
          const el = container.querySelector('.social-media-title');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'posts': {
          const socialMediaPostsEl = container.querySelector('.social-media-posts');
          const socialMediaWrapperEl = container.querySelector('.social-media-wrapper');
          if (socialMediaPostsEl) {
            socialMediaPostsEl.innerHTML = updatedData[key]
              ?.map(post => {
                return `
                  <div class="post-item-wrapper">
                    <div class="post-item">
                      <div class="post-info">
                        <div class="post-author-info-wrapper">
                          <div class="post-author">
                            <div class="post-author-avatar">
                              <img
                                src="${post?.author?.avatar || ''}"
                                alt="avatar"
                              />
                            </div>
                            <div class="post-author-info">
                              <h3 class="post-author-name">${post?.author?.name || ''}</h3>
                              <div class="post-author-time">
                                <p
                                  class="post-author-time-text"
                                >
                                  ${post?.createdAt || ''}
                                </p>
                                <svg
                                  viewBox="0 0 16 16"
                                  width="12"
                                  height="12"
                                  fill="currentColor"
                                  title="Public"
                                  class="post-author-public-icon"
                                >
                                  <g fill-rule="evenodd" transform="translate(-448 -544)">
                                    <g>
                                      <path
                                        d="M109.5 408.5c0 3.23-2.04 5.983-4.903 7.036l.07-.036c1.167-1 1.814-2.967 2-3.834.214-1 .303-1.3-.5-1.96-.31-.253-.677-.196-1.04-.476-.246-.19-.356-.59-.606-.73-.594-.337-1.107.11-1.954.223a2.666 2.666 0 0 1-1.15-.123c-.007 0-.007 0-.013-.004l-.083-.03c-.164-.082-.077-.206.006-.36h-.006c.086-.17.086-.376-.05-.529-.19-.214-.54-.214-.804-.224-.106-.003-.21 0-.313.004l-.003-.004c-.04 0-.084.004-.124.004h-.037c-.323.007-.666-.034-.893-.314-.263-.353-.29-.733.097-1.09.28-.26.863-.8 1.807-.22.603.37 1.166.667 1.666.5.33-.11.48-.303.094-.87a1.128 1.128 0 0 1-.214-.73c.067-.776.687-.84 1.164-1.2.466-.356.68-.943.546-1.457-.106-.413-.51-.873-1.28-1.01a7.49 7.49 0 0 1 6.524 7.434"
                                        transform="translate(354 143.5)"
                                      ></path>
                                      <path
                                        d="M104.107 415.696A7.498 7.498 0 0 1 94.5 408.5a7.48 7.48 0 0 1 3.407-6.283 5.474 5.474 0 0 0-1.653 2.334c-.753 2.217-.217 4.075 2.29 4.075.833 0 1.4.561 1.333 2.375-.013.403.52 1.78 2.45 1.89.7.04 1.184 1.053 1.33 1.74.06.29.127.65.257.97a.174.174 0 0 0 .193.096"
                                        transform="translate(354 143.5)"
                                      ></path>
                                      <path
                                        fill-rule="nonzero"
                                        d="M110 408.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0zm-1 0a7 7 0 1 0-14 0 7 7 0 0 0 14 0z"
                                        transform="translate(354 143.5)"
                                      ></path>
                                    </g>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="post-more-icon"
                          >
                            <circle cx="12" cy="12" r="1" />
                            <circle cx="19" cy="12" r="1" />
                            <circle cx="5" cy="12" r="1" />
                          </svg>
                        </div>
                        <p class="post-content">
                          ${post?.content || ''}
                        </p>
                      </div>
                      <div class="post-reaction">
                        <div class="post-reaction-wrapper">
                          <div class="post-reaction-icon">
                            <img
                              src="${replaceImageUrl(
                                'https://cdn.skyfastimg.com/images/2025/12/10/image-6938daeeed5eebf85bc3aff7.png?w=50&h=50&q=80',
                              )}"
                              alt="like"
                            />
                            <img
                              src="${replaceImageUrl(
                                'https://cdn.skyfastimg.com/images/2025/12/10/image-6938db0ac39e3e75f6eac0bb.png?w=50&h=50&q=80',
                              )}"
                              alt="love"
                            />
                            <img
                              src="${replaceImageUrl(
                                'https://cdn.skyfastimg.com/images/2025/12/10/image-6938db203759502aae341d01.png?w=50&h=50&q=80',
                              )}"
                              alt="laugh"
                            />
                            <p
                              class="post-reaction-likes-count"
                            >
                              ${post?.reactionCount || '0'}
                            </p>
                          </div>
                          <p
                            class="post-reaction-comments-count"
                          >
                            <span class="post-reaction-comments-count-number">${post?.commentCount ||
                              '0'}</span> Comments
                          </p>
                        </div>
                        <div class="post-reaction-button-wrapper">
                          <div class="post-reaction-button">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="post-reaction-button-icon"
                            >
                              <path d="M7 10v12" />
                              <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z" />
                            </svg>
                            <p>Like</p>
                          </div>
                          <div class="post-reaction-button">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="post-reaction-button-icon"
                            >
                              <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
                            </svg>
                            <p>Comment</p>
                          </div>
                        </div>
                      </div>
                      <div class="post-comments">
                        ${post?.comments
                          ?.map(comment => {
                            return `
                          <div class="post-comment-item">
                            <div class="post-comment-avatar">
                              <img
                                src="${comment?.author?.avatar || ''}"
                                alt="avatar"
                              />
                            </div>
                            <div class="post-comment-content">
                              <div class="post-comment-content-header">
                                <h5 class="post-comment-content-header-name">${comment?.author?.name || ''}</h5>
                                <p class="post-comment-content-header-text">
                                  ${comment?.content || ''}
                                </p>
                              </div>
                              <div class="post-comment-content-footer">
                                <p class="post-comment-content-footer-like">Like</p>
                                <p class="post-comment-content-footer-reply">Reply</p>
                                <p
                                  class="post-comment-content-footer-time"
                                >
                                  ${comment?.createdAt || ''}
                                </p>
                              </div>
                            </div>
                          </div>
                        `;
                          })
                          .join('')}
                    </div>
                    </div>
                  </div>
              `;
              })
              .join('');

            // Apply colors to newly created posts
            if (socialMediaWrapperEl && updatedData.colors) {
              socialMediaWrapperEl.style.backgroundColor = updatedData.colors.backgroundColor || '#ffffff';

              const postItemWrappers = socialMediaWrapperEl.querySelectorAll('.post-item-wrapper');
              postItemWrappers.forEach(postItemWrapper => {
                postItemWrapper.style.backgroundColor = updatedData.colors.postWrapperBackgroundColor || '';

                const postItem = postItemWrapper.querySelector('.post-item');
                if (postItem) {
                  postItem.style.backgroundColor = updatedData.colors.postBackgroundColor || '';
                  postItem.style.color = updatedData.colors.postTextColor || '';
                }

                const postContent = postItemWrapper.querySelector('.post-content');
                if (postContent) {
                  postContent.style.color = updatedData.colors.postTextColor || '';
                }

                // Apply colors to reaction button wrapper border
                const postReactionButtonWrapper = postItemWrapper.querySelector('.post-reaction-button-wrapper');
                if (postReactionButtonWrapper) {
                  postReactionButtonWrapper.style.borderTopColor = updatedData.colors.borderColor || '';
                  postReactionButtonWrapper.style.borderBottomColor = updatedData.colors.borderColor || '';
                }

                // Apply colors to comments
                const commentHeaders = postItemWrapper.querySelectorAll('.post-comment-content-header');
                commentHeaders.forEach(commentHeader => {
                  commentHeader.style.backgroundColor = updatedData.colors.commentBackgroundColor || '';
                  commentHeader.style.color = updatedData.colors.commentTextColor || '';
                });
              });
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('.social-media-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('.social-media-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionFeaturedOffer(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'featuredOfferTitle': {
          const el = container.querySelector('.featured-offer-title');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const el = container.querySelector('.featured-offer-wrapper');
          if (el) {
            el.style.backgroundColor = updatedData.colors.backgroundColor || '#ffffff';

            const cardWrapperEl = el.querySelector('.featured-offer-card-wrapper');
            if (cardWrapperEl) {
              cardWrapperEl.style.backgroundColor = updatedData.colors.backgroundColorContent || '';
            }

            const cardEl = el.querySelector('.featured-offer-card');
            if (cardEl) {
              cardEl.style.borderColor = updatedData.colors.borderColor || '';
              cardEl.style.backgroundColor = updatedData.colors.backgroundColorCard || '';
            }

            const buttonEl = el.querySelector('.featured-offer-card-content-button');
            if (buttonEl) {
              buttonEl.style.backgroundColor = updatedData.colors.buttonBackgroundColor || '';
              buttonEl.style.color = updatedData.colors.buttonTextColor || '';
            }
          }
          break;
        }
        case 'buttonText': {
          const el = container.querySelector('.featured-offer-card-content-button');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'buttonShow': {
          const el = container.querySelector('.featured-offer-card-content-button-wrapper');
          if (el) {
            el.setAttribute('data-show-btn', updatedData[key]);
            el.style.display = updatedData[key] ? 'flex' : 'none';
          }
          break;
        }
        case 'imagePosition': {
          const el = container.querySelector('.featured-offer-card');
          if (el) {
            el.setAttribute('data-image-position', updatedData.imagePosition);
          }
          break;
        }
        case 'image': {
          const el = container.querySelector('.featured-offer-card-image img');
          if (el) {
            el.src = updatedData.image;
            el.setAttribute('src', updatedData.image);
          }
          break;
        }
        case 'imageShow': {
          const el = container.querySelector('.featured-offer-card-image');
          if (el) {
            el.setAttribute('data-image-show', updatedData[key]);
            el.style.display = updatedData[key] ? 'flex' : 'none';
          }
          break;
        }
        case 'contentHeader': {
          const el = container.querySelector('.featured-offer-card-content-header');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'contentFooter': {
          const el = container.querySelector('.featured-offer-card-content-footer');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'buttonPosition': {
          const el = container.querySelector('.featured-offer-card-content-button-wrapper');
          if (el) {
            el.setAttribute('data-button-position', updatedData[key]);
          }
          break;
        }
        case 'buttonAnimation': {
          const el = container.querySelector('.featured-offer-card-content-button');
          if (el) {
            el.setAttribute('data-button-animation-show', updatedData[key]);
            el.style.animation = updatedData[key] ? 'pulse-scale 1.5s ease-in-out infinite' : 'none';
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('.featured-offer-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('.featured-offer-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionPost(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'postTitle': {
          const el = container.querySelector('.post-title');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'breadcrumb': {
          const el = container.querySelector('.post-breadcrumb');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'author': {
          const nameEl = container.querySelector('.post-author-name');
          if (nameEl && updatedData[key].name) {
            nameEl.textContent = updatedData[key].name;
          }
          const avatarEl = container.querySelector('.post-author-avatar img');
          if (avatarEl && updatedData[key].avatar) {
            avatarEl.setAttribute('src', updatedData[key].avatar);
          }
          break;
        }
        case 'createdAt': {
          const el = container.querySelector('.post-author-time');
          if (el) {
            el.textContent = updatedData[key];
          }
          break;
        }
        case 'summary': {
          const el = container.querySelector('.post-summary');
          if (el) {
            el.innerHTML = updatedData[key].text;
            el.style.color = updatedData[key].textColor;
            el.style.backgroundColor = updatedData[key].backgroundColor;
          }
          break;
        }
        case 'content': {
          const el = container.querySelector('.post-content');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const wrapperEl = container.querySelector('.post-wrapper');
          if (wrapperEl) {
            wrapperEl.style.backgroundColor = updatedData[key].backgroundColor;
          }

          const breadcrumbEl = container.querySelector('.post-breadcrumb');
          if (breadcrumbEl) {
            breadcrumbEl.style.color = updatedData[key].textColor;
          }

          const authorInfoEl = container.querySelector('.post-author-info-content');
          if (authorInfoEl) {
            authorInfoEl.style.color = updatedData[key].textColor;
          }

          const dividerEl = container.querySelector('.post-author-divider');
          if (dividerEl) {
            dividerEl.style.backgroundColor = updatedData[key].borderColor;
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('.post-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('.post-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardReview(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'review': {
          if (updatedData[key].image !== undefined) {
            const img = container.querySelector('.card-review-image img');
            if (img) {
              img.setAttribute('src', updatedData[key].image);
            }
          }

          if (updatedData[key].text !== undefined) {
            const textEl = container.querySelector('.card-review-text');
            if (textEl) {
              textEl.innerHTML = updatedData[key].text;
            }
          }

          if (updatedData[key].name !== undefined) {
            const nameEl = container.querySelector('.card-review-name');
            if (nameEl) {
              nameEl.textContent = updatedData[key].name;
            }
          }
          if (updatedData[key].position !== undefined) {
            const reviewContainerEl = container.querySelector('.card-review-container');
            if (reviewContainerEl) {
              reviewContainerEl.setAttribute('data-position', updatedData[key].position);
            }
          }

          if (updatedData[key].show !== undefined) {
            const reviewWrapperEl = container.querySelector('.card-review-left');
            if (reviewWrapperEl) {
              reviewWrapperEl.setAttribute('data-review-show', updatedData[key].show);
            }
            if (updatedData[key].show) {
              reviewWrapperEl.style.display = 'block';
            } else {
              reviewWrapperEl.style.display = 'none';
            }
          }
          break;
        }

        case 'rating': {
          const starsContainer = container.querySelector('.card-review-wrap-stars');
          if (starsContainer) {
            starsContainer.setAttribute('data-full-stars', updatedData[key]);

            // Update star display
            const stars = starsContainer.querySelectorAll('svg:not([style*="position: absolute"])');
            const fullStars = Math.floor(updatedData[key]);
            const hasHalfStar = updatedData[key] % 1 >= 0.5;

            stars.forEach((star, index) => {
              if (index < fullStars) {
                star.style.fill = '#f0b100';
                star.style.stroke = '#f0b100';
              } else if (index === fullStars && hasHalfStar) {
                star.style.fill = 'url(#half-star-gradient-infinite)';
                star.style.stroke = '#f0b100';
              } else {
                star.style.fill = 'transparent';
                star.style.stroke = '#d1d5db';
              }
            });
          }
          break;
        }

        case 'ratingShow': {
          const starsContainer = container.querySelector('.card-review-wrap-stars');
          if (starsContainer) {
            starsContainer.setAttribute('data-rating-show', updatedData[key]);
            if (updatedData[key]) {
              starsContainer.style.display = 'flex';
            } else {
              starsContainer.style.display = 'none';
            }
          }
          break;
        }

        case 'content': {
          const contentEl = container.querySelector('.card-review-content');
          if (contentEl) {
            contentEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'list': {
          const listContainer = container.querySelector('.card-review-list');
          if (listContainer && Array.isArray(updatedData[key])) {
            // Clear existing items
            listContainer.innerHTML = '';

            // Add new items
            updatedData[key].forEach(item => {
              const itemEl = document.createElement('div');
              itemEl.className = 'card-review-item';
              itemEl.innerHTML = `
                <div class="card-review-item-image">
                  <img
                    src="${item.image || ''}"
                    alt="image"
                  />
                </div>
                <div class="card-review-item-text">
                  ${item.text || ''}
                </div>
              `;
              listContainer.appendChild(itemEl);
            });
          }
          break;
        }

        case 'footer': {
          const footerEl = container.querySelector('.card-review-footer');
          if (footerEl) {
            footerEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'colors': {
          const cardReviewWrapperEl = container.querySelector('.card-review-wrapper');
          if (cardReviewWrapperEl) {
            cardReviewWrapperEl.style.backgroundColor = updatedData.colors.backgroundColor || '';
          }

          const cardReviewContainerEl = container.querySelector('.card-review-container');
          if (cardReviewContainerEl) {
            cardReviewContainerEl.style.backgroundColor = updatedData.colors.backgroundColorContent || '';
          }

          const cardReviewContentEl = container.querySelector('.card-review-left');
          if (cardReviewContentEl) {
            cardReviewContentEl.style.backgroundColor = updatedData.colors.cardBackgroundColor || '';
          }

          const cardReviewNameEl = container.querySelector('.card-review-name');
          if (cardReviewNameEl) {
            cardReviewNameEl.style.color = updatedData.colors.cardTextColor || '';
          }
          break;
        }

        case 'topPadding': {
          const el = container.querySelector('.card-review-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }

        case 'bottomPadding': {
          const el = container.querySelector('.card-review-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardReview02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'image': {
          const img = container.querySelector('.card-review-image img');
          if (img) {
            img.setAttribute('src', updatedData[key].url);
          }

          if (updatedData[key].position !== undefined) {
            const reviewContainerEl = container.querySelector('.card-review-container');
            if (reviewContainerEl) {
              reviewContainerEl.setAttribute('data-position', updatedData[key].position);
            }
          }

          if (updatedData[key].show !== undefined) {
            const reviewWrapperEl = container.querySelector('.card-review-left');
            if (reviewWrapperEl) {
              reviewWrapperEl.setAttribute('data-review-show', updatedData[key].show);
            }
            if (updatedData[key].show) {
              reviewWrapperEl.style.display = 'flex';
            } else {
              reviewWrapperEl.style.display = 'none';
            }
          }
          break;
        }

        case 'rating': {
          const starsContainer = container.querySelector('.card-review-wrap-stars');
          if (starsContainer) {
            starsContainer.setAttribute('data-full-stars', updatedData[key]);

            // Update star display
            const stars = starsContainer.querySelectorAll('svg:not([style*="position: absolute"])');
            const fullStars = Math.floor(updatedData[key]);
            const hasHalfStar = updatedData[key] % 1 >= 0.5;

            stars.forEach((star, index) => {
              if (index < fullStars) {
                star.style.fill = '#f0b100';
                star.style.stroke = '#f0b100';
              } else if (index === fullStars && hasHalfStar) {
                star.style.fill = 'url(#half-star-gradient-infinite)';
                star.style.stroke = '#f0b100';
              } else {
                star.style.fill = 'transparent';
                star.style.stroke = '#d1d5db';
              }
            });
          }
          break;
        }

        case 'ratingShow': {
          const starsContainer = container.querySelector('.card-review-wrap-stars');
          if (starsContainer) {
            starsContainer.setAttribute('data-rating-show', updatedData[key]);
            if (updatedData[key]) {
              starsContainer.style.display = 'flex';
            } else {
              starsContainer.style.display = 'none';
            }
          }
          break;
        }

        case 'ratingText': {
          const ratingTextEl = container.querySelector('.card-review-rating-text');
          if (ratingTextEl) {
            ratingTextEl.textContent = updatedData[key];
          }
          break;
        }

        case 'content': {
          const contentEl = container.querySelector('.card-review-content');
          if (contentEl) {
            contentEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'list': {
          const listContainer = container.querySelector('.card-review-list');
          if (listContainer && Array.isArray(updatedData[key])) {
            // Clear existing items
            listContainer.innerHTML = '';

            // Add new items
            updatedData[key].forEach(item => {
              const itemEl = document.createElement('div');
              itemEl.className = 'card-review-item';
              itemEl.innerHTML = `
                <div class="card-review-item-image">
                  <img
                    src="${item.image || ''}"
                    alt="image"
                  />
                </div>
                <div class="card-review-item-text">
                  ${item.text || ''}
                </div>
              `;
              listContainer.appendChild(itemEl);
            });
          }
          break;
        }

        case 'footer': {
          const footerEls = container.querySelectorAll('.card-review-footer');
          if (footerEls) {
            footerEls.forEach(footerEl => {
              footerEl.innerHTML = updatedData[key];
            });
          }
          break;
        }

        case 'colors': {
          const cardReviewWrapperEl = container.querySelector('.card-review-wrapper');
          if (cardReviewWrapperEl) {
            cardReviewWrapperEl.style.setProperty('--text-color', updatedData.colors.textColor || '');
            cardReviewWrapperEl.style.setProperty('--background-color', updatedData.colors.backgroundColor || '');
            cardReviewWrapperEl.style.setProperty('--button-text-color', updatedData.colors.buttonTextColor || '');
            cardReviewWrapperEl.style.setProperty(
              '--button-background-color',
              updatedData.colors.buttonBackgroundColor || '',
            );
            cardReviewWrapperEl.style.setProperty(
              '--button-icon-background',
              updatedData.colors.buttonIconBackground || '',
            );
          }
          break;
        }

        case 'button': {
          const cardReviewWrapperEl = container.querySelector('.card-review-wrapper');
          if (cardReviewWrapperEl) {
            const buttonEls = cardReviewWrapperEl.querySelectorAll('.card-review-button');
            buttonEls.forEach(button => {
              const buttonText = button.querySelector('.card-review-button-text');
              buttonText.textContent = updatedData[key].text;
              cardReviewWrapperEl.setAttribute('data-button-show', updatedData[key].show ? 'true' : 'false');
              cardReviewWrapperEl.setAttribute(
                'data-button-animation-show',
                updatedData[key].animationShow ? 'true' : 'false',
              );
              if (updatedData[key].show) {
                button.style.display = 'flex';
              } else {
                button.style.display = 'none';
              }
              if (updatedData[key].animationShow) {
                button.style.animation = 'button-glow-pulse 1.725s cubic-bezier(0.4, 0, 0.2, 1) infinite';
              } else {
                button.style.animation = 'none';
              }
            });
          }
          break;
        }

        case 'topPadding': {
          const el = container.querySelector('.card-review-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }

        case 'bottomPadding': {
          const el = container.querySelector('.card-review-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardMedia(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'reviewTitle': {
          const reviewTitleEl = container.querySelector('.card-review-title');
          if (reviewTitleEl) {
            reviewTitleEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'media': {
          const mediaData = updatedData[key] || {};
          const mediaContainer = container.querySelector('.card-review-image');
          if (mediaContainer) {
            if (mediaData.type === 'video') {
              const videoUrl = mediaData.video || '';
              mediaContainer.innerHTML = `
                <video width="100%" height="auto" autoplay muted loop playsinline>
                  <source data-attribute="card-video" src="${videoUrl}" type="video/mp4" />
                </video>`;
            } else {
              const imageUrl = mediaData.url || '';
              mediaContainer.innerHTML = `
                <img src="${imageUrl}" alt="image" />`;
            }
          }

          if (mediaData.position !== undefined) {
            const reviewWrapperEl = container.querySelector('.card-review-wrapper');
            if (reviewWrapperEl) {
              reviewWrapperEl.setAttribute('data-image-position', mediaData.position);
            }
          }

          if (mediaData.show !== undefined) {
            const reviewWrapperEl = container.querySelector('.card-review-left');
            if (reviewWrapperEl) {
              reviewWrapperEl.setAttribute('data-review-show', mediaData.show ? 'true' : 'false');
            }
            if (mediaData.show) {
              reviewWrapperEl.style.display = 'flex';
            } else {
              reviewWrapperEl.style.display = 'none';
            }
          }
          break;
        }

        case 'customerReview': {
          const customerReviewEl = container.querySelector('.card-review-customer');
          if (customerReviewEl) {
            customerReviewEl
              .querySelector('.card-review-customer-image img')
              .setAttribute('src', updatedData[key].avatar);
            customerReviewEl.querySelector('.card-review-customer-name').innerHTML = updatedData[key].name || '';
            customerReviewEl.querySelector('.card-review-customer-content').innerHTML = updatedData[key].content;
            customerReviewEl
              .querySelector('.card-review-wrap-stars')
              .setAttribute('data-full-stars', updatedData[key].rating);
            customerReviewEl.setAttribute('data-customer-review-enable', updatedData[key].enable ? 'true' : 'false');
            if (updatedData[key].enable) {
              customerReviewEl.style.display = 'flex';
            } else {
              customerReviewEl.style.display = 'none';
            }
          }
          break;
        }

        case 'content': {
          const contentEl = container.querySelector('.card-review-content');
          if (contentEl) {
            contentEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'list': {
          const listContainer = container.querySelector('.card-review-list');
          if (listContainer && Array.isArray(updatedData[key])) {
            // Clear existing items
            listContainer.innerHTML = '';

            // Add new items
            updatedData[key].forEach(item => {
              const itemEl = document.createElement('div');
              itemEl.className = 'card-review-item';
              itemEl.innerHTML = `
                <div class="card-review-item-image">
                  <img
                    src="${item.image || ''}"
                    alt="image"
                  />
                </div>
                <div class="card-review-item-text">
                  ${item.text || ''}
                </div>
              `;
              listContainer.appendChild(itemEl);
            });
          }
          break;
        }

        case 'featureListEnable': {
          const cardReviewWrapperEl = container.querySelector('.card-review-wrapper');
          if (cardReviewWrapperEl) {
            cardReviewWrapperEl.setAttribute('data-feature-list-enable', updatedData[key] ? 'true' : 'false');
            const featureListEl = cardReviewWrapperEl.querySelector('.card-review-list');
            if (featureListEl && updatedData[key]) {
              featureListEl.style.display = 'flex';
            } else {
              featureListEl.style.display = 'none';
            }
          }
          break;
        }

        case 'itemImageWidthDesktop':
        case 'itemImageWidthMobile':
        case 'itemImageHeightDesktop':
        case 'itemImageHeightMobile': {
          const cardReviewWrapperEl = container.querySelector('.card-review-wrapper');
          if (cardReviewWrapperEl) {
            const attrMap = {
              itemImageWidthDesktop: 'data-item-image-width-desktop',
              itemImageWidthMobile: 'data-item-image-width-mobile',
              itemImageHeightDesktop: 'data-item-image-height-desktop',
              itemImageHeightMobile: 'data-item-image-height-mobile',
            };
            const varMap = {
              itemImageWidthDesktop: '--item-image-width-desktop',
              itemImageWidthMobile: '--item-image-width-mobile',
              itemImageHeightDesktop: '--item-image-height-desktop',
              itemImageHeightMobile: '--item-image-height-mobile',
            };
            const value = Math.max(0, Number(updatedData[key]) || 0);
            cardReviewWrapperEl.setAttribute(attrMap[key], String(value));
            cardReviewWrapperEl.style.setProperty(varMap[key], `${value}px`);
          }
          break;
        }

        case 'footer': {
          const footerEls = container.querySelectorAll('.card-review-footer');
          if (footerEls) {
            footerEls.forEach(footerEl => {
              footerEl.innerHTML = updatedData[key];
            });
          }
          break;
        }

        case 'colors': {
          const cardReviewWrapperEl = container.querySelector('.card-review-wrapper');
          if (cardReviewWrapperEl) {
            cardReviewWrapperEl.style.setProperty('--text-color', updatedData.colors.textColor || '');
            cardReviewWrapperEl.style.setProperty('--background-color', updatedData.colors.backgroundColor || '');
            cardReviewWrapperEl.style.setProperty('--button-text-color', updatedData.colors.buttonTextColor || '');
            cardReviewWrapperEl.style.setProperty(
              '--button-background-color',
              updatedData.colors.buttonBackgroundColor || '',
            );
            cardReviewWrapperEl.style.setProperty(
              '--button-icon-background',
              updatedData.colors.buttonIconBackground || '',
            );
          }
          break;
        }

        case 'button': {
          const cardReviewWrapperEl = container.querySelector('.card-review-wrapper');
          if (cardReviewWrapperEl) {
            const buttonData = updatedData[key] || {};
            const borderRadius = Number(buttonData.borderRadius);
            const resolvedBorderRadius = Number.isNaN(borderRadius) ? 8 : Math.max(0, borderRadius);
            const minWidth = Number(buttonData.minWidth);
            const resolvedMinWidth = Number.isNaN(minWidth) ? 400 : Math.max(1, minWidth);

            const buttonEl = cardReviewWrapperEl.querySelector('.card-review-button');
            const buttonText = buttonEl ? buttonEl.querySelector('.card-review-button-text') : null;
            if (buttonText) {
              buttonText.textContent = buttonData.text || '';
            }
            cardReviewWrapperEl.setAttribute('data-button-show', buttonData.show ? 'true' : 'false');
            cardReviewWrapperEl.setAttribute('data-button-border-radius', String(resolvedBorderRadius));
            if (buttonEl) {
              buttonEl.style.borderRadius = resolvedBorderRadius + 'px';
              buttonEl.setAttribute('data-button-border-radius', String(resolvedBorderRadius));
              if (buttonData.show) {
                buttonEl.style.display = 'flex';
              } else {
                buttonEl.style.display = 'none';
              }
            }

            const cardReviewButtonContainerEl = container.querySelector('.card-review-button-container');
            if (cardReviewButtonContainerEl) {
              cardReviewButtonContainerEl.style.setProperty('--button-min-width', `${resolvedMinWidth}px`);
              cardReviewButtonContainerEl.style.removeProperty('min-width');
              cardReviewButtonContainerEl.setAttribute('data-button-min-width', String(resolvedMinWidth));
            }
          }
          break;
        }

        case 'topPadding': {
          const el = container.querySelector('.card-review-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }

        case 'bottomPadding': {
          const el = container.querySelector('.card-review-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardKeyFeatures(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'header': {
          const el = container.querySelector('.key-features-header');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }

        case 'topPadding': {
          const wrapper = container.querySelector('.key-features-wrapper');
          if (wrapper) {
            wrapper.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              wrapper.style.paddingTop = '';
            } else {
              wrapper.style.paddingTop = '0';
            }
          }
          break;
        }

        case 'bottomPadding': {
          const wrapper = container.querySelector('.key-features-wrapper');
          if (wrapper) {
            wrapper.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              wrapper.style.paddingBottom = '';
            } else {
              wrapper.style.paddingBottom = '0';
            }
          }
          break;
        }

        case 'colors': {
          const wrapper = container.querySelector('.key-features-wrapper');
          if (wrapper) {
            wrapper.style.setProperty('--data-background-color', updatedData.colors.backgroundColor || '');
          }
          break;
        }

        case 'items': {
          const grid = container.querySelector('.key-features-grid');
          if (grid && Array.isArray(updatedData[key])) {
            grid.innerHTML = '';

            updatedData[key].forEach(item => {
              const card = doc.createElement('div');
              card.className = 'key-feature-card';

              card.innerHTML = `
                <div class="key-feature-image">
                  <img src="${item.image || ''}" alt="${item.title || ''}" />
                </div>
                <div class="key-feature-content">
                  ${item.content}
                </div>
              `;

              grid.appendChild(card);
            });
          }
          break;
        }

        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardStep(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'stepTitle': {
          const el = container.querySelector('.card-step-description');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }

        case 'topPadding':
        case 'bottomPadding': {
          const wrapper = container.querySelector('.card-step-wrapper');
          if (wrapper) {
            wrapper.setAttribute(
              `data-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`,
              updatedData[key] ? 'true' : 'false',
            );

            // Update padding classes
            const paddingClass = `section-padding-${key === 'topPadding' ? 'top' : 'bottom'}`;
            if (updatedData[key]) {
              wrapper.classList.add(paddingClass);
            } else {
              wrapper.classList.remove(paddingClass);
            }
          }
          break;
        }

        case 'image': {
          if (updatedData.image) {
            // Update image position
            const cardContainer = container.querySelector('.card-step-container');
            if (cardContainer && updatedData.image.position) {
              cardContainer.setAttribute('data-position', updatedData.image.position);
            }

            // Update image URL
            const imageEl = container.querySelector('.card-step-image img');
            if (imageEl && updatedData.image.url) {
              imageEl.setAttribute('src', updatedData.image.url);
            }
          }
          break;
        }

        case 'steps': {
          const stepsContainer = container.querySelector('.card-step-list');
          if (stepsContainer && updatedData.steps) {
            // Clear existing steps
            stepsContainer.innerHTML = '';

            // Generate new steps HTML
            updatedData.steps.forEach(step => {
              const stepHtml = `
                <div class="card-step-item">
                  <div class="card-step-item-number" style="color: ${updatedData.colors.numberColor ||
                    '#90cf5b'}; border-color: ${updatedData.colors.borderColor || '#BCBCBC'}">${step.number}</div>
                  <div class="card-step-item-text">${step.content}</div>
                </div>
              `;
              stepsContainer.insertAdjacentHTML('beforeend', stepHtml.trim());
            });
          }
          break;
        }

        case 'colors': {
          const numberEl = container.querySelector('.card-step-item-number');
          if (numberEl) {
            numberEl.style.color = updatedData.colors.numberColor || '#90cf5b';
            numberEl.style.borderColor = updatedData.colors.borderColor || '#BCBCBC';
          }

          const wrapperEl = container.querySelector('.card-step-wrapper');
          if (wrapperEl) {
            wrapperEl.style.backgroundColor = updatedData.colors.backgroundColor || '#ffffff';
          }

          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionTableBenefitsComparison(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="wrapper-content"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.backgroundColor = updatedData[key];
          }
          break;
        }
        case 'borderColor': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-border-color', updatedData[key]);
            el.style.setProperty('--border-color', updatedData[key]);
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'tableBenefitsComparison': {
          const el = container.querySelector('[data-attribute="table-benefits-comparison"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'headerBorderEnabled': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-header-border-enabled', updatedData[key]);
            const headerBorderEls = el.querySelectorAll('.wrap-table table thead tr th');
            const headerBorderFirstEl = el.querySelector('.wrap-table table thead tr th:first-child');
            headerBorderEls.forEach(headerBorderEl => {
              if (updatedData[key]) {
                headerBorderEl.style.borderTop = `1px solid var(--border-color, #e5e7eb)`;
                headerBorderEl.style.borderRight = `1px solid var(--border-color, #e5e7eb)`;
                headerBorderFirstEl.style.borderLeft = `1px solid var(--border-color, #e5e7eb)`;
              } else {
                headerBorderEl.style.borderTop = 'none';
                headerBorderEl.style.borderRight = 'none';
                headerBorderFirstEl.style.borderLeft = 'none';
              }
            });
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="wrapper-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionSocialComment(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'socialCommentTitle': {
          const el = container.querySelector('.social-comment-title');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'comments': {
          const commentsList = container.querySelector('.comments-list');
          if (commentsList && updatedData[key]) {
            commentsList.innerHTML = updatedData[key]
              .map(comment => {
                return `
                 <div class="comment-item" data-comment-id="${comment?.id}">
                  <div class="comment-avatar">
                    <img src="${comment?.author?.avatar}" alt="avatar" />
                  </div>
                  <div class="comment-info">
                    <h4 class="comment-author-name">${comment?.author?.name}</h4>
                    <div class="comment-content">${comment?.content}</div>
                    <div class="comment-action">
                      <span class="comment-action-like-text">like</span>
                      <span class="comment-action-dot">•</span>
                      <span class="comment-action-reply-text">reply</span>
                      <span class="comment-action-dot">•</span>
                      <div class="comment-action-reaction">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="comment-action-like-icon"
                          aria-hidden="true"
                        >
                          <path d="M7 10v12"></path>
                          <path
                            d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                          ></path>
                        </svg>
                        <span>${comment?.likesCount}</span>
                      </div>
                      <span class="comment-action-dot">•</span>
                      <span class="comment-date"> ${comment?.createdAt} </span>
                    </div>
                    <div class="comment-replies" style="margin-top: ${
                      comment?.replies?.length > 0 ? '' : '0px !important'
                    } ">
                      ${comment?.replies
                        ?.map(reply => {
                          return `
                          <div class="comment-item" data-reply-id="${reply?.id}" data-parent-id="${reply?.parentId}">
                            <div class="comment-avatar">
                              <img src="${reply?.author?.avatar}" alt="avatar" />
                            </div>
                            <div class="comment-info">
                              <h4 class="comment-author-name">${reply?.author?.name}</h4>
                              <div class="comment-content">${reply?.content}</div>
                              <div class="comment-action">
                                <span class="comment-action-like-text">like</span>
                                <span class="comment-action-dot">•</span>
                                <span class="comment-action-reply-text">reply</span>
                                <span class="comment-action-dot">•</span>
                                <div class="comment-action-reaction">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="comment-action-like-icon"
                                    aria-hidden="true"
                                  >
                                    <path d="M7 10v12"></path>
                                    <path
                                      d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"
                                    ></path>
                                  </svg>
                                  <span>${reply?.likesCount}</span>
                                </div>
                                <span class="comment-action-dot">•</span>
                                <span class="comment-date"> ${reply?.createdAt}</span>
                              </div>
                            </div>
                          </div>
                        `;
                        })
                        .join('')}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'colors': {
          const wrapperEl = container.querySelector('.social-comment-wrapper');
          if (!wrapperEl) return;

          const data = updatedData[key];
          if (!data) return;

          const styleMap = {
            '--background-color': data.backgroundColor,
            '--text-color': data.textColor,
            '--author-name-color': data.authorNameColor,
            '--action-color': data.actionColor,
            '--reply-border-color': data.replyBorderColor,
            '--textarea-border-color': data.textareaBorderColor,
          };

          Object.entries(styleMap).forEach(([cssVar, value]) => {
            if (value !== undefined && value !== null && value !== '') {
              wrapperEl.style.setProperty(cssVar, value);
            }
          });
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('.social-comment-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('.social-comment-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardFeature(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'media': {
          const type = updatedData[key].type;
          const mediaContainer = container.querySelector('.card-feature-image');
          if (mediaContainer) {
            if (type === 'video') {
              const videoUrl = updatedData[key].video || '';
              mediaContainer.innerHTML = `
                <video width="100%" height="auto" autoplay muted loop playsinline>
                  <source data-attribute="card-video" src="${videoUrl}" type="video/mp4" />
                </video>`;
            } else {
              const imageUrl = updatedData[key].image || '';
              mediaContainer.innerHTML = `
                <img src="${imageUrl}" alt="image" />`;
            }
          }

          const cardFeatureWrapperEl = container.querySelector('.card-feature-wrapper');
          if (updatedData[key].position !== undefined) {
            if (cardFeatureWrapperEl) {
              cardFeatureWrapperEl.setAttribute('data-position', updatedData[key].position);
            }
          }

          if (updatedData[key].show !== undefined) {
            if (cardFeatureWrapperEl) {
              cardFeatureWrapperEl.setAttribute('data-show-media', updatedData[key].show);
            }
            const mediaWrapperEl = container.querySelector('.card-feature-left');
            if (mediaWrapperEl && updatedData[key].show) {
              mediaWrapperEl.style.display = 'block';
            } else {
              mediaWrapperEl.style.display = 'none';
            }
          }
          break;
        }

        case 'content': {
          const contentEl = container.querySelector('.card-feature-content');
          if (contentEl) {
            contentEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'list': {
          const listContainer = container.querySelector('.card-feature-list');
          if (listContainer && Array.isArray(updatedData[key])) {
            // Clear existing items
            listContainer.innerHTML = '';

            // Add new items
            updatedData[key].forEach(item => {
              const itemEl = document.createElement('div');
              itemEl.className = 'card-feature-item';
              itemEl.innerHTML = `
                <div class="card-feature-item-image">
                  <img
                    src="${item.image || ''}"
                    alt="image"
                  />
                </div>
                <div class="card-feature-item-text">
                  ${item.text || ''}
                </div>
              `;
              listContainer.appendChild(itemEl);
            });
          }
          break;
        }

        case 'footer': {
          const footerEl = container.querySelector('.card-feature-footer');
          if (footerEl) {
            footerEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'colors': {
          const cardReviewWrapperEl = container.querySelector('.card-feature-wrapper');
          if (cardReviewWrapperEl) {
            cardReviewWrapperEl.style.backgroundColor = updatedData.colors.backgroundColor || '';
          }

          const cardReviewContainerEl = container.querySelector('.card-feature-container');
          if (cardReviewContainerEl) {
            cardReviewContainerEl.style.backgroundColor = updatedData.colors.backgroundColorContent || '';
          }

          const cardReviewContentEl = container.querySelector('.card-feature-left');
          if (cardReviewContentEl) {
            cardReviewContentEl.style.backgroundColor = updatedData.colors.cardBackgroundColor || '';
          }

          const cardReviewNameEl = container.querySelector('.card-feature-name');
          if (cardReviewNameEl) {
            cardReviewNameEl.style.color = updatedData.colors.cardTextColor || '';
          }
          break;
        }

        case 'topPadding': {
          const el = container.querySelector('.card-feature-wrapper');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }

        case 'bottomPadding': {
          const el = container.querySelector('.card-feature-wrapper');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionReviewGridSection03(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const wrapper = container.querySelector('[data-attribute="wrapper-container"]');
    const wrapItemsEl = container.querySelector('[data-attribute="wrap-items"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title':
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        case 'enableAnchor':
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        case 'textColor':
          if (wrapper) {
            wrapper.setAttribute('data-text-color', updatedData[key]);
            wrapper.style.color = updatedData[key];
            wrapper.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        case 'padding':
          if (wrapper) {
            wrapper.setAttribute('data-top-padding', updatedData[key].top);
            wrapper.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        case 'background':
          if (wrapper && updatedData[key].color) {
            wrapper.setAttribute('data-background-color', updatedData[key].color);
            wrapper.style.backgroundColor = updatedData[key].color;
          }
          break;
        case 'wrapItems': {
          if (!wrapItemsEl) break;
          const data = updatedData[key];
          if (data.backgroundItem !== undefined) {
            wrapItemsEl.setAttribute('data-background-item', data.backgroundItem);
          }
          if (data.listItem && Array.isArray(data.listItem)) {
            const starsSvg = n =>
              Array(n)
                .fill(
                  '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide-icon lucide lucide-star fill-current text-yellow-500"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>',
                )
                .join('');
            wrapItemsEl.innerHTML = data.listItem
              .map(
                item => `
              <div data-attribute="item-review" class="item-reivew" style="background-color: ${data.backgroundItem ||
                '#ded4d4'};">
                <div class="user-name">
                  <span data-attribute="user-name">${(item.userName || '')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')}</span>
                  <div data-attribute="wrap-verified" class="wrap-verified" data-color="${item.verifiedColor ||
                    '#66CEAA'}" style="color: ${item.verifiedColor || '#66CEAA'};">
                    <span><svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" viewBox="0 0 18 20" width="18"><path d="M8.5675 0.17381C8.6839 0.06227 8.8388 0 9 0C9.1612 0 9.3161 0.06227 9.4325 0.17381C10.8115 1.49531 12.7745 2.21231 14.451 2.59381C15.2805 2.78181 16.0205 2.88381 16.552 2.93881C16.827 2.96702 17.1028 2.98736 17.379 2.99981H17.39C17.5531 3.00373 17.7083 3.0713 17.8223 3.18809C17.9363 3.30488 18 3.46162 18 3.62481V8.4998C18 13.2483 15.47 18.0078 9.1865 19.9713C9.0651 20.0093 8.9349 20.0093 8.8135 19.9713C5.6945 18.9963 3.4795 17.3253 2.0485 15.2623C0.622 13.2038 2.93711e-08 10.7933 2.93711e-08 8.3748V3.62481C-4.99706e-05 3.46162 0.0637401 3.30488 0.17772 3.18809C0.29171 3.0713 0.44685 3.00373 0.61 2.99981H0.621L0.661 2.99831C0.92383 2.98545 1.18626 2.96544 1.448 2.93831C2.15458 2.86527 2.85616 2.75007 3.549 2.59331C5.225 2.21231 7.188 1.49581 8.5675 0.17381ZM13.3065 7.57681C13.3676 7.52058 13.4169 7.45274 13.4514 7.37725C13.486 7.30176 13.5052 7.22014 13.5079 7.13715C13.5106 7.05416 13.4967 6.97147 13.467 6.89391C13.4374 6.81635 13.3926 6.74547 13.3353 6.68541C13.2779 6.62535 13.2092 6.57732 13.1331 6.54412C13.057 6.51092 12.9751 6.49321 12.892 6.49204C12.809 6.49087 12.7266 6.50625 12.6496 6.53729C12.5726 6.56833 12.5025 6.6144 12.4435 6.67281L7.385 11.5013L5.567 9.6828C5.44977 9.5656 5.29078 9.4997 5.125 9.4997C4.95922 9.4997 4.80023 9.5656 4.683 9.6828C4.56577 9.8 4.49992 9.959 4.49992 10.1248C4.49992 10.2906 4.56577 10.4496 4.683 10.5668L6.933 12.8168C7.173 13.0568 7.561 13.0618 7.8065 12.8268L13.3065 7.57681Z" fill="currentColor" /></svg></span>
                    <div class="verified">Verified Buyer</div>
                  </div>
                </div>
                <div data-attribute="rating-stars" data-show-rating="${item.showRating !== false}" data-value="${
                  item.valueStart != null ? item.valueStart : 5
                }" class="wrap-stars" style="display: ${item.showRating !== false ? 'flex' : 'none'};">
                  ${starsSvg(typeof item.valueStart === 'number' ? item.valueStart : 5)}
                </div>
                <div data-attribute="title-review" class="title-review">${(item.titleReview || '')
                  .replace(/</g, '&lt;')
                  .replace(/>/g, '&gt;')}</div>
                <div data-attribute="description-review" class="description-review">${(item.descriptionReview || '')
                  .replace(/</g, '&lt;')
                  .replace(/>/g, '&gt;')}</div>
              </div>
            `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionFaqCard(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const faqGridContainerEl = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (faqGridContainerEl) {
            faqGridContainerEl.setAttribute('data-background', updatedData[key].backgroundContainer);
            faqGridContainerEl.style.setProperty('--background-container', updatedData[key].backgroundContainer);
            faqGridContainerEl.setAttribute('data-background-card', updatedData[key].backgroudCard);
            faqGridContainerEl.style.setProperty('--background-card', updatedData[key].backgroudCard);
          }
          const listItemsEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemsEl) {
            listItemsEl.setAttribute('data-background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.style.setProperty('--background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.setAttribute('data-text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.style.setProperty('--text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.setAttribute('data-border-faq-item', updatedData[key].borderFaqItem);
            listItemsEl.style.setProperty('--border-faq-item', updatedData[key].borderFaqItem);
          }
          break;
        }
        case 'layout': {
          const el = container.querySelector('[data-attribute="faq-grid-content"]');
          if (el) {
            el.setAttribute('data-layout', updatedData[key]);
          }
          break;
        }
        case 'cardImage': {
          const el = container.querySelector('[data-attribute="card-info-img"]');
          if (el) {
            el.setAttribute('src', updatedData[key]);
          }
          break;
        }
        case 'cardContent': {
          const el = container.querySelector('[data-attribute="card-info-text"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div
                  data-attribute="item-wapper"
                  class="item-wapper"
                >
                  <div data-attribute="item-question" class="item-question">
                    <div class="item-question-inner">
                      <div class="item-question-image">
                        <img
                          data-attribute="item-image"
                          src="${item.image}"
                          alt="img"
                        />
                      </div>
                    <h3
                      data-attribute="title-item-question"
                      data-color="#000000"
                      class="title-item-question"
                      style="color: '#000000'"
                    >
                      ${item.question}
                    </h3>
                    </div>
                    <span data-attribute="icon-minus" style="display: none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </span>

                    <span data-attribute="icon-plus">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="m9 18 6-6-6-6" />
                      </svg>
                    </span>
                  </div>
                  <div data-attribute="item-answer" class="item-answer">
                    <div data-attribute="answer-content" class="answer-content">
                      ${item.answer}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionBannerMedia(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleBannerMedia': {
          const el = container.querySelector('[data-attribute="banner-media-title"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const elPlayIcon = container.querySelector('[data-attribute="banner-media-play-icon"]');
          if (elPlayIcon) {
            elPlayIcon.setAttribute('play-icon-background', updatedData[key].playIconBackground);
            elPlayIcon.setAttribute('play-icon-color', updatedData[key].playIconColor);
            elPlayIcon.style.setProperty('--play-icon-background', updatedData[key].playIconBackground);
            elPlayIcon.style.setProperty('--play-icon-color', updatedData[key].playIconColor);
          }
          const elTitle = container.querySelector('[data-attribute="banner-media-title"]');
          if (elTitle) {
            elTitle.style.setProperty('--header-title-color', updatedData[key].headerTitleColor || '#ffffff');
            elTitle.setAttribute('data-header-title-color', updatedData[key].headerTitleColor || '#ffffff');
          }

          const elOverlay = container.querySelector('[data-attribute="banner-media-overlay"]');
          if (elOverlay) {
            elOverlay.setAttribute('data-overlay-color', updatedData[key].overlayColor);
            elOverlay.style.setProperty('--overlay-color', updatedData[key].overlayColor);
          }
          break;
        }
        case 'overlayOpacity': {
          const elOverlay = container.querySelector('[data-attribute="banner-media-overlay"]');
          if (elOverlay) {
            elOverlay.setAttribute('data-overlay-opacity', updatedData[key]);
            elOverlay.style.setProperty('--overlay-opacity', updatedData[key]);
          }
          break;
        }
        case 'videoUrl': {
          const el = container.querySelector('[data-attribute="banner-media-play-icon"]');
          if (el) {
            el.setAttribute('data-video-url', updatedData[key]);
          }
          break;
        }
        case 'imageBackground': {
          const el = container.querySelector('[data-attribute="banner-media-wrapper"]');
          if (el) {
            const desktopBg = updatedData[key].desktop || '';
            const mobileBg = updatedData[key].mobile || '';

            el.setAttribute('data-image-background-desktop', desktopBg);
            el.setAttribute('data-image-background-mobile', mobileBg);
            el.style.setProperty('--image-background-desktop', desktopBg ? `url("${desktopBg}")` : '');
            el.style.setProperty('--image-background-mobile', mobileBg ? `url("${mobileBg}")` : '');
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="banner-media-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardMultiToolYuri(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'topPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key]);
            cardContainer.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'bottomPadding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-bottom-padding', updatedData[key]);
            cardContainer.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }
        case 'background': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#FFFFFF');
            cardContainer.style.backgroundColor = updatedData[key] || '#FFFFFF';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--text-color', updatedData[key] || '#000000');
          }
          break;
        }
        case 'enableContainerPage': {
          if (containerPage) {
            const showContainer = updatedData[key] === true;
            containerPage.setAttribute('data-enable-style', String(showContainer));
            containerPage.style.backgroundColor = showContainer
              ? containerPage.getAttribute('data-background-container') || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'backgroundContainer': {
          if (containerPage) {
            containerPage.setAttribute('data-background-container', updatedData[key] || '#FFFFFF');
            const showContainer = containerPage.getAttribute('data-enable-style') === 'true';
            containerPage.style.backgroundColor = showContainer ? updatedData[key] || '#FFFFFF' : 'transparent';
          }
          break;
        }
        case 'leftCard': {
          const leftCard = container.querySelector('[data-attribute="left-card"]');
          if (leftCard && updatedData[key]?.order !== undefined) {
            leftCard.setAttribute('data-order', updatedData[key].order);
            leftCard.style.order = updatedData[key].order;
          }
          if (leftCard && updatedData[key]?.centerY !== undefined) {
            leftCard.setAttribute('data-center-y', updatedData[key].centerY);
            leftCard.style.setProperty('--center-y', updatedData[key].centerY ? 'center' : 'start');
          }
          break;
        }
        case 'rightCard': {
          const rightCard = container.querySelector('[data-attribute="right-card"]');
          const videoCard = container.querySelector('[data-attribute="video-card"]');
          const imageCard = container.querySelector('[data-attribute="image-card"]');
          const videoEl = container.querySelector('[data-attribute="video-card"] [data-attribute="video"]');
          const imageEl = container.querySelector('[data-attribute="image-card"] [data-attribute="image"]');

          if (rightCard && updatedData[key]?.order !== undefined) {
            rightCard.setAttribute('data-order', updatedData[key].order);
            rightCard.style.order = updatedData[key].order;
          }

          const mediaType = updatedData[key]?.mediaType === 'image' ? 'image' : 'video';
          if (mediaType === 'image') {
            if (imageCard) {
              imageCard.setAttribute('data-show', 'true');
              imageCard.style.display = 'block';
            }
            if (videoCard) {
              videoCard.setAttribute('data-show', 'false');
              videoCard.style.display = 'none';
            }
            if (imageEl) imageEl.setAttribute('src', updatedData[key]?.image || '');
            if (videoEl) videoEl.setAttribute('src', '');
          } else {
            if (videoCard) {
              videoCard.setAttribute('data-show', 'true');
              videoCard.style.display = 'block';
            }
            if (imageCard) {
              imageCard.setAttribute('data-show', 'false');
              imageCard.style.display = 'none';
            }
            if (videoEl) videoEl.setAttribute('src', updatedData[key]?.video || '');
            if (imageEl) imageEl.setAttribute('src', '');
          }
          break;
        }
        case 'showTitle': {
          const titleCard = container.querySelector('[data-attribute="title-card"]');
          if (titleCard) {
            titleCard.setAttribute('data-show-title', String(updatedData[key]));
            titleCard.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'titleCard': {
          const titleCard = container.querySelector('[data-attribute="title-card"]');
          if (titleCard) {
            titleCard.innerHTML = updatedData[key] || '';
          }
          break;
        }
        case 'boxListItem': {
          const boxListItem = container.querySelector('[data-attribute="box-list-item"]');
          if (!boxListItem) break;

          const show = updatedData[key]?.show !== false;
          const background = updatedData[key]?.background || '#ffffff33';
          const color = updatedData[key]?.color || '#ffffff';
          const listItem = updatedData[key]?.listItem || [];

          boxListItem.setAttribute('data-show', String(show));
          boxListItem.style.display = show ? 'block' : 'none';
          boxListItem.setAttribute('data-background-box', background);
          boxListItem.setAttribute('data-color-box', color);
          boxListItem.style.setProperty('--background-box', background);
          boxListItem.style.setProperty('--color-box', color);
          boxListItem.innerHTML = listItem
            .map(
              item => `
                <div data-attribute="item-on-box" class="wrap-item">
                  <div class="head-item">
                    ${
                      item.iconItem
                        ? `
                    <div class="icon-left">
                      <img data-attribute="icon-item" src="${item.iconItem}" alt="">
                    </div>
                  `
                        : ''
                    }
                    <div data-attribute="head-item" class="text-right-item">${item.head || ''}</div>
                  </div>
                  <div data-attribute="content-item" class="content-item">${item.content || ''}</div>
                </div>
              `,
            )
            .join('');
          break;
        }
        case 'pillListItem': {
          const pillListItem = container.querySelector('[data-attribute="pill-list-item"]');
          if (!pillListItem) break;

          const show = updatedData[key]?.show !== false;
          const background = updatedData[key]?.background || '#ffffff';
          const color = updatedData[key]?.color || '#000000';
          const listItem = updatedData[key]?.listItem || [];

          pillListItem.setAttribute('data-show', String(show));
          pillListItem.style.display = show ? 'flex' : 'none';
          pillListItem.setAttribute('data-background-pill', background);
          pillListItem.setAttribute('data-color-pill', color);
          pillListItem.style.setProperty('--background-color-pill', background);
          pillListItem.style.setProperty('--color-pill', color);
          pillListItem.innerHTML = listItem
            .map(
              item => `
                <div data-attribute="pill-item" class="wrap-item">
                  ${
                    item.iconItem
                      ? `
                    <div class="left-icon">
                      <img data-attribute="icon-item" src="${item.iconItem}" alt="">
                    </div>
                  `
                      : `
                  `
                  }
                  <div data-attribute="text-item" class="right-item-text">${item.text || ''}</div>
                </div>
              `,
            )
            .join('');
          break;
        }
        case 'decorBottomShow': {
          const decorBottom = container.querySelector('[data-attribute="decor-bottom"]');
          if (decorBottom) {
            decorBottom.setAttribute('data-show', String(updatedData[key]));
            decorBottom.style.display = updatedData[key] ? 'block' : 'none';
          }
          break;
        }
        case 'decorBottomColor': {
          const decorBottom = container.querySelector('[data-attribute="decor-bottom"]');
          if (decorBottom) {
            decorBottom.setAttribute('data-color', updatedData[key]);
            decorBottom.style.setProperty('--color-decor', updatedData[key]);
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardMultiTool(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'background': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'container': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'leftCard': {
          const elCardContent = container.querySelector('[data-attribute="card-item-content"]');
          if (elCardContent) {
            if (updatedData[key].order !== undefined) {
              elCardContent.setAttribute('data-order', updatedData[key].order);
              elCardContent.style.order = updatedData[key].order;
            }
            if (updatedData[key].centerY !== undefined) {
              elCardContent.setAttribute('data-style-center-y', updatedData[key].centerY);
            }
            if (updatedData[key].enableBorder !== undefined) {
              elCardContent.setAttribute('data-enable-border', updatedData[key].enableBorder);
            }
            if (updatedData[key].colorBorder !== undefined) {
              elCardContent.setAttribute('data-border-color', updatedData[key].colorBorder);
            }
            // Apply border style
            const enableBorder = updatedData[key].enableBorder !== false;
            const borderColor =
              updatedData[key].colorBorder || elCardContent.getAttribute('data-border-color') || '#d4dceb';
            if (enableBorder) {
              elCardContent.style.border = `1px solid ${borderColor}`;
            } else {
              elCardContent.style.border = 'none';
            }
          }
          break;
        }
        case 'rightCard': {
          const elCardImage = container.querySelector('[data-attribute="card-item-image"]');
          if (elCardImage) {
            if (updatedData[key].order !== undefined) {
              elCardImage.setAttribute('data-order', updatedData[key].order);
              elCardImage.style.order = updatedData[key].order;
            }
            const mediaType = updatedData[key].mediaType === 'image' ? 'image' : 'video';
            const elWrapImg = elCardImage.querySelector('[data-attribute="wrap-img"]');
            const elWrapVideo = elCardImage.querySelector('[data-attribute="wrap-video"]');
            const img = elWrapImg?.querySelector('img') || elCardImage.querySelector('img');
            const video = elCardImage.querySelector('[data-attribute="card-video"]');

            if (elWrapImg) {
              const showImg = mediaType === 'image';
              elWrapImg.setAttribute('data-show-img', String(showImg));
              elWrapImg.style.display = showImg ? 'block' : 'none';
            }
            if (elWrapVideo) {
              const showVideo = mediaType === 'video';
              elWrapVideo.setAttribute('data-show-video', String(showVideo));
              elWrapVideo.style.display = showVideo ? 'block' : 'none';
            }

            if (mediaType === 'image') {
              if (img) img.setAttribute('src', updatedData[key].img || '');
              if (video) video.setAttribute('src', '');
            } else {
              if (video) video.setAttribute('src', updatedData[key].video || '');
              if (img) img.setAttribute('src', '');
            }
          }
          break;
        }
        case 'images-small': {
          const el = container.querySelector('[data-attribute="images-small"]');
          if (el) {
            el.setAttribute('data-show-imgsmall', updatedData[key].show);
            el.style.display = updatedData[key].show ? 'flex' : 'none';
            el.innerHTML = (updatedData[key].listItem || [])
              .map(item => {
                const isVideo = item.mediaType === 'video';
                const mediaHtml = isVideo
                  ? `
                    <video width="100%" height="auto" autoplay muted loop playsinline>
                      <source data-attribute="video-small" type="video/mp4" src="${item.video || ''}">
                    </video>`
                  : `
                    <img data-attribute="image-small" loading="lazy" src="${item.img || ''}" alt="">`;
                return `
                  <div class="item-img">
                    ${mediaHtml}
                    <div
                      data-show-icon="${item.showIcon !== false}"
                      data-attribute="data-icon-small"
                      class="icon-img-smal"
                      style="display: ${item.showIcon !== false ? 'block' : 'none'};"
                    >
                      <img src="${item.icon || ''}" alt="">
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        case 'videos-small': {
          const el = container.querySelector('[data-attribute="videos-small"]');
          if (el) {
            el.setAttribute('data-show-videosmall', updatedData[key].show);
            el.style.display = updatedData[key].show ? 'flex' : 'none';
            el.innerHTML = (updatedData[key].listItem || [])
              .map(
                item => `
                  <div class="item-video">
                    <video width="100%" height="auto" autoplay muted loop playsinline>
                      <source data-attribute="video-small" type="video/mp4" src="${item.video || ''}">
                    </video>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        case 'itemWithIcon': {
          const el = container.querySelector('[data-attribute="wrap-item-with-icon"]');
          if (el) {
            el.setAttribute('data-show-item-with-icon', updatedData[key].show);
            el.style.display = updatedData[key].show ? 'block' : 'none';
            el.innerHTML = (updatedData[key].listItem || [])
              .map(
                item => `
                  <div data-attribute="item-with-icon" class="wrap-item">
                    <div class="wrap-icon">
                      <img src="${item.icon || ''}" alt="">
                    </div>
                    <div class="wrap-tex-icon">
                      <div class="title-icon">${item.title || ''}</div>
                      <div class="description-icon">${item.description || ''}</div>
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        case 'reted': {
          const elWrap = container.querySelector('[data-attribute="card-rated-row"]');
          const elStars = container.querySelector('[data-attribute="rating-stars"]');
          const elText = container.querySelector('[data-attribute="rating-text"]');
          if (elWrap) {
            elWrap.style.display = updatedData[key].showRating ? 'block' : 'none';
            elWrap.setAttribute('data-show-rating', updatedData[key].showRating);
          }
          if (elStars && updatedData[key].ratingStars !== undefined) {
            elStars.setAttribute('data-value', updatedData[key].ratingStars);
          }
          if (elText) {
            if (updatedData[key].ratingText !== undefined) elText.textContent = updatedData[key].ratingText || '';
            if (updatedData[key].ratingTextColor) {
              elText.style.color = updatedData[key].ratingTextColor;
              elText.setAttribute('data-text-color', updatedData[key].ratingTextColor);
            }
          }
          break;
        }
        case 'textColor': {
          const cardContent = container.querySelector('[data-attribute="card-content"]');
          const ratingText = container.querySelectorAll('[data-attribute="rating-text"]');
          const subBtn = container.querySelectorAll('[data-attribute="sub-btn"]');
          // Apply CSS variable for section text color
          if (cardContainer) {
            cardContainer.style.setProperty('--text-color', updatedData[key]);
            cardContainer.setAttribute('data-text-color', updatedData[key]);
          }
          if (cardContent) {
            cardContent.style.color = updatedData[key];
            cardContent.setAttribute('data-text-color', updatedData[key]);
          }
          if (ratingText) {
            ratingText.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          if (subBtn) {
            subBtn.forEach(item => {
              item.style.color = updatedData[key];
              item.setAttribute('data-text-color', updatedData[key]);
            });
          }
          break;
        }
        case 'cardContent': {
          const el = container.querySelector('[data-attribute="card-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'itemAccordions': {
          const el = container.querySelector('[data-attribute="card-accordions"]');
          if (el) {
            el.setAttribute('data-show-accordion', updatedData[key]?.dataShowAccordion);
            el.style.display = updatedData[key]?.dataShowAccordion ? 'block' : 'none';
            el.innerHTML = (updatedData[key]?.listItem || [])
              .map(
                item => `
                  <div data-attribute="card-accordion" class="wrap-accordion">
                    <div data-attribute="accordion-title" class="accordion-title">
                      <div data-attribute="accordion-title-text">${item.title || ''}</div>
                      <div class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-chevron-down-icon lucide-chevron-down">
                          <path d="m6 9 6 6 6-6" />
                        </svg>
                      </div>
                    </div>
                    <div data-attribute="accordion-content" class="accordion-content">
                      <div data-attribute="accordion-text" class="accordion-text">${item.answer || ''}</div>
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        case 'btnCard': {
          const elRow = container.querySelector('[data-attribute="card-btn-row"]');
          if (elRow) {
            elRow.style.display = updatedData[key].showBtn ? 'block' : 'none';
            elRow.setAttribute('data-show-btn', updatedData[key].showBtn);
          }
          const elBtn = container.querySelector('[data-attribute="card-btn"]');
          if (elBtn) {
            // Template mới tách icon & text:
            // - text nằm trong [data-attribute="btn-text"]
            // - icon nằm ngoài đó (div.icon-btn) nên không được set elBtn.textContent
            const btnTextEl = elBtn.querySelector('[data-attribute="btn-text"]');
            if (btnTextEl) {
              btnTextEl.textContent = String(updatedData[key].text || '');
            } else {
              // Fallback cho template cũ
              elBtn.textContent = String(updatedData[key].text || '');
            }
            elBtn.setAttribute('href', updatedData[key].url || '#');
            if (updatedData[key].backgroundColor) {
              elBtn.style.backgroundColor = updatedData[key].backgroundColor;
              elBtn.setAttribute('data-background', updatedData[key].backgroundColor);
              // SCSS uses var(--bg-color-btn) for button styling (border/hover/etc.)
              if (cardContainer) {
                cardContainer.style.setProperty('--bg-color-btn', updatedData[key].backgroundColor);
              }
            }
            if (updatedData[key].color) {
              elBtn.style.color = updatedData[key].color;
              elBtn.setAttribute('data-color', updatedData[key].color);
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardMultiToolDouble(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const starSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide-icon lucide lucide-star fill-current text-yellow-500">
        <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
      </svg>
    `;

    const chevronDownSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-chevron-down-icon lucide-chevron-down">
        <path d="m6 9 6 6 6-6" />
      </svg>
    `;

    const cardBtnIconSvg = `
      <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0L3.51 4.78636L0 9.57273H2.34L5.85 4.78636L2.34 0H0Z" fill="currentColor" />
      </svg>
    `;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.style.setProperty('--text-color', updatedData[key]);
            cardContainer.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'wrapCards': {
          const wrapper = container.querySelector('.swiper-wrapper');
          if (!wrapper) break;

          const list = updatedData[key]?.listItem || [];
          wrapper.innerHTML = list
            .map(card => {
              const leftCard = card.leftCard || {};
              const rightCard = card.rightCard || {};
              const reted = card.reted || {};
              const itemAccordions = card.itemAccordions || {};
              const imagesSmall = card['images-small'] || {};
              const itemWithIcon = card.itemWithIcon || {};
              const btnCard = card.btnCard || {};
              const cardSurvey = card.cardSurvey || {};

              const showRating = !!reted.showRating;

              const enableBorder = leftCard.enableBorder !== undefined ? !!leftCard.enableBorder : true;
              const borderColor = leftCard.colorBorder || '#d4dceb';

              const showAccordions =
                itemAccordions.dataShowAccordion !== undefined ? !!itemAccordions.dataShowAccordion : true;
              const showImagesSmall = imagesSmall.show !== undefined ? !!imagesSmall.show : true;
              const showItemWithIcon = itemWithIcon.show !== undefined ? !!itemWithIcon.show : true;
              const showBtn = btnCard.showBtn !== undefined ? !!btnCard.showBtn : true;

              const ratingTextColor = reted.ratingTextColor || updatedData.textColor || '#000000';
              const ratingStars = Number.isFinite(Number(reted.ratingStars)) ? Number(reted.ratingStars) : 4;

              const showSurvey = cardSurvey.show !== undefined ? !!cardSurvey.show : false;
              const colorPercent = cardSurvey.colorPercent || '#606F99';
              const surveyItems = Array.isArray(cardSurvey.listItem) ? cardSurvey.listItem : [];
              const radius = 40;
              const circumference = 2 * Math.PI * radius;
              const surveyHtml = surveyItems
                .map(item => {
                  const percentRaw = item?.percent;
                  const percent = Number.isFinite(Number(percentRaw)) ? Number(percentRaw) : 0;
                  const clampedPercent = Math.max(0, Math.min(100, percent));
                  const offset = circumference * (1 - clampedPercent / 100);
                  return `
                    <div data-attribute="item-survay" class="wrap-survay-item">
                      <div class="left-item">
                        <svg class="size-full" viewBox="0 0 100 100">
                          <circle class="text-gray-300" stroke-width="8" stroke="#D4DCEB" fill="transparent" cx="50" cy="50" r="40"></circle>
                          <circle
                            data-attribute="percent-circle-survay"
                            r="${radius}"
                            cx="50"
                            cy="50"
                            stroke-width="8"
                            fill="transparent"
                            stroke="${colorPercent}"
                            stroke-linecap="butt"
                            transform="rotate(-90 50 50)"
                            stroke-dasharray="${circumference}"
                            stroke-dashoffset="${offset}"
                          ></circle>
                        </svg>
                        <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: ${colorPercent};">
                          <span data-attribute="percent-survay">${clampedPercent}</span>%
                        </div>
                      </div>
                      <div data-attribute="description-survay" class="right-item">
                        ${item?.description || ''}
                      </div>
                    </div>
                  `;
                })
                .join('');

              const accordionsHtml = (itemAccordions.listItem || [])
                .map(
                  item => `
                    <div data-attribute="card-accordion" class="wrap-accordion">
                      <div data-attribute="accordion-title" class="accordion-title">
                        <div data-attribute="accordion-title-text">${item.title || ''}</div>
                        <div class="accordion-icon">
                          ${chevronDownSvg}
                        </div>
                      </div>
                      <div data-attribute="accordion-content" class="accordion-content">
                        <div data-attribute="accordion-text" class="accordion-text">${item.answer || ''}</div>
                      </div>
                    </div>
                  `,
                )
                .join('');

              const imagesSmallHtml = (imagesSmall.listItem || [])
                .map(
                  item => `
                    <div class="item-img">
                      <img data-attribute="image-small" loading="lazy" src="${item.img || ''}" alt="">
                    </div>
                  `,
                )
                .join('');

              const itemWithIconHtml = (itemWithIcon.listItem || [])
                .map(
                  item => `
                    <div data-attribute="item-with-icon" class="wrap-item">
                      <div class="wrap-icon">
                        <img src="${item.icon || ''}" alt="">
                      </div>
                      <div class="wrap-tex-icon">
                        <div class="title-icon">${item.title || ''}</div>
                        <div class="description-icon">${item.description || ''}</div>
                      </div>
                    </div>
                  `,
                )
                .join('');

              const btnBg = btnCard.backgroundColor || '#d4c4a8';
              const btnColor = btnCard.color || '#ffffff';

              return `
                <div data-attribute="item-card-double" class="wrap-item swiper-slide">
                  <div
                    data-enable-border="${enableBorder}"
                    data-border-color="${borderColor}"
                    data-attribute="card-item-content"
                    data-order="${leftCard.order || '1'}"
                    class="card-left"
                    data-style-center-y="${!!leftCard.centerY}"
                    style="border: 1px solid ${enableBorder ? borderColor : 'transparent'}; order: ${leftCard.order ||
                '1'};">
                    <div data-attribute="card-rated-row" data-show-rating="${showRating}" style="display: ${
                showRating ? 'block' : 'none'
              };">
                      <div class="wrap-rated">
                        <div data-attribute="rating-stars" data-value="${ratingStars}" class="wrap-stars">
                          ${Array.from({ length: 5 })
                            .map(() => starSvg)
                            .join('')}
                        </div>
                        <div data-attribute="rating-text" class="wrap-rating" data-text-color="${ratingTextColor}" style="color: ${ratingTextColor};">
                          ${reted.ratingText || ''}
                        </div>
                      </div>
                    </div>
                    <div data-attribute="card-content" class="card-content" data-text-color="">
                      ${card.cardContent || ''}
                    </div>
                    <div data-attribute="card-accordions" data-show-accordion="${showAccordions}" style="display: ${
                showAccordions ? 'block' : 'none'
              };">
                      ${accordionsHtml}
                    </div>

                    <div data-attribute="wrap-item-with-icon" class="wrap-item-with-icon" data-show-item-with-icon="${showItemWithIcon}" style="display: ${
                showItemWithIcon ? 'block' : 'none'
              };">
                      ${itemWithIconHtml}
                    </div>
                    <div
                      data-attribute="card-survay"
                      data-color-percent="${colorPercent}"
                      data-show-survay="${showSurvey ? 'true' : 'false'}"
                      class="card-survay"
                      style="display: ${showSurvey ? 'block' : 'none'};"
                    >
                      ${surveyHtml}
                    </div>
                    <div data-attribute="images-small" data-show-imgsmall="${showImagesSmall}" class="group-images-small" style="display: ${
                showImagesSmall ? 'flex' : 'none'
              };">
                      ${imagesSmallHtml}
                    </div>
                    <div data-attribute="card-btn-row" data-show-btn="${showBtn}" class="row-btn" style="display: ${
                showBtn ? 'block' : 'none'
              };">
                      <a data-attribute="card-btn" class="card-btn" href="${btnCard.url ||
                        '#'}" data-radius="0" data-background="${btnBg}" data-color="${btnColor}" style="background-color: ${btnBg}; color: ${btnColor}">
                        <span data-attribute="btn-text">${btnCard.text || ''}</span>
                        <div class="icon-btn">
                          ${cardBtnIconSvg}
                        </div>
                      </a>
                      <div data-attribute="sub-btn" class="sub-btn" data-text-color=""></div>
                    </div>
                  </div>
                  <div data-attribute="card-item-image" data-order="${rightCard.order ||
                    '2'}" class="card-right" style="order: ${rightCard.order || '2'};">
                    <div data-attribute="wrap-img" data-radius="0" class="wrap-img" style="border-radius: 0;">
                      <video width="100%" height="auto" autoplay muted loop playsinline>
                        <source data-attribute="card-video" type="video/mp4" src="${rightCard.video ||
                          rightCard.img ||
                          ''}">
                      </video>
                    </div>
                  </div>
                </div>
              `;
            })
            .join('');
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionMarkqueueRows(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'container': {
          const containerEl = container.querySelector('[data-attribute="container"]');
          const enableContainer = !!updatedData[key]?.enableContainer;
          if (containerEl) {
            containerEl.setAttribute('data-enable-container', enableContainer);
            if (enableContainer) {
              containerEl.classList.add('container');
            } else {
              containerEl.classList.remove('container');
            }
          }
          break;
        }
        case 'titleMarkqueue': {
          const el = container.querySelector('[data-attribute="title-markqueue"]');
          if (el) el.innerHTML = updatedData[key] || '';
          break;
        }
        case 'listRows': {
          const elListRows = container.querySelector('[data-attribute="list-rows"]');
          const rows = updatedData[key]?.listItem || [];
          if (elListRows) {
            elListRows.innerHTML = rows
              .map(row => {
                const rowImages = Array.isArray(row?.images) ? row.images : [];
                const rowImagesHtml = rowImages
                  .map(
                    img => `
                      <div data-attribute="wrap-img" class="wrap-img">
                        <img data-attribute="img-item" class="img-item" src="${img?.image || ''}" alt="">
                      </div>
                    `,
                  )
                  .join('');
                return `
                  <div data-attribute="row-markqueue" class="wrap-item">
                    ${rowImagesHtml}
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionFbPost03(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        // case 'container': {
        //   const containerEl = container.querySelector('[data-attribute="container"]')
        //   const enableContainer = !!updatedData[key]?.enableContainer
        //   if (containerEl) {
        //     containerEl.setAttribute('data-enable-container', enableContainer)
        //     if (enableContainer) {
        //       containerEl.classList.add('container')
        //     } else {
        //       containerEl.classList.remove('container')
        //     }
        //   }
        //   break
        // }
        case 'titlePost': {
          const titleEl = container.querySelector('[data-attribute="title-post"]');
          if (titleEl) titleEl.innerHTML = updatedData[key] || '';
          break;
        }
        case 'listPost': {
          const listPostEl = container.querySelector('[data-attribute="list-post"]');
          if (!listPostEl) break;

          const colPerViewRaw = Number(updatedData[key]?.colPerView);
          const colPerView = Number.isFinite(colPerViewRaw) ? Math.max(1, colPerViewRaw) : 3;
          listPostEl.setAttribute('data-col-per-view', String(colPerView));

          const baseItemHtml = listPostEl.querySelector('.wrap-item')?.outerHTML || '';
          const posts = Array.isArray(updatedData[key]?.listItem) ? updatedData[key].listItem : [];

          listPostEl.innerHTML = posts
            .map(post => {
              const itemDoc = parser.parseFromString(`<div>${baseItemHtml}</div>`, 'text/html');
              // baseItemHtml là outerHTML của `.wrap-item`, nhưng parse luôn bọc thêm 1 node `<div>`,
              // nên không được lấy `firstElementChild` (dễ gây dư div wrapper ngoài).
              const itemEl = itemDoc.body.querySelector('.wrap-item') || itemDoc.body.firstElementChild;
              if (!itemEl) return '';

              const userNameEl = itemEl.querySelector('[data-attribute="user-name"]');
              if (userNameEl) userNameEl.textContent = post?.outherName || '';

              const avatarEl = itemEl.querySelector('[data-attribute="author-avatar"] img');
              if (avatarEl) avatarEl.setAttribute('src', post?.outherAvatar || '');

              const createdAtEl = itemEl.querySelector('[data-attribute="created-at"]');
              if (createdAtEl) createdAtEl.textContent = post?.createdAt || '';

              const postTextEl = itemEl.querySelector('[data-attribute="post-text"]');
              if (postTextEl) postTextEl.textContent = post?.postText || '';

              const postImageEl = itemEl.querySelector('[data-attribute="post-img"] img');
              if (postImageEl) postImageEl.setAttribute('src', post?.postImage || '');

              const commentCountEl = itemEl.querySelector('[data-attribute="comment-count"]');
              if (commentCountEl) commentCountEl.textContent = `${post?.commentCount || '0'}`;

              const reactionCountEl = itemEl.querySelector('[data-attribute="reaction-count"]');
              if (reactionCountEl) reactionCountEl.textContent = `${post?.reactionCount || '0'}`;

              return itemEl.outerHTML;
            })
            .join('');
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionTpla(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer) {
            if (updatedData[key]?.color) {
              cardContainer.setAttribute('data-background', updatedData[key].color);
              cardContainer.style.backgroundColor = updatedData[key].color;
            }
            const bgImage = updatedData[key]?.image || '';
            cardContainer.setAttribute('data-background-image', bgImage);
            cardContainer.style.backgroundImage = bgImage ? `url('${bgImage}')` : '';
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.style.setProperty('--text-color', updatedData[key]);
            cardContainer.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'titleCard': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) el.innerHTML = updatedData[key];
          break;
        }
        case 'table': {
          const el = container.querySelector('[data-attribute="table-content"]');
          if (el) {
            if (updatedData[key].borderColor) {
              el.setAttribute('data-border-color', updatedData[key].borderColor);
              cardContainer.style.setProperty('--border-color', updatedData[key].borderColor);
            }
            if (updatedData[key].borderWeight) {
              el.setAttribute('data-border-weight', updatedData[key].borderWeight);
              cardContainer.style.setProperty('--border-weight', updatedData[key].borderWeight);
            }
            if (updatedData[key].colBorder !== undefined)
              el.setAttribute('data-col-border', updatedData[key].colBorder);
            if (updatedData[key].rowBorder !== undefined)
              el.setAttribute('data-row-border', updatedData[key].rowBorder);
            if (updatedData[key].borderFull !== undefined)
              el.setAttribute('data-border-full', updatedData[key].borderFull);
            if (updatedData[key].html !== undefined) el.innerHTML = updatedData[key].html;
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionReviewVital(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');
    const containerPage = container.querySelector('[data-attribute="container-page"]');

    const getCssVar = name => {
      if (!cardContainer) return '';
      const styleText = cardContainer.getAttribute('style') || '';
      const matched = styleText.match(new RegExp(`${name}:\\s*([^;]+)`, 'i'));
      return matched?.[1]?.trim() || '';
    };

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'titleCard': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) el.innerHTML = updatedData[key] || '';
          break;
        }
        case 'backgroundColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-background', updatedData[key] || '#ffffff');
            cardContainer.style.backgroundColor = updatedData[key] || '#ffffff';
            cardContainer.style.setProperty('--color-background', updatedData[key] || '#ffffff');
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key] || '#000000');
            cardContainer.setAttribute('data-color', updatedData[key] || '#000000');
            cardContainer.style.color = updatedData[key] || '#000000';
            cardContainer.style.setProperty('--color-text', updatedData[key] || '#000000');
          }
          break;
        }
        case 'colorStar': {
          if (cardContainer) {
            cardContainer.style.setProperty('--color-star', updatedData[key] || '#214a88');
          }
          break;
        }
        case 'container-page': {
          if (containerPage) {
            containerPage.setAttribute('data-background', updatedData[key]?.backgroundContainer || '#FFFFFF');
            containerPage.setAttribute('data-show-style', updatedData[key]?.showStyleContainer ? 'true' : 'false');
            containerPage.style.backgroundColor = updatedData[key]?.showStyleContainer
              ? updatedData[key]?.backgroundContainer || '#FFFFFF'
              : 'transparent';
          }
          break;
        }
        case 'admin': {
          if (cardContainer) {
            cardContainer.setAttribute('data-avatar-admin', updatedData[key]?.avatar || '');
            cardContainer.setAttribute('data-name-admin', updatedData[key]?.name || '');
          }
          break;
        }
        case 'productReview': {
          if (cardContainer) {
            cardContainer.setAttribute('data-img-product-review', updatedData[key]?.imge || '');
            cardContainer.setAttribute('data-title-product-review', updatedData[key]?.title || '');
            cardContainer.setAttribute('data-name-product-review', updatedData[key]?.name || '');
          }
          break;
        }
        case 'pageLimit': {
          if (cardContainer) {
            const val = Number(updatedData[key]);
            cardContainer.setAttribute('data-page-limit', Number.isFinite(val) && val > 0 ? String(val) : '1');
          }
          break;
        }
        case 'listItemReview': {
          if (cardContainer) {
            const safeList = Array.isArray(updatedData[key]) ? updatedData[key] : [];
            cardContainer.setAttribute('data-payload', JSON.stringify(safeList));
          }
          break;
        }
        default:
          break;
      }
    }

    if (cardContainer) {
      if (!getCssVar('--color-star')) {
        cardContainer.style.setProperty('--color-star', updatedData.colorStar || '#214a88');
      }
    }

    return container.innerHTML.trim();
  },

  sectionReviewTitan(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    const starSvg = `
      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
          fill="#F9AC07" />
      </svg>
    `;
    const verifiedBuyerBlock = `
      <div class="verified-buyer">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
            fill="#42ADA4" />
          <path
            d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
            fill="#E3F2FD" />
        </svg>
        <span>verified buyer</span>
      </div>
    `;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer) {
            if (updatedData[key]?.color) {
              cardContainer.setAttribute('data-background', updatedData[key].color);
              cardContainer.style.backgroundColor = updatedData[key].color;
            }
            const bgImage = updatedData[key]?.image || '';
            cardContainer.setAttribute('data-background-image', bgImage);
            cardContainer.style.backgroundImage = bgImage ? `url("${bgImage}")` : '';
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.style.setProperty('--text-color', updatedData[key]);
            cardContainer.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'titleCard': {
          const el = container.querySelector('[data-attribute="title-card"]');
          if (el) el.innerHTML = updatedData[key];
          break;
        }
        case 'wrapReviews': {
          const el = container.querySelector('[data-attribute="body-review"]');
          if (el) {
            if (updatedData[key]?.colPerView !== undefined) {
              el.setAttribute('data-col-per-view', updatedData[key].colPerView);
            }
            const wrapper = el.querySelector('.review-slider');
            if (wrapper) {
              wrapper.innerHTML = (updatedData[key]?.listItem || [])
                .map(item => {
                  const raw = Number(item.stars);
                  const stars = Math.max(1, Math.min(5, Number.isFinite(raw) ? raw : 1));
                  const starHtml = Array.from({ length: stars })
                    .map(() => starSvg)
                    .join('');
                  return `
                    <div data-attribute="item-review" class="item-review swiper-slide">
                      <div class="content-item">
                        <div class="review-image-container">
                          <img loading="lazy" data-attribute="review-image" src="${item.image ||
                            ''}" alt="review image" class="review-image">
                        </div>
                        <div class="review-content">
                          <div data-attribute="wrap-stars" class="wrap-stars" data-value="${stars}">
                            ${starHtml}
                          </div>
                          <div class="review-content-text" data-attribute="review-content">${item.reviewContent ||
                            ''}</div>
                          <div class="review-name" data-attribute="review-name">${item.reviewName || ''}</div>
                          ${verifiedBuyerBlock}
                        </div>
                      </div>
                    </div>
                  `;
                })
                .join('');
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionGuaranteedSafeCheckout02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'content': {
          const el = container.querySelector('[data-attribute="guaranteed-safe-checkout-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const containerEl = container.querySelector('[data-attribute="guaranteed-safe-checkout-section"]');
          if (containerEl) {
            containerEl.style.setProperty('--text-color', updatedData[key].textColor);
            containerEl.style.setProperty('--background-color', updatedData[key].backgroundColor);
            containerEl.style.setProperty('--container-background-color', updatedData[key].containerBackgroundColor);
            containerEl.setAttribute('data-text-color', updatedData[key].textColor);
            containerEl.setAttribute('data-background-color', updatedData[key].backgroundColor);
            containerEl.setAttribute('data-container-background-color', updatedData[key].containerBackgroundColor);
          }
          break;
        }
        case 'image': {
          const el = container.querySelector('[data-attribute="guaranteed-safe-checkout-image"]');
          if (el) {
            const img = el.querySelector('img');
            if (img && updatedData[key].url !== undefined) {
              img.setAttribute('src', updatedData[key].url);
            }
            if (updatedData[key].show !== undefined) {
              el.setAttribute('data-show-image', updatedData[key].show ? 'true' : 'false');
            }
            if (updatedData[key].widthDesktop !== undefined) {
              el.setAttribute('data-image-width-desktop', updatedData[key].widthDesktop);
            }
            if (updatedData[key].widthMobile !== undefined) {
              el.setAttribute('data-image-width-mobile', updatedData[key].widthMobile);
            }
          }

          const containerEl = container.querySelector('[data-attribute="guaranteed-safe-checkout-section"]');
          if (containerEl) {
            if (updatedData[key].position !== undefined) {
              containerEl.setAttribute('data-image-position', updatedData[key].position);
            }
            if (updatedData[key].widthDesktop !== undefined) {
              containerEl.style.setProperty('--image-width-desktop', `${updatedData[key].widthDesktop}px`);
            }
            if (updatedData[key].widthMobile !== undefined) {
              containerEl.style.setProperty('--image-width-mobile', `${updatedData[key].widthMobile}px`);
            }
          }
          break;
        }
        case 'layout': {
          const containerEl = container.querySelector('[data-attribute="guaranteed-safe-checkout-container"]');
          if (containerEl && updatedData[key]) {
            const { alignItems, borderEnabled, borderColor, gap, mobileColumn } = updatedData[key];
            if (alignItems !== undefined) {
              containerEl.setAttribute('data-container-align-items', alignItems);
            }
            if (borderEnabled !== undefined) {
              containerEl.setAttribute('data-container-border-enabled', borderEnabled ? 'true' : 'false');
            }
            if (borderColor !== undefined) {
              containerEl.setAttribute('data-container-border-color', borderColor);
              containerEl.style.setProperty('--container-border-color', borderColor);
            }
            if (gap !== undefined) {
              containerEl.setAttribute('data-container-gap', gap);
              containerEl.style.setProperty('--container-gap', `${gap}px`);
            }
            if (mobileColumn !== undefined) {
              containerEl.setAttribute('data-mobile-column', mobileColumn ? 'true' : 'false');
            }
          }
          break;
        }
        case 'borderRadius': {
          const containerEl = container.querySelector('[data-attribute="guaranteed-safe-checkout-section"]');
          if (containerEl) {
            containerEl.style.setProperty('--container-border-radius', `${updatedData[key]}px`);
            containerEl.setAttribute('data-container-border-radius', updatedData[key]);
          }
          break;
        }
        case 'sectionPadding': {
          const containerEl = container.querySelector('[data-attribute="guaranteed-safe-checkout-section"]');
          const pad = updatedData[key];
          if (!containerEl || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (attrName, cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            containerEl.setAttribute(attrName, n);
            containerEl.style.setProperty(cssVar, `${n}px`);
          };

          setSide('data-top-desktop-padding', '--padding-top-desktop', pad.topDesktop);
          setSide('data-bottom-desktop-padding', '--padding-bottom-desktop', pad.bottomDesktop);
          setSide('data-top-mobile-padding', '--padding-top-mobile', pad.topMobile);
          setSide('data-bottom-mobile-padding', '--padding-bottom-mobile', pad.bottomMobile);
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionFreestyleOrderPolicy(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'content': {
          const el = container.querySelector('[data-attribute="content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'text-color': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          if (containerEl) {
            containerEl.style.color = updatedData[key];
            containerEl.setAttribute('data-text-color', updatedData[key]);
          }
          break;
        }
        case 'background-color': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          if (containerEl) {
            containerEl.style.backgroundColor = updatedData[key];
            containerEl.setAttribute('data-background-color', updatedData[key]);
          }
          break;
        }
        case 'sectionPadding': {
          const containerEl = container.querySelector('[data-attribute="content"]');
          const pad = updatedData[key];
          if (!containerEl || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (attrName, cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            containerEl.setAttribute(attrName, n);
            containerEl.style.setProperty(cssVar, `${n}px`);
          };

          setSide('data-top-desktop-padding', '--padding-top-desktop', pad.topDesktop);
          setSide('data-bottom-desktop-padding', '--padding-bottom-desktop', pad.bottomDesktop);
          setSide('data-top-mobile-padding', '--padding-top-mobile', pad.topMobile);
          setSide('data-bottom-mobile-padding', '--padding-bottom-mobile', pad.bottomMobile);
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionTrustBadge(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) el.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'trust-badge-score': {
          const el = container.querySelector('[data-attribute="trust-badge-score"]');
          if (el) el.innerHTML = updatedData[key];
          break;
        }
        case 'brand-content': {
          const el = container.querySelector('[data-attribute="brand-content"]');
          if (el) el.innerHTML = updatedData[key];
          break;
        }
        case 'trust-image-1': {
          const el = container.querySelector('[data-attribute="trust-image-1"]');
          if (el) el.setAttribute('src', updatedData[key]);
          break;
        }
        case 'trust-image-2': {
          const el = container.querySelector('[data-attribute="trust-image-2"]');
          if (el) el.setAttribute('src', updatedData[key]);
          break;
        }
        case 'trust-image-3': {
          const el = container.querySelector('[data-attribute="trust-image-3"]');
          if (el) el.setAttribute('src', updatedData[key]);
          break;
        }
        case 'background-color': {
          const el = container.querySelector('[data-attribute="trust-badge-section"]');
          if (el) el.style.setProperty('--background-color', updatedData[key]);
          break;
        }
        case 'container-background-color': {
          const el = container.querySelector('[data-attribute="trust-badge-section"]');
          if (el) el.style.setProperty('--container-background-color', updatedData[key]);
          break;
        }
        case 'trust-badge-score-bg-color': {
          const el = container.querySelector('[data-attribute="trust-badge-section"]');
          if (el) el.style.setProperty('--trust-badge-score-bg-color', updatedData[key]);
          break;
        }
        case 'trust-badge-score-color': {
          const el = container.querySelector('[data-attribute="trust-badge-section"]');
          if (el) el.style.setProperty('--trust-badge-score-color', updatedData[key]);
          break;
        }
        case 'border-color': {
          const el = container.querySelector('[data-attribute="trust-badge-section"]');
          if (el) el.style.setProperty('--border-color', updatedData[key]);
          break;
        }
        case 'sectionPadding': {
          const el = container.querySelector('[data-attribute="trust-badge-section"]');
          const pad = updatedData[key];
          if (!el || !pad || typeof pad !== 'object' || Array.isArray(pad)) break;

          const setSide = (cssVar, raw) => {
            if (raw === undefined || raw === null) return;
            const n = Number(raw);
            if (Number.isNaN(n)) return;
            el.style.setProperty(cssVar, `${n}px`);
          };

          setSide('--padding-top-desktop', pad.topDesktop);
          setSide('--padding-bottom-desktop', pad.bottomDesktop);
          setSide('--padding-top-mobile', pad.topMobile);
          setSide('--padding-bottom-mobile', pad.bottomMobile);
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionCardCompareProduct(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const checkSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44412L19.2743 9.52467L10.5478 17.4581Z" fill="#121212"></path></svg>`;
    const crossSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM17.9662 15.9777L15.9777 17.9662L12 13.9885L8.02228 17.9662L6.03375 15.9777L10.0115 12L6.03375 8.02228L8.02228 6.03375L12 10.0115L15.9777 6.03375L17.9662 8.02228L13.9885 12L17.9662 15.9777Z" fill="#121212"></path></svg>`;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'header': {
          const headerEl = container.querySelector('.card-compare-product-title');
          if (headerEl) {
            headerEl.innerHTML = updatedData[key];
          }
          break;
        }

        case 'leftMedia': {
          const leftEl = container.querySelector('.card-compare-product-image-left');
          if (leftEl) {
            const mediaData = updatedData[key] || {};
            if (mediaData.type === 'video') {
              const videoUrl = mediaData.video || '';
              leftEl.innerHTML = `<video width="100%" height="auto" autoplay muted loop playsinline><source src="${videoUrl}" type="video/mp4" /></video>`;
            } else {
              const imageUrl = mediaData.url || '';
              leftEl.innerHTML = `<img src="${imageUrl}" alt="" />`;
            }
          }
          break;
        }

        case 'rightMedia': {
          const rightEl = container.querySelector('.card-compare-product-image-right');
          if (rightEl) {
            const mediaData = updatedData[key] || {};
            if (mediaData.type === 'video') {
              const videoUrl = mediaData.video || '';
              rightEl.innerHTML = `<video width="100%" height="auto" autoplay muted loop playsinline><source src="${videoUrl}" type="video/mp4" /></video>`;
            } else {
              const imageUrl = mediaData.url || '';
              rightEl.innerHTML = `<img src="${imageUrl}" alt="" />`;
            }
          }
          break;
        }

        case 'vsBox': {
          const vsEl = container.querySelector('.card-compare-product-image-text');
          if (vsEl) {
            vsEl.textContent = updatedData[key].text || 'VS.';
          }
          const wrapper = container.querySelector('[data-attribute="card-compare-product-wrapper"]');
          if (wrapper) {
            wrapper.style.setProperty('--vs-bg-color', updatedData[key].backgroundColor || '#121212');
            wrapper.style.setProperty('--vs-text-color', updatedData[key].textColor || '#ffffff');
          }
          break;
        }

        case 'badPosition': {
          const wrapper = container.querySelector('[data-attribute="card-compare-product-wrapper"]');
          if (wrapper) {
            wrapper.setAttribute('data-bad-position', updatedData[key] || 'right');
          }
          break;
        }

        case 'compareList': {
          const listContainer = container.querySelector('.card-compare-functionality-list');
          if (listContainer && Array.isArray(updatedData[key])) {
            listContainer.innerHTML = '';
            updatedData[key].forEach(item => {
              const itemEl = document.createElement('div');
              itemEl.className = 'card-compare-functionality-item';
              itemEl.setAttribute('data-attribute', 'card-compare-functionality-item');
              itemEl.innerHTML = `
                <div class="card-compare-functionality-good">
                  <div class="card-compare-functionality-good-text" data-attribute="card-compare-functionality-good-text">${item.goodText ||
                    ''}</div>
                  <div class="card-compare-functionality-good-icon" data-attribute="card-compare-functionality-good-icon">${checkSvg}</div>
                </div>
                <div class="card-compare-functionality-bad">
                  <div class="card-compare-functionality-bad-icon" data-attribute="card-compare-functionality-bad-icon">${crossSvg}</div>
                  <div class="card-compare-functionality-bad-text" data-attribute="card-compare-functionality-bad-text">${item.badText ||
                    ''}</div>
                </div>
              `;
              listContainer.appendChild(itemEl);
            });
          }
          break;
        }

        case 'colors': {
          const wrapper = container.querySelector('[data-attribute="card-compare-product-wrapper"]');
          if (wrapper) {
            wrapper.style.setProperty('--background-color', updatedData.colors.backgroundColor || '');
            wrapper.style.setProperty('--text-color', updatedData.colors.textColor || '');
            wrapper.style.setProperty('--good-bg-color', updatedData.colors.goodBackgroundColor || '');
            wrapper.style.setProperty('--good-text-color', updatedData.colors.goodTextColor || '');
            wrapper.style.setProperty('--bad-bg-color', updatedData.colors.badBackgroundColor || '');
            wrapper.style.setProperty('--bad-text-color', updatedData.colors.badTextColor || '');
          }
          break;
        }

        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="card-compare-product-wrapper"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key] ? 'true' : 'false');
          }
          break;
        }

        case 'topPadding': {
          const wrapper = container.querySelector('[data-attribute="card-compare-product-wrapper"]');
          if (wrapper) {
            wrapper.setAttribute('data-top-padding', updatedData[key] ? 'true' : 'false');
            wrapper.style.paddingTop = updatedData[key] ? '' : '0';
          }
          break;
        }

        case 'bottomPadding': {
          const wrapper = container.querySelector('[data-attribute="card-compare-product-wrapper"]');
          if (wrapper) {
            wrapper.setAttribute('data-bottom-padding', updatedData[key] ? 'true' : 'false');
            wrapper.style.paddingBottom = updatedData[key] ? '' : '0';
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },
  sectionFaqGrid05(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const faqGridContainerEl = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (faqGridContainerEl) {
            faqGridContainerEl.setAttribute('data-background', updatedData[key].backgroundContainer);
            faqGridContainerEl.style.setProperty('--background-container', updatedData[key].backgroundContainer);
          }
          const listItemsEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemsEl) {
            listItemsEl.setAttribute('data-background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.style.setProperty('--background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.setAttribute('data-background-faq-item-content', updatedData[key].backgroundFaqItemContent);
            listItemsEl.style.setProperty('--background-faq-item-content', updatedData[key].backgroundFaqItemContent);
            listItemsEl.setAttribute('data-text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.style.setProperty('--text-faq-item-color', updatedData[key].textFaqItem);
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div
                  data-attribute="item-wapper"
                  class="item-wapper"
                >
                  <div data-attribute="item-question" class="item-question">
                    <div
                      class="item-question-line"
                      data-attribute="item-question-line"
                      data-line-color="${item.lineColor}"
                      style="background-color: ${item.lineColor}"
                    ></div>
                    <h3
                      data-attribute="title-item-question"
                      data-color="#000000"
                      class="title-item-question"
                      style="color: '#000000'"
                    >
                      ${item.question}
                    </h3>
                    <span data-attribute="icon-minus" style="display: none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-minus-icon lucide-minus"
                      >
                        <path d="M5 12h14" />
                      </svg>
                    </span>

                    <span data-attribute="icon-plus"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="lucide lucide-plus-icon lucide-plus"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5v14" /></svg
                    ></span>
                  </div>
                  <div data-attribute="item-answer" class="item-answer">
                    <div data-attribute="answer-content" class="answer-content">
                      ${item.answer}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
          }
          break;
        }
        case 'showSeparator': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-show-separator', updatedData[key]);
          }
          break;
        }
        case 'showLineColor': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-show-line-color', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },
  sectionItemsGrid03(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.setProperty('--background-color', updatedData[key]);
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'cardBackgroundColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-card-background-color', updatedData[key]);
            el.style.setProperty('--card-background-color', updatedData[key]);
          }
          break;
        }
        case 'cardTextColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-card-text-color', updatedData[key]);
            el.style.setProperty('--card-text-color', updatedData[key]);
          }
          break;
        }
        case 'backgroundImage': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-background-image', updatedData[key]);
          }
          break;
        }
        case 'cardBorderRadius': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-card-border-radius', updatedData[key]);
            el.style.setProperty('--card-border-radius', `${updatedData[key]}px`);
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              ?.map(item => {
                return `
                <div data-attribute="item" class="items-grid-item">
                  <div class="items-grid-item-image">
                    <img data-attribute="image-item" src="${item.image}" alt="">
                  </div>
                  <div data-attribute="text-item" class="items-grid-item-text">
                    ${item.htmlText}
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="items-grid-content"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
            if (updatedData[key]) {
              el.classList.remove('container');
            } else {
              el.classList.add('container');
            }
          }
          break;
        }
        case 'itemsPerRow': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            const itemCount =
              Array.isArray(updatedData.listItem) && updatedData.listItem.length > 0
                ? updatedData.listItem.length
                : el.querySelectorAll('[data-attribute="item"]').length || 1;
            const normalizedMobile = Math.max(1, Math.min(Number(updatedData[key].mobile) || 1, itemCount));
            const normalizedDesktop = Math.max(1, Math.min(Number(updatedData[key].desktop) || 1, itemCount));

            el.setAttribute('data-items-per-row-mobile', normalizedMobile);
            el.setAttribute('data-items-per-row-desktop', normalizedDesktop);
            el.style.setProperty('--items-per-row-mobile', `${normalizedMobile}`);
            el.style.setProperty('--items-per-row-desktop', `${normalizedDesktop}`);
          }
          break;
        }
        case 'itemImageWidthMobile': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-item-image-width-mobile', updatedData[key]);
            el.style.setProperty('--item-image-width-mobile', `${updatedData[key]}px`);
          }
          break;
        }
        case 'itemImageWidthDesktop': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-item-image-width-desktop', updatedData[key]);
            el.style.setProperty('--item-image-width-desktop', `${updatedData[key]}px`);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionItemsGrid04(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.setProperty('--background-color', updatedData[key]);
          }
          break;
        }
        case 'textColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-text-color', updatedData[key]);
            el.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'cardBackgroundColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-card-background-color', updatedData[key]);
            el.style.setProperty('--card-background-color', updatedData[key]);
          }
          break;
        }
        case 'cardTextColor': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-card-text-color', updatedData[key]);
            el.style.setProperty('--card-text-color', updatedData[key]);
          }
          break;
        }
        case 'cardBorderRadius': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-card-border-radius', updatedData[key]);
            el.style.setProperty('--card-border-radius', `${updatedData[key]}px`);
          }
          break;
        }
        case 'titleContent': {
          const el = container.querySelector('[data-attribute="title-content"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'image': {
          const wrapperEl = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (wrapperEl) {
            wrapperEl.setAttribute('data-image-show', updatedData[key].show);
            wrapperEl.setAttribute('data-image-position', updatedData[key].position);
          }
          const imgEl = container.querySelector('[data-attribute="items-grid-image"]');
          if (imgEl) {
            const imgInnerEl = imgEl.querySelector('[data-attribute="items-grid-image-inner"]');
            if (imgInnerEl) {
              imgInnerEl.setAttribute('src', updatedData[key].url);
            }
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="items-grid-list"]');
          if (el) {
            el.innerHTML = updatedData[key]
              ?.map(item => {
                return `
                <div data-attribute="items-grid-item" class="items-grid-item">
                  <div class="items-grid-item-number" data-attribute="number-item">
                    ${item.number}
                  </div>
                  <div class="items-grid-item-image">
                    <img data-attribute="image-item" src="${item.image}" alt="">
                  </div>
                  <div data-attribute="text-item" class="items-grid-item-text">
                    ${item.htmlText}
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="items-grid-content"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
            if (updatedData[key]) {
              el.classList.remove('container');
            } else {
              el.classList.add('container');
            }
          }
          break;
        }
        case 'itemsGridListWidth': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-items-grid-list-width', updatedData[key]);
            el.style.setProperty('--items-grid-list-width', `${updatedData[key]}%`);
          }
          break;
        }
        case 'itemImageWidthDesktop': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-item-image-width-desktop', updatedData[key]);
            el.style.setProperty('--item-image-width-desktop', `${updatedData[key]}px`);
          }
          break;
        }
        case 'itemImageWidthMobile': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-item-image-width-mobile', updatedData[key]);
            el.style.setProperty('--item-image-width-mobile', `${updatedData[key]}px`);
          }
          break;
        }
        case 'showNumber': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-show-number', updatedData[key]);
          }
          break;
        }
        case 'itemsPerRow': {
          const el = container.querySelector('[data-attribute="items-grid-list"]');
          if (el) {
            const itemCount =
              Array.isArray(updatedData.listItem) && updatedData.listItem.length > 0
                ? updatedData.listItem.length
                : el.querySelectorAll('[data-attribute="items-grid-item"]').length || 1;
            const normalizedMobile = Math.max(1, Math.min(Number(updatedData[key].mobile) || 1, itemCount));
            const normalizedDesktop = Math.max(1, Math.min(Number(updatedData[key].desktop) || 1, itemCount));

            el.setAttribute('data-items-per-row-mobile', normalizedMobile);
            el.setAttribute('data-items-per-row-desktop', normalizedDesktop);
            el.style.setProperty('--items-per-row-mobile', `${normalizedMobile}`);
            el.style.setProperty('--items-per-row-desktop', `${normalizedDesktop}`);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="items-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionReviewGrid04(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'review-header': {
          const el = container.querySelector('[data-attribute="review-header"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const el = container.querySelector('[data-attribute="review-grid-wrapper"]');
          if (el) {
            el.style.setProperty('--background-color', updatedData[key].backgroundColor);
            el.setAttribute('data-background-color', updatedData[key].backgroundColor);
            el.style.setProperty('--text-color', updatedData[key].textColor);
            el.setAttribute('data-text-color', updatedData[key].textColor);
            el.style.setProperty('--primary-color', updatedData[key].primaryColor);
            el.setAttribute('data-primary-color', updatedData[key].primaryColor);
            el.style.setProperty('--reviews-list-background-color', updatedData[key].reviewsListBackgroundColor);
            el.setAttribute('data-reviews-list-background-color', updatedData[key].reviewsListBackgroundColor);
          }
          break;
        }
        case 'tag': {
          const el = container.querySelector('[data-attribute="review-grid-wrapper"]');
          if (el) {
            el.style.setProperty('--tag-background-color', updatedData[key].backgroundColor);
            el.setAttribute('data-tag-background-color', updatedData[key].backgroundColor);
            el.style.setProperty('--tag-text-color', updatedData[key].textColor);
            el.setAttribute('data-tag-text-color', updatedData[key].textColor);
            el.style.setProperty('--tag-active-text-color', updatedData[key].activeTextColor);
            el.setAttribute('data-tag-active-text-color', updatedData[key].activeTextColor);
            el.style.setProperty('--tag-border-radius', `${updatedData[key].borderRadius}px`);
            el.setAttribute('data-tag-border-radius', updatedData[key].borderRadius);
            el.setAttribute('data-show-tags', updatedData[key].show);

            const tagsWrapper = el.querySelector('[data-attribute="review-tags"]');
            if (tagsWrapper) {
              const tags = [{ text: 'All', value: 'all' }, ...updatedData[key].options];
              tagsWrapper.innerHTML = tags
                .map(option => {
                  return `
                  <div class="review-tag-item ${
                    option.value === 'all' ? 'active' : ''
                  }" data-attribute="review-tag-item" data-tag="${option.value}">
                    ${option.text}
                  </div>
                `;
                })
                .join('');
            }
          }
          break;
        }
        case 'button': {
          const el = container.querySelector('[data-attribute="review-grid-wrapper"]');
          if (el) {
            el.style.setProperty('--button-text-color', updatedData[key].textColor);
            el.setAttribute('data-button-text-color', updatedData[key].textColor);
            el.style.setProperty('--button-border-radius', `${updatedData[key].borderRadius}px`);
            el.setAttribute('data-button-border-radius', updatedData[key].borderRadius);
            el.setAttribute('data-text-line-clamp', updatedData[key].textLineClamp);
            el.style.setProperty('--text-line-clamp', Number(updatedData[key].textLineClamp));
            el.setAttribute('data-page-size', updatedData[key].pageSize);
            el.setAttribute('data-read-more-text', updatedData[key].readMoreText);
            el.setAttribute('data-show-less-text', updatedData[key].showLessText);

            const loadMoreButton = el.querySelector('[data-attribute="load-more-button"]');
            if (loadMoreButton) {
              loadMoreButton.textContent = updatedData[key].loadMoreText;
            }

            const readMoreButton = el.querySelectorAll('[data-attribute="read-more-button"]');
            readMoreButton.forEach(button => {
              button.textContent = updatedData[key].readMoreText;
            });
          }
          break;
        }
        case 'avatar': {
          const el = container.querySelector('[data-attribute="review-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-show-avatar-border', updatedData[key].showBorder);
            el.setAttribute('data-avatar-size-desktop', updatedData[key].desktopSize);
            el.setAttribute('data-avatar-size-mobile', updatedData[key].mobileSize);
            el.style.setProperty('--avatar-size-desktop', `${updatedData[key].desktopSize}px`);
            el.style.setProperty('--avatar-size-mobile', `${updatedData[key].mobileSize}px`);
          }
          break;
        }
        case 'itemsPerRow': {
          const el = container.querySelector('[data-attribute="review-grid-wrapper"]');
          if (el) {
            el.setAttribute('data-items-per-row-mobile', updatedData[key].mobile);
            el.setAttribute('data-items-per-row-desktop', updatedData[key].desktop);
            el.style.setProperty('--items-per-row-mobile', `${updatedData[key].mobile}`);
            el.style.setProperty('--items-per-row-desktop', `${updatedData[key].desktop}`);
          }
          break;
        }
        case 'reviewsList': {
          const bodyReview = container.querySelector('[data-attribute="review-grid-items"]');
          const reviews = updatedData[key].map(review => ({
            ...review,
            tag: review?.tag
              ?.toLowerCase()
              .trim()
              .replace(/\s+/g, '-'),
          }));
          if (bodyReview && updatedData[key]) {
            bodyReview.innerHTML = reviews
              .map(review => {
                return `
                  <div class="review-grid-item-empty" data-attribute="review-grid-item-empty">No reviews found</div>
                  <div data-attribute="review-grid-item" class="review-grid-item" ${
                    review?.tag ? `data-tag="${review?.tag}"` : ''
                  }>
                    <div class="reviewer-avatar-wrapper">
                      <img data-attribute="reviewer-avatar" src="${review?.avatar || ''}" alt="${review?.name}" />
                    </div>
                    <div class="review-info-container">
                      <h3 data-attribute="review-title" class="review-title">
                        ${review?.title}
                      </h3>
                      <p data-attribute="review-content" class="review-content">
                        ${review?.content}
                      </p>
                      <div class="review-footer">
                        <p data-attribute="reviewer-name" class="reviewer-name">
                          ${review?.name}
                        </p>
                        <button
                          type="button"
                          data-attribute="read-more-button"
                          class="read-more-button"
                        >
                          read more
                        </button>
                      </div>
                    </div>
                  </div>
                  `;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="review-grid-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionReviewGrid05(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleHeader': {
          const el = container.querySelector('[data-attribute="card-header"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'listItem': {
          const el = container.querySelector('[data-attribute="list-item"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                const type = item.type || (item.image ? 'image' : 'video');

                const starsSvg = Array(5)
                  .fill(
                    `<svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide-icon lucide lucide-star fill-current text-yellow-500"
                    >
                      <path
                        d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
                      ></path>
                    </svg>`,
                  )
                  .join('');

                if (type === 'image' && item.image) {
                  // Render image
                  return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <img loading="lazy" data-attribute="card-image" src="${item.image}" alt="" />
                    <div data-attribute="rating-stars" data-show-rating="true" data-value="${item.rating}" class="wrap-stars">
                      ${starsSvg}
                    </div>
                    <div class="wrap-item-content">
                      ${item.content}
                    </div>
                  </div>
                </div>
              `;
                } else {
                  // Render video (default or fallback)
                  return `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <div class="wrap-item-video">
                      <video loop playsinline muted width="600">
                        <source data-attribute="card-video"
                          src="${item.video || ''}"
                          type="video/mp4">
                      </video>
                      <div class="volume">
                        <span class="volume-icon" style="display: none;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-volume2-icon lucide-volume-2">
                            <path
                              d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z" />
                            <path d="M16 9a5 5 0 0 1 0 6" />
                            <path d="M19.364 18.364a9 9 0 0 0 0-12.728" />
                          </svg>
                        </span>
                        <span class="mute-icon" style="display: flex;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-volume-off-icon lucide-volume-off">
                            <path d="M16 9a5 5 0 0 1 .95 2.293" />
                            <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96" />
                            <path d="m2 2 20 20" />
                            <path
                              d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11" />
                            <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686" />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div data-attribute="rating-stars" data-show-rating="true" data-value="${
                      item.rating
                    }" class="wrap-stars">
                      ${starsSvg}
                    </div>
                    <div class="wrap-item-content">
                      ${item.content}
                    </div>
                  </div>
                </div>
              `;
                }
              })
              .join('');
          }
          break;
        }
        case 'containerWidth': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-container-width', updatedData[key]);
            el.style.setProperty('--container-width', `${updatedData[key]}%`);
          }
          break;
        }
        case 'showRating': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-show-rating', updatedData[key]);
          }
          break;
        }
        case 'colors': {
          const containerEl = container.querySelector('[data-attribute="card-container"]');
          if (containerEl) {
            containerEl.setAttribute('data-pagination-active-color', updatedData[key].paginationActiveColor);
            containerEl.style.setProperty('--pagination-active-color', updatedData[key].paginationActiveColor);
            containerEl.setAttribute('data-pagination-inactive-color', updatedData[key].paginationInactiveColor);
            containerEl.style.setProperty('--pagination-inactive-color', updatedData[key].paginationInactiveColor);
            containerEl.setAttribute('data-star-color', updatedData[key].starColor);
            containerEl.style.setProperty('--star-color', updatedData[key].starColor);
            containerEl.setAttribute('data-text-color', updatedData[key].textColor);
            containerEl.style.setProperty('--text-color', updatedData[key].textColor);
            containerEl.setAttribute('data-background-color', updatedData[key].backgroundColor);
            containerEl.style.setProperty('--background-color', updatedData[key].backgroundColor);
          }
          break;
        }
        case 'breakpoints': {
          const sectionEl = container.querySelector('[data-section]');
          if (sectionEl && updatedData[key]) {
            const breakpoints = updatedData[key];
            if (breakpoints.mobile) {
              sectionEl.setAttribute('data-breakpoint-mobile-slides', breakpoints.mobile.slidesPerView);
            }
            if (breakpoints.tablet) {
              sectionEl.setAttribute('data-breakpoint-tablet-slides', breakpoints.tablet.slidesPerView);
            }
            if (breakpoints.desktop) {
              sectionEl.setAttribute('data-breakpoint-desktop-slides', breakpoints.desktop.slidesPerView);
            }
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-container"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardBasic(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'colors': {
          const containerEl = container.querySelector('[data-attribute="card-basic-wrapper"]');
          if (containerEl) {
            containerEl.setAttribute('data-background-color', updatedData[key].backgroundColor);
            containerEl.style.setProperty('--background-color', updatedData[key].backgroundColor);
            containerEl.setAttribute('data-text-color', updatedData[key].textColor);
            containerEl.style.setProperty('--text-color', updatedData[key].textColor);
          }
          break;
        }
        case 'content': {
          const el = container.querySelector('[data-attribute="card-basic-content-text"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'image': {
          const el = container.querySelector('[data-attribute="card-basic-wrapper"]');
          if (el) {
            el.setAttribute('data-image-position', updatedData[key].position);
            el.setAttribute('data-image-width', updatedData[key].width);
          }
          const imageEl = container.querySelector('[data-attribute="card-basic-image-inner"]');
          if (imageEl) {
            imageEl.setAttribute('src', updatedData[key].url);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-basic-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-basic-wrapper"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionItemsGridMedia(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'colors': {
          const containerEl = container.querySelector('[data-attribute="items-grid-media-wrapper"]');
          if (containerEl) {
            containerEl.setAttribute('data-background-color', updatedData[key].backgroundColor);
            containerEl.style.setProperty('--background-color', updatedData[key].backgroundColor);
            containerEl.setAttribute('data-text-color', updatedData[key].textColor);
            containerEl.style.setProperty('--text-color', updatedData[key].textColor);
          }
          break;
        }
        case 'titleItemsGridMedia': {
          const el = container.querySelector('[data-attribute="items-grid-media-header"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'padding': {
          const el = container.querySelector('[data-attribute="items-grid-media-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key].top);
            el.setAttribute('data-bottom-padding', updatedData[key].bottom);
          }
          break;
        }
        case 'itemsPerRow': {
          const el = container.querySelector('[data-attribute="items-grid-media-wrapper"]');
          if (el) {
            el.setAttribute('data-items-per-row-mobile', updatedData[key].mobile);
            el.setAttribute('data-items-per-row-desktop', updatedData[key].desktop);
            el.style.setProperty('--items-per-row-mobile', updatedData[key].mobile);
            el.style.setProperty('--items-per-row-desktop', updatedData[key].desktop);
          }
          break;
        }
        case 'videoHeight': {
          const el = container.querySelector('[data-attribute="items-grid-media-wrapper"]');
          if (el) {
            el.setAttribute('data-video-height', updatedData[key]);
            el.style.setProperty('--video-height', `${updatedData[key]}px`);
          }
          break;
        }
        case 'mediaItems': {
          const el = container.querySelector('[data-attribute="items-grid-media-list"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                const checkIsYoutubeUrl = isYoutubeUrl(item.url);
                let videoHtml = '';
                if (checkIsYoutubeUrl) {
                  videoHtml = `
                    <iframe
                      width="560"
                      height="315"
                      class="items-grid-media-item-video-inner"
                      data-attribute="items-grid-media-item-video-inner"
                      src="${item.url}"
                      title="Lignosus helped to relieve my COPD symptoms"
                      frameborder="0"
                      allow="
                        accelerometer;
                        autoplay;
                        clipboard-write;
                        encrypted-media;
                        gyroscope;
                        picture-in-picture;
                        web-share;
                      "
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  `;
                } else {
                  videoHtml = `
                    <video
                      class="items-grid-media-item-video-inner"
                      data-attribute="items-grid-media-item-video-inner"
                      src="${item.url}"
                      loop
                      playsinline
                      muted
                      autoplay
                      height="315"
                      width="560"
                    ></video>
                    <div class="volume">
                      <span class="volume-icon" style="display: none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-volume2-icon lucide-volume-2"
                        >
                          <path
                            d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"
                          ></path>
                          <path d="M16 9a5 5 0 0 1 0 6"></path>
                          <path d="M19.364 18.364a9 9 0 0 0 0-12.728"></path>
                        </svg>
                      </span>
                      <span class="mute-icon" style="display: flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-volume-off-icon lucide-volume-off"
                        >
                          <path d="M16 9a5 5 0 0 1 .95 2.293"></path>
                          <path d="M19.364 5.636a9 9 0 0 1 1.889 9.96"></path>
                          <path d="m2 2 20 20"></path>
                          <path
                            d="m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11"
                          ></path>
                          <path d="M9.828 4.172A.686.686 0 0 1 11 4.657v.686"></path>
                        </svg>
                      </span>
                    </div>
                  `;
                }
                return `
                  <div class="items-grid-media-item" data-attribute="items-grid-media-item">
                    <div class="items-grid-media-item-video" data-attribute="items-grid-media-item-video">
                      ${videoHtml}
                    </div>
                    <div class="items-grid-media-item-content" data-attribute="items-grid-media-item-content">
                      ${item.content}
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionCardStepInstructions02(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'header': {
          const el = container.querySelector('[data-attribute="card-step-instructions-header"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const containerEl = container.querySelector('[data-attribute="card-step-instructions-wrapper"]');
          if (containerEl) {
            containerEl.setAttribute('data-background-color', updatedData[key].backgroundColor);
            containerEl.style.setProperty('--background-color', updatedData[key].backgroundColor);
            containerEl.setAttribute('data-text-color', updatedData[key].textColor);
            containerEl.style.setProperty('--text-color', updatedData[key].textColor);
            containerEl.setAttribute('data-odd-background', updatedData[key].oddBackgroundColor);
            containerEl.style.setProperty('--odd-background', updatedData[key].oddBackgroundColor);
            containerEl.setAttribute('data-odd-text-color', updatedData[key].oddTextColor);
            containerEl.style.setProperty('--odd-text-color', updatedData[key].oddTextColor);
            containerEl.setAttribute('data-even-background', updatedData[key].evenBackgroundColor);
            containerEl.style.setProperty('--even-background', updatedData[key].evenBackgroundColor);
            containerEl.setAttribute('data-even-text-color', updatedData[key].evenTextColor);
            containerEl.style.setProperty('--even-text-color', updatedData[key].evenTextColor);
          }
          break;
        }
        case 'itemsPerRow': {
          const el = container.querySelector('[data-attribute="card-step-instructions-wrapper"]');
          if (el) {
            el.setAttribute('data-items-per-row-mobile', updatedData[key].mobile);
            el.setAttribute('data-items-per-row-desktop', updatedData[key].desktop);
            el.style.setProperty('--items-per-row-mobile', updatedData[key].mobile);
            el.style.setProperty('--items-per-row-desktop', updatedData[key].desktop);
          }
          break;
        }
        case 'itemImageHeight': {
          const el = container.querySelector('[data-attribute="card-step-instructions-wrapper"]');
          if (el) {
            el.setAttribute('data-item-image-height', updatedData[key]);
            el.style.setProperty('--item-image-height', `${updatedData[key]}px`);
          }
          break;
        }
        case 'items': {
          const el = container.querySelector('[data-attribute="card-step-instructions-list"]');
          if (el) {
            el.innerHTML = updatedData[key]
              .map(item => {
                return `
                  <div
                    class="card-step-instructions-item"
                    data-attribute="card-step-instructions-item"
                  >
                    <div
                      class="card-step-instructions-item-title"
                      data-attribute="card-step-instructions-item-title"
                    >
                      ${item.title}
                    </div>
                    <div
                      class="card-step-instructions-item-image"
                      data-attribute="card-step-instructions-item-image"
                    >
                      <img
                        data-attribute="card-step-instructions-item-image-inner"
                        src="${item.image}"
                        alt="img"
                      />
                    </div>
                    <div
                      class="card-step-instructions-item-content"
                      data-attribute="card-step-instructions-item-content"
                    >
                      ${item.content}
                    </div>
                  </div>
                `;
              })
              .join('');
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="card-step-instructions-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="card-step-instructions-wrapper"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionBannerBasic(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'backgroundColor': {
          const el = container.querySelector('[data-attribute="banner-basic-wrapper"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key]);
            el.style.setProperty('--background-color', updatedData[key]);
          }
          break;
        }

        case 'card1': {
          const el = container.querySelector('[data-attribute="banner-basic-wrapper"]');
          if (el) {
            el.setAttribute('data-card-1-background-color', updatedData[key].backgroundColor);
            el.setAttribute('data-card-1-text-color', updatedData[key].textColor);
            el.setAttribute('button-text-color', updatedData[key].button.textColor);
            el.setAttribute('button-background-color', updatedData[key].button.backgroundColor);
            el.setAttribute('button-radius', updatedData[key].button.radius);

            el.style.setProperty('--card-1-background-color', updatedData[key].backgroundColor);
            el.style.setProperty('--card-1-text-color', updatedData[key].textColor);
            el.style.setProperty('button-text-color', updatedData[key].button.textColor);
            el.style.setProperty('button-background-color', updatedData[key].button.backgroundColor);
            el.style.setProperty('button-radius', `${updatedData[key].button.radius}px`);
          }

          const card1ImageEl = container.querySelector('[data-attribute="banner-basic-card-1-image-inner"]');
          if (card1ImageEl) {
            card1ImageEl.setAttribute('src', updatedData[key].image);
          }

          const card1TextEl = container.querySelector('[data-attribute="banner-basic-card-1-text"]');
          if (card1TextEl) {
            card1TextEl.innerHTML = updatedData[key].text;
          }

          const card1ButtonEl = container.querySelector('[data-attribute="banner-basic-card-1-button"]');
          if (card1ButtonEl) {
            card1ButtonEl.innerHTML = updatedData[key].button.text;
          }

          break;
        }

        case 'card2': {
          const el = container.querySelector('[data-attribute="banner-basic-card-2-image-inner"]');
          if (el) {
            el.setAttribute('src', updatedData[key].image);
          }
          break;
        }

        case 'card3': {
          const el = container.querySelector('[data-attribute="banner-basic-card-3-image-inner"]');
          if (el) {
            el.setAttribute('src', updatedData[key].image);
          }

          const card3TextEl = container.querySelector('[data-attribute="banner-basic-card-3-text"]');
          if (card3TextEl) {
            card3TextEl.innerHTML = updatedData[key].text;
          }

          const elWrapper = container.querySelector('[data-attribute="banner-basic-wrapper"]');
          if (elWrapper) {
            elWrapper.setAttribute('data-card-3-background-color', updatedData[key].backgroundColor);
            elWrapper.setAttribute('data-card-3-text-color', updatedData[key].textColor);

            elWrapper.style.setProperty('--card-3-background-color', updatedData[key].backgroundColor);
            elWrapper.style.setProperty('--card-3-text-color', updatedData[key].textColor);
          }
          break;
        }

        case 'card4': {
          const el = container.querySelector('[data-attribute="banner-basic-card-4-image-inner"]');
          if (el) {
            el.setAttribute('src', updatedData[key].image);
          }

          const elWrapper = container.querySelector('[data-attribute="banner-basic-wrapper"]');
          if (elWrapper) {
            elWrapper.setAttribute('data-card-4-background-color', updatedData[key].backgroundColor);
            elWrapper.style.setProperty('--card-4-background-color', updatedData[key].backgroundColor);
          }
          break;
        }

        case 'topPadding': {
          const el = container.querySelector('[data-attribute="banner-basic-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="banner-basic-wrapper"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionFreestyleInfo(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'colors': {
          const el = container.querySelector('[data-attribute="freestyle-info-wrapper"]');
          if (el) {
            el.setAttribute('data-background-color', updatedData[key].backgroundColor);
            el.style.setProperty('--background-color', updatedData[key].backgroundColor);
            el.setAttribute('data-text-color', updatedData[key].textColor);
            el.style.setProperty('--text-color', updatedData[key].textColor);
            el.setAttribute('data-table-header-background-color', updatedData[key].tableHeaderBackgroundColor);
            el.style.setProperty('--table-header-background-color', updatedData[key].tableHeaderBackgroundColor);
            el.setAttribute('data-table-header-text-color', updatedData[key].tableHeaderTextColor);
            el.style.setProperty('--table-header-text-color', updatedData[key].tableHeaderTextColor);
            el.setAttribute('data-table-old-row-background-color', updatedData[key].tableOldRowBackgroundColor);
            el.style.setProperty('--table-old-row-background-color', updatedData[key].tableOldRowBackgroundColor);
            el.setAttribute('data-table-old-row-text-color', updatedData[key].tableOldRowTextColor);
            el.style.setProperty('--table-old-row-text-color', updatedData[key].tableOldRowTextColor);
          }
          break;
        }
        case 'productFacts': {
          const el = container.querySelector('[data-attribute="freestyle-info-product-facts"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'directionForUse': {
          const el = container.querySelector('[data-attribute="freestyle-info-direction-for-use"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'table': {
          const el = container.querySelector('[data-attribute="freestyle-info-table"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'image': {
          const el1s = container.querySelectorAll('[data-attribute="freestyle-info-image-1-inner"]');
          if (el1s) {
            el1s.forEach(el1 => {
              el1.setAttribute('src', updatedData[key].url1);
            });
          }
          const el2s = container.querySelectorAll('[data-attribute="freestyle-info-image-2-inner"]');
          if (el2s) {
            el2s.forEach(el2 => {
              el2.setAttribute('src', updatedData[key].url2);
            });
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="freestyle-info-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="freestyle-info-wrapper"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }

        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionFaqGrid06(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;
    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const faqGridContainerEl = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (faqGridContainerEl) {
            faqGridContainerEl.setAttribute('data-background', updatedData[key].backgroundContainer);
            faqGridContainerEl.style.setProperty('--background-container', updatedData[key].backgroundContainer);
          }
          const listItemsEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemsEl) {
            listItemsEl.setAttribute('data-background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.style.setProperty('--background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.setAttribute('data-text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.style.setProperty('--text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.setAttribute('data-border-faq-item', updatedData[key].borderFaqItem);
            listItemsEl.style.setProperty('--border-faq-item', updatedData[key].borderFaqItem);
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div
                  data-attribute="item-wapper"
                  class="item-wapper"
                >
                  <div data-attribute="item-question" class="item-question">
                    <h3
                      data-attribute="title-item-question"
                      data-color="#000000"
                      class="title-item-question"
                      style="color: '#000000'"
                    >
                      ${item.question}
                    </h3>
                    <span data-attribute="icon-minus" style="display: none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M18 6 6 18" />
                        <path d="m6 6 12 12" />
                      </svg>
                    </span>
                    <span data-attribute="icon-plus">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                      </svg>
                    </span>
                  </div>
                  <div data-attribute="item-answer" class="item-answer">
                    <div data-attribute="answer-content" class="answer-content">
                      ${item.answer}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
          }
          break;
        }
        case 'topPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingTop = '';
            } else {
              el.style.paddingTop = '0';
            }
          }
          break;
        }
        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="faq-grid-container-fluid"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
            if (updatedData[key]) {
              el.style.paddingBottom = '';
            } else {
              el.style.paddingBottom = '0';
            }
          }
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },

  sectionMoneyBackGuarantee(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }

        case 'header': {
          const el = container.querySelector('[data-attribute="money-back-guarantee-header"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }

        case 'footer': {
          const el = container.querySelector('[data-attribute="money-back-guarantee-footer"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }

        case 'colors': {
          const wrapperEl = container.querySelector('[data-attribute="money-back-guarantee-wrapper"]');
          if (wrapperEl) {
            wrapperEl.setAttribute('data-background-color', updatedData[key].backgroundColor);
            wrapperEl.style.setProperty('--background-color', updatedData[key].backgroundColor);
            wrapperEl.setAttribute('data-container-background-color', updatedData[key].containerBackgroundColor);
            wrapperEl.style.setProperty('--container-background-color', updatedData[key].containerBackgroundColor);
            wrapperEl.setAttribute('data-text-color', updatedData[key].textColor);
            wrapperEl.style.setProperty('--text-color', updatedData[key].textColor);

            wrapperEl.setAttribute('data-button-text-color', updatedData.button.textColor);
            wrapperEl.style.setProperty('--button-text-color', updatedData.button.textColor);
            wrapperEl.setAttribute('data-button-background-color', updatedData.button.backgroundColor);
            wrapperEl.style.setProperty('--button-background-color', updatedData.button.backgroundColor);
            wrapperEl.setAttribute('data-button-border-radius', updatedData.button.borderRadius);
            wrapperEl.style.setProperty('--button-border-radius', `${updatedData.button.borderRadius}px`);
          }
          break;
        }

        case 'button': {
          const el = container.querySelector('[data-attribute="btn-claim-now"]');
          if (el) {
            el.textContent = updatedData[key].text;
          }
          break;
        }

        case 'topPadding': {
          const el = container.querySelector('[data-attribute="money-back-guarantee-wrapper"]');
          if (el) {
            el.setAttribute('data-top-padding', updatedData[key]);
          }
          break;
        }

        case 'bottomPadding': {
          const el = container.querySelector('[data-attribute="money-back-guarantee-wrapper"]');
          if (el) {
            el.setAttribute('data-bottom-padding', updatedData[key]);
          }
          break;
        }
        default:
          break;
      }
    }
    return container.innerHTML.trim();
  },

  sectionBannerFastvaluedeal(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.titleBanner) {
      const titleBannerEl = container.querySelector('[data-attribute="title-banner"]');
      if (titleBannerEl) {
        const show = updatedData.titleBanner.show !== false;
        titleBannerEl.setAttribute('data-show', show ? 'true' : 'false');
        titleBannerEl.style.display = show ? '' : 'none';
        titleBannerEl.innerHTML = updatedData.titleBanner.content || '';
      }
    }

    if (updatedData.keyFeatures) {
      const keyFeaturesEl = container.querySelector('[data-attribute="key-features"]');
      if (keyFeaturesEl) {
        const show = updatedData.keyFeatures.show !== false;
        keyFeaturesEl.setAttribute('data-show', show ? 'true' : 'false');
        keyFeaturesEl.style.display = show ? '' : 'none';
        const items = updatedData.keyFeatures.items || [];
        keyFeaturesEl.innerHTML = items
          .map(
            item => `
              <div data-attribute="key-feature-item" class="key-feature-item">
                <div data-attribute="key-feature-item-icon" class="key-feature-item-icon">
                  <img data-attribute="key-feature-item-icon-image" src="${item.icon || ''}" alt="" />
                </div>
                <div data-attribute="key-feature-item-content" class="key-feature-item-content">
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.imgSmallBanner) {
      const imgSmallBannerEl = container.querySelector('[data-attribute="img-small-banner"]');
      if (imgSmallBannerEl) {
        const show = updatedData.imgSmallBanner.show !== false;
        imgSmallBannerEl.setAttribute('data-show', show ? 'true' : 'false');
        imgSmallBannerEl.style.display = show ? '' : 'none';
        const maxWidth = Number(updatedData.imgSmallBanner.maxWidthSmall) || 430;
        imgSmallBannerEl.setAttribute('data-max-width-small', String(maxWidth));
        imgSmallBannerEl.style.setProperty('--max-width-small', `${maxWidth}px`);
        const imgEl = imgSmallBannerEl.querySelector('[data-attribute="img-small-banner-image"]');
        if (imgEl) imgEl.setAttribute('src', updatedData.imgSmallBanner.src || '');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) {
        updateButtonBasic(wrapButtonEl, updatedData.button);
        // const tmpDoc = new DOMParser().parseFromString(`<div>${updatedHtml}</div>`, 'text/html')
        // const newWrapButton = tmpDoc.querySelector('[data-attribute="wrap-button"]')
        // if (newWrapButton) {
        //   wrapButtonEl.replaceWith(newWrapButton)
        // }
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardBannerRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.bannerImage) {
      const wrapBannerEl = container.querySelector('[data-attribute="wrap-banner"]');
      const useBannerMobile = updatedData.bannerImage.useBannerMobile !== false && updatedData.bannerImage.bannerMobile;
      if (wrapBannerEl) {
        wrapBannerEl.setAttribute('data-use-banner-mobile', useBannerMobile ? 'true' : 'false');
        wrapBannerEl
          .querySelector('[data-attribute="banner-desktop-img"]')
          .setAttribute('src', updatedData.bannerImage.bannerDesktop || '');
        wrapBannerEl
          .querySelector('[data-attribute="banner-mobile-img"]')
          .setAttribute('src', updatedData.bannerImage.bannerMobile || '');
      }
    }

    if (updatedData.wrapContent) {
      const wrapContentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (wrapContentEl) {
        const widthContent = Number(updatedData.wrapContent.widthContent) || 1200;
        const paddingTop = Number(updatedData.wrapContent.paddingTop) || 0;
        const paddingBottom = Number(updatedData.wrapContent.paddingBottom) || 0;
        wrapContentEl.setAttribute('data-width-content', String(widthContent));
        wrapContentEl.setAttribute('data-padding-top', String(paddingTop));
        wrapContentEl.setAttribute('data-padding-bottom', String(paddingBottom));
        wrapContentEl.style.setProperty('--padding-top-content', `${paddingTop}px`);
        wrapContentEl.style.setProperty('--padding-bottom-content', `${paddingBottom}px`);
        wrapContentEl.style.setProperty('--width-content', `${widthContent}px`);
      }
    }

    if (updatedData.tags) {
      const listTagEl = container.querySelector('[data-attribute="list-tag"]');
      if (listTagEl) {
        const show = updatedData.tags.show !== false;
        const borderRadius = Number(updatedData.tags.borderRadius) || 0;
        listTagEl.setAttribute('data-show', show ? 'true' : 'false');
        listTagEl.style.display = show ? '' : 'none';
        listTagEl.setAttribute('data-background-color-tag', updatedData.tags.backgroundColorTag || '');
        listTagEl.style.setProperty('--background-color-tag', updatedData.tags.backgroundColorTag || '');
        listTagEl.setAttribute('data-text-color-tag', updatedData.tags.textColorTag || '');
        listTagEl.style.setProperty('--text-color-tag', updatedData.tags.textColorTag || '');
        listTagEl.setAttribute('data-border-radius', String(borderRadius));
        listTagEl.setAttribute('data-border-color', updatedData.tags.borderColor || '');
        listTagEl.style.setProperty('--border-radius', `${borderRadius}px`);
        listTagEl.style.setProperty('--border-color', updatedData.tags.borderColor || '');
        listTagEl.innerHTML = (updatedData.tags.items || [])
          .map(
            item => `
              <div class="item-tag">
                <span data-attribute="text-tag-item" class="text-tag-item">${item.text || ''}</span>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.textContent) {
      const textContentEl = container.querySelector('[data-attribute="text-content"]');
      if (textContentEl) {
        const show = updatedData.textContent.show !== false;
        textContentEl.setAttribute('data-show', show ? 'true' : 'false');
        textContentEl.style.display = show ? '' : 'none';
        textContentEl.innerHTML = updatedData.textContent.content || '';
      }
    }

    if (updatedData.pills) {
      const listPillEl = container.querySelector('[data-attribute="list-pill"]');
      if (listPillEl) {
        const show = updatedData.pills.show !== false;
        listPillEl.setAttribute('data-show', show ? 'true' : 'false');
        listPillEl.style.display = show ? '' : 'none';
        listPillEl.setAttribute('data-background-pill', updatedData.pills.background || '');
        listPillEl.setAttribute('data-color-pill', updatedData.pills.color || '');
        listPillEl.style.setProperty('--background-pill', updatedData.pills.background || '');
        listPillEl.style.setProperty('--color-pill', updatedData.pills.color || '');
        listPillEl.innerHTML = (updatedData.pills.items || [])
          .map(
            item => `
              <div class="item-pill">
                <span class="icon-pill-item" style="${item.icon ? 'display:flex' : 'display:none'}">
                  <img data-attribute="icon-pill-item" src="${item.icon || ''}" alt="" style="${
              item.icon ? 'display:block' : 'display:none'
            }" />
                </span>
                <span data-attribute="text-pill-item" class="text-pill-item">${item.text || ''}</span>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    if (updatedData.rating) {
      const blockRatingEl = container.querySelector('[data-attribute="block-rating"]');
      if (blockRatingEl) {
        const show = updatedData.rating.show !== false;
        blockRatingEl.setAttribute('data-show', show ? 'true' : 'false');
        blockRatingEl.style.display = show ? '' : 'none';

        const starsEl = blockRatingEl.querySelector('[data-attribute="stars"]');
        if (starsEl) {
          const value = Math.max(1, Math.min(5, Number(updatedData.rating.value) || 4));
          starsEl.setAttribute('data-value', String(value));
          const starSvg = `
            <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 17" fill="none">
              <path fill="#FFA800"
                d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z">
              </path>
            </svg>`;
          starsEl.innerHTML = Array(value)
            .fill(starSvg)
            .join('');
        }

        const ratingTextEl = blockRatingEl.querySelector('.rating-text');
        if (ratingTextEl) {
          ratingTextEl.textContent = updatedData.rating.text || '';
        }
      }
    }

    if (updatedData.smallImages) {
      const listSmallImageEl = container.querySelector('[data-attribute="list-small-image"]');
      const listSmallImageMobileEl = container.querySelector('[data-attribute="list-small-image-mobile"]');

      if (listSmallImageEl) {
        const show = updatedData.smallImages.show !== false;
        listSmallImageEl.setAttribute('data-show', show ? 'true' : 'false');
        listSmallImageEl.style.display = show ? '' : 'none';
        listSmallImageEl.innerHTML = (updatedData.smallImages.items || [])
          .map(
            item => `
              <a data-attribute="small-image-item" data-href="${item.href || '#'}" class="small-image-item">
                <img data-attribute="small-image-img" src="${item.src || ''}" alt="${item.alt || ''}" />
              </a>
            `,
          )
          .join('');
      }
      if (listSmallImageMobileEl) {
        const show = updatedData.smallImages.show !== false;
        listSmallImageMobileEl.setAttribute('data-show', show ? 'true' : 'false');
        listSmallImageMobileEl.style.display = show ? '' : 'none';
        listSmallImageMobileEl.innerHTML = (updatedData.smallImages.items || [])
          .map(
            item => `
              <a data-attribute="small-image-item" data-href="${item.href || '#'}" class="small-image-item">
                <img data-attribute="small-image-img" src="${item.src || ''}" alt="${item.alt || ''}" />
              </a>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardBanner02Rivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.banner) {
      const wrapBannerEl = container.querySelector('[data-attribute="wrap-banner"]');
      if (wrapBannerEl) {
        wrapBannerEl.setAttribute(
          'data-use-banner-mobile',
          updatedData.banner.useBannerMobile !== false ? 'true' : 'false',
        );
        const desktopEl = wrapBannerEl.querySelector('[data-attribute="banner-desktop-img"]');
        if (desktopEl) {
          if (!updatedData.banner.desktop) {
            desktopEl.style.cssText += '; display: none !important;';
            desktopEl.setAttribute('src', '');
          } else {
            desktopEl.setAttribute('src', updatedData.banner.desktop || '');
          }
        }
        const mobileEl = wrapBannerEl.querySelector('[data-attribute="banner-mobile-img"]');
        if (mobileEl) mobileEl.setAttribute('src', updatedData.banner.mobile || '');
      }
    }

    if (updatedData.wrapContent) {
      const wrapContentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (wrapContentEl) {
        const widthContent = Number(updatedData.wrapContent.widthContent) || 625;
        wrapContentEl.setAttribute('data-width-content', String(widthContent));
        wrapContentEl.style.setProperty('--width-content', `${widthContent}px`);
      }
    }

    if (updatedData.heading) {
      const headingEl = container.querySelector('[data-attribute="heading-content"]');
      if (headingEl) {
        const show = updatedData.heading.show !== false;
        headingEl.setAttribute('data-show', show ? 'true' : 'false');
        headingEl.style.display = show ? '' : 'none';
        headingEl.innerHTML = updatedData.heading.content || '';
      }
    }

    if (updatedData.divider) {
      const dividerEl = container.querySelector('[data-attribute="divider-primary"]');
      if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
      const dividerContentEl = container.querySelector('[data-attribute="divider-content"]');
      if (dividerContentEl) {
        const show = updatedData.divider.show !== false;
        dividerContentEl.setAttribute('data-show', show ? 'true' : 'false');
        dividerContentEl.style.display = show ? '' : 'none';
      }
    }

    if (updatedData.description) {
      const descriptionEl = container.querySelector('[data-attribute="description-content"]');
      if (descriptionEl) {
        const show = updatedData.description.show !== false;
        descriptionEl.setAttribute('data-show', show ? 'true' : 'false');
        descriptionEl.style.display = show ? '' : 'none';
        descriptionEl.innerHTML = updatedData.description.content || '';
      }
    }

    if (updatedData.smallImage) {
      const smallImageEl = container.querySelector('[data-attribute="wrap-image-small"]');
      if (smallImageEl) {
        const show = updatedData.smallImage.show !== false;
        smallImageEl.setAttribute('data-show', show ? 'true' : 'false');
        smallImageEl.style.display = show ? '' : 'none';
        const imageEl = smallImageEl.querySelector('[data-attribute="image-small"]');
        if (imageEl) {
          imageEl.setAttribute('src', updatedData.smallImage.src || '');
          imageEl.setAttribute('alt', updatedData.smallImage.alt || '');
        }
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionCardSatelliteRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.mainMedia) {
      const mainEl = container.querySelector('[data-attribute="main-satellite"]');
      if (mainEl) {
        const useVideo = updatedData.mainMedia.type !== 'image';
        mainEl.setAttribute('data-use-video', useVideo ? 'true' : 'false');

        const wrapVideoEl = mainEl.querySelector('.wrap-video');
        const wrapImageEl = mainEl.querySelector('.wrap-img');
        if (wrapVideoEl) wrapVideoEl.style.display = useVideo ? '' : 'none';
        if (wrapImageEl) wrapImageEl.style.display = useVideo ? 'none' : '';

        const videoEl = mainEl.querySelector('[data-attribute="video-satellite"]');
        if (videoEl) videoEl.setAttribute('src', updatedData.mainMedia.videoSrc || '');

        const imageEl = mainEl.querySelector('[data-attribute="img-satellite"]');
        if (imageEl) {
          imageEl.setAttribute('src', updatedData.mainMedia.imageSrc || '');
          imageEl.setAttribute('alt', updatedData.mainMedia.imageAlt || '');
        }
      }
    }

    if (updatedData.items) {
      const wrapListSmallEl = container.querySelector('[data-attribute="wrap-list-small"]');
      if (wrapListSmallEl) {
        wrapListSmallEl.innerHTML = (updatedData.items || [])
          .slice(0, 4)
          .map(item => {
            const overlayOpacity = Number(item.overlayOpacity) || 0;
            return `
              <div data-overlay-opacity="${overlayOpacity}" data-attribute="item-small" class="item-small" style="--overlay-opacity: ${overlayOpacity}">
                <div data-attribute="text-content" class="text-content">
                  ${item.content || ''}
                </div>
                <img data-attribute="img-small" src="${item.imageSrc || ''}" alt="${item.imageAlt || ''}" />
              </div>
            `;
          })
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionCardWithSliderRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.contentCard) {
      const wrapContentCardEl = container.querySelector('[data-attribute="wrap-content-card"]');
      if (wrapContentCardEl) {
        const width = Number(updatedData.contentCard.width) || 549;
        const align = updatedData.contentCard.align || 'left';
        const alignMap = {
          left: 'flex-start',
          center: 'center',
          right: 'flex-end',
        };
        wrapContentCardEl.setAttribute('data-width', String(width));
        wrapContentCardEl.setAttribute('data-align', align);
        wrapContentCardEl.style.setProperty('--width-content-card', `${width}px`);
        wrapContentCardEl.style.setProperty('--align-content-card', alignMap[align] || 'flex-start');
      }
    }

    if (updatedData.slides) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.slides || [])
          .map(
            item => `
              <div data-attribute="item-slide" class="swiper-slide">
                <div data-attribute="wrap-item-slide" class="wrap-item-slide" data-overlay-opacity="${
                  item.overlayOpacity
                }" style="--overlay-opacity: ${item.overlayOpacity};">
                  <div class="wrap-image">
                    <img data-attribute="image-item" src="${item.image || ''}" alt="${item.alt || ''}" />
                  </div>
                  <div data-attribute="title-item" class="title-item">
                    ${item.title || ''}
                  </div>
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.benefits) {
      const benefitsEl = container.querySelector('[data-attribute="wrap-benefis"]');
      if (benefitsEl) {
        benefitsEl.innerHTML = (updatedData.benefits || [])
          .map(
            item => `
              <div data-attribute="item-benefit" class="item-benefit">
                <div class="icon-item-benefit">
                  <img src="${item.icon || ''}" alt="${item.alt || ''}" />
                </div>
                <div class="text-item-benefit">
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardGridItemRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.list) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        const borderRadius = Number(updatedData.list.borderRadiusItem) || 0;
        listItemEl.setAttribute('data-padding-item', updatedData.list.paddingItem ? 'true' : 'false');
        listItemEl.setAttribute('data-border-radius-item', String(borderRadius));
        listItemEl.setAttribute('data-background-color-item', updatedData.list.backgroundColorItem || '');
        listItemEl.style.setProperty('--border-radius-item', `${borderRadius}px`);
        listItemEl.style.setProperty('--background-color-item', updatedData.list.backgroundColorItem || '');
      }
    }

    if (updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="item-grid" class="item-grid">
                <div class="wrap-image">
                  <img data-attribute="image-item" src="${item.image || ''}" alt="${item.alt || ''}" />
                </div>
                <div data-attribute="text-item" class="content">
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionCardSliderRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.slides) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.slides || [])
          .map(
            item => `
              <div class="swiper-slide">
                <div data-attribute="item-slide" class="wrap-item">
                  <div class="wrap-image">
                    <img data-attribute="image-item" src="${item.image || ''}" alt="${item.alt || ''}" />
                  </div>
                  <div data-attribute="title-item" class="wrap-content">
                    ${item.content || ''}
                  </div>
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionMarqueeRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.marquee) {
      const blockMarqueeEl = container.querySelector('[data-attribute="block-marquee"]');
      if (blockMarqueeEl) {
        const widthItem = Number(updatedData.marquee.widthItem) || 320;
        const gapItem = Number(updatedData.marquee.gapItem) || 15;
        const borderRadiusItem = Number(updatedData.marquee.borderRadiusItem) || 0;
        const colorBorderItem = updatedData.marquee.colorBorderItem || '#ff0000';
        const speedMarquee = Number(updatedData.marquee.speedMarquee) || 20;

        blockMarqueeEl.setAttribute('data-width-item', String(widthItem));
        blockMarqueeEl.setAttribute('data-gap-item', String(gapItem));
        blockMarqueeEl.setAttribute('data-border-radius-item', String(borderRadiusItem));
        blockMarqueeEl.setAttribute('data-color-border-item', colorBorderItem);
        blockMarqueeEl.setAttribute('data-speed-marquee', String(speedMarquee));
        blockMarqueeEl.style.setProperty('--width-item', `${widthItem}px`);
        blockMarqueeEl.style.setProperty('--gap-item', `${gapItem}px`);
        blockMarqueeEl.style.setProperty('--border-radius-item', `${borderRadiusItem}px`);
        blockMarqueeEl.style.setProperty('--color-border-item', colorBorderItem);
        blockMarqueeEl.style.setProperty('--speed-marquee', `${speedMarquee}s`);
      }
    }

    if (updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.items || [])
          .map(item => {
            const overlayColor = item.overlay?.color || '#000000';
            const overlayOpacity =
              item.overlay?.opacity !== undefined && item.overlay?.opacity !== null ? item.overlay.opacity : 0.1;
            return `
              <div
                data-attribute="item-marquee"
                class="item-marquee"
                data-color-overlay="${overlayColor}"
                data-opacity-overlay="${overlayOpacity}"
                style="--color-overlay: ${overlayColor}; --opacity-overlay: ${overlayOpacity}"
              >
                <img data-attribute="image-item" src="${item.image || ''}" alt="${item.alt || ''}" />
                <div data-attribute="content-item" class="wrap-content">
                  ${item.content || ''}
                </div>
              </div>
            `;
          })
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardBasicRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.leftCard) {
      const leftCardEl = container.querySelector('[data-attribute="left-card"]');
      if (leftCardEl) {
        const order = Number(updatedData.leftCard.order) || 1;
        const colorBorder = updatedData.leftCard.colorBorder || '#ffffff';
        leftCardEl.setAttribute('data-order', String(order));
        leftCardEl.setAttribute('data-color-border', colorBorder);
        leftCardEl.style.setProperty('--order-left', order);
        leftCardEl.style.setProperty('--color-border', colorBorder);
      }
    }

    if (updatedData.rightCard) {
      const rightCardEl = container.querySelector('[data-attribute="right-card"]');
      if (rightCardEl) {
        const order = Number(updatedData.rightCard.order) || 2;
        rightCardEl.setAttribute('data-order', String(order));
        rightCardEl.style.setProperty('--order-right', order);
      }

      const imageEl = container.querySelector('[data-attribute="image-card"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.rightCard.image || '');
        imageEl.setAttribute('alt', updatedData.rightCard.alt || '');
      }
    }

    if (updatedData.titleContent !== undefined) {
      const titleContentEl = container.querySelector('[data-attribute="title-content"]');
      if (titleContentEl) titleContentEl.innerHTML = updatedData.titleContent || '';
    }

    if (updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="item" class="item">
                <div data-attribute="label-item" class="label-item">${item.label || ''}</div>
                <div data-attribute="value-item" class="value-item">${item.value || ''}</div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardBadgeRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="item" class="item">
                <div class="icon">
                  <img data-attribute="icon-item" src="${item.icon || ''}" alt="${item.alt || ''}" />
                </div>
                <div data-attribute="content-item" class="content">
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardFaqRivoneed(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const accordionIcon = `
      <div class="accordion-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-chevron-down-icon lucide-chevron-down"
        >
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </div>
    `;

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.accordion) {
      const cardAccordionsEl = container.querySelector('[data-attribute="card-accordions"]');
      if (cardAccordionsEl) {
        const show = updatedData.accordion.show !== false;
        cardAccordionsEl.setAttribute('data-show-accordion', show ? 'true' : 'false');
        cardAccordionsEl.style.display = show ? 'block' : 'none';
      }
    }

    if (updatedData.items) {
      const cardAccordionsEl = container.querySelector('[data-attribute="card-accordions"]');
      if (cardAccordionsEl) {
        cardAccordionsEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="card-accordion" class="wrap-accordion">
                <div data-attribute="accordion-title" class="accordion-title">
                  <div data-attribute="accordion-title-text">${item.question || ''}</div>
                  ${accordionIcon}
                </div>
                <div data-attribute="accordion-content" class="accordion-content">
                  <div data-attribute="accordion-text" class="accordion-text">
                    ${item.answer || ''}
                  </div>
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionCardBannerGatorz(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardImage) {
      const cardImageEl = container.querySelector('[data-attribute="card-image"]');
      if (cardImageEl) {
        const showOverlay = updatedData.cardImage.showOverlay !== false;
        const overlayOpacity = Number(updatedData.cardImage.overlayOpacity) || 0;
        cardImageEl.setAttribute('data-show-overlay', showOverlay ? 'true' : 'false');
        cardImageEl.setAttribute('data-overlay-opacity', String(overlayOpacity));
        cardImageEl.style.setProperty('--overlay-opacity', overlayOpacity);
      }

      const imageEl = container.querySelector('[data-attribute="card-image-src"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.cardImage.src || '');
        imageEl.setAttribute('alt', updatedData.cardImage.alt || '');
      }
    }

    if (updatedData.cardContent) {
      const cardContentEl = container.querySelector('[data-attribute="card-content"]');
      if (cardContentEl) {
        const show = updatedData.cardContent.show !== false;
        const maxWidth = Number(updatedData.cardContent.maxWidth) || 750;

        cardContentEl.setAttribute('data-show', show ? 'true' : 'false');
        cardContentEl.style.display = show ? '' : 'none';
        cardContentEl.setAttribute('data-position', updatedData.cardContent.position || 'left');
        cardContentEl.setAttribute('data-max-width', String(maxWidth));
        cardContentEl.style.setProperty('--ct-max-width', `${maxWidth}px`);
        cardContentEl.innerHTML = updatedData.cardContent.content || '';
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardGatorzCustom(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.containerGatorz) {
      const containerGatorzEl = container.querySelector('[data-attribute="container-gatorz"]');
      if (containerGatorzEl) {
        containerGatorzEl.setAttribute('data-padding-left', updatedData.containerGatorz.paddingLeft ? 'true' : 'false');
        containerGatorzEl.setAttribute(
          'data-padding-right',
          updatedData.containerGatorz.paddingRight ? 'true' : 'false',
        );
      }
    }

    if (updatedData.layout) {
      const wrapCardEl = container.querySelector('[data-attribute="wrap-card"]');
      if (wrapCardEl) {
        const gap = Number(updatedData.layout.gap) || 0;
        const widthImg = updatedData.layout.widthImg || 50;
        wrapCardEl.setAttribute(
          'data-use-custom-width-img',
          updatedData.layout.useCustomWidthImg !== false ? 'true' : 'false',
        );
        wrapCardEl.setAttribute('data-width-img', widthImg);
        wrapCardEl.setAttribute('data-gap', String(gap));
        wrapCardEl.setAttribute('data-center-y', updatedData.layout.centerY !== false ? 'true' : 'false');
        wrapCardEl.style.setProperty('--gap-card', `${gap}px`);
        wrapCardEl.style.setProperty('--width-img', `${widthImg}%`);
      }
    }

    if (updatedData.leftCard) {
      const leftCardEl = container.querySelector('[data-attribute="left-card"]');
      if (leftCardEl) {
        const order = Number(updatedData.leftCard.order) || 1;
        leftCardEl.setAttribute('data-order', String(order));
        leftCardEl.style.setProperty('--order-left', order);
      }
    }

    if (updatedData.rightCard) {
      const rightCardEl = container.querySelector('[data-attribute="right-card"]');
      if (rightCardEl) {
        const order = Number(updatedData.rightCard.order) || 2;
        rightCardEl.setAttribute('data-order', String(order));
        rightCardEl.style.setProperty('--order-right', order);
      }
    }

    if (updatedData.content !== undefined) {
      const contentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (contentEl) contentEl.innerHTML = updatedData.content || '';
    }

    if (updatedData.image) {
      const imageEl = container.querySelector('[data-attribute="card-image"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.image.src || '');
        imageEl.setAttribute('alt', updatedData.image.alt || '');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardGatorzGridItem(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="item" class="item">
                <div class="wrap-icon">
                  <img data-attribute="icon-item" src="${item.icon || ''}" alt="${item.alt || ''}" />
                </div>
                <div data-attribute="text-item" class="wrap-content">
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    if (updatedData.note) {
      const noteEl = container.querySelector('[data-attribute="text-note"]');
      if (noteEl) {
        const show = updatedData.note.show !== false;
        noteEl.setAttribute('data-show', show ? 'true' : 'false');
        noteEl.style.display = show ? '' : 'none';
        noteEl.innerHTML = updatedData.note.content || '';
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardFastvaluedealTitleImg(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.wrapImages) {
      const wrapImagesEl = container.querySelector('[data-attribute="wrap-images"]');
      if (wrapImagesEl) {
        const useMobileImage = updatedData.wrapImages.useMobileImage !== false;
        wrapImagesEl.setAttribute('data-use-mobile-image', useMobileImage ? 'true' : 'false');

        const maxWidth = Number(updatedData.wrapImages.maxWidth) || 900;
        wrapImagesEl.setAttribute('data-max-width', String(maxWidth));
        wrapImagesEl.style.setProperty('--max-width', `${maxWidth}px`);

        wrapImagesEl.setAttribute('data-align', updatedData.wrapImages.align || 'center');

        const desktopEl = wrapImagesEl.querySelector('[data-attribute="image-desktop"]');
        if (desktopEl) desktopEl.setAttribute('src', updatedData.wrapImages.imageDesktop || '');

        const mobileEl = wrapImagesEl.querySelector('[data-attribute="image-mobile"]');
        if (mobileEl) mobileEl.setAttribute('src', updatedData.wrapImages.imageMobile || '');
      }
    }

    return container.innerHTML.trim();
  },

  sectionSliderFastvaluedeal01(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.divider) {
      const dividerEl = container.querySelector('[data-attribute="divider-primary"]');
      if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
    }

    if (updatedData.cardSummary) {
      const cardSummaryEl = container.querySelector('[data-attribute="card-summary"]');
      if (cardSummaryEl) {
        const show = updatedData.cardSummary.show !== false;
        cardSummaryEl.setAttribute('data-show', show ? 'true' : 'false');
        cardSummaryEl.style.display = show ? '' : 'none';
        cardSummaryEl.innerHTML = updatedData.cardSummary.content || '';
      }
    }

    if (updatedData.slider || updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        if (updatedData.slider) {
          const colPerView = parseInt(updatedData.slider.colPerView, 10) || 4;
          const spaceBetween = parseInt(updatedData.slider.spaceBetween, 10) || 20;
          listItemEl.setAttribute('data-col-per-view', String(colPerView));
          listItemEl.setAttribute('data-space-between', String(spaceBetween));
        }
        if (updatedData.items) {
          const items = updatedData.items || [];
          listItemEl.innerHTML = items
            .map(
              item => `
                <div data-attribute="item" class="swiper-slide">
                  <div class="wrap-item">
                    <div class="wrap-image">
                      <img data-attribute="image-item" src="${item.image || ''}" alt="" />
                    </div>
                    <div data-attribute="content-item" class="wrap-content">
                      ${item.content || ''}
                    </div>
                  </div>
                </div>
              `,
            )
            .join('');
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealCountdown(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.titleBanner) {
      const titleBannerEl = container.querySelector('[data-attribute="title-banner"]');
      if (titleBannerEl) {
        const show = updatedData.titleBanner.show !== false;
        titleBannerEl.setAttribute('data-show', show ? 'true' : 'false');
        titleBannerEl.style.display = show ? '' : 'none';
        titleBannerEl.innerHTML = updatedData.titleBanner.content || '';
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) {
        updateButtonBasic(wrapButtonEl, updatedData.button);
      }
    }

    if (updatedData.productImage) {
      const fvdCountdownContentEl = container.querySelector('[data-attribute="fvd-countdown-content"]');
      if (fvdCountdownContentEl) {
        fvdCountdownContentEl.setAttribute('data-image-position', updatedData.productImage.position || 'left');
        fvdCountdownContentEl.setAttribute('data-image-show', updatedData.productImage.show ? 'true' : 'false');
      }
      const productImageEl = container.querySelector('[data-attribute="fvd-countdown__image"]');
      if (productImageEl) {
        const imgEl = productImageEl.querySelector('[data-attribute="fvd-countdown__image-img"]');
        if (imgEl) imgEl.setAttribute('src', updatedData.productImage.src || '');
      }
    }

    if (updatedData.info) {
      const infoTitleEl = container.querySelector('[data-attribute="fvd-countdown__title"]');
      if (infoTitleEl) {
        infoTitleEl.innerHTML = updatedData.info.title || '';
      }
      const policyMoneyBackEl = container.querySelector('[data-attribute="fvd-countdown__policy-item-money-back"]');
      if (policyMoneyBackEl) {
        policyMoneyBackEl.textContent = updatedData.info.policy.moneyBack || '';
      }
      const policyFastShippingEl = container.querySelector(
        '[data-attribute="fvd-countdown__policy-item-fast-shipping"]',
      );
      if (policyFastShippingEl) {
        policyFastShippingEl.textContent = updatedData.info.policy.fastShipping || '';
      }
      const policySupportEl = container.querySelector('[data-attribute="fvd-countdown__policy-item-support"]');
      if (policySupportEl) {
        policySupportEl.textContent = updatedData.info.policy.support || '';
      }
      const ratingImageEl = container.querySelector('[data-attribute="fvd-countdown__rating-img"]');
      if (ratingImageEl) {
        ratingImageEl.setAttribute('src', updatedData.info.ratingImage || '');
      }
      const timerCountdownTextEl = container.querySelector('[data-attribute="fvd-countdown__timer-countdown-text"]');
      if (timerCountdownTextEl) {
        timerCountdownTextEl.textContent = updatedData.info.timer.text || '';
      }
      const timerCountdownTimeEl = container.querySelector('[data-attribute="fvd-countdown__timer-countdown-time"]');
      if (timerCountdownTimeEl) {
        timerCountdownTimeEl.setAttribute('data-time', updatedData.info.timer.time || '');
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealFaq(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    for (const key in updatedData) {
      switch (key) {
        case 'enableAnchor': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-enable-anchor', updatedData[key]);
          }
          break;
        }
        case 'title': {
          const el = container.querySelector('[data-section]');
          if (el) {
            el.setAttribute('data-title', updatedData[key]);
          }
          break;
        }
        case 'titleFaq': {
          const el = container.querySelector('[data-attribute="title-faq-grid"]');
          if (el) {
            el.innerHTML = updatedData[key];
          }
          break;
        }
        case 'colors': {
          const listItemsEl = container.querySelector('[data-attribute="list-item"]');
          if (listItemsEl) {
            listItemsEl.setAttribute('data-background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.style.setProperty('--background-faq-item', updatedData[key].backgroundFaqItem);
            listItemsEl.setAttribute('data-text-faq-item-color', updatedData[key].textFaqItem);
            listItemsEl.style.setProperty('--text-faq-item-color', updatedData[key].textFaqItem);
          }
          break;
        }
        case 'listItem': {
          const elListItem = container.querySelector('[data-attribute="list-item"]');
          if (elListItem) {
            elListItem.innerHTML = updatedData[key]
              .map(item => {
                return `
                <div
                  data-attribute="item-wapper"
                  class="item-wapper"
                >
                  <div data-attribute="item-question" class="item-question">
                    <h3
                      data-attribute="title-item-question"
                      data-color="#000000"
                      class="title-item-question"
                      style="color: '#000000'"
                    >
                      ${item.question}
                    </h3>
                    <span data-attribute="icon-minus" style="display: none">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M5 12h14" />
                      </svg>
                    </span>

                    <span data-attribute="icon-plus">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M5 12h14" />
                        <path d="M12 5v14" />
                      </svg>
                    </span>
                  </div>
                  <div data-attribute="item-answer" class="item-answer">
                    <div data-attribute="answer-content" class="answer-content">
                      ${item.answer}
                    </div>
                  </div>
                </div>
              `;
              })
              .join('');
          }
          break;
        }
        case 'containerFullWidth': {
          const el = container.querySelector('[data-attribute="faq-grid-container"]');
          if (el) {
            el.setAttribute('data-container-full-width', updatedData[key]);
          }
          break;
        }
        case 'divider': {
          const dividerEl = container.querySelector('[data-attribute="divider-primary"]');
          if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
          break;
        }
      }
    }
    return container.innerHTML.trim();
  },

  sectionFastvaluedealMoneyBackGuarantee(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.image) {
      const contentEl = container.querySelector('[data-attribute="fvd-mbg-content"]');
      if (contentEl) {
        contentEl.setAttribute('data-image-position', updatedData.image.position || 'left');
        contentEl.setAttribute('data-background-content-color', updatedData.backgroundContentColor || '#0130E2');
        contentEl.style.setProperty('--background-content-color', updatedData.backgroundContentColor || '#0130E2');
      }
      const imageEl = container.querySelector('[data-attribute="fvd-mbg__image-img"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.image.src || '');
      }
    }

    if (updatedData.content !== undefined) {
      const textEl = container.querySelector('[data-attribute="fvd-mbg__text"]');
      if (textEl) {
        textEl.innerHTML = updatedData.content || '';
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealReviewer(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const contentEl = container.querySelector('[data-attribute="fvd-reviewer-content"]');
    if (contentEl) {
      const imagePosition = updatedData.image?.position || contentEl.getAttribute('data-image-position') || 'left';
      const backgroundContentColor =
        updatedData.backgroundContentColor || contentEl.getAttribute('data-background-content-color') || '#F6F8FF';
      const borderColor = updatedData.borderColor || contentEl.getAttribute('data-border-color') || '#E5E7EB';

      contentEl.setAttribute('data-image-position', imagePosition);
      contentEl.setAttribute('data-background-content-color', backgroundContentColor);
      contentEl.setAttribute('data-border-color', borderColor);
      contentEl.style.setProperty('--background-content-color', backgroundContentColor);
      contentEl.style.setProperty('--border-color', borderColor);
    }

    if (updatedData.image) {
      const imageEl = container.querySelector('[data-attribute="fvd-reviewer__image-img"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.image.src || '');
      }
    }

    if (updatedData.content !== undefined) {
      const textEl = container.querySelector('[data-attribute="fvd-reviewer__text"]');
      if (textEl) {
        textEl.innerHTML = updatedData.content || '';
      }
    }

    if (updatedData.author) {
      const authorNameEl = container.querySelector('[data-attribute="fvd-reviewer__author-name"]');
      if (authorNameEl) {
        authorNameEl.textContent = updatedData.author.name || '';
      }

      const signatureEl = container.querySelector('[data-attribute="fvd-reviewer__author-signature"]');
      if (signatureEl) {
        const show = updatedData.author.signature?.show !== false;
        signatureEl.setAttribute('data-show', show ? 'true' : 'false');
        signatureEl.style.display = show ? '' : 'none';
        signatureEl.setAttribute('src', updatedData.author.signature?.src || '');
      }
    }

    if (updatedData.quotes) {
      const quoteStartImgEl = container.querySelector('[data-attribute="fvd-reviewer__info-quote-start-img"]');
      if (quoteStartImgEl) {
        const show = updatedData.quotes.start?.show !== false;
        quoteStartImgEl.setAttribute('data-show', show ? 'true' : 'false');
        quoteStartImgEl.style.display = show ? '' : 'none';
        quoteStartImgEl.setAttribute('src', updatedData.quotes.start?.src || '');
      }

      const quoteEndImgEl = container.querySelector('[data-attribute="fvd-reviewer__info-quote-end-img"]');
      if (quoteEndImgEl) {
        const show = updatedData.quotes.end?.show !== false;
        quoteEndImgEl.setAttribute('data-show', show ? 'true' : 'false');
        quoteEndImgEl.style.display = show ? '' : 'none';
        quoteEndImgEl.setAttribute('src', updatedData.quotes.end?.src || '');
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealCta(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) {
        updateButtonBasic(wrapButtonEl, updatedData.button);
      }
    }

    if (updatedData.logo) {
      const logoImgEl = container.querySelector('[data-attribute="fvd-cta__logo-img"]');
      if (logoImgEl) {
        logoImgEl.setAttribute('src', updatedData.logo.src || '');
      }
    }

    if (updatedData.rating) {
      const avatarsImgEl = container.querySelector('[data-attribute="fvd-cta__avatars-img"]');
      if (avatarsImgEl) {
        avatarsImgEl.setAttribute('src', updatedData.rating.avatarsImage || '');
      }
      const starsImgEl = container.querySelector('[data-attribute="fvd-cta__stars-img"]');
      if (starsImgEl) {
        starsImgEl.setAttribute('src', updatedData.rating.starsImage || '');
      }
      const ratingTextEl = container.querySelector('[data-attribute="fvd-cta__rating-text"]');
      if (ratingTextEl) {
        ratingTextEl.textContent = updatedData.rating.text || '';
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealCardBasic(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const contentEl = container.querySelector('[data-attribute="fvd-card-basic-content"]');
    if (contentEl) {
      if (updatedData.layout) {
        contentEl.setAttribute('data-grid-ratio', updatedData.layout.gridRatio || '2fr-1fr');
      }
      if (updatedData.sideImage) {
        contentEl.setAttribute('data-image-position', updatedData.sideImage.position || 'right');
        contentEl.setAttribute('data-image-show', updatedData.sideImage.show ? 'true' : 'false');
      }
      if (updatedData.features) {
        contentEl.setAttribute('data-features-show', updatedData.features.show ? 'true' : 'false');
      }
    }

    if (updatedData.sectionTitle) {
      const sectionTitleWrapEl = container.querySelector('[data-attribute="fvd-card-basic__section-title-wrap"]');
      if (sectionTitleWrapEl) {
        const show = updatedData.sectionTitle.show !== false;
        sectionTitleWrapEl.setAttribute('data-show', show ? 'true' : 'false');
        sectionTitleWrapEl.style.display = show ? '' : 'none';
        const sectionTitleEl = sectionTitleWrapEl.querySelector('[data-attribute="fvd-card-basic__section-title"]');
        if (sectionTitleEl) {
          sectionTitleEl.innerHTML = updatedData.sectionTitle.content || '';
        }
      }
    }

    if (updatedData.context) {
      const contextTitleEl = container.querySelector('[data-attribute="fvd-card-basic__context-title"]');
      if (contextTitleEl) {
        contextTitleEl.innerHTML = updatedData.context.title || '';
      }
      const contextTextEl = container.querySelector('[data-attribute="fvd-card-basic__context-text"]');
      if (contextTextEl) {
        contextTextEl.innerHTML = updatedData.context.text || '';
      }
    }

    if (updatedData.dividerHeader) {
      const sectionTitleWrapEl = container.querySelector('[data-attribute="fvd-card-basic__section-title-wrap"]');
      const headerDividerEl = sectionTitleWrapEl?.querySelector('[data-attribute="divider-primary"]');
      if (headerDividerEl) updateDividerPrimary(headerDividerEl, updatedData.dividerHeader);
    }

    if (updatedData.dividerContext) {
      const leftEl = container.querySelector('[data-attribute="fvd-card-basic__left"]');
      const contextDividerEl = leftEl?.querySelector('[data-attribute="divider-primary"]');
      if (contextDividerEl) updateDividerPrimary(contextDividerEl, updatedData.dividerContext);
    }

    if (updatedData.features) {
      const featuresEl = container.querySelector('[data-attribute="fvd-card-basic__features"]');
      if (featuresEl) {
        if (updatedData.features.show !== undefined) {
          const show = updatedData.features.show !== false;
          featuresEl.setAttribute('data-show', show ? 'true' : 'false');
          featuresEl.style.display = show ? '' : 'none';
        }

        const backgroundColor = updatedData.features.backgroundColor || '#0130E2';
        const textColor = updatedData.features.textColor || '#FFFFFF';
        featuresEl.setAttribute('data-background-color', backgroundColor);
        featuresEl.setAttribute('data-text-color', textColor);
        featuresEl.style.setProperty('--feature-bg', backgroundColor);
        featuresEl.style.setProperty('--feature-text', textColor);

        if (updatedData.features.items) {
          featuresEl.innerHTML = (updatedData.features.items || [])
            .map(item => {
              const imageShow = item.image?.show !== false;
              return `
              <div
                class="fvd-card-basic__feature-item"
                data-attribute="fvd-card-basic__feature-item"
              >
                <div data-attribute="fvd-card-basic__feature-content" class="fvd-card-basic__feature-content">
                  ${item.content || ''}
                </div>
                <div
                  data-show="${imageShow ? 'true' : 'false'}"
                  data-attribute="fvd-card-basic__feature-image-wrap"
                  class="fvd-card-basic__feature-image-wrap"
                  style="display: ${imageShow ? '' : 'none'}"
                >
                  <img
                    data-attribute="fvd-card-basic__feature-image"
                    src="${item.image?.src || ''}"
                    alt=""
                  />
                </div>
              </div>
            `;
            })
            .join('');
        }
      }
    }

    if (updatedData.sideImage) {
      const sideImageWrapEl = container.querySelector('[data-attribute="fvd-card-basic__side-image"]');
      if (sideImageWrapEl) {
        const show = updatedData.sideImage.show !== false;
        sideImageWrapEl.setAttribute('data-show', show ? 'true' : 'false');
        sideImageWrapEl.style.display = show ? '' : 'none';
      }
      const sideImageEl = container.querySelector('[data-attribute="fvd-card-basic__side-image-img"]');
      if (sideImageEl) {
        sideImageEl.setAttribute('src', updatedData.sideImage.src || '');
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealCardStep(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.header) {
      const titleEl = container.querySelector('[data-attribute="fvd-card-step__title"]');
      if (titleEl) {
        titleEl.innerHTML = updatedData.header.title || '';
      }
      const descriptionEl = container.querySelector('[data-attribute="fvd-card-step__description"]');
      if (descriptionEl) {
        descriptionEl.innerHTML = updatedData.header.description || '';
      }
    }

    if (updatedData.divider) {
      const headerEl = container.querySelector('[data-attribute="fvd-card-step__header"]');
      const dividerEl = headerEl?.querySelector('[data-attribute="divider-primary"]');
      if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
    }

    if (updatedData.grid) {
      const gridEl = container.querySelector('[data-attribute="fvd-card-step__grid"]');
      if (gridEl) {
        const columns = updatedData.grid.columns || 3;
        const gap = updatedData.grid.gap ?? 20;
        const numberBg = updatedData.grid.stepNumber?.backgroundColor || '#ffffff';
        const numberColor = updatedData.grid.stepNumber?.textColor || '#0130E2';
        gridEl.setAttribute('data-columns', String(columns));
        gridEl.setAttribute('data-gap', String(gap));
        gridEl.setAttribute('data-step-number-bg', numberBg);
        gridEl.setAttribute('data-step-number-color', numberColor);
        gridEl.style.setProperty('--columns', String(columns));
        gridEl.style.setProperty('--gap', `${gap}px`);
        gridEl.style.setProperty('--step-number-bg', numberBg);
        gridEl.style.setProperty('--step-number-color', numberColor);
      }
    }

    if (updatedData.steps) {
      const gridEl = container.querySelector('[data-attribute="fvd-card-step__grid"]');
      if (gridEl) {
        gridEl.innerHTML = (updatedData.steps || [])
          .map(item => {
            const numberText = item.stepNumber?.text || '';
            return `
            <div
              class="fvd-card-step__item"
              data-attribute="fvd-card-step__item"
            >
              <div class="fvd-card-step__item-media" data-attribute="fvd-card-step__item-media">
                <span
                  class="fvd-card-step__step-number"
                  data-attribute="fvd-card-step__step-number"
                >${numberText}</span>
                <img
                  data-attribute="fvd-card-step__step-image"
                  src="${item.stepImage?.src || ''}"
                  alt="step"
                />
              </div>
              <div class="fvd-card-step__item-content" data-attribute="fvd-card-step__item-content">
                <div class="fvd-card-step__content-head">
                  <img
                    data-attribute="fvd-card-step__content-icon"
                    class="fvd-card-step__content-icon"
                    src="${item.content?.iconSrc || ''}"
                    alt="icon"
                  />
                  <div data-attribute="fvd-card-step__content-title" class="fvd-card-step__content-title">
                    ${item.content?.title || ''}
                  </div>
                </div>
                <div data-attribute="fvd-card-step__content-description" class="fvd-card-step__content-description">
                  ${item.content?.description || ''}
                </div>
              </div>
            </div>
          `;
          })
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealCompareBenefits(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.top) {
      const topEl = container.querySelector('[data-attribute="fvd-compare-benefits__top"]');
      if (topEl) {
        const backgroundColor = updatedData.top.backgroundColor || '#0130E2';
        const textColor = updatedData.top.textColor || '#FFFFFF';
        topEl.setAttribute('data-background-color', backgroundColor);
        topEl.setAttribute('data-text-color', textColor);
        topEl.style.setProperty('--top-bg', backgroundColor);
        topEl.style.setProperty('--top-text', textColor);
      }
      const topTitleEl = container.querySelector('[data-attribute="fvd-compare-benefits__top-title"]');
      if (topTitleEl) {
        topTitleEl.innerHTML = updatedData.top.title || '';
      }
    }

    if (updatedData.dividerLeft) {
      const dividerLeftWrapEl = container.querySelector('[data-attribute="fvd-compare-benefits__top-divider-left"]');
      const dividerLeftEl = dividerLeftWrapEl?.querySelector('[data-attribute="divider-primary"]');
      if (dividerLeftEl) updateDividerPrimary(dividerLeftEl, updatedData.dividerLeft);
    }

    if (updatedData.dividerRight) {
      const dividerRightWrapEl = container.querySelector('[data-attribute="fvd-compare-benefits__top-divider-right"]');
      const dividerRightEl = dividerRightWrapEl?.querySelector('[data-attribute="divider-primary"]');
      if (dividerRightEl) updateDividerPrimary(dividerRightEl, updatedData.dividerRight);
    }

    if (updatedData.features) {
      const featuresEl = container.querySelector('[data-attribute="fvd-compare-benefits__features"]');
      if (featuresEl) {
        const columns = updatedData.features.columns || 6;
        featuresEl.setAttribute('data-columns', String(columns));
        featuresEl.style.setProperty('--columns', String(columns));

        if (updatedData.features.items) {
          featuresEl.innerHTML = (updatedData.features.items || [])
            .map(item => {
              return `
              <div
                class="fvd-compare-benefits__feature-item"
                data-attribute="fvd-compare-benefits__feature-item"
              >
                <div class="fvd-compare-benefits__feature-icon-wrap" data-attribute="fvd-compare-benefits__feature-icon-wrap">
                  <img
                    data-attribute="fvd-compare-benefits__feature-image"
                    src="${item.image?.src || ''}"
                    alt=""
                  />
                </div>
                <div data-attribute="fvd-compare-benefits__feature-text" class="fvd-compare-benefits__feature-text">
                  ${item.text || ''}
                </div>
              </div>
            `;
            })
            .join('');
        }
      }
    }

    if (updatedData.compare) {
      if (updatedData.compare.without) {
        const withoutContentEl = container.querySelector(
          '[data-attribute="fvd-compare-benefits__box-without-content"]',
        );
        if (withoutContentEl) {
          withoutContentEl.innerHTML = updatedData.compare.without.content || '';
        }
      }
      if (updatedData.compare.with) {
        const withBoxEl = container.querySelector('[data-attribute="fvd-compare-benefits__box-with"]');
        const withContentEl = container.querySelector('[data-attribute="fvd-compare-benefits__box-with-content"]');
        const highlightBorder = updatedData.compare.with.highlightBorderColor || '#0130E2';
        if (withBoxEl) {
          withBoxEl.setAttribute('data-highlight-border', highlightBorder);
          withBoxEl.style.setProperty('--highlight-border', highlightBorder);
        }
        if (withContentEl) {
          withContentEl.innerHTML = updatedData.compare.with.content || '';
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionFastvaluedealTable(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    if (updatedData.header) {
      const titleEl = container.querySelector('[data-attribute="fvd-table__title"]');
      if (titleEl) {
        titleEl.innerHTML = updatedData.header.title || '';
      }
    }

    if (updatedData.divider) {
      const dividerEl = container.querySelector(
        '[data-attribute="fvd-table__divider"] [data-attribute="divider-primary"]',
      );
      if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
    }

    if (updatedData.table) {
      const tableContentEl = container.querySelector('[data-attribute="table-content"]');
      if (tableContentEl) {
        if (updatedData.table.borderColor) {
          tableContentEl.setAttribute('data-border-color', updatedData.table.borderColor);
          if (cardContainer) cardContainer.style.setProperty('--border-color', updatedData.table.borderColor);
        }
        if (updatedData.table.borderWeight) {
          tableContentEl.setAttribute('data-border-weight', updatedData.table.borderWeight);
          if (cardContainer) cardContainer.style.setProperty('--border-weight', updatedData.table.borderWeight);
        }
        if (updatedData.table.colBorder !== undefined) {
          tableContentEl.setAttribute('data-col-border', updatedData.table.colBorder);
        }
        if (updatedData.table.rowBorder !== undefined) {
          tableContentEl.setAttribute('data-row-border', updatedData.table.rowBorder);
        }
        if (updatedData.table.borderFull !== undefined) {
          tableContentEl.setAttribute('data-border-full', updatedData.table.borderFull);
        }
        if (updatedData.table.html !== undefined) {
          tableContentEl.innerHTML = updatedData.table.html;
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionGatorzYoutube(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.videoUrl !== undefined) {
      const iframeEl = container.querySelector('[data-attribute="gatorz-youtube__iframe"]');
      if (iframeEl) {
        iframeEl.setAttribute('data-youtube-url', updatedData.videoUrl || '');
        iframeEl.removeAttribute('src');
      }
    }

    return container.innerHTML.trim();
  },

  sectionGatorzCompareImage(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.header) {
      const headerEl = container.querySelector('[data-attribute="gatorz-compare-image__header"]');
      if (headerEl && updatedData.header.html !== undefined) {
        headerEl.innerHTML = updatedData.header.html || '';
      }
    }

    if (updatedData.image) {
      const imageLeftEl = container.querySelector('[data-attribute="gatorz-compare-image__image-left"]');
      if (imageLeftEl && updatedData.image.left !== undefined) {
        imageLeftEl.setAttribute('src', updatedData.image.left || '');
      }

      const imageRightEl = container.querySelector('[data-attribute="gatorz-compare-image__image-right"]');
      if (imageRightEl && updatedData.image.right !== undefined) {
        imageRightEl.setAttribute('src', updatedData.image.right || '');
      }

      const sliderEl = container.querySelector('[data-attribute="gatorz-compare-image__slider"]');
      if (sliderEl && updatedData.image.initialPercent !== undefined) {
        sliderEl.setAttribute('data-initial-percent', String(updatedData.image.initialPercent));
      }
    }

    return container.innerHTML.trim();
  },

  sectionGatorzSupport(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.divider) {
      const dividerEl = container.querySelector('[data-attribute="divider-primary"]');
      if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
    }

    if (updatedData.accordion) {
      const wrapEl = container.querySelector('[data-attribute="gatorz-support-content"]');
      if (wrapEl) updateAccordionPrimary(wrapEl, updatedData.accordion);
    }

    if (updatedData.links) {
      const linksEl = container.querySelector('[data-attribute="gatorz-support__links"]');
      if (linksEl) {
        linksEl.innerHTML = updatedData.links
          .map(item => {
            const url = (item.url || '').trim();
            const href = url || 'javascript:void(0)';
            const targetAttr = item.openInNewTab && url ? ' target="_blank" rel="noopener noreferrer"' : '';

            return `
              <a
                class="gatorz-support__link"
                data-attribute="gatorz-support__link-item"
                data-url="${url}"
                data-open-new-tab="${item.openInNewTab ? 'true' : 'false'}"
                href="${href}"${targetAttr}
              >${item.label || ''}</a>`;
          })
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionGatorzFrameSpecs(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.divider) {
      const dividerEl = container.querySelector('[data-attribute="divider-primary"]');
      if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
    }

    if (updatedData.accordion) {
      const wrapEl = container.querySelector('[data-attribute="gatorz-frame-specs-content"]');
      if (wrapEl) updateAccordionPrimary(wrapEl, updatedData.accordion);
    }

    if (updatedData.layout) {
      const wrapCardEl = container.querySelector('[data-attribute="wrap-card"]');
      if (wrapCardEl) {
        const gap = Number(updatedData.layout.gap) || 0;
        const widthImg = updatedData.layout.widthImg || 50;
        wrapCardEl.setAttribute(
          'data-use-custom-width-img',
          updatedData.layout.useCustomWidthImg !== false ? 'true' : 'false',
        );
        wrapCardEl.setAttribute('data-width-img', widthImg);
        wrapCardEl.setAttribute('data-gap', String(gap));
        wrapCardEl.setAttribute('data-center-y', updatedData.layout.centerY !== false ? 'true' : 'false');
        wrapCardEl.style.setProperty('--gap-card', `${gap}px`);
        wrapCardEl.style.setProperty('--width-img', `${widthImg}%`);
      }
    }

    if (updatedData.leftCard) {
      const leftCardEl = container.querySelector('[data-attribute="left-card"]');
      if (leftCardEl) {
        const order = Number(updatedData.leftCard.order) || 1;
        leftCardEl.setAttribute('data-order', String(order));
        leftCardEl.style.setProperty('--order-left', order);
      }
    }

    if (updatedData.rightCard) {
      const rightCardEl = container.querySelector('[data-attribute="right-card"]');
      if (rightCardEl) {
        const order = Number(updatedData.rightCard.order) || 2;
        rightCardEl.setAttribute('data-order', String(order));
        rightCardEl.style.setProperty('--order-right', order);
      }
    }

    if (updatedData.content !== undefined) {
      const contentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (contentEl) contentEl.innerHTML = updatedData.content || '';
    }

    if (updatedData.image) {
      const imageEl = container.querySelector('[data-attribute="card-image"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.image.src || '');
        imageEl.setAttribute('alt', updatedData.image.alt || '');
      }
    }

    return container.innerHTML.trim();
  },

  sectionGatorzPolicy(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.items) {
      const listEl = container.querySelector('[data-attribute="gatorz-policy__list"]');
      if (listEl) {
        listEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <li class="gatorz-policy__item" data-attribute="gatorz-policy__item">
                <div class="gatorz-policy__item-content" data-attribute="gatorz-policy__item-content">
                  ${item.content || ''}
                </div>
              </li>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionSaintbrandShipping(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.bar) {
      const barEl = container.querySelector('[data-attribute="saintbrand-shipping-bar"]');
      if (barEl) {
        if (updatedData.bar.background !== undefined) {
          barEl.setAttribute('data-background', updatedData.bar.background);
          barEl.style.setProperty('--bar-background', updatedData.bar.background);
        }
        if (updatedData.bar.borderRadius !== undefined) {
          barEl.setAttribute('data-border-radius', updatedData.bar.borderRadius);
          barEl.style.setProperty('--bar-border-radius', `${updatedData.bar.borderRadius}px`);
        }
      }
    }

    if (updatedData.shipping) {
      const dotEl = container.querySelector('[data-attribute="saintbrand-shipping-dot"]');
      if (dotEl && updatedData.shipping.dotColor !== undefined) {
        dotEl.setAttribute('data-dot-color', updatedData.shipping.dotColor);
        dotEl.style.setProperty('--dot-color', updatedData.shipping.dotColor);
      }

      const shipPrefixEl = container.querySelector('[data-attribute="saintbrand-shipping-ship-prefix"]');
      if (shipPrefixEl && updatedData.shipping.prefixText !== undefined) {
        shipPrefixEl.textContent = updatedData.shipping.prefixText;
      }

      const deliveryDaysEl = container.querySelector('[data-attribute="saintbrand-shipping-delivery-days"]');
      if (deliveryDaysEl && updatedData.shipping.deliveryDays !== undefined) {
        deliveryDaysEl.setAttribute('data-delivery-days', updatedData.shipping.deliveryDays);
      }
    }

    if (updatedData.location) {
      const locationPrefixEl = container.querySelector('[data-attribute="saintbrand-shipping-location-prefix"]');
      if (locationPrefixEl && updatedData.location.prefixText !== undefined) {
        locationPrefixEl.textContent = updatedData.location.prefixText;
      }

      const locationSuffixEl = container.querySelector('[data-attribute="saintbrand-shipping-location-suffix"]');
      if (locationSuffixEl && updatedData.location.suffixText !== undefined) {
        locationSuffixEl.textContent = updatedData.location.suffixText;
      }

      const flagEl = container.querySelector('[data-attribute="saintbrand-shipping-flag"]');
      if (flagEl && updatedData.location.flagUrl !== undefined) {
        flagEl.setAttribute('src', updatedData.location.flagUrl || '');
      }

      const countryCodeEl = container.querySelector('[data-attribute="saintbrand-shipping-country-code"]');
      if (countryCodeEl && updatedData.location.countryCode !== undefined) {
        countryCodeEl.textContent = updatedData.location.countryCode || '';
      }
    }

    return container.innerHTML.trim();
  },

  sectionSaintbrandInfiniteMarquee(htmlString, updatedData) {
    const VERIFIED_SVG = `<svg class="saintbrand-infinite-marquee-verified" enable-background="new 0 0 609.626 609.626" viewBox="0 0 609.626 609.626" xmlns="http://www.w3.org/2000/svg"><path d="m567.469 245.053c-7.825-5.254-14.893-11.556-21.004-18.732.454-9.991 2.462-19.85 5.953-29.221 6.561-22.213 14.733-49.858-1.016-71.49-15.863-21.804-44.842-22.536-68.123-23.131-9.794.391-19.591-.662-29.078-3.126-5.216-8.182-9.199-17.087-11.82-26.43-7.768-22.123-17.445-49.658-43.361-58.08-25.147-8.173-47.715 7.355-67.614 21.01-7.997 6.385-16.975 11.432-26.586 14.946-9.616-3.51-18.599-8.558-26.597-14.946-19.9-13.667-42.474-29.146-67.615-21.01-25.909 8.422-35.583 35.943-43.36 58.071-2.616 9.296-6.555 18.168-11.696 26.343-9.517 2.539-19.363 3.622-29.204 3.213-23.28.594-52.259 1.327-68.122 23.13-15.749 21.644-7.578 49.289-1.016 71.504 3.45 9.322 5.476 19.11 6.009 29.036-6.084 7.277-13.178 13.647-21.066 18.914-18.784 14.325-42.153 32.159-42.153 59.756s23.369 45.431 42.157 59.757c7.825 5.254 14.893 11.556 21.004 18.732-.454 9.991-2.462 19.849-5.953 29.221-6.561 22.213-14.733 49.86 1.016 71.49 15.863 21.804 44.842 22.536 68.123 23.132 9.794-.391 19.591.662 29.078 3.126 5.216 8.182 9.199 17.088 11.82 26.43 7.777 22.127 17.451 49.659 43.366 58.083 4.591 1.505 9.393 2.271 14.225 2.27 19.504 0 37.314-12.242 53.389-23.28 7.997-6.387 16.975-11.435 26.587-14.95 9.616 3.51 18.599 8.558 26.599 14.946 19.899 13.667 42.467 29.134 67.614 21.01 25.909-8.422 35.583-35.943 43.36-58.071 2.616-9.296 6.555-18.168 11.696-26.343 9.517-2.539 19.363-3.622 29.204-3.213 23.28-.594 52.259-1.327 68.122-23.13 15.749-21.643 7.578-49.29 1.016-71.504-3.45-9.322-5.476-19.11-6.009-29.036 6.084-7.277 13.178-13.647 21.066-18.914 18.776-14.325 42.145-32.159 42.145-59.756.001-27.597-23.368-45.431-42.156-59.757zm-149.442 14.214-127.006 127.005c-9.916 9.919-25.995 9.922-35.914.006-.002-.002-.004-.004-.006-.006l-63.503-63.503c-10.045-9.793-10.249-25.875-.456-35.92s25.875-10.249 35.92-.456c.154.15.306.302.456.456l45.543 45.544 109.046-109.047c9.793-10.045 25.875-10.248 35.92-.455s10.248 25.875.455 35.92c-.15.155-.302.306-.455.456z"></path></svg>`;

    const renderReviewCard = (review, position) => `
      <div
        class="saintbrand-infinite-marquee-review-card saintbrand-infinite-marquee-review-card--${position}"
        data-attribute="saintbrand-infinite-marquee-review-card"
        data-position="${position}"
      >
        <img
          loading="lazy"
          class="saintbrand-infinite-marquee-review-avatar"
          data-attribute="saintbrand-infinite-marquee-review-avatar"
          src="${review?.avatar || ''}"
          alt=""
        />
        <div class="saintbrand-infinite-marquee-review-body">
          <div class="saintbrand-infinite-marquee-review-name-row">
            <span data-attribute="saintbrand-infinite-marquee-review-name">${review?.name || ''}</span>
            ${VERIFIED_SVG}
          </div>
          <div data-attribute="saintbrand-infinite-marquee-review-content">${review?.content || ''}</div>
        </div>
      </div>`;

    const getCardPosition = index => (index % 2 === 0 ? 'top' : 'bottom');

    const getCardOffset = index => {
      const mod = index % 4;
      if (mod === 0 || mod === 2) {
        return mod === 0 ? 'far' : 'near';
      }
      return mod === 1 ? 'near' : 'far';
    };

    const renderSlide = (item, index, isOriginal) => {
      const cardPosition = getCardPosition(index);
      const cardOffset = getCardOffset(index);
      const review = item.review || {};

      return `
      <div
        data-attribute="saintbrand-infinite-marquee-slide"
        class="saintbrand-infinite-marquee-slide ${isOriginal ? 'marquee-item-original' : 'marquee-item-clone'}"
        data-original="${isOriginal}"
        data-slide-index="${index}"
        data-card-position="${cardPosition}"
        data-card-offset="${cardOffset}"
      >
        <div
          class="saintbrand-infinite-marquee-image-zone"
          data-attribute="saintbrand-infinite-marquee-image-zone"
        >
          <div class="saintbrand-infinite-marquee-image" data-attribute="saintbrand-infinite-marquee-image">
            <img
              loading="lazy"
              data-attribute="saintbrand-infinite-marquee-review-image"
              src="${review.image || ''}"
              alt=""
            />
          </div>
        </div>
        <div
          class="saintbrand-infinite-marquee-card-zone saintbrand-infinite-marquee-card-zone--top"
          data-attribute="saintbrand-infinite-marquee-card-zone-top"
        >
          ${cardPosition === 'top' ? renderReviewCard(review, 'top') : ''}
        </div>
        <div
          class="saintbrand-infinite-marquee-card-zone saintbrand-infinite-marquee-card-zone--bottom"
          data-attribute="saintbrand-infinite-marquee-card-zone-bottom"
        >
          ${cardPosition === 'bottom' ? renderReviewCard(review, 'bottom') : ''}
        </div>
      </div>`;
    };

    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.content !== undefined) {
      const titleEl = container.querySelector('[data-attribute="saintbrand-infinite-marquee-title"]');
      if (titleEl) {
        titleEl.innerHTML = updatedData.content || '';
      }
    }

    const marqueeContainer = container.querySelector('[data-attribute="saintbrand-infinite-marquee-container"]');
    if (marqueeContainer && updatedData.pauseOnHover !== undefined) {
      marqueeContainer.setAttribute('data-pause-on-hover', updatedData.pauseOnHover ? 'true' : 'false');
    }

    if (updatedData.items) {
      const listEl = container.querySelector('[data-attribute="saintbrand-infinite-marquee-list"]');

      if (listEl) {
        const items = updatedData.items || [];

        if (!items.length) {
          listEl.innerHTML = '';
          if (marqueeContainer) {
            marqueeContainer.style.removeProperty('--marquee-duration');
            marqueeContainer.style.removeProperty('--marquee-translate-distance');
          }
        } else {
          let containerWidth = 1920;
          if (typeof window !== 'undefined' && window.innerWidth) {
            containerWidth = window.innerWidth;
            if (marqueeContainer && marqueeContainer.offsetWidth > 0) {
              containerWidth = marqueeContainer.offsetWidth;
            }
          }

          const itemWidth = containerWidth <= 768 ? 230 : 340;
          const gap = containerWidth <= 768 ? 16 : 24;
          const itemWithGap = itemWidth + gap;
          const minItemsNeeded = Math.ceil((containerWidth * 3) / itemWithGap);
          const minItemsForSmoothScroll = Math.max(6, minItemsNeeded);

          let slidesToRender = [];

          if (items.length < minItemsForSmoothScroll) {
            const duplicationFactor = Math.ceil(minItemsForSmoothScroll / items.length);
            for (let i = 0; i < duplicationFactor; i++) {
              slidesToRender.push(...items);
            }
          } else {
            slidesToRender = items;
          }

          listEl.innerHTML = slidesToRender
            .map((item, index) => renderSlide(item, index, index < items.length))
            .join('');

          const originalItems = items.length;
          const baseSpeedPerOriginalItem = 4;
          const minDuration = 12;
          const maxDuration = 120;
          const calculatedDuration = Math.max(
            minDuration,
            Math.min(maxDuration, originalItems * baseSpeedPerOriginalItem),
          );

          if (marqueeContainer) {
            marqueeContainer.style.setProperty('--marquee-duration', `${calculatedDuration}s`);

            if (items.length < minItemsForSmoothScroll) {
              const originalContentWidth = items.length * itemWidth + (items.length - 1) * gap;
              marqueeContainer.style.setProperty('--marquee-translate-distance', `-${originalContentWidth}px`);
            } else {
              marqueeContainer.style.setProperty('--marquee-translate-distance', '-50%');
            }
          }
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionSaintbrandFeaturesGrid(htmlString, updatedData) {
    const FEATURE_ICON = `<svg class="feature-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.10477 7.65644L5.08502 6.59479C5.0012 6.50167 4.89877 6.45509 4.77769 6.45509C4.65663 6.45509 4.54955 6.497 4.4564 6.58082C4.36328 6.67393 4.31671 6.78105 4.31671 6.90211C4.31671 7.02317 4.36328 7.13029 4.4564 7.2234L5.81142 8.56445C5.89524 8.6483 5.99302 8.69015 6.10477 8.69015C6.21653 8.69015 6.31431 8.6483 6.39813 8.56445L8.95449 6.02204C9.03835 5.93822 9.0802 5.83577 9.0802 5.71472C9.0802 5.59366 9.0337 5.49121 8.94057 5.4074C8.85671 5.33288 8.75665 5.29796 8.64023 5.30262C8.52381 5.30729 8.42831 5.34685 8.35382 5.42137L6.10477 7.65644ZM4.638 12.5318L3.7719 11.051L2.03972 10.7017C1.93727 10.6831 1.85113 10.6272 1.78128 10.5341C1.71144 10.441 1.68583 10.3433 1.70445 10.2408L1.90002 8.56445L0.79645 7.27928C0.721943 7.20477 0.684692 7.11165 0.684692 6.9999C0.684692 6.88814 0.721943 6.79502 0.79645 6.72051L1.90002 5.4493L1.70445 3.77298C1.68583 3.67053 1.71144 3.57275 1.78128 3.47963C1.85113 3.38651 1.93727 3.33064 2.03972 3.312L3.7719 2.96277L4.638 1.46805C4.69387 1.37492 4.77305 1.30973 4.87548 1.27248C4.97793 1.23523 5.08038 1.23988 5.1828 1.28645L6.70545 1.99888L8.22811 1.28645C8.33054 1.23988 8.43303 1.2329 8.53545 1.2655C8.63787 1.29809 8.71701 1.36095 8.77293 1.45408L9.65295 2.96277L11.3712 3.312C11.4737 3.33064 11.5598 3.38651 11.6296 3.47963C11.6995 3.57275 11.7251 3.67053 11.7065 3.77298L11.5109 5.4493L12.6145 6.72051C12.689 6.79502 12.7262 6.88814 12.7262 6.9999C12.7262 7.11165 12.689 7.20477 12.6145 7.27928L11.5109 8.56445L11.7065 10.2408C11.7251 10.3433 11.6995 10.441 11.6296 10.5341C11.5598 10.6272 11.4737 10.6831 11.3712 10.7017L9.65295 11.051L8.77293 12.5457C8.71701 12.6388 8.63787 12.7017 8.53545 12.7343C8.43303 12.7669 8.33054 12.7599 8.22811 12.7133L6.70545 12.0009L5.1828 12.7133C5.08038 12.7599 4.97793 12.7645 4.87548 12.7273C4.77305 12.6901 4.69387 12.6249 4.638 12.5318Z" fill="#121212"></path>
</svg>`;

    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.layout) {
      const gridEl = container.querySelector('[data-attribute="saintbrand-features-grid"]');
      if (gridEl) {
        const columns = updatedData.layout.columns || 2;
        const gap = updatedData.layout.gap ?? 16;
        gridEl.setAttribute('data-columns', String(columns));
        gridEl.setAttribute('data-gap', String(gap));
        gridEl.style.setProperty('--columns', String(columns));
        gridEl.style.setProperty('--gap', `${gap}px`);
      }
    }

    if (updatedData.items) {
      const gridEl = container.querySelector('[data-attribute="saintbrand-features-grid"]');
      if (gridEl) {
        gridEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="item" class="saintbrand-features-grid-item">
                <div class="saintbrand-features-grid-icon">
                  ${FEATURE_ICON}
                </div>
                <div data-attribute="text-item" class="saintbrand-features-grid-text">
                  ${item.text || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionMarkqueueOrthopedic(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    for (const key in updatedData) {
      switch (key) {
        case 'backgroundMarkqueue': {
          const el = container.querySelector('[data-attribute="container-markqueue"]');
          if (el) {
            el.setAttribute('data-background-markqueue', updatedData[key]);
            el.style.setProperty('--background-color-markqueue', updatedData[key]);
          }
          break;
        }
        case 'textColorMarkqueue': {
          const el = container.querySelector('[data-attribute="container-markqueue"]');
          if (el) {
            el.setAttribute('data-text-color-markqueue', updatedData[key]);
            el.style.setProperty('--text-color-markqueue', updatedData[key]);
          }
          break;
        }
        case 'markqueueItems': {
          const el = container.querySelector('[data-attribute="block-markqueue"]');
          if (el) {
            el.removeAttribute('data-markqueue-duplicated');
            el.innerHTML = (updatedData[key] || [])
              .map(
                item => `
                  <div data-attribute="item-markqueue" class="item-markqueue">
                    <div class="icon-item">
                      <img data-attribute="icon-item-markqueue" src="${item.icon || ''}" alt="" />
                    </div>
                    <div data-attribute="text-item-markqueue" class="text-item">
                      ${item.text || ''}
                    </div>
                  </div>
                `,
              )
              .join('');
          }
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },

  sectionOrthopedicFeaturesGrid(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.header !== undefined) {
      const headerEl = container.querySelector('[data-attribute="orthopedic-features-grid__header"]');
      if (headerEl) headerEl.innerHTML = updatedData.header || '';
    }

    if (updatedData.backgroundContent !== undefined || updatedData.layout) {
      const bodyEl = container.querySelector('[data-attribute="orthopedic-features-grid__body"]');
      if (bodyEl) {
        if (updatedData.backgroundContent !== undefined) {
          bodyEl.setAttribute('data-background', updatedData.backgroundContent);
          bodyEl.style.setProperty('--body-background', updatedData.backgroundContent);
          bodyEl.setAttribute('data-text-color', updatedData.textColorContent);
          bodyEl.style.setProperty('--body-text-color', updatedData.textColorContent);
        }
        if (updatedData.layout) {
          const mobile = updatedData.layout.itemsPerRow?.mobile ?? 1;
          const desktop = updatedData.layout.itemsPerRow?.desktop ?? 4;
          const gap = updatedData.layout.gap ?? 24;
          bodyEl.setAttribute('data-items-per-row-mobile', String(mobile));
          bodyEl.setAttribute('data-items-per-row-desktop', String(desktop));
          bodyEl.setAttribute('data-items-gap', String(gap));
          bodyEl.style.setProperty('--items-per-row-mobile', String(mobile));
          bodyEl.style.setProperty('--items-per-row-desktop', String(desktop));
          bodyEl.style.setProperty('--items-gap', `${gap}px`);
        }
      }
    }

    if (updatedData.items) {
      const listEl = container.querySelector('[data-attribute="orthopedic-features-grid__list"]');
      if (listEl) {
        listEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div class="orthopedic-features-grid__item" data-attribute="orthopedic-features-grid__item">
                <div class="orthopedic-features-grid__item-image-wrap">
                  <img
                    data-attribute="orthopedic-features-grid__item-image"
                    src="${item.image || ''}"
                    alt=""
                  />
                </div>
                <div
                  class="orthopedic-features-grid__item-content"
                  data-attribute="orthopedic-features-grid__item-content"
                >
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionOrthopedicCardFeatures(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const contentEl = container.querySelector('[data-attribute="orthopedic-card-features-content"]');
    if (contentEl) {
      if (updatedData.image) {
        contentEl.setAttribute('data-image-position', updatedData.image.position || 'left');
      }
      if (updatedData.backgroundContent !== undefined) {
        contentEl.setAttribute('data-background', updatedData.backgroundContent);
        contentEl.style.setProperty('--content-background', updatedData.backgroundContent);
      }
      if (updatedData.textColorContent !== undefined) {
        contentEl.setAttribute('data-text-color', updatedData.textColorContent);
        contentEl.style.setProperty('--content-text-color', updatedData.textColorContent);
      }
      if (updatedData.layout) {
        const gap = updatedData.layout.gap ?? 8;
        contentEl.setAttribute('data-gap', String(gap));
        contentEl.style.setProperty('--section-gap', `${gap}px`);
      }
    }

    const contentPanelEl = container.querySelector('[data-attribute="orthopedic-card-features__content"]');
    if (contentPanelEl) {
      if (updatedData.backgroundContent !== undefined) {
        contentPanelEl.style.backgroundColor = updatedData.backgroundContent;
      }
      if (updatedData.textColorContent !== undefined) {
        contentPanelEl.style.color = updatedData.textColorContent;
      }
    }

    if (updatedData.image) {
      const imageEl = container.querySelector('[data-attribute="orthopedic-card-features__image-img"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.image.src || '');
      }
    }

    if (updatedData.header !== undefined) {
      const headerEl = container.querySelector('[data-attribute="orthopedic-card-features__header"]');
      if (headerEl) headerEl.innerHTML = updatedData.header || '';
    }

    if (updatedData.items) {
      const listEl = container.querySelector('[data-attribute="orthopedic-card-features__list"]');
      if (listEl) {
        listEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div class="orthopedic-card-features__item" data-attribute="orthopedic-card-features__item">
                <div class="orthopedic-card-features__item-image-wrap">
                  <img
                    data-attribute="orthopedic-card-features__item-image"
                    src="${item.image || ''}"
                    alt=""
                  />
                </div>
                <div
                  class="orthopedic-card-features__item-content"
                  data-attribute="orthopedic-card-features__item-content"
                >
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionOrthopedicCardReview(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) {
        updateButtonBasic(wrapButtonEl, updatedData.button);
      }
    }

    const contentEl = container.querySelector('[data-attribute="orthopedic-card-review-content"]');
    if (contentEl) {
      if (updatedData.image) {
        contentEl.setAttribute('data-image-position', updatedData.image.position || 'right');
      }
      if (updatedData.layout) {
        const gap = updatedData.layout.gap ?? 60;
        contentEl.setAttribute('data-gap', String(gap));
        contentEl.style.setProperty('--section-gap', `${gap}px`);
      }
    }

    if (updatedData.image) {
      const imageEl = container.querySelector('[data-attribute="orthopedic-card-review__image-img"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.image.src || '');
      }
    }

    if (updatedData.rating) {
      const ratingEl = container.querySelector('[data-attribute="orthopedic-card-review__rating"]');
      if (ratingEl) {
        const show = updatedData.rating.show !== false;
        ratingEl.setAttribute('data-show', show ? 'true' : 'false');
        ratingEl.style.display = show ? '' : 'none';
        const ratingTextEl = ratingEl.querySelector('[data-attribute="orthopedic-card-review__rating-text"]');
        if (ratingTextEl) {
          ratingTextEl.textContent = updatedData.rating.text || '';
        }
      }
    }

    if (updatedData.titleContent !== undefined) {
      const titleEl = container.querySelector('[data-attribute="orthopedic-card-review__title"]');
      if (titleEl) {
        titleEl.innerHTML = updatedData.titleContent || '';
      }
    }

    if (updatedData.guarantee) {
      const guaranteeEl = container.querySelector('[data-attribute="orthopedic-card-review__guarantee"]');
      if (guaranteeEl) {
        const show = updatedData.guarantee.show !== false;
        guaranteeEl.setAttribute('data-show', show ? 'true' : 'false');
        guaranteeEl.style.display = show ? '' : 'none';
        if (updatedData.guarantee.backgroundColor !== undefined) {
          guaranteeEl.setAttribute('data-background', updatedData.guarantee.backgroundColor);
          guaranteeEl.style.setProperty('--guarantee-bg', updatedData.guarantee.backgroundColor);
          guaranteeEl.style.backgroundColor = updatedData.guarantee.backgroundColor;
        }
        if (updatedData.guarantee.textColor !== undefined) {
          guaranteeEl.setAttribute('data-text-color', updatedData.guarantee.textColor);
          guaranteeEl.style.setProperty('--guarantee-text', updatedData.guarantee.textColor);
          guaranteeEl.style.color = updatedData.guarantee.textColor;
        }
        const guaranteeTextEl = guaranteeEl.querySelector('[data-attribute="orthopedic-card-review__guarantee-text"]');
        if (guaranteeTextEl) {
          guaranteeTextEl.textContent = updatedData.guarantee.text || '';
        }
      }
    }

    if (updatedData.body !== undefined) {
      const bodyEl = container.querySelector('[data-attribute="orthopedic-card-review__body"]');
      if (bodyEl) {
        bodyEl.innerHTML = updatedData.body || '';
      }
    }

    return container.innerHTML.trim();
  },

  sectionOrthopedicCardBasic(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) {
        updateButtonBasic(wrapButtonEl, updatedData.button);
      }
    }

    const contentEl = container.querySelector('[data-attribute="orthopedic-card-basic-content"]');
    if (contentEl) {
      if (updatedData.images) {
        contentEl.setAttribute('data-image-position', updatedData.images.position || 'left');
      }
      if (updatedData.layout) {
        const gap = updatedData.layout.gap ?? 80;
        contentEl.setAttribute('data-gap', String(gap));
        contentEl.style.setProperty('--section-gap', `${gap}px`);
      }
    }

    if (updatedData.images && updatedData.images.items) {
      updatedData.images.items.forEach((item, index) => {
        const imageEl = container.querySelector(`[data-attribute="orthopedic-card-basic__image-img-${index + 1}"]`);
        if (imageEl) {
          imageEl.setAttribute('src', item.src || '');
        }
      });
    }

    if (updatedData.content !== undefined) {
      let textEl = container.querySelector('[data-attribute="orthopedic-card-basic__text"]');
      if (!textEl) {
        const contentWrapper = container.querySelector('[data-attribute="orthopedic-card-basic__content"]');
        const headerEl = container.querySelector('[data-attribute="orthopedic-card-basic__header"]');
        const bodyEl = container.querySelector('[data-attribute="orthopedic-card-basic__body"]');
        if (contentWrapper && (headerEl || bodyEl)) {
          if (headerEl) headerEl.remove();
          if (bodyEl) bodyEl.remove();
          textEl = container.ownerDocument.createElement('div');
          textEl.className = 'orthopedic-card-basic__text';
          textEl.setAttribute('data-attribute', 'orthopedic-card-basic__text');
          const signatureEl = contentWrapper.querySelector('[data-attribute="orthopedic-card-basic__signature"]');
          if (signatureEl) {
            contentWrapper.insertBefore(textEl, signatureEl);
          } else {
            contentWrapper.prepend(textEl);
          }
        }
      }
      if (textEl) {
        textEl.innerHTML = updatedData.content || '';
      }
    }

    if (updatedData.signature) {
      const signatureEl = container.querySelector('[data-attribute="orthopedic-card-basic__signature"]');
      if (signatureEl) {
        const show = updatedData.signature.show !== false;
        signatureEl.setAttribute('data-show', show ? 'true' : 'false');
        signatureEl.style.display = show ? '' : 'none';
        const signatureImgEl = signatureEl.querySelector('[data-attribute="orthopedic-card-basic__signature-img"]');
        if (signatureImgEl) {
          signatureImgEl.setAttribute('src', updatedData.signature.src || '');
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionLosaprilyImagesGrid(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const losaprilyImagesGridEl = container.querySelector('[data-attribute="losaprily-images-grid-content"]');
    if (losaprilyImagesGridEl) {
      losaprilyImagesGridEl.setAttribute(
        'data-container-full-width',
        updatedData.containerFullWidth ? 'true' : 'false',
      );
    }

    if (updatedData.images) {
      const imageKeys = ['image1', 'image2', 'image3', 'image4', 'image5'];
      imageKeys.forEach((key, index) => {
        if (updatedData.images[key] === undefined) return;
        const imageEl = container.querySelector(`[data-attribute="losaprily-images-grid__image-${index + 1}"]`);
        if (imageEl) {
          imageEl.setAttribute('src', updatedData.images[key] || '');
        }
      });
    }

    if (updatedData.box) {
      const boxEl = container.querySelector('[data-attribute="losaprily-images-grid__box"]');
      if (boxEl) {
        if (updatedData.box.backgroundColor !== undefined) {
          boxEl.setAttribute('data-background', updatedData.box.backgroundColor);
          boxEl.style.setProperty('--box-bg', updatedData.box.backgroundColor);
          boxEl.style.backgroundColor = updatedData.box.backgroundColor;
        }
        if (updatedData.box.textColor !== undefined) {
          boxEl.setAttribute('data-text-color', updatedData.box.textColor);
          boxEl.style.setProperty('--box-text-color', updatedData.box.textColor);
          boxEl.style.color = updatedData.box.textColor;
        }
      }

      const boxIconEl = container.querySelector('[data-attribute="losaprily-images-grid__box-icon"]');
      if (boxIconEl) {
        if (updatedData.box.icon !== undefined) {
          boxIconEl.setAttribute('src', updatedData.box.icon || '');
        }
        if (updatedData.box.iconSizeDesktop !== undefined) {
          boxIconEl.setAttribute('data-icon-size-desktop', String(updatedData.box.iconSizeDesktop));
          if (boxEl) {
            boxEl.style.setProperty('--box-icon-size-desktop', `${updatedData.box.iconSizeDesktop}px`);
          }
        }
        if (updatedData.box.iconSizeMobile !== undefined) {
          boxIconEl.setAttribute('data-icon-size-mobile', String(updatedData.box.iconSizeMobile));
          if (boxEl) {
            boxEl.style.setProperty('--box-icon-size-mobile', `${updatedData.box.iconSizeMobile}px`);
          }
        }
        if (updatedData.box.iconPosition !== undefined) {
          boxIconEl.setAttribute('data-icon-position', updatedData.box.iconPosition || 'center');
        }
      }

      const boxTextEl = container.querySelector('[data-attribute="losaprily-images-grid__box-text"]');
      if (boxTextEl && updatedData.box.text !== undefined) {
        boxTextEl.innerHTML = updatedData.box.text || '';
      }
    }

    return container.innerHTML.trim();
  },
  sectionCardMediaWithSliderLosaprily(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.gapCard !== undefined) {
      const wrapCardEl = container.querySelector('[data-attribute="wrap-card"]');
      if (wrapCardEl) {
        const gap = updatedData.gapCard ?? 30;
        wrapCardEl.setAttribute('data-grap-card', String(gap));
        wrapCardEl.style.setProperty('--grap-card', `${gap}px`);
      }
    }

    if (updatedData.useMedia !== undefined || updatedData.orderMedia !== undefined) {
      const wrapMediaEl = container.querySelector('[data-attribute="wrap-media"]');
      if (wrapMediaEl) {
        if (updatedData.useMedia !== undefined) {
          wrapMediaEl.setAttribute('data-use-media', updatedData.useMedia);

          const videoWrapEl = wrapMediaEl.querySelector('.wrap-video');
          const imgWrapEl = wrapMediaEl.querySelector('.wrap-image');
          if (videoWrapEl && imgWrapEl) {
            if (updatedData.useMedia === 'video') {
              videoWrapEl.style.display = '';
              imgWrapEl.style.display = 'none';
            } else {
              videoWrapEl.style.display = 'none';
              imgWrapEl.style.display = '';
            }
          }
        }
        if (updatedData.orderMedia !== undefined) {
          const order = updatedData.orderMedia ?? 1;
          wrapMediaEl.setAttribute('data-order', String(order));
          wrapMediaEl.style.setProperty('--order-media', String(order));
        }
      }
    }

    if (updatedData.videoCard !== undefined) {
      const videoEl = container.querySelector('[data-attribute="video-card"]');
      if (videoEl) {
        videoEl.setAttribute('src', updatedData.videoCard || '');
      }
    }

    if (updatedData.imageCard !== undefined) {
      const imageEl = container.querySelector('[data-attribute="image-card"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.imageCard || '');
      }
    }

    if (updatedData.orderContent !== undefined) {
      const wrapContentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (wrapContentEl) {
        const order = updatedData.orderContent ?? 2;
        wrapContentEl.setAttribute('data-order', String(order));
        wrapContentEl.style.setProperty('--order-content', String(order));
      }
    }

    if (updatedData.titleDesContent !== undefined) {
      const titleDesDesktopEl = container.querySelector('[data-attribute="title-des-content-desktop"]');
      if (titleDesDesktopEl) {
        titleDesDesktopEl.innerHTML = updatedData.titleDesContent || '';
      }
      const titleDesEl = container.querySelector('[data-attribute="title-des-content"]');
      if (titleDesEl) {
        titleDesEl.innerHTML = updatedData.titleDesContent || '';
      }
    }

    if (updatedData.slides) {
      const listEl = container.querySelector('[data-attribute="list-item"]');
      if (listEl) {
        listEl.innerHTML = (updatedData.slides || [])
          .map(slide => {
            return `
            <div class="swiper-slide">
              <div class="wrap-item-slide">
                <div class="wrap-img-item">
                  <img data-attribute="img-item" src="${slide.image || ''}" alt="">
                </div>
                <div data-attribute="content-item" class="content-item">
                  ${slide.content || ''}
                </div>
              </div>
            </div>
            `;
          })
          .join('\n');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardTabWithContentLosaprily(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const tabsHeadingEl = container.querySelector('[data-attribute="tabs-heading"]');
    if (tabsHeadingEl && updatedData.colorBorder !== undefined) {
      tabsHeadingEl.setAttribute('data-color-border', updatedData.colorBorder);
      tabsHeadingEl.style.setProperty('--color-border', updatedData.colorBorder);
    }

    const tabsContentEl = container.querySelector('[data-attribute="tabs-content"]');
    if (tabsContentEl && updatedData.widthTabContentItem !== undefined) {
      const width = updatedData.widthTabContentItem ?? 576;
      tabsContentEl.setAttribute('data-width-tab-content-item', String(width));
      tabsContentEl.style.setProperty('--width-tab-content-item', `${width}px`);
    }

    const listTab = updatedData.listTab || [];

    const tabImageBgEl = container.querySelector('[data-attribute="tab-image-bg"]');
    if (tabImageBgEl) {
      tabImageBgEl.innerHTML = listTab
        .map((tab, idx) => {
          const isActive = idx === 0 ? 'active' : '';
          const useBgMobile = tab.useBgMobile !== false ? 'true' : 'false';
          return `
            <div data-attribute="tab-images-bg-item" class="tab-images-bg-item ${isActive}" data-tab="${
            tab.tabId
          }" data-use-bg-mobile="${useBgMobile}"
              data-bg-desktop-url="${tab.bgDesktopUrl || ''}"
              data-bg-mobile-url="${tab.bgMobileUrl || ''}"
              style="--bg-desktop-url:url('${tab.bgDesktopUrl || ''}'); --bg-mobile-url:url('${tab.bgMobileUrl ||
            ''}')">
            </div>
          `;
        })
        .join('\n');
    }

    if (tabsHeadingEl) {
      tabsHeadingEl.innerHTML = listTab
        .map((tab, idx) => {
          const isActive = idx === 0 ? 'active' : '';
          return `
            <div class="tab-deading-item ${isActive}" data-attribute="tab-heading-item" data-tab="${tab.tabId}">
              <span data-attribute="tab-text-content" class="tab-text-content">${tab.headerText || ''}</span>
            </div>
          `;
        })
        .join('\n');
    }

    if (tabsContentEl) {
      tabsContentEl.innerHTML = listTab
        .map((tab, idx) => {
          const isActive = idx === 0 ? 'active' : '';
          const subTitleShow = tab.subTitleShow !== false ? 'true' : 'false';
          const subTitleStyle = tab.subTitleShow !== false ? '' : 'display: none;';
          const benefitsShow = tab.benefitsShow !== false ? 'true' : 'false';
          const benefitsStyle = tab.benefitsShow !== false ? '' : 'display: none;';
          const colorBenefit = tab.colorBenefit || '#0079eb';

          const benefitsHtml = (tab.benefits || [])
            .map(benefit => {
              return `
                <div data-attribute="benefit-item" class="benefit-item">
                  <div class="icon-benefit">
                    <img data-attribute="icon-benefit" src="${benefit.icon || ''}" alt="">
                  </div>
                  <div class="text-benefit">${benefit.text || ''}</div>
                </div>
              `;
            })
            .join('\n');

          return `
            <div class="tab-content-item ${isActive}" data-attribute="tab-content-item" data-tab="${tab.tabId}">
              <div data-show="${subTitleShow}" data-attribute="sub-title" class="sub-title" style="${subTitleStyle}">
                ${tab.subTitleText || ''}
              </div>
              <div data-attribute="title-tab-item">
                ${tab.titleContent || ''}
              </div>
              <div data-attribute="key-benefits" data-color-benefit="${colorBenefit}" data-show="${benefitsShow}" class="key-benefits"
                style="--color-benefit: ${colorBenefit}; ${benefitsStyle}">
                ${benefitsHtml}
              </div>
            </div>
          `;
        })
        .join('\n');
    }

    return container.innerHTML.trim();
  },

  sectionLosaprilyCardBanner(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.banner) {
      const wrapBannerEl = container.querySelector('[data-attribute="wrap-banner"]');
      if (wrapBannerEl) {
        wrapBannerEl.setAttribute(
          'data-use-banner-mobile',
          updatedData.banner.useBannerMobile !== false ? 'true' : 'false',
        );
        const desktopEl = wrapBannerEl.querySelector('[data-attribute="banner-desktop-img"]');
        if (desktopEl) desktopEl.setAttribute('src', updatedData.banner.desktop || '');
        const mobileEl = wrapBannerEl.querySelector('[data-attribute="banner-mobile-img"]');
        if (mobileEl) mobileEl.setAttribute('src', updatedData.banner.mobile || '');
      }
    }

    if (updatedData.wrapContent) {
      const wrapContentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (wrapContentEl) {
        const widthContent = Number(updatedData.wrapContent.widthContent) || 625;
        wrapContentEl.setAttribute('data-width-content', String(widthContent));
        wrapContentEl.style.setProperty('--width-content', `${widthContent}px`);
      }
    }

    if (updatedData.heading) {
      const headingEl = container.querySelector('[data-attribute="heading-content"]');
      if (headingEl) {
        const show = updatedData.heading.show !== false;
        headingEl.setAttribute('data-show', show ? 'true' : 'false');
        headingEl.style.display = show ? '' : 'none';
        headingEl.innerHTML = updatedData.heading.content || '';
      }
    }

    if (updatedData.divider) {
      const dividerEl = container.querySelector('[data-attribute="divider-primary"]');
      if (dividerEl) updateDividerPrimary(dividerEl, updatedData.divider);
      const dividerContentEl = container.querySelector('[data-attribute="divider-content"]');
      if (dividerContentEl) {
        const show = updatedData.divider.show !== false;
        dividerContentEl.setAttribute('data-show', show ? 'true' : 'false');
        dividerContentEl.style.display = show ? '' : 'none';
      }
    }

    if (updatedData.description) {
      const descriptionEl = container.querySelector('[data-attribute="description-content"]');
      if (descriptionEl) {
        const show = updatedData.description.show !== false;
        descriptionEl.setAttribute('data-show', show ? 'true' : 'false');
        descriptionEl.style.display = show ? '' : 'none';
        descriptionEl.innerHTML = updatedData.description.content || '';
      }
    }

    if (updatedData.smallImage) {
      const smallImageEl = container.querySelector('[data-attribute="wrap-image-small"]');
      if (smallImageEl) {
        const show = updatedData.smallImage.show !== false;
        smallImageEl.setAttribute('data-show', show ? 'true' : 'false');
        // smallImageEl.style.display = show ? '' : 'none'
        const imageEl = smallImageEl.querySelector('[data-attribute="image-small"]');
        if (imageEl) {
          imageEl.setAttribute('src', updatedData.smallImage.src || '');
          imageEl.setAttribute('alt', updatedData.smallImage.alt || '');
        }
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionMarqueeShopzovya(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.rows) {
      const wrapMarqueesEl = container.querySelector('.wrap-marquees');
      if (wrapMarqueesEl) {
        wrapMarqueesEl.innerHTML = (updatedData.rows || [])
          .map(row => {
            const gapItem = Number(row.gapItem) || 28;
            const speedAnimation = Number(row.speedAnimation) || 20;
            const bgBadge = row.bgBadge || '#f7c4ce';
            const bgItem = row.bgItem || '#ffffff';
            const colorBadge = row.colorBadge || '#ffffff';
            const itemsHtml = (row.items || [])
              .map(
                item => `
                <div data-attribute="marquee-item" class="marquee-item">
                  <div class="wrap-avatar">
                    <div class="avatar">
                      <img data-attribute="avatar" src="${item.avatar || ''}" alt="">
                    </div>
                    <div class="rating">
                      <span data-attribute="rating-point" data-value="${item.ratingPoint || 5}">${item.ratingPoint ||
                  5}</span>
                      <svg class="trustoo-rating-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17" fill="none">
                        <path fill="currentColor" d="M8.89062 0.565613L11.4299 6.07066L17.4501 6.78446L12.9992 10.9006L14.1807 16.8468L8.89062 13.8856L3.60056 16.8468L4.78206 10.9006L0.331117 6.78446L6.35139 6.07066L8.89062 0.565613Z"></path>
                      </svg>
                    </div>
                  </div>
                  <p data-attribute="text-rating" class="text-rating">
                    ${item.textRating || ''}
                  </p>
                </div>
              `,
              )
              .join('');

            return `
              <div data-attribute="row-marquee" data-bg-badge="${bgBadge}" data-bg-item="${bgItem}" data-color-badge="${colorBadge}"
                data-gap-item="${gapItem}" data-speed-animation="${speedAnimation}" class="row-marquee"
                style="--speed-animation:${speedAnimation}s; --gap-item:${gapItem}px; --bg-badge:${bgBadge}; --color-badge:${colorBadge}; --bg-item:${bgItem};">
                <div class="list-item">
                  ${itemsHtml}
                </div>
              </div>
            `;
          })
          .join('\n');
      }
    }

    return container.innerHTML.trim();
  },
  sectionSowhatbuyCardBasic(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const contentEl = container.querySelector('[data-attribute="sowhatbuy-card-basic-content"]');
    if (contentEl) {
      if (updatedData.image) {
        contentEl.setAttribute('data-image-position', updatedData.image.position || 'left');
      }
      if (updatedData.layout) {
        const gap = updatedData.layout.gap ?? 40;
        contentEl.setAttribute('data-gap', String(gap));
        contentEl.style.setProperty('--section-gap', `${gap}px`);
      }
    }

    if (updatedData.image) {
      const imageEl = container.querySelector('[data-attribute="sowhatbuy-card-basic__image"]');
      if (imageEl && updatedData.image.src !== undefined) {
        imageEl.setAttribute('src', updatedData.image.src || '');
      }
    }

    if (updatedData.specification !== undefined) {
      const specificationEl = container.querySelector('[data-attribute="sowhatbuy-card-basic__specification"]');
      if (specificationEl) {
        specificationEl.innerHTML = updatedData.specification || '';
      }
    }

    if (updatedData.box) {
      const boxTitleEl = container.querySelector('[data-attribute="sowhatbuy-card-basic__box-title"]');
      if (boxTitleEl) {
        if (updatedData.box.title !== undefined) {
          boxTitleEl.textContent = updatedData.box.title || '';
        }
        if (updatedData.box.titleBackgroundColor !== undefined) {
          boxTitleEl.setAttribute('data-background', updatedData.box.titleBackgroundColor);
          boxTitleEl.style.backgroundColor = updatedData.box.titleBackgroundColor;
        }
        if (updatedData.box.titleTextColor !== undefined) {
          boxTitleEl.setAttribute('data-text-color', updatedData.box.titleTextColor);
          boxTitleEl.style.color = updatedData.box.titleTextColor;
        }
      }

      if (updatedData.box.items) {
        const boxListEl = container.querySelector('[data-attribute="sowhatbuy-card-basic__box-list"]');
        if (boxListEl) {
          boxListEl.innerHTML = (updatedData.box.items || [])
            .map(
              text => `
              <li data-attribute="sowhatbuy-card-basic__box-item">${text || ''}</li>
            `,
            )
            .join('');
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionSowhatbuyGuaranteeMarquee(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const updateHeaderIcon = (side, iconData) => {
      if (!iconData) return;
      const wrapEl = container.querySelector(`[data-attribute="sowhatbuy-guarantee-marquee__header-icon-${side}"]`);
      if (!wrapEl) return;

      if (iconData.show !== undefined) {
        const show = iconData.show !== false;
        wrapEl.setAttribute('data-show', show ? 'true' : 'false');
        wrapEl.style.display = show ? '' : 'none';
      }
      if (iconData.sizeDesktop !== undefined) {
        wrapEl.setAttribute('data-icon-size-desktop', String(iconData.sizeDesktop));
        wrapEl.style.setProperty('--icon-size-desktop', `${iconData.sizeDesktop}px`);
      }
      if (iconData.sizeMobile !== undefined) {
        wrapEl.setAttribute('data-icon-size-mobile', String(iconData.sizeMobile));
        wrapEl.style.setProperty('--icon-size-mobile', `${iconData.sizeMobile}px`);
      }
      if (iconData.src !== undefined) {
        const imgEl = wrapEl.querySelector(`[data-attribute="sowhatbuy-guarantee-marquee__header-icon-${side}-img"]`);
        if (imgEl) imgEl.setAttribute('src', iconData.src || '');
      }
    };

    if (updatedData.header) {
      if (updatedData.header.title !== undefined) {
        const titleEl = container.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__header-title"]');
        if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
      }
      updateHeaderIcon('left', updatedData.header.iconLeft);
      updateHeaderIcon('right', updatedData.header.iconRight);
    }

    if (updatedData.marquee && updatedData.marquee.items !== undefined) {
      const items = updatedData.marquee.items || [];
      const renderMarqueeItem = item => `
        <div data-attribute="sowhatbuy-guarantee-marquee__marquee-item" class="sowhatbuy-guarantee-marquee__marquee-item">
          <div class="sowhatbuy-guarantee-marquee__marquee-icon">
            <img
              data-attribute="sowhatbuy-guarantee-marquee__marquee-item-icon"
              src="${item.icon || ''}"
              alt=""
            />
          </div>
          <div data-attribute="sowhatbuy-guarantee-marquee__marquee-item-text" class="sowhatbuy-guarantee-marquee__marquee-text">
            ${item.text || ''}
          </div>
        </div>
      `;
      const itemHtml = items.map(renderMarqueeItem).join('');

      const trackEl = container.querySelector('[data-attribute="sowhatbuy-guarantee-marquee__marquee-track"]');
      if (trackEl) {
        trackEl.innerHTML = itemHtml;
      }
    }

    return container.innerHTML.trim();
  },

  sectionSowhatbuyFeatureSlider(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.header && updatedData.header.title !== undefined) {
      const titleEl = container.querySelector('[data-attribute="sowhatbuy-features-slider__title"]');
      if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector(
        '[data-attribute="sowhatbuy-features-slider__slider-wrap"] [data-attribute="wrap-button"]',
      );
      if (wrapButtonEl) {
        updateButtonBasic(wrapButtonEl, updatedData.button);
      }
    }

    if (updatedData.items) {
      const items = updatedData.items || [];

      const renderTab = (item, index) => `
        <button
          type="button"
          class="sowhatbuy-features-slider__tab${index === 0 ? ' active' : ''}"
          data-attribute="sowhatbuy-features-slider__tab"
          data-index="${index}"
          data-active="${index === 0 ? 'true' : 'false'}"
        >${item.tabLabel || ''}</button>
      `;

      const renderSlide = item => `
        <div class="swiper-slide" data-attribute="sowhatbuy-features-slider__slide">
          <div class="sowhatbuy-features-slider__card" data-attribute="sowhatbuy-features-slider__card">
            <div class="sowhatbuy-features-slider__card-image-wrap">
              <img
                loading="lazy"
                data-attribute="sowhatbuy-features-slider__card-image"
                src="${item.image || ''}"
                alt=""
              />
            </div>
            <div class="sowhatbuy-features-slider__card-body">
              <div
                class="sowhatbuy-features-slider__card-title"
                data-attribute="sowhatbuy-features-slider__card-title"
              >${item.title || ''}</div>
              <div
                class="sowhatbuy-features-slider__card-description"
                data-attribute="sowhatbuy-features-slider__card-description"
              >${item.description || ''}</div>
            </div>
          </div>
        </div>
      `;

      const tabsEl = container.querySelector('[data-attribute="sowhatbuy-features-slider__tabs"]');
      if (tabsEl) {
        tabsEl.innerHTML = items.map(renderTab).join('\n');
      }

      const listEl = container.querySelector('[data-attribute="sowhatbuy-features-slider__list"]');
      if (listEl) {
        listEl.innerHTML = items.map(renderSlide).join('\n');
      }
    }

    return container.innerHTML.trim();
  },

  sectionSowhatbuyReward(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const updateHeaderIcon = (side, iconData) => {
      if (!iconData) return;
      const wrapEl = container.querySelector(`[data-attribute="sowhatbuy-reward__header-icon-${side}"]`);
      if (!wrapEl) return;

      if (iconData.show !== undefined) {
        const show = iconData.show !== false;
        wrapEl.setAttribute('data-show', show ? 'true' : 'false');
        wrapEl.style.display = show ? '' : 'none';
      }
      if (iconData.src !== undefined) {
        const imgEl = wrapEl.querySelector(`[data-attribute="sowhatbuy-reward__header-icon-${side}-img"]`);
        if (imgEl) imgEl.setAttribute('src', iconData.src || '');
      }
    };

    if (updatedData.background) {
      const contentEl = container.querySelector('[data-attribute="sowhatbuy-reward-content"]');
      if (contentEl) {
        if (updatedData.background.desktop !== undefined) {
          contentEl.setAttribute('data-background-image-desktop', updatedData.background.desktop || '');
          contentEl.style.setProperty(
            '--bg-desktop',
            updatedData.background.desktop ? `url(${updatedData.background.desktop})` : 'none',
          );
        }
        if (updatedData.background.mobile !== undefined) {
          contentEl.setAttribute('data-background-image-mobile', updatedData.background.mobile || '');
          contentEl.style.setProperty(
            '--bg-mobile',
            updatedData.background.mobile ? `url(${updatedData.background.mobile})` : 'none',
          );
        }
      }
    }

    if (updatedData.header) {
      if (updatedData.header.title !== undefined) {
        const titleEl = container.querySelector('[data-attribute="sowhatbuy-reward__header-title"]');
        if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
      }
      updateHeaderIcon('left', updatedData.header.iconLeft);
      updateHeaderIcon('right', updatedData.header.iconRight);
    }

    if (updatedData.description !== undefined) {
      const descEl = container.querySelector('[data-attribute="sowhatbuy-reward__desc"]');
      if (descEl) descEl.innerHTML = updatedData.description || '';
    }

    if (updatedData.signature) {
      const signatureEl = container.querySelector('[data-attribute="sowhatbuy-reward__signature"]');
      if (signatureEl) {
        if (updatedData.signature.show !== undefined) {
          const show = updatedData.signature.show !== false;
          signatureEl.setAttribute('data-show', show ? 'true' : 'false');
          signatureEl.style.display = show ? '' : 'none';
        }
        if (updatedData.signature.src !== undefined) {
          const imgEl = signatureEl.querySelector('[data-attribute="sowhatbuy-reward__signature-img"]');
          if (imgEl) imgEl.setAttribute('src', updatedData.signature.src || '');
        }
      }
    }

    if (updatedData.items) {
      const items = updatedData.items || [];
      const renderStatItem = item => `
        <div class="sowhatbuy-reward__stat-item" data-attribute="sowhatbuy-reward__stat-item">
          <div class="sowhatbuy-reward__stat-value" data-attribute="sowhatbuy-reward__stat-value">${item.value ||
            ''}</div>
          <div class="sowhatbuy-reward__stat-label">
            <img data-attribute="sowhatbuy-reward__stat-icon" src="${item.icon || ''}" alt="" />
            <span class="sowhatbuy-reward__stat-label-text" data-attribute="sowhatbuy-reward__stat-label-text">${item.label ||
              ''}</span>
          </div>
        </div>
      `;

      const statsEl = container.querySelector('[data-attribute="sowhatbuy-reward__stats"]');
      if (statsEl) {
        statsEl.innerHTML = items.map(renderStatItem).join('\n');
      }
    }

    return container.innerHTML.trim();
  },

  sectionSowhatbuyCardImage(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const updateTag = (key, tagData) => {
      if (!tagData) return;
      const tagEl = container.querySelector(`[data-attribute="sowhatbuy-card-image__tag-${key}"]`);
      if (!tagEl) return;

      if (tagData.show !== undefined) {
        const show = tagData.show !== false;
        tagEl.setAttribute('data-show', show ? 'true' : 'false');
        tagEl.style.display = show ? '' : 'none';
      }
      if (tagData.bgImage !== undefined) {
        tagEl.setAttribute('data-bg-image', tagData.bgImage || '');
        tagEl.style.backgroundImage = tagData.bgImage ? `url(${tagData.bgImage})` : 'none';
      }
      if (tagData.text !== undefined) {
        const textEl = tagEl.querySelector(`[data-attribute="sowhatbuy-card-image__tag-${key}-text"]`);
        if (textEl) textEl.textContent = tagData.text || '';
      }
    };

    if (updatedData.header !== undefined) {
      const headerEl = container.querySelector('[data-attribute="sowhatbuy-card-image__header"]');
      if (headerEl) headerEl.innerHTML = updatedData.header || '';
    }

    if (updatedData.tags) {
      updateTag('brightness', updatedData.tags.brightness);
      updateTag('led', updatedData.tags.led);
    }

    if (updatedData.boxes) {
      const items = updatedData.boxes || [];
      const renderBox = item => `
        <div class="sowhatbuy-card-image__box" data-attribute="sowhatbuy-card-image__box">
          <div
            class="sowhatbuy-card-image__box-label"
            data-attribute="sowhatbuy-card-image__box-label"
          >${item.label || ''}</div>
        </div>
      `;

      const boxesEl = container.querySelector('[data-attribute="sowhatbuy-card-image__boxes"]');
      if (boxesEl) {
        boxesEl.innerHTML = items.map(renderBox).join('\n');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardBannerSowhatbuy(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.bannerImage) {
      const wrapCardEl = container.querySelector('[data-attribute="wrap-card"]');
      if (wrapCardEl) {
        const useBannerMobile = updatedData.bannerImage.useBannerMobile !== false;
        wrapCardEl.setAttribute('data-use-banner-mobile', useBannerMobile ? 'true' : 'false');

        const desktopUrl = updatedData.bannerImage.bannerDesktop || '';
        wrapCardEl.setAttribute('data-banner-desktop', desktopUrl);
        wrapCardEl.style.setProperty('--banner-desktop', `url('${desktopUrl}')`);
      }

      const bannerMobileImgEl = container.querySelector('[data-attribute="banner-mobile-image"]');
      if (bannerMobileImgEl) {
        bannerMobileImgEl.setAttribute('src', updatedData.bannerImage.bannerMobile || '');
      }
    }

    if (updatedData.wrapContent) {
      const wrapContentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (wrapContentEl) {
        const width = updatedData.wrapContent.widthContent || 1000;
        wrapContentEl.setAttribute('data-width-content', `${width}px`);
        wrapContentEl.style.setProperty('--width-content', `${width}px`);
      }
    }

    if (updatedData.titleBanner) {
      const titleBannerEl = container.querySelector('[data-attribute="title-banner"]');
      if (titleBannerEl) {
        titleBannerEl.innerHTML = updatedData.titleBanner.content || '';
      }
    }

    if (updatedData.keyBenefits) {
      const listKeybenefitsEl = container.querySelector('[data-attribute="list-keybenefits"]');
      if (listKeybenefitsEl) {
        const show = updatedData.keyBenefits.show !== false;
        listKeybenefitsEl.setAttribute('data-show', show ? 'true' : 'false');
        listKeybenefitsEl.style.display = show ? '' : 'none';

        if (updatedData.keyBenefits.items) {
          listKeybenefitsEl.innerHTML = (updatedData.keyBenefits.items || [])
            .map(
              item => `
                <div data-attribute="item-benefit" class="item-benefit">
                  <div class="icon-benefit">
                    <img data-attribute="icon-benefit" src="${item.icon || ''}" alt="">
                  </div>
                  <div data-attribute="text-benefit" class="text-benefit">
                    ${item.text || ''}
                  </div>
                </div>
              `,
            )
            .join('\n');
        }
      }
    }

    if (updatedData.button) {
      const btnCtaBannerEl = container.querySelector('[data-attribute="btn-cta-banner"]');
      if (btnCtaBannerEl) {
        const show = updatedData.button.show !== false;
        const showDiscount = updatedData.button.showDiscount !== false;
        btnCtaBannerEl.setAttribute('data-show', show ? 'true' : 'false');
        btnCtaBannerEl.setAttribute('data-show-discount', showDiscount ? 'true' : 'false');
        btnCtaBannerEl.style.display = show ? '' : 'none';
        btnCtaBannerEl.setAttribute('href', updatedData.button.href || '');

        const bgButton = updatedData.button.bgButton || '#c75023';
        const colorButton = updatedData.button.colorButton || '#ffffff';
        btnCtaBannerEl.setAttribute('data-bg-button', bgButton);
        btnCtaBannerEl.setAttribute('data-color-button', colorButton);
        btnCtaBannerEl.style.setProperty('--bg-button', bgButton);
        btnCtaBannerEl.style.setProperty('--color-button', colorButton);

        const valueDiscountEl = btnCtaBannerEl.querySelector('[data-attribute="value-discount"]');
        if (valueDiscountEl) {
          valueDiscountEl.innerHTML = updatedData.button.valueDiscount || '';
        }

        const textBtnEl = btnCtaBannerEl.querySelector('[data-attribute="text-button"]');
        if (textBtnEl) {
          textBtnEl.innerHTML = updatedData.button.text || '';
        }

        const iconBtnEl = btnCtaBannerEl.querySelector('[data-attribute="icon-btn"]');
        if (iconBtnEl) {
          const showIcon = updatedData.button.showIcon !== false;
          iconBtnEl.setAttribute('data-show', showIcon ? 'true' : 'false');
          iconBtnEl.style.display = showIcon ? '' : 'none';

          const imgEl = iconBtnEl.querySelector('img');
          if (imgEl) {
            imgEl.setAttribute('src', updatedData.button.icon || '');
          }
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardItemsSowhatbuy(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="item" class="item">
                <div class="wrap-image-item">
                  <img data-attribute="image-item" src="${item.image || ''}" alt="${item.alt || ''}">
                </div>
                <div data-attribute="info-item" class="info-item">
                  ${item.info || ''}
                </div>
              </div>
            `,
          )
          .join('\n');
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardCompareSowhatbuy(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.wrapContent) {
      const wrapContentEl = container.querySelector('[data-attribute="wrap-content"]');
      if (wrapContentEl) {
        const bgContent = updatedData.wrapContent.bgContent || '#1c150c';
        const colorText = updatedData.wrapContent.colorText || '#ffffff';
        wrapContentEl.setAttribute('data-bg-content', bgContent);
        wrapContentEl.setAttribute('data-color-text', colorText);
        wrapContentEl.style.setProperty('--bg-content', bgContent);
        wrapContentEl.style.setProperty('--color-text', colorText);
      }
    }

    if (updatedData.leftCard) {
      const leftCardEl = container.querySelector('[data-attribute="left-card"]');
      if (leftCardEl) {
        const useVideo = updatedData.leftCard.useVideo !== false;
        leftCardEl.setAttribute('data-use-vide', useVideo ? 'true' : 'false');
        leftCardEl.setAttribute('data-order', String(updatedData.leftCard.order || 1));
        leftCardEl.style.setProperty('--order-media', String(updatedData.leftCard.order || 1));

        const wrapVideoEl = leftCardEl.querySelector('.wrap-video');
        const wrapImgEl = leftCardEl.querySelector('.wrap-img');
        if (wrapVideoEl) wrapVideoEl.style.display = useVideo ? '' : 'none';
        if (wrapImgEl) wrapImgEl.style.display = useVideo ? 'none' : '';

        const videoEl = leftCardEl.querySelector('video');
        if (videoEl) {
          videoEl.setAttribute('src', updatedData.leftCard.videoSrc || '');
        }

        const imgEl = leftCardEl.querySelector('.wrap-img img');
        if (imgEl) {
          imgEl.setAttribute('src', updatedData.leftCard.imageSrc || '');
          imgEl.setAttribute('alt', updatedData.leftCard.imageAlt || '');
        }

        const listBenefitsEl = leftCardEl.querySelector('[data-attribute="list-benefits"]');
        if (listBenefitsEl && updatedData.leftCard.benefits) {
          listBenefitsEl.innerHTML = (updatedData.leftCard.benefits || [])
            .map(
              item => `
                <div data-attribute="item-benefit" class="item-benefit">
                  ${item.content || ''}
                </div>
              `,
            )
            .join('\n');
        }
      }
    }

    if (updatedData.rightCard) {
      const rightCardEl = container.querySelector('[data-attribute="right-card"]');
      if (rightCardEl) {
        rightCardEl.setAttribute('data-order', String(updatedData.rightCard.order || 2));
        rightCardEl.style.setProperty('--order-content', String(updatedData.rightCard.order || 2));

        if (updatedData.rightCard.leftCompare) {
          const leftCompareEl = rightCardEl.querySelector('[data-attribute="left-compare"]');
          if (leftCompareEl) {
            const imgEl = leftCompareEl.querySelector('img');
            if (imgEl) {
              imgEl.setAttribute('src', updatedData.rightCard.leftCompare.image || '');
              imgEl.setAttribute('alt', updatedData.rightCard.leftCompare.alt || '');
            }

            const titleEl = leftCompareEl.querySelector('[data-attribute="title-compare-left"]');
            if (titleEl) {
              const color = updatedData.rightCard.leftCompare.color || '#ffffff';
              const bg = updatedData.rightCard.leftCompare.bg || '#535353';
              titleEl.innerHTML =
                (updatedData.rightCard.leftCompare.title || '') + (updatedData.rightCard.leftCompare.title ? ':' : '');
              titleEl.setAttribute('data-color-title-compare-left', color);
              titleEl.setAttribute('data-bg-title-compare-left', bg);
              titleEl.style.setProperty('--color-title-compare-left', color);
              titleEl.style.setProperty('--bg-title-compare-left', bg);
            }
          }
        }

        if (updatedData.rightCard.rightCompare) {
          const rightCompareEl = rightCardEl.querySelector('[data-attribute="right-compare"]');
          if (rightCompareEl) {
            const imgEl = rightCompareEl.querySelector('img');
            if (imgEl) {
              imgEl.setAttribute('src', updatedData.rightCard.rightCompare.image || '');
              imgEl.setAttribute('alt', updatedData.rightCard.rightCompare.alt || '');
            }

            const titleEl = rightCompareEl.querySelector('[data-attribute="title-compare-right"]');
            if (titleEl) {
              const color = updatedData.rightCard.rightCompare.color || '#ffffff';
              const bg = updatedData.rightCard.rightCompare.bg || '#c75023';
              titleEl.innerHTML =
                (updatedData.rightCard.rightCompare.title || '') +
                (updatedData.rightCard.rightCompare.title ? ':' : '');
              titleEl.setAttribute('data-color-title-compare-right', color);
              titleEl.setAttribute('data-bg-title-compare-right', bg);
              titleEl.style.setProperty('--color-title-compare-right', color);
              titleEl.style.setProperty('--bg-title-compare-right', bg);
            }
          }
        }

        if (updatedData.rightCard.textCompareList) {
          const compareByTextEl = rightCardEl.querySelector('.compare-by-text');
          if (compareByTextEl) {
            compareByTextEl.innerHTML = (updatedData.rightCard.textCompareList || [])
              .map(
                item => `
                  <div data-attribute="item-compare-by-text" class="item-compare-by-text">
                    <div class="icon-prefix">
                      <img data-attribute="icon-prefix" src="${item.iconPrefix || ''}" alt="">
                    </div>
                    <div data-attribute="text-compare" class="text-compare">${item.text || ''}</div>
                    <div class="icon-suffix">
                      <img data-attribute="icon-suffix" src="${item.iconSuffix || ''}" alt="">
                    </div>
                  </div>
                `,
              )
              .join('\n');
          }
        }
      }
    }

    if (updatedData.button) {
      const btnCtaBannerEl = container.querySelector('[data-attribute="btn-cta-banner"]');
      if (btnCtaBannerEl) {
        const show = updatedData.button.show !== false;
        btnCtaBannerEl.setAttribute('data-show', show ? 'true' : 'false');
        btnCtaBannerEl.style.display = show ? '' : 'none';
        btnCtaBannerEl.setAttribute('href', updatedData.button.href || '');

        const bgButton = updatedData.button.bgButton || '#c75023';
        const colorButton = updatedData.button.colorButton || '#ffffff';
        btnCtaBannerEl.setAttribute('data-bg-button', bgButton);
        btnCtaBannerEl.setAttribute('data-color-button', colorButton);
        btnCtaBannerEl.style.setProperty('--bg-button', bgButton);
        btnCtaBannerEl.style.setProperty('--color-button', colorButton);

        const showDiscount = updatedData.button.showDiscount !== false;
        btnCtaBannerEl.setAttribute('data-show-discount', showDiscount ? 'true' : 'false');

        const groupDiscountEl = btnCtaBannerEl.querySelector('.group-discount');
        if (groupDiscountEl) {
          groupDiscountEl.style.display = showDiscount ? '' : 'none';
        }

        const valueDiscountEl = btnCtaBannerEl.querySelector('[data-attribute="value-discount"]');
        if (valueDiscountEl) {
          valueDiscountEl.textContent = updatedData.button.valueDiscount || '50';
        }

        const textBtnEl = btnCtaBannerEl.querySelector('[data-attribute="text-button"]');
        if (textBtnEl) {
          textBtnEl.textContent = updatedData.button.text || '';
        }

        const iconBtnEl = btnCtaBannerEl.querySelector('[data-attribute="icon-btn"]');
        if (iconBtnEl) {
          const showIcon = updatedData.button.showIcon !== false;
          iconBtnEl.setAttribute('data-show', showIcon ? 'true' : 'false');
          iconBtnEl.style.display = showIcon ? '' : 'none';

          const imgEl = iconBtnEl.querySelector('img');
          if (imgEl) {
            imgEl.setAttribute('src', updatedData.button.icon || '');
          }
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionTryherReviewGrid(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="tryher-review-grid"]');
    const headerEl = container.querySelector('[data-attribute="tryher-review-grid__header"]');
    const listEl = container.querySelector('[data-attribute="tryher-review-grid__list"]');
    if (rootEl) {
      rootEl.setAttribute('data-card-border-color', updatedData.cardBorderColor);
      rootEl.style.setProperty('--card-border-color', updatedData.cardBorderColor);

      rootEl.setAttribute('data-card-background-color', updatedData.cardBgColor);
      rootEl.style.setProperty('--card-background-color', updatedData.cardBgColor);

      rootEl.setAttribute('data-card-text-color', updatedData.cardTextColor);
      rootEl.style.setProperty('--card-text-color', updatedData.cardTextColor);

      rootEl.setAttribute('data-star-color', updatedData.starColor);
      rootEl.style.setProperty('--star-color', updatedData.starColor);

      rootEl.setAttribute('data-arrow-color', updatedData.arrowColor);
      rootEl.style.setProperty('--arrow-color', updatedData.arrowColor);

      rootEl.setAttribute('data-container-full-width', updatedData.containerFullWidth);

      const { mobile, tablet, desktop } = updatedData.breakpoints;
      rootEl.setAttribute('data-breakpoint-mobile-slides', (mobile && mobile.slidesPerView) || 1);
      rootEl.setAttribute('data-breakpoint-tablet-slides', (tablet && tablet.slidesPerView) || 3);
      rootEl.setAttribute('data-breakpoint-desktop-slides', (desktop && desktop.slidesPerView) || 5);
    }

    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header')) {
      headerEl.innerHTML = updatedData.header || '';
    }

    if (listEl && updatedData.listItem) {
      const starIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.32l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z" /></svg>`;
      listEl.innerHTML = updatedData.listItem
        .map(item => {
          const rating = Math.max(0, Math.min(5, Number(item.rating) || 0));
          return `<div
          data-attribute="tryher-review-grid__item"

          class="swiper-slide"
        >
          <article
            class="tryher-review-grid__card"

          >
            <img
              loading="lazy"
              data-attribute="tryher-review-grid__image"
              class="tryher-review-grid__image"
              src="${item.image || ''}"
              alt="Customer before and after result"
            />
            <div
              data-attribute="tryher-review-grid__stars"
              data-value="${rating}"
              class="tryher-review-grid__stars"
            >
              ${Array(5)
                .fill(starIcon)
                .join('')}
            </div>
            <div
              data-attribute="tryher-review-grid__content"
              class="tryher-review-grid__content"
            >
              ${item.content || ''}
            </div>
          </article>
        </div>
        `;
        })
        .join('');
    }

    return container.innerHTML.trim();
  },

  sectionTryherTimeline(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="tryher-timeline"]');
    const headerEl = container.querySelector('[data-attribute="tryher-timeline__header"]');
    const listEl = container.querySelector('[data-attribute="tryher-timeline__list"]');
    if (rootEl) {
      const colors = [
        ['data-card-background-color', '--card-background-color', updatedData.cardBgColor],
        ['data-card-text-color', '--card-text-color', updatedData.cardTextColor],
        ['data-card-border-color', '--card-border-color', updatedData.cardBorderColor],
        ['data-line-color', '--line-color', updatedData.lineColor],
        ['data-line-border-color', '--line-border-color', updatedData.lineBorderColor],
      ];
      colors.forEach(([attribute, variable, value]) => {
        rootEl.setAttribute(attribute, value || '');
        rootEl.style.setProperty(variable, value || '');
      });
    }
    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header'))
      headerEl.innerHTML = updatedData.header || '';
    if (listEl && Array.isArray(updatedData.listItem)) {
      listEl.innerHTML = updatedData.listItem
        .map(
          (item, index) => `
          <article
            data-attribute="tryher-timeline__item"
            data-position="${index % 2 ? 'left' : 'right'}"
            class="tryher-timeline__item"
          >
            <div data-attribute="tryher-timeline__label" class="tryher-timeline__label">
              ${item.title || ''}
            </div>
            <div class="tryher-timeline__marker" aria-hidden="true"></div>
            <div data-attribute="tryher-timeline__card" class="tryher-timeline__card">
              ${item.content || ''}
            </div>
          </article>
          `,
        )
        .join('');
    }
    return container.innerHTML.trim();
  },
  sectionTryherCardCompare(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="tryher-card-compare"]');
    const headerEl = container.querySelector('[data-attribute="tryher-card-compare__header"]');
    const goodImageEl = container.querySelector('[data-attribute="tryher-card-compare__good-image"]');
    const badImageEl = container.querySelector('[data-attribute="tryher-card-compare__bad-image"]');
    const vsEl = container.querySelector('[data-attribute="tryher-card-compare__vs"]');
    const listEl = container.querySelector('[data-attribute="tryher-card-compare__list"]');
    if (rootEl) {
      rootEl.setAttribute('data-bad-position', updatedData.badPosition || 'right');
      const colors = [
        ['data-card-border-color', '--card-border-color', updatedData.cardBorderColor],
        ['data-card-text-color', '--card-text-color', updatedData.cardTextColor],
        ['data-card-background-color', '--card-background-color', updatedData.cardBackgroundColor],
      ];
      colors.forEach(([attribute, variable, value]) => {
        rootEl.setAttribute(attribute, value || '');
        rootEl.style.setProperty(variable, value || '');
      });
    }
    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header'))
      headerEl.innerHTML = updatedData.header || '';
    if (goodImageEl) goodImageEl.setAttribute('src', updatedData.goodImage || '');
    if (badImageEl) badImageEl.setAttribute('src', updatedData.badImage || '');
    if (vsEl) vsEl.textContent = updatedData.vsText || 'VS';
    if (listEl && Array.isArray(updatedData.listItem)) {
      listEl.innerHTML = updatedData.listItem
        .map(
          item => `
        <div
          data-attribute="tryher-card-compare__item"
          class="tryher-card-compare__item"
        >
          <div
            data-attribute="tryher-card-compare__good"
            class="tryher-card-compare__cell tryher-card-compare__good"
          >
            <span class="tryher-card-compare__icon tryher-card-compare__icon--good"
              >&#10003;</span
            >
            <div class="tryher-card-compare__text">${item.good || ''}</div>
          </div>
          <div
            data-attribute="tryher-card-compare__bad"
            class="tryher-card-compare__cell tryher-card-compare__bad"
          >
            <span class="tryher-card-compare__icon tryher-card-compare__icon--bad"
              >&#215;</span
            >
            <div class="tryher-card-compare__text">${item.bad || ''}</div>
          </div>
        </div>
        `,
        )
        .join('');
    }
    return container.innerHTML.trim();
  },
  sectionTryherCardBasic(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="tryher-card-basic"]');
    const headerEl = container.querySelector('[data-attribute="tryher-card-basic__header"]');
    const contentBoxEl = container.querySelector('[data-attribute="tryher-card-basic__content-box"]');
    const contentEl = container.querySelector('[data-attribute="tryher-card-basic__content"]');
    const imageEl = container.querySelector('[data-attribute="tryher-card-basic__image"]');
    const buttonWrapEl = container.querySelector('[data-attribute="tryher-card-basic__button"]');
    const buttonEl = container.querySelector('[data-attribute="wrap-button"]');

    if (rootEl && updatedData.image) {
      const imagePosition = updatedData.image.position === 'left' ? 'left' : 'right';
      rootEl.setAttribute('data-image-position', imagePosition);
      rootEl.setAttribute('data-container-full-width', updatedData.containerFullWidth);

      rootEl.setAttribute('data-border-color', updatedData.borderColor);
      rootEl.style.setProperty('--border-color', updatedData.borderColor);
    }
    if (headerEl && updatedData.header) {
      const showHeader = updatedData.header.show !== false;
      headerEl.setAttribute('data-show', showHeader ? 'true' : 'false');
      headerEl.style.display = showHeader ? '' : 'none';
      headerEl.innerHTML = updatedData.header.content || '';
    }
    if (contentBoxEl && updatedData.content) {
      const backgroundColor = updatedData.content.backgroundColor || '#FFFFFF';
      const textColor = updatedData.content.textColor || '#000000';
      contentBoxEl.setAttribute('data-background-color', backgroundColor);
      contentBoxEl.setAttribute('data-text-color', textColor);
      contentBoxEl.style.setProperty('--content-background-color', backgroundColor);
      contentBoxEl.style.setProperty('--content-text-color', textColor);
    }
    if (contentEl && updatedData.content) contentEl.innerHTML = updatedData.content.html || '';
    if (imageEl && updatedData.image) imageEl.setAttribute('src', updatedData.image.src || '');
    if (buttonWrapEl) {
      const position = ['left', 'center', 'right'].includes(updatedData.buttonPosition)
        ? updatedData.buttonPosition
        : 'center';
      buttonWrapEl.setAttribute('data-position', position);
    }
    if (buttonEl && updatedData.button) updateButtonBasic(buttonEl, updatedData.button);

    return container.innerHTML.trim();
  },

  sectionTryherGridPercent(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="tryher-grid-percent"]');
    const headerEl = container.querySelector('[data-attribute="tryher-grid-percent__header"]');
    const listEl = container.querySelector('[data-attribute="tryher-grid-percent__list"]');

    if (rootEl) {
      const colors = [
        ['data-card-background-color', '--card-background-color', updatedData.cardBgColor || '#FFFFFF'],
        ['data-card-text-color', '--card-text-color', updatedData.cardTextColor || '#000000'],
        ['data-percent-line-color', '--percent-line-color', updatedData.percentLineColor || '#FF6099'],
        ['data-percent-text-color', '--percent-text-color', updatedData.percentTextColor || '#FFFFFF'],
      ];
      colors.forEach(([attribute, property, value]) => {
        rootEl.setAttribute(attribute, value);
        rootEl.style.setProperty(property, value);
      });
      rootEl.setAttribute('data-container-full-width', updatedData.containerFullWidth ? 'true' : 'false');

      const breakpoints = updatedData.breakpoints || {};
      rootEl.setAttribute(
        'data-breakpoint-mobile-slides',
        (breakpoints.mobile && breakpoints.mobile.slidesPerView) || 1.5,
      );
      rootEl.setAttribute(
        'data-breakpoint-tablet-slides',
        (breakpoints.tablet && breakpoints.tablet.slidesPerView) || 2,
      );
      rootEl.setAttribute(
        'data-breakpoint-desktop-slides',
        (breakpoints.desktop && breakpoints.desktop.slidesPerView) || 5,
      );
    }

    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header')) {
      headerEl.innerHTML = updatedData.header || '';
    }

    if (listEl && updatedData.listItem) {
      listEl.innerHTML = updatedData.listItem
        .map(item => {
          const percent = Math.max(0, Math.min(100, Number(item.percent) || 0));
          return `<div data-attribute="tryher-grid-percent__item" class="swiper-slide">
            <article class="tryher-grid-percent__card">
              <div class="tryher-grid-percent__media">
                <img
                  loading="lazy"
                  data-attribute="tryher-grid-percent__image"
                  class="tryher-grid-percent__image"
                  src="${item.image || ''}"
                  alt="Customer visible result"
                />
                <div data-attribute="tryher-grid-percent__percent" data-value="${percent}" class="tryher-grid-percent__percent">
                  <svg viewBox="0 0 64 64" aria-hidden="true">
                    <circle class="tryher-grid-percent__percent-track" cx="32" cy="32" r="28" pathLength="100"></circle>
                    <circle class="tryher-grid-percent__percent-value" cx="32" cy="32" r="28" pathLength="100" stroke-dasharray="${percent} 100"></circle>
                  </svg>
                  <strong data-attribute="tryher-grid-percent__percent-text">${percent}%</strong>
                </div>
              </div>
              <div data-attribute="tryher-grid-percent__content" class="tryher-grid-percent__content">${item.content ||
                ''}</div>
            </article>
          </div>`;
        })
        .join('');
    }

    return container.innerHTML.trim();
  },

  sectionImageWithTextCol1(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.cardImage) {
      const cardImageEl = container.querySelector('[data-attribute="card-image"]');
      if (cardImageEl) {
        cardImageEl.setAttribute('src', updatedData.cardImage.src || '');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionSideBySideGridIcon(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.leftCard) {
      const leftCardEl = container.querySelector('[data-attribute="left-card"] img');
      if (leftCardEl) {
        leftCardEl.setAttribute('src', updatedData.leftCard.src || '');
      }
    }

    if (updatedData.rightCard) {
      const titleEl = container.querySelector('[data-attribute="text-right-card"]');
      if (titleEl) {
        titleEl.innerHTML = updatedData.rightCard.title || '';
      }
    }

    if (updatedData.listIcons) {
      const listIconEl = container.querySelector('[data-attribute="list-icon"]');
      if (listIconEl) {
        listIconEl.innerHTML = (updatedData.listIcons || [])
          .map(item => {
            return `
              <div class="item-icon" data-attribute="item-icon" data-use-icon-svg="${item.useIconSvg || false}">
                <div class="wrap-icon-image" data-attribute="wrap-icon-image" style="display: ${
                  item.useIconSvg ? 'none' : 'block'
                }">
                  ${
                    item.useIconSvg
                      ? ''
                      : `
                    <img
                      data-attribute="icon"
                      src="${item.icon || ''}"
                    />
                  `
                  }
                </div>
                <div class="wrap-icon-svg" data-attribute="wrap-icon-svg" style="display: ${
                  item.useIconSvg ? 'block' : 'none'
                }">
                  ${item.useIconSvg ? item.iconSvg : ''}
                </div>
                <div data-attribute="text-item">${item.text}</div>
              </div>
              `;
          })
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionLeonieandcoReviewGrid(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="leonieandco-review-grid"]');
    const headerEl = container.querySelector('[data-attribute="leonieandco-review-grid__header"]');
    const tabsEl = container.querySelector('[data-attribute="leonieandco-review-grid__tabs"]');
    const listEl = container.querySelector('[data-attribute="leonieandco-review-grid__list"]');
    const escapeHtml = value =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    if (rootEl) {
      if (Object.prototype.hasOwnProperty.call(updatedData, 'starColor')) {
        const starColor = updatedData.starColor || '#00B979';
        rootEl.setAttribute('data-star-color', starColor);
        rootEl.style.setProperty('--leonieandco-star-color', starColor);
      }
      if (Object.prototype.hasOwnProperty.call(updatedData, 'tabHeaderColor')) {
        const tabHeaderColor = updatedData.tabHeaderColor || '#772647';
        rootEl.setAttribute('data-tab-header-color', tabHeaderColor);
        rootEl.style.setProperty('--leonieandco-tab-header-color', tabHeaderColor);
      }

      if (Object.prototype.hasOwnProperty.call(updatedData, 'contentBackground')) {
        const contentBackground = updatedData.contentBackground || '#772647';
        rootEl.setAttribute('data-content-background', contentBackground);
        rootEl.style.setProperty('--leonieandco-content-background', contentBackground);
      }
    }

    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header')) {
      headerEl.innerHTML = updatedData.header || '';
    }

    if (tabsEl && listEl && Array.isArray(updatedData.listItem)) {
      const starIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.32l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z" /></svg>`;
      tabsEl.innerHTML = updatedData.listItem
        .map(
          (item, index) => `<button
            type="button"
            class="leonieandco-review-grid__tab${index === 0 ? ' active' : ''}"
            data-attribute="leonieandco-review-grid__tab"
            data-index="${index}"
            data-active="${index === 0 ? 'true' : 'false'}"
          >${escapeHtml(item.header)}</button>`,
        )
        .join('');

      listEl.innerHTML = updatedData.listItem
        .map(item => {
          const rating = Math.max(1, Math.min(5, Number(item.rating) || 5));
          return `<div class="swiper-slide" data-attribute="leonieandco-review-grid__item">
            <article class="leonieandco-review-grid__review">
              <img
                loading="lazy"
                class="leonieandco-review-grid__image"
                data-attribute="leonieandco-review-grid__image"
                src="${escapeHtml(item.image)}"
                alt="Leonie and Co customer before and after result"
              />
              <div class="leonieandco-review-grid__review-body">
                <div
                  class="leonieandco-review-grid__stars"
                  data-attribute="leonieandco-review-grid__stars"
                  data-value="${rating}"
                >${Array(5)
                  .fill(starIcon)
                  .join('')}</div>
                <div
                  class="leonieandco-review-grid__value"
                  data-attribute="leonieandco-review-grid__value"
                >${item.value || ''}</div>
              </div>
            </article>
          </div>`;
        })
        .join('');
    }

    return container.innerHTML.trim();
  },

  sectionCedrowFreetypeContent(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.pills && Array.isArray(updatedData.pills)) {
      const wrapPillEl = container.querySelector('[data-attribute="wrap-pill"]');
      if (wrapPillEl) {
        wrapPillEl.innerHTML = updatedData.pills
          .map(
            pill => `
            <div data-attribute="pill-item" class="pill-item">
              <div class="icon" style="display: ${pill.icon ? 'flex' : 'none !important'}">
                <img
                  data-attribute="icon-pill"
                  src="${pill.icon || ''}"
                  alt=""
                />
              </div>
              <span data-attribute="content-pill" class="content">${pill.content || ''}</span>
            </div>
          `,
          )
          .join('');
      }
    }

    if (Object.prototype.hasOwnProperty.call(updatedData, 'showPills')) {
      const wrapPillEl = container.querySelector('[data-attribute="wrap-pill"]');
      if (wrapPillEl) {
        const show = updatedData.showPills !== false;
        wrapPillEl.setAttribute('data-show', show ? 'true' : 'false');
        wrapPillEl.style.display = show ? '' : 'none';
      }
    }

    if (updatedData.pillStyles) {
      const wrapPillEl = container.querySelector('[data-attribute="wrap-pill"]');
      if (wrapPillEl) {
        const styles = updatedData.pillStyles;
        const borderRadius =
          typeof styles.borderRadius === 'number' ? `${styles.borderRadius}px` : styles.borderRadius || '10px';
        const styleStr = `--border-radius: ${borderRadius}; --border-background: ${styles.borderBackground ||
          '#ffffff33'}; --text-color-pill: ${styles.textColorPill ||
          '#ffffff'}; --background-color-pill: ${styles.backgroundColorPill || '#ffffff1a'};`;
        wrapPillEl.setAttribute('style', styleStr);
      }
    }

    if (Object.prototype.hasOwnProperty.call(updatedData, 'sectionContent')) {
      const sectionContentEl = container.querySelector('[data-attribute="section-content"]');
      if (sectionContentEl) {
        sectionContentEl.innerHTML = updatedData.sectionContent || '';
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionCardCedrowWithTab(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    const listTabHeaderEl = container.querySelector('[data-attribute="list-tab-header"]');
    const listTabContentEl = container.querySelector('[data-attribute="list-tab-content"]');
    const listTab = updatedData.listTab || [];

    if (listTabHeaderEl) {
      const colorTabHeader = updatedData.colorTabHeader || '#214a88';
      const colorTabHeaderHover = updatedData.colorTabHeaderHover || '#ffffff';
      const bgTabHeaderHover = updatedData.bgTabHeaderHover || '#214a88';
      listTabHeaderEl.setAttribute('data-color-tab-header', colorTabHeader);
      listTabHeaderEl.setAttribute('data-color-tab-header-hover', colorTabHeaderHover);
      listTabHeaderEl.setAttribute('data-bg-tab-header-hover', bgTabHeaderHover);
      listTabHeaderEl.style.setProperty('--color-tab-header', colorTabHeader);
      listTabHeaderEl.style.setProperty('--color-tab-header-hover', colorTabHeaderHover);
      listTabHeaderEl.style.setProperty('--bg-tab-header-hover', bgTabHeaderHover);

      listTabHeaderEl.innerHTML = listTab
        .map((tab, idx) => {
          const isActive = idx === 0 ? 'active' : '';
          return `<div class="tab-header-item ${isActive}" data-tab="${
            tab.tabId
          }" data-attribute="tab-header-item">${tab.headerLabel || ''}</div>`;
        })
        .join('\n');
    }

    if (listTabContentEl) {
      listTabContentEl.innerHTML = listTab
        .map((tab, idx) => {
          const isActive = idx === 0 ? 'active' : '';
          const listChildItemShow = tab.listChildItemShow !== false;

          const childItemsHtml = (tab.childItems || [])
            .map(
              child => `
                <div class="child-item">
                  <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                    <img data-attribute="icon-child-item" src="${child.icon || ''}" alt="">
                  </div>
                  <div data-attribute="text-child-item" class="text-child-item">${child.text || ''}</div>
                </div>
              `,
            )
            .join('\n');

          const buttonHtml = buttonPrimaryHtml(tab.button || {});

          return `
            <div data-tab="${tab.tabId}" data-attribute="tab-content-item" class="tab-content-item ${isActive}">
              <div class="wrapper-item">
                <div data-attribute="left-item" class="left-item">
                  <div data-attribute="text-header-item" class="text-header-item">
                    ${tab.headingContent || ''}
                  </div>
                  <div data-show="${
                    listChildItemShow ? 'true' : 'false'
                  }" class="list-child-item" data-attribute="list-child-item" style="${
            listChildItemShow ? '' : 'display: none;'
          }">
                    ${childItemsHtml}
                  </div>
                  <div class="wrap-btn-rivoneed">${buttonHtml}</div>
                </div>
                <div data-attribute="right-item" class="right-item">
                  <img data-attribute="right-image" src="${tab.rightImage || ''}" alt="">
                </div>
              </div>
            </div>
          `;
        })
        .join('\n');
    }

    return container.innerHTML.trim();
  },

  sectionCardCedrowSideBySide(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.mediaPosition !== undefined || updatedData.centerY !== undefined) {
      const wrapImgWithTextEl = container.querySelector('[data-attribute="wrap-img-with-text"]');
      if (wrapImgWithTextEl) {
        if (updatedData.mediaPosition !== undefined) {
          wrapImgWithTextEl.setAttribute('data-media-position', updatedData.mediaPosition);
          const leftCardEl = wrapImgWithTextEl.querySelector('[data-attribute="left-card-media"]');
          if (leftCardEl) {
            const orderLeft = updatedData.mediaPosition === 'left' ? '1' : '2';
            leftCardEl.setAttribute('data-order-left', orderLeft);
            leftCardEl.style.setProperty('--order-left', orderLeft);
          }
        }
        if (updatedData.centerY !== undefined) {
          wrapImgWithTextEl.setAttribute('data-center-y', updatedData.centerY ? 'true' : 'false');
        }
      }
    }

    if (updatedData.mediaType) {
      const leftCardMediaEl = container.querySelector('[data-attribute="left-card-media"]');
      if (leftCardMediaEl) {
        leftCardMediaEl.setAttribute('data-media-type', updatedData.mediaType);
        const wrapVideoEl = leftCardMediaEl.querySelector('[data-attribute="wrap-video"]');
        const wrapImageEl = leftCardMediaEl.querySelector('[data-attribute="wrap-image"]');
        if (wrapVideoEl) {
          wrapVideoEl.style.display = updatedData.mediaType === 'video' ? '' : 'none';
        }
        if (wrapImageEl) {
          wrapImageEl.style.display = updatedData.mediaType === 'image' ? '' : 'none';
        }
      }
    }

    if (updatedData.video) {
      const videoEl = container.querySelector('[data-attribute="video"]');
      if (videoEl) {
        videoEl.setAttribute('src', updatedData.video.src || '');
      }
    }

    if (updatedData.image) {
      const imageEl = container.querySelector('[data-attribute="image"]');
      if (imageEl) {
        imageEl.setAttribute('src', updatedData.image.src || '');
      }
    }

    if (updatedData.headingText) {
      const headingTextEl = container.querySelector('[data-attribute="heading-text"]');
      if (headingTextEl) {
        const show = updatedData.headingText.show !== false;
        headingTextEl.setAttribute('data-show', show ? 'true' : 'false');
        headingTextEl.style.display = show ? '' : 'none';
        headingTextEl.innerHTML = updatedData.headingText.content || '';
      }
    }

    if (updatedData.ratingBlock) {
      const ratingBlockEl = container.querySelector('[data-attribute="block-social-rating"]');
      if (ratingBlockEl) {
        const show = updatedData.ratingBlock.show !== false;
        ratingBlockEl.setAttribute('data-show', show ? 'true' : 'false');
        ratingBlockEl.style.display = show ? '' : 'none';
        ratingBlockEl.setAttribute('data-color-item-social', updatedData.ratingBlock.colorText || '#000000');
        ratingBlockEl.setAttribute('data-background-item-social', updatedData.ratingBlock.backgroundColor || '#f9fbff');
        ratingBlockEl.style.setProperty('--color-item-social', updatedData.ratingBlock.colorText || '#000000');
        ratingBlockEl.style.setProperty('--bg-item-social', updatedData.ratingBlock.backgroundColor || '#f9fbff');

        const listSocialItemEl = ratingBlockEl.querySelector('[data-attribute="list-social-item"]');
        if (listSocialItemEl) {
          const starSvg = count => {
            let svg = '';
            for (let i = 0; i < count; i++) {
              svg +=
                '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>star</title><path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" fill="currentColor" /></svg>';
            }
            return svg;
          };

          listSocialItemEl.innerHTML = (updatedData.ratingBlock.items || [])
            .map(
              item => `
                <div data-attribute="social-item" class="item-social">
                  <div data-show="${item.showImage ? 'true' : 'false'}" data-attribute="image-social" style="display: ${
                item.showImage ? '' : 'none'
              };">
                    <img src="${item.imageSrc || ''}" alt="">
                  </div>
                  <div data-attribute="title-social" class="title-social">
                    <h3>${item.platformName || ''}</h3>
                  </div>
                  <div data-attribute="rating-text" class="text-reating-social">${item.ratingText || ''}</div>
                  <div data-value="${item.stars || 5}" data-attribute="star-rating" class="stars">
                    ${starSvg(item.stars || 5)}
                  </div>
                </div>
              `,
            )
            .join('\n');
        }
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },

  sectionCardCedrowWithTabel(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.tableEditor) {
      const tableEditorEl = container.querySelector('[data-attribute="table-editor"]');
      if (tableEditorEl) {
        tableEditorEl.innerHTML = updatedData.tableEditor.content || '';
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionCardCedrowBenefitsPolicy(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.blocksBenefits) {
      const blocksBenefitsEl = container.querySelector('[data-attribute="blocks-benefits"]');
      if (blocksBenefitsEl) {
        const useBorder = updatedData.blocksBenefits.useBorder !== false;
        const colorBorder = updatedData.blocksBenefits.colorBorder || '#123123';
        blocksBenefitsEl.setAttribute('data-use-border', useBorder ? 'true' : 'false');
        blocksBenefitsEl.setAttribute('data-color-border', colorBorder);
        blocksBenefitsEl.style.setProperty('--use-border', useBorder ? 'true' : 'false');
        blocksBenefitsEl.style.setProperty('--color-border', colorBorder);
      }
    }

    if (updatedData.titleBenefits !== undefined) {
      const titleBenefitsEl = container.querySelector('[data-attribute="title-benefits"]');
      if (titleBenefitsEl) titleBenefitsEl.textContent = updatedData.titleBenefits || '';
    }

    if (updatedData.blockCompare) {
      const blockCompareEl = container.querySelector('[data-attribute="block-compare"]');
      if (blockCompareEl) {
        const show = updatedData.blockCompare.show !== false;
        blockCompareEl.setAttribute('data-show', show ? 'true' : 'false');
        blockCompareEl.style.display = show ? '' : 'none';

        const before = updatedData.blockCompare.before || {};
        const beforeEl = blockCompareEl.querySelector('[data-attribute="before"]');
        if (beforeEl) {
          const bgBefore = before.backgroundColor || '#fff5f5';
          const textBefore = before.textColor || '#6b7280';
          beforeEl.setAttribute('data-background-color-before', bgBefore);
          beforeEl.setAttribute('data-text-color-before', textBefore);
          beforeEl.style.setProperty('--bg-color-before', bgBefore);
          beforeEl.style.setProperty('--text-color-before', textBefore);

          const titleBeforeEl = beforeEl.querySelector('[data-attribute="title-before"]');
          if (titleBeforeEl) titleBeforeEl.textContent = show ? before.title || '' : '';

          const listItemBeforeEl = beforeEl.querySelector('[data-attribute="list-item-before"]');
          if (!show) {
            listItemBeforeEl.innerHTML = '';
          } else {
            if (listItemBeforeEl) {
              listItemBeforeEl.innerHTML = (before.items || [])
                .map(
                  item => `
                  <div data-attribute="item-before" class="item-label">
                    <div data-attribute="wrap-image-item-before" class="wrap-item-label">
                      <img data-attribute="img-item-before" src="${item.image || ''}" alt="">
                    </div>
                    <div data-attribute="text-item-before" class="text-item-label">${item.text || ''}</div>
                  </div>
                `,
                )
                .join('\n');
            }
          }
        }

        const vs = updatedData.blockCompare.vs || {};
        const vsEl = blockCompareEl.querySelector('[data-attribute="vs"]');
        if (vsEl) {
          const bgVs = vs.backgroundColor || '#00374c';
          const textVs = vs.textColor || '#ffffff';
          vsEl.setAttribute('data-bg-color-vs', bgVs);
          vsEl.setAttribute('data-text-color-vs', textVs);
          vsEl.style.setProperty('--bg-color-vs', bgVs);
          vsEl.style.setProperty('--text-color-vs', textVs);
        }

        const after = updatedData.blockCompare.after || {};
        const afterEl = blockCompareEl.querySelector('[data-attribute="after"]');
        if (afterEl) {
          const bgAfter = after.backgroundColor || '#f3f7fe';
          const textAfter = after.textColor || '#6b7280';
          afterEl.setAttribute('data-background-color-after', bgAfter);
          afterEl.setAttribute('data-text-color-after', textAfter);
          afterEl.style.setProperty('--bg-color-after', bgAfter);
          afterEl.style.setProperty('--text-color-after', textAfter);

          const titleAfterEl = afterEl.querySelector('[data-attribute="title-after"]');
          if (titleAfterEl) titleAfterEl.textContent = show ? after.title || '' : '';

          const listItemAfterEl = afterEl.querySelector('[data-attribute="list-item-after"]');
          if (!show) {
            listItemAfterEl.innerHTML = ``;
          } else {
            if (listItemAfterEl) {
              listItemAfterEl.innerHTML = (after.items || [])
                .map(
                  item => `
                  <div data-attribute="item-after" class="item-label">
                    <div data-attribute="wrap-image-item-after" class="wrap-item-label">
                      <img data-attribute="img-item-after" src="${item.image || ''}" alt="">
                    </div>
                    <div data-attribute="text-item-after" class="text-item-label">${item.text || ''}</div>
                  </div>
                `,
                )
                .join('\n');
            }
          }
        }
      }
    }

    if (updatedData.blockFeature) {
      const blockFeatureEl = container.querySelector('[data-attribute="block-feature"]');
      if (blockFeatureEl) {
        const show = updatedData.blockFeature.show === true;
        blockFeatureEl.setAttribute('data-show', show ? 'true' : 'false');
        blockFeatureEl.style.display = show ? '' : 'none';
        const listItemFeatureEl = blockFeatureEl.querySelector('[data-attribute="list-item-feature"]');
        if (!show) {
          listItemFeatureEl.innerHTML = ``;
        } else {
          if (listItemFeatureEl) {
            listItemFeatureEl.innerHTML = (updatedData.blockFeature.items || [])
              .map(
                item => `
                <div data-attribute="item-feature" class="item-feature">
                  <div data-attribute="wrap-image-item-feature" class="wrap-image-item-feature">
                    <img data-attribute="img-item-feature" src="${item.image || ''}" alt="">
                  </div>
                  <div data-attribute="text-item-feature" class="text-item-feature">${item.content || ''}</div>
                </div>
              `,
              )
              .join('\n');
          }
        }
      }
    }

    if (updatedData.blockFeatureWithIndex) {
      const blockFeatureWithIndexEl = container.querySelector('[data-attribute="block-feature-with-index"]');
      if (blockFeatureWithIndexEl) {
        const show = updatedData.blockFeatureWithIndex.show !== false;
        const bgIndex = updatedData.blockFeatureWithIndex.backgroundColor || '#eef2f3';
        const indexColor = updatedData.blockFeatureWithIndex.indexColor || '#094a59';
        blockFeatureWithIndexEl.setAttribute('data-show', show ? 'true' : 'false');
        blockFeatureWithIndexEl.style.display = show ? '' : 'none';
        blockFeatureWithIndexEl.setAttribute('data-bg-index', bgIndex);
        blockFeatureWithIndexEl.setAttribute('data-color-text-index', indexColor);
        blockFeatureWithIndexEl.style.setProperty('--bg-index', bgIndex);
        blockFeatureWithIndexEl.style.setProperty('--color-text-index', indexColor);
        const listItemFeatureEl = blockFeatureWithIndexEl.querySelector('[data-attribute="list-item-feature"]');

        if (!show) {
          listItemFeatureEl.innerHTML = ``;
        } else {
          if (listItemFeatureEl) {
            listItemFeatureEl.innerHTML = (updatedData.blockFeatureWithIndex.items || [])
              .map(
                item => `
                <div data-attribute="item-feature" class="item-feature">
                  <div data-attribute="index-item-feature">${item.index || ''}</div>
                  <div data-attribute="text-item-feature" class="text-item-feature">${item.content || ''}</div>
                </div>
              `,
              )
              .join('\n');
          }
        }
      }
    }

    if (updatedData.textHint) {
      const textHintEl = container.querySelector('[data-attribute="text-hint"]');
      if (textHintEl) {
        const show = updatedData.textHint.show !== false;
        const bgHint = updatedData.textHint.backgroundColor || '#f3f7fe';
        const textHintColor = updatedData.textHint.textColor || '#6b7280';
        textHintEl.setAttribute('data-show', show ? 'true' : 'false');
        textHintEl.style.display = show ? '' : 'none';
        textHintEl.setAttribute('data-bg-hint', bgHint);
        textHintEl.setAttribute('data-text-hint', textHintColor);
        textHintEl.style.setProperty('--bg-hint', bgHint);
        textHintEl.style.setProperty('--text-hint', textHintColor);
        if (!show) {
          textHintEl.innerHTML = '';
        } else {
          textHintEl.innerHTML = updatedData.textHint.content || '';
        }
      }
    }

    return container.innerHTML.trim();
  },

  sectionCardCedrowGridIcons(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        if (!show) {
          cardTitleEl.innerHTML = '';
        } else {
          cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
        }
      }
    }

    if (updatedData.list) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        const colPerView = Number(updatedData.list.colPerView) || 4;
        listItemEl.setAttribute('data-col-per-view', String(colPerView));
        listItemEl.style.setProperty('--col-per-view', String(colPerView));
      }
    }

    if (updatedData.items) {
      const listItemEl = container.querySelector('[data-attribute="list-item"]');
      if (listItemEl) {
        listItemEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div data-attribute="item" class="item-with-icon">
                <div class="wrap-icon">
                  <img data-attribute="image-item" src="${item.image || ''}" alt="${item.alt || ''}" />
                </div>
                <div data-attribute="text-item" class="text-item">
                  ${item.content || ''}
                </div>
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },

  sectionUpairyTabs(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector("[data-attribute='upairy-tabs']");
    const headerEl = container.querySelector("[data-attribute='upairy-tabs__header']");
    const tabsEl = container.querySelector("[data-attribute='upairy-tabs__tabs']");
    const listEl = container.querySelector("[data-attribute='upairy-tabs__list']");
    const escapeHtml = value =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&#39;');

    if (rootEl) {
      if (Object.prototype.hasOwnProperty.call(updatedData, 'tabHeaderColor')) {
        const tabHeaderColor = updatedData.tabHeaderColor || '#000000';
        rootEl.setAttribute('data-tab-header-color', tabHeaderColor);
        rootEl.style.setProperty('--tab-header-color', tabHeaderColor);
      }
      if (Object.prototype.hasOwnProperty.call(updatedData, 'imageBorderRadius')) {
        const parsedRadius = Number(updatedData.imageBorderRadius);
        const imageBorderRadius = Number.isNaN(parsedRadius) ? 9999 : Math.max(0, parsedRadius);
        rootEl.setAttribute('data-image-border-radius', imageBorderRadius);
        rootEl.style.setProperty('--image-border-radius', `${imageBorderRadius}px`);
      }
      if (Object.prototype.hasOwnProperty.call(updatedData, 'imageWidth')) {
        const parsedWidth = Number(updatedData.imageWidth);
        const imageWidth = Number.isNaN(parsedWidth) ? 296 : Math.max(0, parsedWidth);
        rootEl.setAttribute('data-image-width', imageWidth);
        rootEl.style.setProperty('--image-width', `${imageWidth}px`);
      }
      if (Object.prototype.hasOwnProperty.call(updatedData, 'imagePosition')) {
        rootEl.setAttribute('data-image-position', updatedData.imagePosition === 'right' ? 'right' : 'left');
      }
    }

    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header')) {
      headerEl.innerHTML = updatedData.header || '';
    }

    if (tabsEl && listEl && Array.isArray(updatedData.listItem)) {
      tabsEl.innerHTML = updatedData.listItem
        .map(
          (item, index) => `<div
            class='upairy-tabs__tab${index === 0 ? ' active' : ''}'
            data-attribute='upairy-tabs__tab'
            data-index='${index}'
            data-active='${index === 0 ? 'true' : 'false'}'
          >${escapeHtml(item.header)}</div>`,
        )
        .join('');

      listEl.innerHTML = updatedData.listItem
        .map(item => {
          const media =
            item.mediaType === 'video'
              ? `<video class='upairy-tabs__media' data-attribute='upairy-tabs__video' autoplay muted loop playsinline><source src='${escapeHtml(
                  item.video,
                )}' type='video/mp4' /></video>`
              : `<img loading='lazy' class='upairy-tabs__media' data-attribute='upairy-tabs__image' src='${escapeHtml(
                  item.image,
                )}' alt='Upairy tab media' />`;

          return `<div class='swiper-slide' data-attribute='upairy-tabs__item'>
            <article class='upairy-tabs__content'>
              <div class='upairy-tabs__media-wrapper' data-attribute='upairy-tabs__media-wrapper'>${media}</div>
              <div class='upairy-tabs__body' data-attribute='upairy-tabs__value'>${item.value || ''}</div>
            </article>
          </div>`;
        })
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionUpairyTimeline(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector("[data-attribute='upairy-timeline']");
    const headerEl = container.querySelector("[data-attribute='upairy-timeline__header']");
    const listEl = container.querySelector("[data-attribute='upairy-timeline__list']");
    const imageEl = container.querySelector("[data-attribute='upairy-timeline__image-element']");

    if (rootEl) {
      const lineColor = updatedData.lineColor || '#23873D';
      const parsedLineWidth = Number(updatedData.lineWidth);
      const lineWidth = Number.isNaN(parsedLineWidth) ? 2 : Math.max(1, parsedLineWidth);
      rootEl.setAttribute('data-line-color', lineColor);
      rootEl.setAttribute('data-line-width', lineWidth);
      rootEl.style.setProperty('--line-color', lineColor);
      rootEl.style.setProperty('--line-width', `${lineWidth}px`);
      if (updatedData.image) {
        rootEl.setAttribute('data-image-show', updatedData.image.show === false ? 'false' : 'true');
        rootEl.setAttribute('data-image-position', updatedData.image.position === 'left' ? 'left' : 'right');
      }
    }
    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header')) {
      headerEl.innerHTML = updatedData.header || '';
    }
    if (imageEl && updatedData.image) {
      imageEl.setAttribute('src', updatedData.image.src || '');
      imageEl.setAttribute('alt', updatedData.image.alt || '');
    }
    if (listEl && Array.isArray(updatedData.listItem)) {
      listEl.innerHTML = updatedData.listItem
        .map(
          item => `
            <article class="upairy-timeline__item" data-attribute="upairy-timeline__item">
              <div class="upairy-timeline__marker" aria-hidden="true"></div>
              <div class="upairy-timeline__item-content" data-attribute="upairy-timeline__item-content">
                ${item.content || ''}
              </div>
            </article>
          `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionUpairyCard(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector("[data-attribute='upairy-card']");
    const imageEl = container.querySelector("[data-attribute='upairy-card__image-element']");
    const headerEl = container.querySelector("[data-attribute='upairy-card__header']");
    const listEl = container.querySelector("[data-attribute='upairy-card__list']");
    const footerEl = container.querySelector("[data-attribute='upairy-card__footer']");
    const buttonEl = container.querySelector("[data-attribute='upairy-card__button'] [data-attribute='wrap-button']");
    if (rootEl && updatedData.image) {
      rootEl.setAttribute('data-image-show', updatedData.image.show === false ? 'false' : 'true');
      rootEl.setAttribute('data-image-position', updatedData.image.position === 'right' ? 'right' : 'left');
    }
    if (imageEl && updatedData.image) {
      imageEl.setAttribute('src', updatedData.image.src || '');
      imageEl.setAttribute('alt', updatedData.image.alt || '');
    }
    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header'))
      headerEl.innerHTML = updatedData.header || '';
    if (footerEl && Object.prototype.hasOwnProperty.call(updatedData, 'footer'))
      footerEl.innerHTML = updatedData.footer || '';
    if (buttonEl && updatedData.button) updateButtonBasic(buttonEl, updatedData.button);
    if (listEl && Array.isArray(updatedData.listItem)) {
      listEl.innerHTML = updatedData.listItem
        .map(
          item => `
            <div class="upairy-card__item" data-attribute="upairy-card__item">
              <div class="upairy-card__item-title" data-attribute="upairy-card__item-title">${item.title || ''}</div>
              <div class="upairy-card__item-description" data-attribute="upairy-card__item-description">${item.description ||
                ''}</div>
            </div>
          `,
        )
        .join('');
    }

    return container.innerHTML.trim();
  },

  sectionUpairyCompareCard(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const updateCard = (type, card) => {
      if (!card) return;
      const cardEl = container.querySelector(`[data-attribute='upairy-compare-card__${type}']`);
      const imageEl = container.querySelector(`[data-attribute='upairy-compare-card__${type}-image']`);
      const titleEl = container.querySelector(`[data-attribute='upairy-compare-card__${type}-title']`);
      const listEl = container.querySelector(`[data-attribute='upairy-compare-card__${type}-list']`);
      const backgroundColor = card.backgroundColor || (type === 'good' ? '#4D903F' : '#EAEAEA');
      const titleColor = card.titleColor || (type === 'good' ? '#FFFFFF' : '#242424');
      const itemBackgroundColor = card.itemBackgroundColor || '#FFFFFF';
      const itemTextColor = card.itemTextColor || '#242424';

      if (cardEl) {
        cardEl.setAttribute('data-card-background-color', backgroundColor);
        cardEl.setAttribute('data-title-color', titleColor);
        cardEl.setAttribute('data-item-background-color', itemBackgroundColor);
        cardEl.setAttribute('data-item-text-color', itemTextColor);
        cardEl.style.setProperty('--card-background-color', backgroundColor);
        cardEl.style.setProperty('--card-title-color', titleColor);
        cardEl.style.setProperty('--item-background-color', itemBackgroundColor);
        cardEl.style.setProperty('--item-text-color', itemTextColor);
      }
      if (imageEl && card.image) {
        imageEl.setAttribute('src', card.image.src || '');
        imageEl.setAttribute('alt', card.image.alt || '');
      }
      if (titleEl && Object.prototype.hasOwnProperty.call(card, 'title')) titleEl.innerHTML = card.title || '';
      if (listEl && Array.isArray(card.items)) {
        listEl.innerHTML = card.items
          .map(
            item =>
              `<div class="upairy-compare-card__card-item" data-attribute="upairy-compare-card__${type}-item">${item ||
                ''}</div>`,
          )
          .join('');
      }
    };
    const rootEl = container.querySelector("[data-attribute='upairy-compare-card']");
    const imageEl = container.querySelector("[data-attribute='upairy-compare-card__image-element']");
    const headerEl = container.querySelector("[data-attribute='upairy-compare-card__header']");
    const footerEl = container.querySelector("[data-attribute='upairy-compare-card__footer']");
    const buttonEl = container.querySelector(
      "[data-attribute='upairy-compare-card__button'] [data-attribute='wrap-button']",
    );

    if (rootEl && updatedData.image) {
      rootEl.setAttribute('data-image-show', updatedData.image.show === false ? 'false' : 'true');
      rootEl.setAttribute('data-image-position', updatedData.image.position === 'right' ? 'right' : 'left');
    }
    if (imageEl && updatedData.image) {
      imageEl.setAttribute('src', updatedData.image.src || '');
      imageEl.setAttribute('alt', updatedData.image.alt || '');
    }
    if (headerEl && Object.prototype.hasOwnProperty.call(updatedData, 'header'))
      headerEl.innerHTML = updatedData.header || '';
    if (footerEl && Object.prototype.hasOwnProperty.call(updatedData, 'footer'))
      footerEl.innerHTML = updatedData.footer || '';
    if (buttonEl && updatedData.button) updateButtonBasic(buttonEl, updatedData.button);
    updateCard('good', updatedData.good);
    updateCard('bad', updatedData.bad);

    return container.innerHTML.trim();
  },
  sectionKonfortifyFb(htmlString, updatedData) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${htmlString}</div>`, 'text/html');
    const container = doc.body.firstElementChild;

    const sectionEl = container.querySelector('[data-section]');
    const cardContainer = container.querySelector('[data-attribute="card-container"]');

    for (const key in updatedData) {
      switch (key) {
        case 'title': {
          if (sectionEl) sectionEl.setAttribute('data-title', updatedData[key]);
          break;
        }
        case 'enableAnchor': {
          if (sectionEl) sectionEl.setAttribute('data-enable-anchor', updatedData[key]);
          break;
        }
        case 'padding': {
          if (cardContainer) {
            cardContainer.setAttribute('data-top-padding', updatedData[key].top);
            cardContainer.setAttribute('data-bottom-padding', updatedData[key].bottom);
            cardContainer.style.paddingTop = updatedData[key].top ? '' : '0';
            cardContainer.style.paddingBottom = updatedData[key].bottom ? '' : '0';
          }
          break;
        }
        case 'background-section': {
          if (cardContainer && updatedData[key]?.color) {
            cardContainer.setAttribute('data-background', updatedData[key].color);
            cardContainer.style.backgroundColor = updatedData[key].color;
          }
          break;
        }
        case 'textColor': {
          if (cardContainer) {
            cardContainer.setAttribute('data-text-color', updatedData[key]);
            cardContainer.style.color = updatedData[key];
            cardContainer.style.setProperty('--text-color', updatedData[key]);
          }
          break;
        }
        case 'container-content': {
          const elContainerPage = container.querySelector('[data-attribute="container-page"]');
          if (elContainerPage) {
            elContainerPage.setAttribute('data-show-style', updatedData[key].showStyle);
            elContainerPage.setAttribute('data-background', updatedData[key].background);
            elContainerPage.style.backgroundColor = updatedData[key].showStyle
              ? updatedData[key].background
              : 'transparent';
          }
          break;
        }
        case 'showTitlePost': {
          const titleEl = container.querySelector('[data-attribute="title-post"]');
          if (titleEl) titleEl.setAttribute('data-show', String(updatedData[key] !== false));
          break;
        }
        case 'titlePost': {
          const titleEl = container.querySelector('[data-attribute="title-post"]');
          if (titleEl) titleEl.innerHTML = updatedData[key] || '';
          break;
        }
        case 'listPost': {
          const listPostEl = container.querySelector('[data-attribute="list-post"]');
          if (!listPostEl) break;

          const colPerViewRaw = Number(updatedData[key]?.colPerView);
          const colPerView = Number.isFinite(colPerViewRaw) ? Math.max(1, colPerViewRaw) : 3;
          listPostEl.setAttribute('data-col-per-view', String(colPerView));

          const baseItemHtml = listPostEl.querySelector('.wrap-item')?.outerHTML || '';
          const posts = Array.isArray(updatedData[key]?.listItem) ? updatedData[key].listItem : [];

          listPostEl.innerHTML = posts
            .map(post => {
              const itemDoc = parser.parseFromString(`<div>${baseItemHtml}</div>`, 'text/html');
              const itemEl = itemDoc.body.querySelector('.wrap-item') || itemDoc.body.firstElementChild;
              if (!itemEl) return '';

              const userNameEl = itemEl.querySelector('[data-attribute="user-name"]');
              if (userNameEl) userNameEl.textContent = post?.outherName || '';

              const avatarEl = itemEl.querySelector('[data-attribute="author-avatar"] img');
              if (avatarEl) avatarEl.setAttribute('src', post?.outherAvatar || '');

              const createdAtEl = itemEl.querySelector('[data-attribute="created-at"]');
              if (createdAtEl) createdAtEl.textContent = post?.createdAt || '';

              const postTextEl = itemEl.querySelector('[data-attribute="post-text"]');
              if (postTextEl) postTextEl.textContent = post?.postText || '';

              const postImageEl = itemEl.querySelector('[data-attribute="post-img"] img');
              if (postImageEl) postImageEl.setAttribute('src', post?.postImage || '');

              const commentCountEl = itemEl.querySelector('[data-attribute="comment-count"]');
              if (commentCountEl) commentCountEl.textContent = `${post?.commentCount || '0'}`;

              const reactionCountEl = itemEl.querySelector('[data-attribute="reaction-count"]');
              if (reactionCountEl) reactionCountEl.textContent = `${post?.reactionCount || '0'}`;

              return itemEl.outerHTML;
            })
            .join('');
          break;
        }
        default:
          break;
      }
    }

    return container.innerHTML.trim();
  },
  sectionKonfortifyCardBasic(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="konfortify-card-basic"]');
    const contentBoxEl = container.querySelector('[data-attribute="konfortify-card-basic__content-box"]');
    const contentEl = container.querySelector('[data-attribute="konfortify-card-basic__content"]');
    const mediaEl = container.querySelector('[data-attribute="konfortify-card-basic__media"]');
    const imageEl = container.querySelector('[data-attribute="konfortify-card-basic__image"]');
    const buttonEl = container.querySelector('[data-attribute="wrap-button"]');

    if (rootEl && updatedData.image) {
      const position = updatedData.image.position === 'right' ? 'right' : 'left';
      rootEl.setAttribute('data-image-position', position);
      rootEl.setAttribute('data-image-show', updatedData.image.show !== false ? 'true' : 'false');
    }
    if (mediaEl && updatedData.image) {
      const show = updatedData.image.show !== false;
      mediaEl.setAttribute('data-show', show ? 'true' : 'false');
      mediaEl.style.display = show ? '' : 'none';
    }
    if (contentBoxEl && updatedData.content) {
      const backgroundColor = updatedData.content.backgroundColor || '#E2ECFD';
      const textColor = updatedData.content.textColor || '#000000';
      contentBoxEl.setAttribute('data-background-color', backgroundColor);
      contentBoxEl.setAttribute('data-text-color', textColor);
      contentBoxEl.style.setProperty('--content-background-color', backgroundColor);
      contentBoxEl.style.setProperty('--content-text-color', textColor);
    }
    if (contentEl && updatedData.content) contentEl.innerHTML = updatedData.content.html || '';
    if (imageEl && updatedData.image) imageEl.setAttribute('src', updatedData.image.src || '');
    if (buttonEl && updatedData.button) updateButtonBasic(buttonEl, updatedData.button);

    return container.innerHTML.trim();
  },
  sectionKonfortifyBanner(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="konfortify-banner"]');
    const contentBoxEl = container.querySelector('[data-attribute="konfortify-banner__content-box"]');
    const contentEl = container.querySelector('[data-attribute="konfortify-banner__content"]');
    const mediaEl = container.querySelector('[data-attribute="konfortify-banner__media"]');
    const imageEl = container.querySelector('[data-attribute="konfortify-banner__image"]');
    const buttonEl = container.querySelector('[data-attribute="wrap-button"]');

    if (rootEl && updatedData.image) {
      const position = updatedData.image.position === 'left' ? 'left' : 'right';
      rootEl.setAttribute('data-image-position', position);
      rootEl.setAttribute('data-image-show', updatedData.image.show !== false ? 'true' : 'false');
    }
    if (mediaEl && updatedData.image) {
      const show = updatedData.image.show !== false;
      mediaEl.setAttribute('data-show', show ? 'true' : 'false');
      mediaEl.style.display = show ? '' : 'none';
      mediaEl.setAttribute('data-shape-curved-show', updatedData.image.showShapeCurved !== false ? 'true' : 'false');
    }
    if (contentBoxEl && updatedData.content) {
      const backgroundColor = updatedData.content.backgroundColor || '#E2ECFD';
      const textColor = updatedData.content.textColor || '#000000';
      contentBoxEl.setAttribute('data-background-color', backgroundColor);
      contentBoxEl.setAttribute('data-text-color', textColor);
      contentBoxEl.style.setProperty('--content-background-color', backgroundColor);
      contentBoxEl.style.setProperty('--content-text-color', textColor);
    }
    if (contentEl && updatedData.content) contentEl.innerHTML = updatedData.content.html || '';
    if (imageEl && updatedData.image) imageEl.setAttribute('src', updatedData.image.src || '');
    if (buttonEl && updatedData.button) updateButtonBasic(buttonEl, updatedData.button);

    return container.innerHTML.trim();
  },
  sectionKonfortifyReviewGrid(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute="konfortify-review-grid"]');
    const headerTitleEl = container.querySelector('[data-attribute="konfortify-review-grid__header-title"]');
    const ratingValueEl = container.querySelector('[data-attribute="konfortify-review-grid__rating-value"]');
    const listEl = container.querySelector('[data-attribute="konfortify-review-grid__list"]');
    const headerStarsEl = container.querySelector('[data-attribute="konfortify-review-grid__header-stars"]');

    const starIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.32l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z" /></svg>`;
    const renderStars = (attribute, value) =>
      `<div class="konfortify-review-grid__stars" data-attribute="${attribute}" data-value="${value}">${Array(5)
        .fill(starIcon)
        .join('')}</div>`;

    if (rootEl && updatedData.starColor !== undefined) {
      rootEl.setAttribute('data-star-color', updatedData.starColor || '#39CA41');
      rootEl.style.setProperty('--star-color', updatedData.starColor || '#39CA41');
    }
    if (headerTitleEl && updatedData.headerTitle !== undefined) headerTitleEl.innerHTML = updatedData.headerTitle || '';
    if (updatedData.rating) {
      const ratingValue = Math.max(0, Math.min(5, Number(updatedData.rating.value) || 0));
      if (ratingValueEl) {
        ratingValueEl.textContent = ratingValue.toFixed(1);
      }

      if (headerStarsEl) {
        headerStarsEl.setAttribute('data-value', ratingValue.toFixed(1));
        const rating = parseFloat(ratingValue.toFixed(1));
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.1;

        headerStarsEl.setAttribute('data-value', fullStars);
        if (hasHalfStar) {
          headerStarsEl.setAttribute('data-half-star', fullStars + 1);
        } else {
          headerStarsEl.removeAttribute('data-half-star');
        }

        let starsHTML = `
              <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0" style="position: absolute;">
                <defs>
                  <linearGradient id="half-star-gradient-konfortify-review" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="50%" style="stop-color:var(--star-color, #39ca41);stop-opacity:1" />
                    <stop offset="50%" style="stop-color:var(--star-color, #39ca41);stop-opacity:0" />
                  </linearGradient>
                </defs>
              </svg>
            `;
        for (let i = 0; i < 5; i++) {
          starsHTML += `
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.32l-5.8 3.05 1.11-6.47-4.7-4.58 6.49-.94L12 2.5z" />
              </svg>
              `;
        }

        headerStarsEl.innerHTML = starsHTML;
      }
    }
    if (listEl && Array.isArray(updatedData.listItem)) {
      listEl.innerHTML = updatedData.listItem
        .map(item => {
          const rating = Math.max(1, Math.min(5, Number(item.rating) || 1));
          return `
            <div class="swiper-slide" data-attribute="konfortify-review-grid__item">
              <article class="konfortify-review-grid__card">
                <div
                  class="konfortify-review-grid__card-title"
                  data-attribute="konfortify-review-grid__item-title"
                >
                  ${item.title || ''}
                </div>
                <div
                  class="konfortify-review-grid__content"
                  data-attribute="konfortify-review-grid__item-content"
                >
                  ${item.content || ''}
                </div>
                <div class="konfortify-review-grid__info">
                  <img
                    class="konfortify-review-grid__avatar"
                    data-attribute="konfortify-review-grid__item-avatar"
                    loading="lazy"
                    src="${item.avatar || ''}"
                    alt="${item.fullName || ''}"
                  />
                  <div class="konfortify-review-grid__review">
                    <div
                      class="konfortify-review-grid__name"
                      data-attribute="konfortify-review-grid__item-full-name"
                    >
                      ${item.fullName || ''}
                    </div>
                    ${renderStars('konfortify-review-grid__item-stars', rating)}
                  </div>
                </div>
              </article>
            </div>
          `;
        })
        .join('');
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopBanner(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }
    if (updatedData.tags) {
      const deepGlossEl = container.querySelector('[data-attribute="furnitureshop-banner__tag"]');
      if (deepGlossEl) deepGlossEl.textContent = updatedData.tags.deepGloss || '';
      const ceramicEl = container.querySelector('[data-attribute="furnitureshop-banner__ceramic"]');
      if (ceramicEl) ceramicEl.textContent = updatedData.tags.ceramic || '';
    }
    if (updatedData.content) {
      const headlineEl = container.querySelector('[data-attribute="furnitureshop-banner__headline"]');
      if (headlineEl) headlineEl.innerHTML = updatedData.content.headline || '';
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopCardStep(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.header) {
      const titleEl = container.querySelector('[data-attribute="furnitureshop-card-step__title"]');
      const descriptionEl = container.querySelector('[data-attribute="furnitureshop-card-step__description"]');
      if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
      if (descriptionEl) descriptionEl.innerHTML = updatedData.header.description || '';
    }

    if (updatedData.media) {
      const mediaEl = container.querySelector('[data-attribute="furnitureshop-card-step__media"]');
      if (mediaEl) {
        const type = updatedData.media.type === 'image' ? 'image' : 'video';
        mediaEl.setAttribute('data-show', updatedData.media.show ? 'true' : 'false');
        mediaEl.setAttribute('data-position', updatedData.media.position === 'right' ? 'right' : 'left');
        mediaEl.setAttribute('data-media-type', type);
        mediaEl.style.display = updatedData.media.show ? '' : 'none';
        const videoEl = mediaEl.querySelector('[data-attribute="furnitureshop-card-step__video"]');
        const videoSourceEl = mediaEl.querySelector('[data-attribute="furnitureshop-card-step__video-source"]');
        const imageEl = mediaEl.querySelector('[data-attribute="furnitureshop-card-step__media-image"]');
        const imageInnerEl = mediaEl.querySelector('[data-attribute="furnitureshop-card-step__media-image-inner"]');
        if (videoSourceEl) videoSourceEl.setAttribute('src', updatedData.media.videoSrc || '');
        if (imageInnerEl) imageInnerEl.setAttribute('src', updatedData.media.imageSrc || '');
        if (videoEl) videoEl.style.display = type === 'video' ? '' : 'none';
        if (imageEl) imageEl.style.display = type === 'image' ? '' : 'none';
      }
    }

    if (updatedData.steps) {
      const stepsEl = container.querySelector('[data-attribute="furnitureshop-card-step__steps"]');
      if (stepsEl) {
        stepsEl.innerHTML = (updatedData.steps || [])
          .map(
            item => `
              <article class="furnitureshop-card-step__item" data-attribute="furnitureshop-card-step__item">
                <img class="furnitureshop-card-step__item-image" data-attribute="furnitureshop-card-step__item-image" src="${item.image ||
                  ''}" alt="">
                <div class="furnitureshop-card-step__item-description" data-attribute="furnitureshop-card-step__item-description">
                  ${item.description || ''}
                </div>
              </article>`,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopGridSlider(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.images) {
      const listEl = container.querySelector('[data-attribute=furnitureshop-grid-slider__list]');
      if (listEl) {
        const images = updatedData.images || [];
        const slides = [];
        for (let index = 0; index < images.length; index += 2) {
          slides.push(`
            <div class='swiper-slide' data-attribute='furnitureshop-grid-slider__slide'>
              <div class='furnitureshop-grid-slider__image-grid'>
                ${images
                  .slice(index, index + 2)
                  .map(
                    image => `
                      <img
                        class='furnitureshop-grid-slider__image'
                        data-attribute='furnitureshop-grid-slider__image'
                        src='${image || ''}'
                        alt=''
                      />`,
                  )
                  .join('')}
              </div>
            </div>`);
        }
        listEl.innerHTML = slides.join('');
      }
    }

    if (updatedData.items) {
      const itemsEl = container.querySelector('[data-attribute=furnitureshop-grid-slider__items]');
      if (itemsEl) {
        itemsEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <div class='furnitureshop-grid-slider__item' data-attribute='furnitureshop-grid-slider__item'>
                <img
                  class='furnitureshop-grid-slider__item-image'
                  data-attribute='furnitureshop-grid-slider__item-image'
                  src='${item.image || ''}'
                  alt=''
                />
                <span data-attribute='furnitureshop-grid-slider__item-text'>${item.text || ''}</span>
              </div>`,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopGridSlider02(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.header) {
      const titleEl = container.querySelector('[data-attribute="furnitureshop-grid-slider-02__title"]');
      const descriptionEl = container.querySelector('[data-attribute="furnitureshop-grid-slider-02__description"]');
      if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
      if (descriptionEl) descriptionEl.innerHTML = updatedData.header.description || '';
    }

    if (updatedData.slides) {
      const listEl = container.querySelector('[data-attribute="furnitureshop-grid-slider-02__list"]');
      if (listEl) {
        listEl.innerHTML = (updatedData.slides || [])
          .map(
            slide => `
              <div class="swiper-slide" data-attribute="furnitureshop-grid-slider-02__slide">
                <article class="furnitureshop-grid-slider-02__card">
                  <img
                    class="furnitureshop-grid-slider-02__image"
                    data-attribute="furnitureshop-grid-slider-02__image"
                    src="${slide.image || ''}"
                    alt=""
                  />
                  <div
                    class="furnitureshop-grid-slider-02__slide-content"
                    data-attribute="furnitureshop-grid-slider-02__slide-content"
                  >
                    ${slide.content || ''}
                  </div>
                </article>
              </div>`,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopSpecification(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const contentEl = container.querySelector('[data-attribute=furnitureshop-specification__content]');
    if (contentEl && updatedData.content !== undefined) contentEl.innerHTML = updatedData.content || '';

    const noteEl = container.querySelector('[data-attribute=furnitureshop-specification__note-content]');
    if (noteEl && updatedData.note !== undefined) noteEl.innerHTML = updatedData.note || '';

    if (updatedData.image) {
      const sectionEl = container.querySelector('[data-attribute=furnitureshop-specification]');
      const mediaEl = container.querySelector('[data-attribute=furnitureshop-specification__media]');
      const imageEl = container.querySelector('[data-attribute=furnitureshop-specification__image]');
      const subTextEl = container.querySelector('[data-attribute=furnitureshop-specification__sub-text-image]');
      const show = updatedData.image.show !== false;
      const position = updatedData.image.position === 'left' ? 'left' : 'right';
      if (sectionEl) {
        sectionEl.setAttribute('data-image-show', show ? 'true' : 'false');
        sectionEl.setAttribute('data-image-position', position);
      }
      if (mediaEl) mediaEl.style.display = show ? '' : 'none';
      if (imageEl) imageEl.setAttribute('src', updatedData.image.src || '');
      if (subTextEl) subTextEl.textContent = updatedData.image.subText || '';
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute=wrap-button]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopCarousel(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const imageEl = container.querySelector('[data-attribute=furnitureshop-carousel__image]');
    if (imageEl && updatedData.image !== undefined) imageEl.setAttribute('src', updatedData.image || '');

    return container.innerHTML.trim();
  },
  sectionFurnitureshopReward(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const contentEl = container.querySelector('[data-attribute=furnitureshop-reward__content]');
    if (contentEl && updatedData.content !== undefined) contentEl.innerHTML = updatedData.content || '';

    if (updatedData.awards) {
      const innovationEl = container.querySelector('[data-attribute=furnitureshop-reward__innovation]');
      const tiktokHotEl = container.querySelector('[data-attribute=furnitureshop-reward__tiktok-hot]');
      if (innovationEl && updatedData.awards.innovation !== undefined) {
        innovationEl.innerHTML = updatedData.awards.innovation || '';
      }
      if (tiktokHotEl && updatedData.awards.tiktokHot !== undefined) {
        tiktokHotEl.innerHTML = updatedData.awards.tiktokHot || '';
      }
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopBanner02(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute=wrap-button]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    if (updatedData.header) {
      const titleEl = container.querySelector('[data-attribute=furnitureshop-banner-02__title]');
      const descriptionEl = container.querySelector('[data-attribute=furnitureshop-banner-02__description]');
      const decorEl = container.querySelector('[data-attribute=furnitureshop-banner-02__decor]');
      if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
      if (descriptionEl) descriptionEl.innerHTML = updatedData.header.description || '';
      if (decorEl) decorEl.setAttribute('src', updatedData.header.decor || '');
    }

    if (updatedData.content) {
      const logoEl = container.querySelector('[data-attribute=furnitureshop-banner-02__logo]');
      if (logoEl) logoEl.setAttribute('src', updatedData.content.logo || '');
    }

    if (updatedData.items) {
      const itemsEl = container.querySelector('[data-attribute=furnitureshop-banner-02__items]');
      if (itemsEl) {
        itemsEl.innerHTML = (updatedData.items || [])
          .map(
            item => `
              <li class='furnitureshop-banner-02__item' data-attribute='furnitureshop-banner-02__item'>
                <img class='furnitureshop-banner-02__item-icon' data-attribute='furnitureshop-banner-02__item-icon' src='${item.icon ||
                  ''}' alt=''>
                <span class='furnitureshop-banner-02__item-text' data-attribute='furnitureshop-banner-02__item-text'>${item.text ||
                  ''}</span>
              </li>`,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionFurnitureshopBanner03(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    if (updatedData.header) {
      const titleEl = container.querySelector('[data-attribute=furnitureshop-banner-03__title]');
      const descriptionEl = container.querySelector('[data-attribute=furnitureshop-banner-03__description]');
      const decorEl = container.querySelector('[data-attribute=furnitureshop-banner-03__decor]');
      if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
      if (descriptionEl) descriptionEl.innerHTML = updatedData.header.description || '';
      if (decorEl) decorEl.setAttribute('src', updatedData.header.decor || '');
    }
    if (updatedData.media) {
      const mediaEl = container.querySelector('[data-attribute=furnitureshop-banner-03__media]');
      const type = updatedData.media.type === 'image' ? 'image' : 'video';
      if (mediaEl) {
        mediaEl.setAttribute('data-show', updatedData.media.show ? 'true' : 'false');
        mediaEl.setAttribute('data-media-type', type);
        const videoEl = mediaEl.querySelector('[data-attribute=furnitureshop-banner-03__video]');
        const sourceEl = mediaEl.querySelector('[data-attribute=furnitureshop-banner-03__video-source]');
        const imageEl = mediaEl.querySelector('[data-attribute=furnitureshop-banner-03__media-image]');
        const imageInnerEl = mediaEl.querySelector('[data-attribute=furnitureshop-banner-03__media-image-inner]');
        if (sourceEl) sourceEl.setAttribute('src', updatedData.media.videoSrc || '');
        if (imageInnerEl) imageInnerEl.setAttribute('src', updatedData.media.imageSrc || '');
        if (videoEl) videoEl.style.display = type === 'video' ? '' : 'none';
        if (imageEl) imageEl.style.display = type === 'image' ? '' : 'none';
      }
      const mediaColumnEl = container.querySelector('.furnitureshop-banner-03__media-column');
      if (mediaColumnEl) mediaColumnEl.style.display = updatedData.media.show ? '' : 'none';
      const subtextEl = container.querySelector('[data-attribute=furnitureshop-banner-03__subtext]');
      if (subtextEl) subtextEl.textContent = updatedData.media.subtext || '';
    }
    if (updatedData.features) {
      const featuresEl = container.querySelector('[data-attribute=furnitureshop-banner-03__features]');
      if (featuresEl) {
        featuresEl.innerHTML = updatedData.features
          .map(item => {
            return (
              '<li class="furnitureshop-banner-03__feature" data-attribute="furnitureshop-banner-03__feature">' +
              '<img class="furnitureshop-banner-03__feature-icon" ' +
              'data-attribute="furnitureshop-banner-03__feature-icon" src="' +
              (item.icon || '') +
              '" alt="">' +
              '<span class="furnitureshop-banner-03__feature-text" ' +
              'data-attribute="furnitureshop-banner-03__feature-text">' +
              (item.text || '') +
              '</span></li>'
            );
          })
          .join('');
      }
    }
    return container.innerHTML.trim();
  },
  sectionFurnitureshopFaq(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute=furnitureshop-faq__title]');
    if (titleEl && updatedData.heading !== undefined) titleEl.innerHTML = updatedData.heading || '';

    if (updatedData.items) {
      const listEl = container.querySelector('[data-attribute=furnitureshop-faq__list]');
      const templateItem = listEl?.firstElementChild?.cloneNode(true);
      if (listEl && templateItem) {
        listEl.innerHTML = '';
        updatedData.items.forEach((item, index) => {
          const itemEl = templateItem.cloneNode(true);
          const isOpen = index === 0;
          const questionEl = itemEl.querySelector('[data-attribute=furnitureshop-faq__question]');
          const answerEl = itemEl.querySelector('[data-attribute=furnitureshop-faq__answer]');
          const answerWrapEl = itemEl.querySelector('[data-attribute=item-answer]');
          const minusEl = itemEl.querySelector('[data-attribute=icon-minus]');
          const plusEl = itemEl.querySelector('[data-attribute=icon-plus]');
          if (questionEl) questionEl.textContent = item.question || '';
          if (answerEl) answerEl.innerHTML = item.answer || '';
          itemEl.classList.toggle('is-active', isOpen);
          itemEl.setAttribute('data-active', isOpen ? 'true' : 'false');
          answerWrapEl?.classList.toggle('open', isOpen);
          if (answerWrapEl) answerWrapEl.style.maxHeight = isOpen ? '300px' : '';
          if (minusEl) minusEl.style.display = isOpen ? '' : 'none';
          if (plusEl) plusEl.style.display = isOpen ? 'none' : '';
          listEl.appendChild(itemEl);
        });
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute=wrap-button]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionFeetscareListImage(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.listImages) {
      const listEl = container.querySelector('[data-attribute="list-item-image"]');
      if (listEl) {
        const width = updatedData.listImages.width || 100;
        const widthPx = `${width}px`;
        listEl.setAttribute('data-width-image', widthPx);
        listEl.style.setProperty('--width-image', widthPx);

        listEl.innerHTML = (updatedData.listImages.items || [])
          .map(
            item => `
              <div class="wrap-img-item" data-attribute="item-image">
                <img class="img-item" data-attribute="img-item" src="${item.image || ''}" alt="">
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionFeetscareListItem(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.listItem) {
      const listEl = container.querySelector('[data-attribute="list-item"]');
      if (listEl) {
        const bgItem = updatedData.listItem.bgItem || '#ffffff';
        const colorItem = updatedData.listItem.colorItem || '#000000';
        listEl.setAttribute('data-bg-item', bgItem);
        listEl.setAttribute('data-color-item', colorItem);
        listEl.style.setProperty('--bg-item', bgItem);
        listEl.style.setProperty('--color-item', colorItem);

        listEl.innerHTML = (updatedData.listItem.items || [])
          .map(
            item => `
              <div data-attribute="item" class="item-feetscare">
                ${item.content || ''}
              </div>
            `,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionFeetscareStat(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.cardLeft) {
      const cardLeftEl = container.querySelector('[data-attribute="card-left"]');
      if (cardLeftEl) {
        const order = updatedData.cardLeft.order || 1;
        cardLeftEl.setAttribute('data-order-left', order);
        cardLeftEl.style.setProperty('--order-left', order);
      }
    }

    if (updatedData.cardRight) {
      const cardRightEl = container.querySelector('[data-attribute="card-right"]');
      if (cardRightEl) {
        const order = updatedData.cardRight.order || 2;
        const bgColor = updatedData.cardRight.bgColor || '#ffffff';
        cardRightEl.setAttribute('data-order-right', order);
        cardRightEl.setAttribute('data-bg-color-right', bgColor);
        cardRightEl.style.setProperty('--order-right', order);
        cardRightEl.style.setProperty('--bg-color-right', bgColor);
      }

      const cardRightContentEl = container.querySelector('[data-attribute="card-right-content"]');
      if (cardRightContentEl) {
        cardRightContentEl.innerHTML = updatedData.cardRight.content || '';
      }
    }

    if (updatedData.listItemStat) {
      const listEl = container.querySelector('[data-attribute="list-item-stat"]');
      if (listEl) {
        listEl.innerHTML = (updatedData.listItemStat || [])
          .map(item => {
            const color = item.color || '#417505';
            const showIcon = item.showIcon !== false;
            // Only the active icon type is written out — the unused type (image or svg) is dropped
            // entirely instead of being hidden, per the icon-stat field being either/or.
            const iconMarkup = item.useSvg
              ? item.iconSvg || ''
              : `<img data-attribute="icon-stat-image" src="${item.icon || ''}" alt="" />`;
            return `
              <div data-attribute="item-stat" class="item-stat">
                <div
                  data-attribute="wrap-value-stat"
                  class="wrap-value-stat"
                  data-color-item-stat="${color}"
                  style="--color-item-stat: ${color}"
                >
                  <span data-attribute="value-stat" class="value-stat">${item.value || ''}</span>
                  <span
                    data-attribute="icon-stat"
                    class="icon-stat"
                    data-show="${showIcon ? 'true' : 'false'}"
                    data-use-svg="${item.useSvg ? 'true' : 'false'}"
                    style="display: ${showIcon ? '' : 'none'}"
                  >
                    ${iconMarkup}
                  </span>
                </div>
                <div data-attribute="description" class="description-stat">
                  ${item.description || ''}
                </div>
              </div>
            `;
          })
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionFeetscareSatellite(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    if (updatedData.mainImage) {
      const mainImageEl = container.querySelector('[data-attribute="satellite-image"]');
      if (mainImageEl) {
        mainImageEl.setAttribute('src', updatedData.mainImage.src || '');
      }
    }

    if (updatedData.listItemsSatellite) {
      const leftEl = container.querySelector('[data-attribute="items-left"]');
      const rightEl = container.querySelector('[data-attribute="items-right"]');
      if (leftEl && rightEl) {
        const items = updatedData.listItemsSatellite || [];
        // Split the single list evenly across the two columns — left gets the extra item on an odd count.
        const half = Math.ceil(items.length / 2);
        const leftItems = items.slice(0, half);
        const rightItems = items.slice(half);

        const renderItem = item => {
          const bgItem = item.bgItem || '#dc9376';
          const colorItem = item.colorItem || '#ffffff';
          const widthImg = item.widthImg || 34;
          // Only the active icon type is written out — the unused type (image or svg) is dropped
          // entirely instead of being hidden, per the icon field being either/or.
          const iconMarkup = item.useSvg
            ? item.iconSvg || ''
            : `<img data-attribute="icon-item-image" src="${item.icon || ''}" alt="" />`;
          return `
            <div
              data-attribute="item-satellite"
              class="item-satellite"
              data-bg-item="${bgItem}"
              data-color-item="${colorItem}"
              style="--bg-item: ${bgItem}; --color-item: ${colorItem}"
            >
              <div
                class="wrap-img-item"
                data-attribute="wrap-img-item"
                data-use-svg="${item.useSvg ? 'true' : 'false'}"
                data-width-img="${widthImg}"
                style="--width-img: ${widthImg}px"
              >
                ${iconMarkup}
              </div>
              <div class="title-item" data-attribute="title-item">
                ${item.title || ''}
              </div>
            </div>
          `;
        };

        leftEl.innerHTML = leftItems.map(renderItem).join('');
        rightEl.innerHTML = rightItems.map(renderItem).join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionManchestoreCompareSlider(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const rootEl = container.querySelector('[data-attribute=manchestore-compare-slider]');
    const escapeAttr = value =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&#39;');

    if (updatedData.heading) {
      const titleEl = container.querySelector('[data-attribute=mcs__title]');
      if (titleEl) titleEl.innerHTML = updatedData.heading.title || '';
    }

    if (rootEl && updatedData.media) {
      const mediaType = updatedData.media.type === 'image' ? 'image' : 'video';
      const mediaPosition = updatedData.media.position === 'right' ? 'right' : 'left';
      rootEl.setAttribute('data-media-type', mediaType);
      rootEl.setAttribute('data-media-position', mediaPosition);
      const videoSourceEl = rootEl.querySelector('[data-attribute=mcs__video-source]');
      const imageEl = rootEl.querySelector('[data-attribute=mcs__image]');
      if (videoSourceEl) videoSourceEl.setAttribute('src', updatedData.media.video || '');
      if (imageEl) imageEl.setAttribute('src', updatedData.media.image || '');
    }

    if (Array.isArray(updatedData.features)) {
      const featuresEl = container.querySelector('[data-attribute=mcs__features]');
      if (featuresEl) {
        featuresEl.innerHTML = updatedData.features
          .map(
            item => `<div class='mcs__feature' data-attribute='mcs__feature'>
              <div class='mcs__feature-content' data-attribute='mcs__feature-content'>${item.content || ''}</div>
            </div>`,
          )
          .join('');
      }
    }

    if (Array.isArray(updatedData.slides)) {
      const slidesEl = container.querySelector('[data-attribute=mcs__slides]');
      if (slidesEl) {
        slidesEl.innerHTML = updatedData.slides
          .map(
            (slide, index) => `<div class='swiper-slide mcs__slide' data-attribute='mcs__slide'>
              <div class='mcs__compare' data-attribute='mcs__compare'>
                <img class='mcs__compare-image mcs__compare-image--after' data-attribute='mcs__after-image' src='${escapeAttr(
                  slide.after,
                )}' alt='After result ${index + 1}' loading='lazy'>
                <div class='mcs__before-layer'>
                  <img class='mcs__compare-image mcs__compare-image--before' data-attribute='mcs__before-image' src='${escapeAttr(
                    slide.before,
                  )}' alt='Before result ${index + 1}' loading='lazy'>
                </div>
                <button class='mcs__handle' type='button' aria-label='Adjust before and after comparison'>
                  <span class='mcs__handle-knob' aria-hidden='true'>
                    <svg viewBox='0 0 18 18' focusable='false'><path d='m7 5-4 4 4 4M11 5l4 4-4 4' fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.8'></path></svg>
                  </span>
                </button>
                <span class='mcs__tag mcs__tag--before'>Before</span>
                <span class='mcs__tag mcs__tag--after'>After</span>
              </div>
            </div>`,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute=wrap-button]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionManchestoreBanner(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const escapeHtml = value =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\x22/g, '&quot;')
        .replace(/'/g, '&#39;');

    if (updatedData.header) {
      const titleEl = container.querySelector('[data-attribute=manchestore-banner__title]');
      const descriptionEl = container.querySelector('[data-attribute=manchestore-banner__description]');
      const dividerEl = container.querySelector('[data-attribute=manchestore-banner__divider]');
      if (titleEl) titleEl.innerHTML = updatedData.header.title || '';
      if (descriptionEl) descriptionEl.innerHTML = updatedData.header.description || '';
      if (dividerEl) {
        const dividerColor = updatedData.header.dividerColor || '#FE9790';
        dividerEl.setAttribute('data-color', dividerColor);
        dividerEl.style.backgroundColor = dividerColor;
      }
    }

    if (updatedData.video) {
      const videoSourceEl = container.querySelector('[data-attribute=manchestore-banner__video-source]');
      if (videoSourceEl) videoSourceEl.setAttribute('src', updatedData.video.src || '');
    }

    if (updatedData.card) {
      const cardTitleEl = container.querySelector('[data-attribute=manchestore-banner__card-title]');
      if (cardTitleEl) cardTitleEl.textContent = updatedData.card.title || '';

      if (Array.isArray(updatedData.card.items)) {
        const itemsEl = container.querySelector('[data-attribute=manchestore-banner__items]');
        if (itemsEl) {
          itemsEl.innerHTML = updatedData.card.items
            .map(
              item => `<div class='manchestore-banner__item' data-attribute='manchestore-banner__item'>
                <img class='manchestore-banner__item-image' data-attribute='manchestore-banner__item-image'
                  src='${escapeHtml(item.image)}' alt='${escapeHtml(item.text)}' loading='lazy'>
                <span class='manchestore-banner__item-text' data-attribute='manchestore-banner__item-text'>${escapeHtml(
                  item.text,
                )}</span>
              </div>`,
            )
            .join('');
        }
      }
    }

    return container.innerHTML.trim();
  },
  sectionSofyreTabsReview(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const starSvg = (count = 5) => {
      let svg = '';
      for (let i = 0; i < count; i++) {
        svg +=
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>star</title><path fill="currentColor" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" /></svg>';
      }
      return svg;
    };

    const verifiedBadgeSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>check-decagram</title><path fill="currentColor" d="M23,12L20.56,9.22L20.9,5.54L17.29,4.72L15.4,1.54L12,3L8.6,1.54L6.71,4.72L3.1,5.53L3.44,9.21L1,12L3.44,14.78L3.1,18.47L6.71,19.29L8.6,22.47L12,21L15.4,22.46L17.29,19.28L20.9,18.46L20.56,14.78L23,12M10,17L6,13L7.41,11.59L10,14.17L16.59,7.58L18,9L10,17Z" /></svg>';

    if (updatedData.ratingSummary) {
      const ratingStarEl = container.querySelector('[data-attribute="rating-summary-star"]');
      if (ratingStarEl) {
        const value = updatedData.ratingSummary.value || 5;
        const colorStar = updatedData.ratingSummary.colorStar || '#ccf46f';
        ratingStarEl.setAttribute('data-value', String(value));
        ratingStarEl.setAttribute('data-color-star', colorStar);
        ratingStarEl.style.setProperty('--color-star', colorStar);
        ratingStarEl.innerHTML = starSvg(value);
      }

      const ratingTextEl = container.querySelector('[data-attribute="rating-summary-text"]');
      if (ratingTextEl) {
        ratingTextEl.textContent = updatedData.ratingSummary.text || '';
      }
    }

    if (updatedData.titleTestimonial) {
      const titleTestimonialEl = container.querySelector('[data-attribute="title-testimonial"]');
      if (titleTestimonialEl) {
        const show = updatedData.titleTestimonial.show !== false;
        titleTestimonialEl.setAttribute('data-show', show ? 'true' : 'false');
        titleTestimonialEl.style.display = show ? '' : 'none';
        titleTestimonialEl.innerHTML = updatedData.titleTestimonial.content || '';
      }
    }

    const tabHeaderEl = container.querySelector('[data-attribute="tab-header"]');
    const tabBodyEl = container.querySelector('[data-attribute="tab-body"]');
    const tabs = updatedData.tabs || [];

    if (tabHeaderEl) {
      const colorTab = (updatedData.tabColors && updatedData.tabColors.colorTab) || '#23372b';
      const bgTabActive = (updatedData.tabColors && updatedData.tabColors.bgTabActive) || '#23372b';
      tabHeaderEl.setAttribute('data-color-tab', colorTab);
      tabHeaderEl.setAttribute('data-bg-tab-active', bgTabActive);
      tabHeaderEl.style.setProperty('--color-tab', colorTab);
      tabHeaderEl.style.setProperty('--bg-tab-active', bgTabActive);

      tabHeaderEl.innerHTML = tabs
        .map(
          (tab, idx) => `
            <div class="tab-item${idx === 0 ? ' active' : ''}" data-attribute="tab-item" data-tab="${
            tab.tabId
          }">${tab.label || ''}</div>
          `,
        )
        .join('\n');
    }

    if (tabBodyEl) {
      const colorStar = (updatedData.cardColors && updatedData.cardColors.colorStar) || '#ccf46f';
      const colorVerifiedBuyer = (updatedData.cardColors && updatedData.cardColors.colorVerifiedBuyer) || '#365941';
      const bgCardItem = (updatedData.cardColors && updatedData.cardColors.bgCardItem) || '#F8F8F4';
      tabBodyEl.setAttribute('data-color-star', colorStar);
      tabBodyEl.setAttribute('data-color-verified-buyer', colorVerifiedBuyer);
      tabBodyEl.setAttribute('data-bg-card-item', bgCardItem);
      tabBodyEl.style.setProperty('--color-star', colorStar);
      tabBodyEl.style.setProperty('--color-verified-buyer', colorVerifiedBuyer);
      tabBodyEl.style.setProperty('--bg-card-item', bgCardItem);

      tabBodyEl.innerHTML = tabs
        .map((tab, idx) => {
          const reviewsHtml = (tab.reviews || [])
            .map(
              review => `
                <div class="swiper-slide">
                  <div class="review-card">
                    <div class="review-card__header">
                      <div class="review-card__rating" data-value="${review.rating || 5}" data-attribute="rating">
                        ${starSvg(review.rating || 5)}
                      </div>
                      <div class="review-card__badge">
                        ${verifiedBadgeSvg}
                        <span> Verified Buyer </span>
                      </div>
                    </div>
                    <div data-attribute="review-card-body" class="review-card__body">
                      ${review.bodyContent || ''}
                    </div>
                    <div class="review-card__footer">
                      <div class="avatar">
                        <img data-attribute="avatar" src="${review.avatar || ''}" />
                      </div>
                      <div class="review-card__author-info">
                        <div class="review-card__author-name" data-attribute="author-name">${review.authorName ||
                          ''}</div>
                        <div class="review-card__author-meta" data-attribute="author-meta">${review.authorMeta ||
                          ''}</div>
                        <span class="review-card__purchase-tag">
                          <strong>Purchased:</strong> <span data-attribute="purchase-tag">${review.purchaseTag ||
                            ''}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              `,
            )
            .join('\n');

          return `
            <div class="tab-panel${idx === 0 ? ' active' : ''}" data-attribute="tab-panel" data-tab="${tab.tabId}">
              <div class="tab-panel__content swiper">
                <div class="swiper-wrapper" data-attribute="list-item">
                  ${reviewsHtml}
                </div>
                <div class="wrap-pagination">
                  <div class="swiper-button-next"></div>
                  <div class="swiper-button-prev"></div>
                </div>
              </div>
            </div>
          `;
        })
        .join('\n');
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionSofyreTimeline(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const query = selector => container.querySelector(selector);
    const rootEl = query('[data-attribute=sofyre-timeline]');
    if (rootEl && updatedData.primaryColor !== undefined) {
      const color = updatedData.primaryColor || '#23372B';
      rootEl.setAttribute('data-primary-color', color);
      rootEl.style.setProperty('--color-primary', color);
    }

    const headerEl = query('[data-attribute=sofyre-timeline__header]');
    if (headerEl && updatedData.header !== undefined) headerEl.innerHTML = updatedData.header || '';

    if (updatedData.image) {
      const layoutEl = query('[data-attribute=sofyre-timeline__layout]');
      const imageEl = query('[data-attribute=sofyre-timeline__image]');
      const imageImgEl = query('[data-attribute=sofyre-timeline__image-img]');
      const show = updatedData.image.show !== false;
      if (layoutEl) {
        layoutEl.setAttribute('data-image-position', updatedData.image.position || 'left');
        layoutEl.setAttribute('data-image-show', show ? 'true' : 'false');
      }
      if (imageEl) {
        imageEl.setAttribute('data-show', show ? 'true' : 'false');
        imageEl.style.display = show ? '' : 'none';
      }
      if (imageImgEl) imageImgEl.setAttribute('src', updatedData.image.src || '');
    }

    if (updatedData.guide) {
      const imageEl = query('[data-attribute=sofyre-timeline__guide-image]');
      const textEl = query('[data-attribute=sofyre-timeline__guide-text]');
      if (imageEl) imageEl.setAttribute('src', updatedData.guide.image || '');
      if (textEl) textEl.textContent = updatedData.guide.text || '';
    }

    if (Array.isArray(updatedData.tabs)) {
      const escapeHtml = value =>
        String(value || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\x22/g, '&quot;')
          .replace(/'/g, '&#39;');
      const tabs = updatedData.tabs.map((tab, index) => ({ ...tab, id: `sofyre-tab-${index + 1}` }));
      const headersEl = query('[data-attribute=list-tab-header]');
      const contentsEl = query('[data-attribute=list-tab-content]');
      const renderFeature = feature => `<div class=sofyre-timeline__feature data-attribute=sofyre-timeline__feature>
        <div class=sofyre-timeline__feature-title data-attribute=sofyre-timeline__feature-title>${feature.title ||
          ''}</div>
        <div class=sofyre-timeline__feature-content data-attribute=sofyre-timeline__feature-content>${feature.content ||
          ''}</div>
      </div>`;
      const renderHeader = (tab, index) => `<button type='button'
        class='sofyre-timeline__tab-header tab-header-item${index === 0 ? ' active' : ''}'
        data-attribute='tab-header-item' data-tab='${tab.id}'
        aria-selected='${index === 0 ? 'true' : 'false'}'>${escapeHtml(tab.label)}</button>`;
      const renderContent = (tab, index) => `<article
        class='sofyre-timeline__tab-content tab-content-item${index === 0 ? ' active' : ''}'
        data-attribute='tab-content-item' data-tab='${tab.id}'>
        <div class='sofyre-timeline__timeline'>
          <span class='sofyre-timeline__marker' aria-hidden='true'>
            <svg data-name="Group 1484581850 (1).svg" data-id="610890338768257833" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39 39" fill="none">
              <circle cx="19.5" cy="19.5" r="19.5" fill="#D9E8D0"></circle>
              <circle cx="19.5" cy="19.4998" r="14.1207" fill="#BFD5B2"></circle>
              <circle cx="19.5" cy="19.4997" r="8.74138" fill="#23372B"></circle>
            </svg>
          </span>
          <div class='sofyre-timeline__tag' data-attribute='sofyre-timeline__tag'>${escapeHtml(tab.tag)}</div>
          <div class='sofyre-timeline__tab-title' data-attribute='sofyre-timeline__tab-title'>${tab.title || ''}</div>
          <div class='sofyre-timeline__features' data-attribute='sofyre-timeline__features'>${(tab.features || [])
            .map(renderFeature)
            .join('')}</div>
        </div>
      </article>`;

      if (headersEl) {
        headersEl.innerHTML = tabs.map(renderHeader).join('');
      }
      if (contentsEl) contentsEl.innerHTML = tabs.map(renderContent).join('');
    }

    if (updatedData.button) {
      const wrapButtonEl = query('[data-attribute=wrap-button]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }
    return container.innerHTML.trim();
  },
  sectionSofyreIngredients(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const query = selector => container.querySelector(selector);
    const escapeHtml = value =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\x22/g, '&quot;')
        .replace(/'/g, '&#39;');

    const headerEl = query('[data-attribute=sofyre-ingredients__header]');
    if (headerEl && updatedData.header !== undefined) headerEl.innerHTML = updatedData.header || '';

    if (Array.isArray(updatedData.features)) {
      const featuresEl = query('[data-attribute=sofyre-ingredients__features]');
      if (featuresEl) {
        featuresEl.innerHTML = updatedData.features
          .map(
            feature => `<article class='sofyre-ingredients__feature' data-attribute='sofyre-ingredients__feature'>
              <picture class='sofyre-ingredients__picture'>
                <source data-attribute='sofyre-ingredients__image-mobile' media='(max-width: 768px)'
                  srcset='${escapeHtml(feature.mobileImage)}'>
                <img data-attribute='sofyre-ingredients__image-desktop' src='${escapeHtml(
                  feature.desktopImage,
                )}' alt='' loading='lazy'>
              </picture>
              <div class='sofyre-ingredients__feature-overlay' aria-hidden='true'></div>
              <div class='sofyre-ingredients__feature-content'>
                <div class='sofyre-ingredients__feature-title'
                  data-attribute='sofyre-ingredients__feature-title'>${feature.title || ''}</div>
                <div class='sofyre-ingredients__tags' data-attribute='sofyre-ingredients__tags'>${(feature.tags || [])
                  .map(
                    tag =>
                      `<span class='sofyre-ingredients__tag' data-attribute='sofyre-ingredients__tag'>${escapeHtml(
                        tag,
                      )}</span>`,
                  )
                  .join('')}</div>
                <div class='sofyre-ingredients__description'
                  data-attribute='sofyre-ingredients__description'>${feature.description || ''}</div>
              </div>
            </article>`,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = query('[data-attribute=wrap-button]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionSofyreUserManual(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const query = selector => container.querySelector(selector);
    const escapeHtml = value =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\x22/g, '&quot;')
        .replace(/'/g, '&#39;');

    const headerEl = query('[data-attribute=sofyre-user-manual__header]');
    const recommendationEl = query('[data-attribute=sofyre-user-manual__recommendation]');
    if (headerEl && updatedData.header !== undefined) headerEl.innerHTML = updatedData.header || '';
    if (recommendationEl && updatedData.recommendation !== undefined) {
      recommendationEl.innerHTML = updatedData.recommendation || '';
    }

    if (Array.isArray(updatedData.cards)) {
      const cardsEl = query('[data-attribute=sofyre-user-manual__cards]');
      if (cardsEl) {
        cardsEl.innerHTML = updatedData.cards
          .map(
            card => `<article class='sofyre-user-manual__card' data-attribute='sofyre-user-manual__card'>
              <div class='sofyre-user-manual__card-title' data-attribute='sofyre-user-manual__card-title'>${escapeHtml(
                card.title,
              )}</div>
              <div class='sofyre-user-manual__card-body'>
                <img class='sofyre-user-manual__card-image' data-attribute='sofyre-user-manual__card-image'
                  src='${escapeHtml(card.image)}' alt='' loading='lazy'>
                <div class='sofyre-user-manual__card-tag' data-attribute='sofyre-user-manual__card-tag'>${escapeHtml(
                  card.tag,
                )}</div>
                <div class='sofyre-user-manual__card-description'
                  data-attribute='sofyre-user-manual__card-description'>${escapeHtml(card.description)}</div>
              </div>
            </article>`,
          )
          .join('');
      }
    }

    if (updatedData.button) {
      const wrapButtonEl = query('[data-attribute=wrap-button]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionSofyreComparison(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);
    const escapeHtml = value =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    if (updatedData.cardTitle) {
      const cardTitleEl = container.querySelector('[data-attribute="card-title"]');
      if (cardTitleEl) {
        const show = updatedData.cardTitle.show !== false;
        cardTitleEl.setAttribute('data-show', show ? 'true' : 'false');
        cardTitleEl.style.display = show ? '' : 'none';
        cardTitleEl.innerHTML = updatedData.cardTitle.content || '';
      }
    }

    const renderItems = items =>
      (items || [])
        .map(item => {
          const useSvgMain = !!item.useSvgMain;
          const iconMainMarkup = useSvgMain
            ? item.iconMainSvg || ''
            : `<img data-attribute="icon-main-image" src="${escapeHtml(item.iconMain)}" />`;
          const iconSubShow = !item.iconSub || item.iconSub.show !== false;
          return `
            <div data-attribute="item" class="comparison-card__item">
              <span data-attribute="icon-main" data-use-svg="${
                useSvgMain ? 'true' : 'false'
              }" class="comparison-card__icon-main">
                ${iconMainMarkup}
              </span>
              <span data-attribute="icon-sub" data-show="${
                iconSubShow ? 'true' : 'false'
              }" class="comparison-card__icon-sub" style="display: ${iconSubShow ? '' : 'none'}">
                ${(iconSubShow && item.iconSub && item.iconSub.svg) || ''}
              </span>
              <span data-attribute="text" class="comparison-card__text">${escapeHtml(item.text)}</span>
            </div>
          `;
        })
        .join('');

    const applyCard = (selector, cardData) => {
      if (!cardData) return;
      const cardEl = container.querySelector(selector);
      if (!cardEl) return;

      if (cardData.colorBg) {
        cardEl.setAttribute('data-color-bg', cardData.colorBg);
        cardEl.style.setProperty('--color-bg', cardData.colorBg);
        cardEl.style.backgroundColor = cardData.colorBg;
      }
      if (cardData.colorText) {
        cardEl.setAttribute('data-color-text', cardData.colorText);
        cardEl.style.setProperty('--color-text', cardData.colorText);
        cardEl.style.color = cardData.colorText;
      }

      const titleEl = cardEl.querySelector('[data-attribute="title-compare-item"]');
      if (titleEl) titleEl.innerHTML = `<h3>${escapeHtml(cardData.title)}</h3>`;

      const listEl = cardEl.querySelector('[data-attribute="list-item"]');
      if (listEl && Array.isArray(cardData.items)) listEl.innerHTML = renderItems(cardData.items);
    };

    applyCard('[data-attribute="card-left"]', updatedData.cardLeft);
    applyCard('[data-attribute="card-right"]', updatedData.cardRight);

    if (updatedData.media) {
      const mediaImageEl = container.querySelector(
        '[data-attribute="comparison-section-media"] [data-attribute="image"]',
      );
      if (mediaImageEl) mediaImageEl.setAttribute('src', updatedData.media.src || '');
    }

    if (updatedData.button) {
      const wrapButtonEl = container.querySelector('[data-attribute="wrap-button"]');
      if (wrapButtonEl) updateButtonBasic(wrapButtonEl, updatedData.button);
    }

    return container.innerHTML.trim();
  },
  sectionMadamSizeCalculator(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const titleEl = container.querySelector('[data-attribute="title-size-chart"]');
    if (titleEl && updatedData.title !== undefined) titleEl.innerHTML = updatedData.title || '';

    const iconEl = container.querySelector('[data-attribute="icon-prefix-image"]');
    if (iconEl && updatedData.iconPrefix !== undefined) iconEl.setAttribute('src', updatedData.iconPrefix || '');

    const chart = updatedData.sizeChart;
    if (chart) {
      const holderEl = container.querySelector('[data-attribute="calculator-holder"]');
      if (holderEl) holderEl.setAttribute('data-size-chart', JSON.stringify(chart));

      const bandEl = container.querySelector('[data-attribute="select-band"]');
      if (bandEl) bandEl.innerHTML = renderBandOptions(chart.band);
      const cupEl = container.querySelector('[data-attribute="select-cup"]');
      if (cupEl) cupEl.innerHTML = renderCupOptions(chart.cup);
      const sizeEl = container.querySelector('[data-attribute="size-calculator"]');
      if (sizeEl) sizeEl.innerHTML = renderSizeOptions(chart.result);
      const textEl = container.querySelector('[data-attribute="text-resultes"]');
      if (textEl) textEl.textContent = chart.emptyText || '';
    }

    return container.innerHTML.trim();
  },
  sectionEskiinPolicy(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    if (updatedData.items) {
      const listEl = container.querySelector('[data-attribute="list-item"]');
      if (listEl) {
        listEl.innerHTML = updatedData.items
          .map(
            item => `
            <div class="item-sm" data-attribute="item">
              <div class="wrap-img">
                <img data-attribute="item-image" src="${escapeHtml(item.image || '')}" alt="" />
              </div>
              <div class="item-title" data-attribute="item-title">${item.title || ''}</div>
            </div>`,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
  sectionEskiinHurrybox(htmlString, updatedData) {
    const container = updateContainerFuild(htmlString, updatedData);

    const listEl = container.querySelector('[data-attribute="list-item"]');
    if (listEl) {
      const colPerView = updatedData.colPerView || 4;
      const colorBrand = updatedData.colorBrand || '#005F2A';
      listEl.setAttribute('data-col-perview', String(colPerView));
      listEl.setAttribute('color-brand', colorBrand);
      listEl.style.setProperty('--col-perview', String(colPerView));
      listEl.style.setProperty('--color-brand', colorBrand);
    }

    if (updatedData.items) {
      if (listEl) {
        listEl.innerHTML = updatedData.items
          .map(
            item => `
  <div data-attribute="item" class="item-sm">
    <div class="wrap-main-item">
      <div data-attribute="tag-item" class="tag-item">
        <span data-attribute="pre-text">${escapeHtml(item.preText || '')}</span>
        <span data-attribute="price">${escapeHtml(item.price || '')}</span>
      </div>
      <div data-attribute="wrap-image" class="wrap-image">
        <img data-attribute="image-item" src="${escapeHtml(item.image || '')}" alt="" />
      </div>
    </div>
    <div data-attribute="title-item" class="title-item">${item.title || ''}</div>
  </div>`,
          )
          .join('');
      }
    }

    return container.innerHTML.trim();
  },
};
